/**
 * German Translations
 * Tyska översättningar för DQFleet
 */

export const translationsDe: Record<string, any> = {
  reportGenerator: {
    title: 'Berichtsgenerator',
    intro: 'Wählen Sie ein Datenmodell aus, das der Kunde erhalten hat, aktivieren Sie das Kontrollkästchen und speichern Sie eine Vorlage. Mailings sind Excel, mit einem Blatt pro Registerkarte, das mehrere Zeilen hat.',
    organization: 'Organisation',
    templates: 'Vorlagen',
    noTemplates: 'Keine Vorlagen für diese Organisation.',
    newTemplate: 'Neue Vorlage',
    name: 'Name',
    model: 'Datenmodell',
    noModels: 'Der Kunde hat keine Datenmodelle. Weisen Sie sie am obersten Knoten der Organisation zu.',
    fields: {
      title: 'Feld',
      registrationNumber: 'Regnr',
      brand: 'Marke',
      model: 'Modell',
      year: 'Modelljahr',
      color: 'Farbe',
      systemStatus: 'Systemstatus',
      fuelType: 'Kraftstoff',
      engine: 'Motor',
      transmission: 'Getriebe',
      horsepower: 'Leistung',
      vehicleType: 'Fahrzeugtyp',
      category: 'Fahrzeugkategorie',
      usageStatus: 'Fahrzeugstatus',
      ownership: 'Eigentumsform',
      vin: 'VIN',
      replacesVehicle: 'Ersetzt Fahrzeug',
      flinkey: 'Flinkey',
      registeredDate: 'Registriert',
      manufacturedDate: 'Hergestellt',
      stolen: 'Gestohlen',
      emergencyVehicle: 'Einsatzfahrzeug',
      drivingBan: 'Fahrverbot',
      parentGroup: 'Hauptgruppe',
      group: 'Gruppe',
      referenceNumber: 'Referenznummer',
      costCenter: 'Kostenstelle',
      businessResponsibility: 'Geschäftsverantwortung',
      assignedUser: 'Zugeordneter Fahrer',
      leasingCompany: 'Leasingunternehmen',
      rentStart: 'Vertragsbeginn',
      rentEnd: 'Vertragsende',
      monthlyCost: 'Monatliche Leasingkosten',
      kmCap: 'Kilometerobergrenze',
      odometer: 'Aktueller Kilometerstand',
      initialOdometer: 'Beginn des Kilometerstands',
      drivenKm: 'Gefahrene Strecke',
      nextInspection: 'Nächste Inspektion',
      imei: 'IMEI',
      lastSeen: 'Zuletzt verbunden',
      distanceKm: 'Gefahrene Kilometer',
      tripCount: 'Anzahl der Fahrten',
      agreementNo: 'Vertragsnr.',
      contractNo: 'Vertragsnr.',
      termMonths: 'Vertragslaufzeit (Monate)',
      leasingProduct: 'Leasingprodukt',
      basePrice: 'Ursprünglicher Grundpreis',
      bookValue: 'Buchwert',
      residualValue: 'Garantierter Restbetrag Wert',
      extraKmCost: 'Kosten für zusätzliche Kilometer',
      taxCost: 'Monatliche Kostensteuer',
      malusCost: 'Monatlicher Kostenmalus',
      insuranceCompany: 'Versicherungsunternehmen',
      insuranceAgreement: 'Versicherungsvertrag',
      insuranceStart: 'Versicherung von',
      insuranceEnd: 'Versicherung bis',
      insuranceCost: 'Monatliche Kostenversicherung',
      disposalType: 'Abrechnung',
      disposalSupplier: 'Autohändler',
      disposalDate: 'Abrechnungsdatum',
      disposalAmount: 'Verkäufe Betrag',
      placementAddress: 'Standortadresse',
      placementPostal: 'Postleitzahl',
      placementCity: 'Stadt',
      batteryKwh: 'Batteriekapazität (kWh)',
      chargingEfficiency: 'Ladeeffizienz',
      homeAddress: 'Laden zu Hause',
      workAddress: 'Laden am Arbeitsplatz',
      bookingDescription: 'Buchungsbeschreibung',
      bookingRest: 'Ruhezeit (Min.)',
      bookingEmailNote: 'Text in der Buchungs-E-Mail',
      notes: 'Hinweis',
      cardNumber: 'Kartennummer',
      cardName: 'Kartenname',
      fuelCompany: 'Kraftstoffunternehmen',
      cardFrom: 'Gültig von',
      cardTo: 'Gültig bis',
      cardActive: 'Aktive Karte',
      serviceName: 'Servicestelle',
      serviceStatus: 'Servicestatus',
      serviceDueDate: 'Ablaufdatum',
      serviceDueKm: 'Ablaufkilometer',
      serviceBooked: 'Gebucht',
      tireType: 'Reifentyp',
      tireBrand: 'Reifenmarke',
      tireSize: 'Dimension',
      tireStatus: 'Reifenstatus',
      tireStorage: 'Lagerung',
      tireTread: 'Mustertiefe (mm)',
      attachmentName: 'Anhang',
      attachmentCategory: 'Kategorie',
      attachmentDescription: 'Beschreibung',
      attachmentDate: 'Hinzugefügt',
      equipmentName: 'Ausrüstung',
      equipmentNotes: 'Ausrüstungshinweis',
    },
    groups: {
      vehicle: 'Fahrzeuge',
      organization: 'Organisation',
      economy: 'Wirtschaftlichkeit',
      contract: 'Wirtschaftlichkeit',
      placement: 'Standort',
      charging: 'Laden',
      booking: 'Buchungsinformationen',
      notes: 'Notizen',
      current: 'Aktueller Status',
      period: 'Zeitraum',
      fuelCards: 'Tankkarte',
      service: 'Service',
      tires: 'Reifen',
      attachments: 'Anhänge',
      equipment: 'Fahrzeugausstattung',
    },
    activeOnly: 'Nur aktive Fahrzeuge',
    dataWindow: 'Daten Zeitraum',
    snapshot: 'Aktueller Status',
    previousWeek: 'Vorherige Woche',
    previousMonth: 'Vorheriger Kalendermonat',
    previousQuarter: 'Vorheriges Quartal',
    previousTertial: 'Vorheriges Quartal',
    previousYear: 'Vorheriges Kalenderjahr',
    schedule: 'Zeitplan',
    manual: 'Nur manuelle Ausführung',
    monthly: 'Jeden Monat',
    yearly: 'Jedes Jahr',
    day: 'Tag',
    month: 'Monat',
    scheduleHelp: 'Geplante Berichte werden um 06:15 Uhr gesendet. Tag 1–28.',
    recipients: 'Empfänger',
    noRecipients: 'Keine Benutzer mit E-Mail-Adresse in der Organisation.',
    save: 'Vorlage speichern',
    saved: 'Vorlage wird gespeichert',
    deleted: 'Vorlage wird entfernt',
    run: 'Herunterladen Excel',
    preview: 'Vorschau',
    previewCount: 'Zeigt die ersten Zeilen von',
    cancel: 'Abbrechen',
    edit: 'Änderung',
    delete: 'Entfernen',
    lockedField: 'Immer mit',
    models: {
      vehicleFleet: 'Fahrzeugbericht',
    },
  },
  common: {
    save: 'Speichern',
    selectTime: 'Zeit auswählen',
    cancel: 'Abbrechen',
    delete: 'Entfernen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    module: 'Modul',
    type: 'Typ',
    description: 'Beschreibung',
    saveChanges: 'Änderungen speichern',
    saving: 'Speichern...',
    update: 'Aktualisieren',
    search: 'Suchen',
    clear: 'Löschen',
    filter: 'Filter',
    allOrganizations: 'Alle Organisationen',
    allRoles: 'Alle Rollen',
    clearFilters: 'Filter löschen',
    refresh: 'Aktualisieren',
    loading: 'Laden...',
    error: 'Fehler',
    tryAgain: 'Erneut versuchen',
    success: 'Erfolgreich',
    confirm: 'Bestätigen',
    confirmDelete: 'Sind Sie sicher, dass Sie dies löschen möchten?',
    yes: 'Ja',
    no: 'Nein',
    close: 'Schließen',
    back: 'Zurück',
    pageErrorTitle: 'Die Seite konnte nicht angezeigt werden',
    pageErrorDescription: 'Ein unerwarteter Fehler ist aufgetreten. Zurück zur vorherigen Seite.',
    next: 'Weiter',
    previous: 'Vorherige',
    actions: 'Aktionen',
    status: 'Status',
    notes: 'Notizen',
    open: 'Offen',
    view: 'Anzeigen',
    hide: 'Ausblenden',
    notFound: 'Nicht gefunden',
    unknown: 'Unbekannt',
    comingSoon: 'Bald verfügbar',
    plannedFeatures: 'Geplante Funktionen',
    underDevelopment: 'Diese Funktion befindet sich in der Entwicklung',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    suspended: 'Unterbrochen',
    overview: 'Übersicht',
    organizations: 'Organisationen',
    vehicles: 'Fahrzeuge',
    vehicle: 'Fahrzeuge',
    trend: 'Trend',
    trips: 'Reise',
    distance: 'Entfernung',
    organization: 'Organisation',
    fromDate: 'Von-Datum',
    toDate: 'Bis-Datum',
    from: 'Von',
    to: 'Bis',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    all: 'Alle',
    export: 'Export',
    exportCsv: 'Export CSV',
    saveError: 'Speichern nicht möglich',
    deleteError: 'Löschen nicht möglich',
    activateError: 'Aktivieren nicht möglich',
    loadDataError: 'Daten konnten nicht geladen werden',
    updateStatusError: 'Status konnte nicht aktualisiert werden',
    changeLanguageError: 'Sprache konnte nicht geändert werden',
    copiedToClipboard: 'In die Zwischenablage kopiert',
    week: 'Woche',
    month: 'Monat',
    day: 'Tag',
    quarter: 'Quartal',
    selected: 'Ausgewählt',
    noResults: 'Keine Ergebnisse gefunden',
    select: 'Auswählen...',
    selectOrganization: 'Organisation auswählen',
    selectLanguage: 'Sprache auswählen',
    searchOrSelect: 'Suchen oder auswählen',
    noData: 'Keine Daten',
    count: 'Anzahl',
    showing: 'Anzeige',
    of: 'von',
  },
  nav: {
    dashboard: 'Dashboard',
    fleet: 'Fahrzeugflotte',
    liveTracking: 'Echtzeitkarte',
    reports: 'Berichte',
    statistics: 'Statistiken',
    vehicles: 'Fahrzeuge',
    profile: 'Profil',
    administration: 'Administration',
    sysAdmin: 'SysAdmin',
    crm: 'CRM',
    logout: 'Abmelden',
    organization: 'Organisation',
  },
  auth: {
    login: 'Anmelden',
    signup: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    rememberMe: 'An mich erinnern',
    loginSuccess: 'Anmelden erfolgreich',
    loginError: 'Anmeldung fehlgeschlagen',
    logout: 'Abmelden',
    otpTitle: 'Verifizierungscode',
    otpDescription: 'Wir haben einen Bestätigungscode gesendet an',
    otpSent: 'Verifizierungscode gesendet',
    otpVerified: 'Verifizierung erfolgreich',
    otpResent: 'Neuer Bestätigungscode gesendet',
    invalidOtp: 'Ungültiger Bestätigungscode',
    resend: 'Erneut senden',
    samlRequired: 'SAML-Authentifizierung ist für diese Organisation erforderlich',
    authMethodChanged: 'Authentifizierungsmethode wurde geändert',
    ssoRedirect: 'Weiterleitung zur Anmeldung mit Firmenidentität...',
    ssoCompleting: 'Anmeldung...',
    ssoCompleteError: 'Anmeldung konnte nicht abgeschlossen werden. Versuchen Sie es erneut.',
    checkingSso: 'Anmeldemethode wird überprüft...',
    ssoContinue: 'Weiter zu {org}',
    ssoDomainSignupBlocked: 'Ihre Organisation verwendet die Anmeldung über SSO. Erstellen Sie kein Konto – melden Sie sich mit Ihrem Organisations-Login an.',
    useSsoInstead: 'Anmelden mit SSO',
    ssoLogin: 'Single Sign-On',
    chooseLoginMethod: 'Anmeldemethode wählen',
    loginWith: 'Anmelden mit',
    loginWithSaml: 'Mit SAML anmelden',
    loginWithPassword: 'Mit Passwort anmelden',
    backToLogin: 'Zurück zur Anmeldung',
    noOrganizationId: 'Keine Organisation angegeben',
    samlError: 'SAML-Authentifizierung fehlgeschlagen',
    samlErrorTitle: 'Anmeldung fehlgeschlagen',
    retryLogin: 'Erneut versuchen',
    backToLanding: 'Zurück zur Startseite',
    goToLogin: 'Zur Anmeldung gehen',
    contactSupport: 'Wenn das Problem weiterhin besteht, wenden Sie sich an den Support.',
  },
  resetPassword: {
    title: 'Passwort zurücksetzen',
    description: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
    emailSentTitle: 'E-Mail gesendet',
    emailSentMessage: 'Wenn ein Benutzer mit dieser E-Mail-Adresse existiert, wird eine E-Mail zum Zurücksetzen gesendet. Überprüfen Sie Ihren Posteingang und befolgen Sie die Anweisungen zum Zurücksetzen Ihres Passworts.',
    newPasswordLabel: 'Neues Passwort',
    newPasswordPlaceholder: 'Neues Passwort eingeben',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Neues Passwort bestätigen',
    sendButton: 'Link zum Zurücksetzen senden',
    resetButton: 'Passwort zurücksetzen',
    sending: 'Senden...',
    resetting: 'Zurücksetzen...',
    backToLogin: 'Zurück zur Anmeldung',
    rememberPassword: 'Kennwort vergessen?',
  },
  admin: {
    title: 'Administration',
    roles: 'Rollenverwaltung',
    organizations: 'Organisationsverwaltung',
    users: 'Benutzerverwaltung',
    deleteUserConfirm: 'Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten?',
    hardDeleteUserConfirm: 'Dadurch wird {{name}} ({{email}}) vollständig aus dem System entfernt, sodass SSO neu erstellt werden kann das Konto. Kann nicht rückgängig gemacht werden.',
    translations: 'Übersetzungen',
    imports: 'Importgenerator',
    packages: 'Preispaket',
    sysAdmin: 'Systemadministrator',
    devices: 'Geräte',
    deviceManagement: 'Geräteverwaltung',
  },
  packages: {
    title: 'Preispaket',
    description: 'Preispakete für Systeme und Module verwalten',
    createNew: 'Neues Paket erstellen',
    noPackages: 'Keine Pakete erstellt',
    priceMonthly: 'Preis pro Monat',
    priceYearly: 'Preis pro Jahr',
    includedModules: 'Enthaltene Module',
    maxUsers: 'Max. Benutzer',
    maxVehicles: 'Max. Fahrzeug',
    features: 'Zusatzfunktionen',
    isDefault: 'Standardpaket',
    selectPackage: 'Paket auswählen',
    currentPackage: 'Aktuelles Paket',
    totalMonthly: 'Monatliche Gesamtkosten',
    modulePrices: 'Modulpreise',
    modulePrice: 'Modulpreis',
    setDefaultPrice: 'Standardpreis eingeben',
    addon: 'Extras',
    demo: 'Demo',
    trial: 'Testzeitraum',
    included: 'Inklusive',
    startDemo: 'Start Demo',
    startTrial: 'Testzeitraum starten',
    upgrade: 'Upgrade',
    upgradeToFull: 'Upgrade auf volle Leistung',
    daysRemaining: 'verbleibende Tage',
    trialDays: 'Anzahl der Tage',
    trialPrice: 'Testpreis',
    addModule: 'Modul hinzufügen',
    removeModule: 'Modul entfernen',
    moduleAdded: 'Modul hinzugefügt',
    moduleRemoved: 'Modul entfernt',
    demoStarted: 'Demo gestartet (30 Tage)',
    trialStarted: 'Testzeitraum begonnen',
    upgraded: 'Upgrade auf Vollabonnement',
    syncFromPackage: 'Aus Paket synchronisieren',
    modulesSynced: 'Module synchronisiert',
    packages: 'Preispaket',
    modules: 'Module',
    pricePerMonth: 'Preis/Monat',
    pricePerYear: 'Preis/Jahr',
    modulePricesDescription: 'Standardpreis für jedes Modul eingeben. Diese Preise werden als Zusatzmodule verwendet, wenn Kunden ihrem Paket Module hinzufügen möchten.',
    packagesCount: 'Paket',
    newPackage: 'Neues Paket',
    systemsWithoutPackages: 'System ohne Paket',
    modulesWithoutPackages: 'Module ohne Paket',
    noModulesFound: 'Keine Module gefunden',
    noSystemsFound: 'Keine Systeme gefunden',
    noModulesForSystem: 'Keine Module für dieses System verfügbar',
    noPacketsSelected: 'Keine Pakete ausgewählt',
    addPacketsInSectionAbove: 'Fügen Sie Pakete im Abschnitt „Preispaket“ oben hinzu, um verfügbare Module anzuzeigen.',
    systemsActive: 'System aktiv',
    enableModule: 'Modul aktivieren',
    disableModule: 'Modul deaktivieren',
    enableAction: 'Aktivieren',
    disableAction: 'Deaktivieren',
    noActionsForModule: 'Keine Funktionen für Modul verfügbar',
    moduleEnabledForCustomer: 'Modul für Kunden aktiviert',
    moduleDisabledForCustomer: 'Modul deaktiviert für Kunde',
    moduleToggleError: 'Modul konnte nicht geändert werden',
    moduleActionsLoadError: 'Modulfunktionen konnten nicht gelesen werden',
    moduleActionEnabled: 'Funktion aktiviert',
    moduleActionDisabled: 'Funktion deaktiviert',
    moduleActionToggleError: 'Funktion konnte nicht geändert werden',
    defaultPackage: 'Standardpaket für Neukunden',
    extraFeatures: 'Extrafunktionen (eine pro Zeile)',
    internalName: 'Interner Name',
    displayName: 'Anzeigename',
    descriptionPlaceholder: 'Kurze Beschreibung des Pakets',
    codeExample: 'z.B. Standard',
    nameExample: 'zB. DequeStandard',
    unlimited: 'Unbegrenzt',
    editPrice: 'Preis bearbeiten',
    createPackage: 'Paket erstellen',
    editPackage: 'Paket bearbeiten',
    notSet: 'Nicht festgelegt',
    loadError: 'Paket konnte nicht geladen werden',
    saveError: 'Paket konnte nicht gespeichert werden',
    modulePriceSaved: 'Modulpreis gespeichert',
    modulePriceError: 'Modulpreis konnte nicht gespeichert werden',
    packageUpdated: 'Paket aktualisiert',
    packageCreated: 'Paket erstellt',
    packageActivatedAndSynced: 'Paket aktiviert und Module synchronisiert',
    activateError: 'Konnte nicht aktiviert werden Paket',
    addModuleError: 'Modul konnte nicht hinzugefügt werden',
    confirmRemoveModule: 'Modul vom Kunden entfernen?',
    removeModuleError: 'Modul konnte nicht entfernt werden',
    upgradeError: 'Upgrade nicht möglich',
    noPackagesAvailable: 'Keine Preispakete verfügbar',
    selectModule: 'Modul auswählen',
    fullFunctionFullPrice: 'Volle Funktion, voller Preis',
    demoDescription: '30 Tage, begrenzt',
    trialDescription: 'Volle Funktion, jederzeit',
    standard: 'Standard',
    free: 'Kostenlos',
    perMonth: 'pro Monat',
  },
  imports: {
    title: 'Importgenerator',
    description: 'Datenimporte erstellen und verwalten',
    createNew: 'Neuen Import erstellen',
    noImports: 'Noch keine Importe erstellt',
    name: 'Importname',
    targetTable: 'Zieltabelle',
    schedule: 'Zeitplan',
    lastRun: 'Letzte Ausführung',
    status: 'Status',
    actions: 'Aktionen',
    run: 'Import ausführen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    fileLoaded: 'Datei geladen',
    missingFields: 'Alle erforderlichen Felder ausfüllen',
    saved: 'Import gespeichert',
    deleted: 'Import gelöscht',
    loadError: 'Importe konnten nicht geladen werden',
    confirmDelete: 'Sind Sie sicher, dass Sie diesen Import löschen möchten?',
    step1: 'Grundeinstellungen',
    step2: 'Datei hochladen',
    step3: 'Felder zuordnen',
    step4: 'Einstellungen',
    sourceFields: 'Quellfelder',
    targetFields: 'Zielfelder',
    fieldsMapped: 'zugeordnete Felder',
    decimalSeparator: 'Dezimaltrennzeichen',
    csvDelimiter: 'CSV-Trennzeichen',
    hasHeader: 'Erste Zeile ist Kopfzeile',
    duplicateAction: 'Bei Duplikaten',
    skipDuplicate: 'Überspringen (vorhanden bleiben)',
    updateDuplicate: 'Vorhandenes aktualisieren',
    errorAction: 'Bei Fehler',
    skipErrors: 'Fehlerhafte Zeilen überspringen',
    abortOnError: 'Gesamten Import abbrechen',
    loadForEditError: 'Import konnte nicht zur Bearbeitung geladen werden',
    importSource: 'Importquelle',
    importSourceNone: 'Keine Quelle',
    selectedSource: 'Ausgewählte Quelle',
    lastFetchAt: 'Letzter Download',
    lastFetchStatus: 'Gesundheitsstatus',
    filesInSource: 'Dateien in der Quelle',
    notFetchedYet: 'Nie',
    sourceHealthSuccess: 'Erfolg',
    sourceHealthFailed: 'Fehlgeschlagen',
    sourceHealthUnknown: 'Unbekannt',
    sourcesStatusTitle: 'Quellenstatus',
    sourceSyncError: 'Synchronisierungsfehler',
    sourcePreviewLoading: 'Letzte Datei aus Quelle laden...',
    sourcePreviewLoaded: 'Vorlagendatei aus Quelle geladen',
    sourcePreviewNotFound: 'Keine Synchronisierungsdatei für ausgewählte Quelle gefunden',
    sourcePreviewLoadError: 'Vorlagendatei konnte nicht aus Quelle geladen werden',
    sourcePreviewReload: 'Neues Laden aus Quelle',
    livePreviewNeedsSample: 'Keine Vorlagendatei geladen – gehen Sie zurück zu Schritt 2 und laden Sie die Datei erneut von der Quelle zur Vorschau.',
    runLatestSource: 'Ausführung von der neuesten Quelldatei erzwingen',
    autoMappedFields: 'Felder wurden automatisch zugeordnet',
    importHistoryTitle: 'Importverlauf',
    allDefinitions: 'Alle Definitionen',
    historyUpdateBtn: 'Aktualisieren',
    historyLoadingText: 'Ladeverlauf…',
    noRunsFound: 'Keine Läufe gefunden',
    showDetails: 'Details anzeigen',
    loadRunError: 'Lauf konnte nicht geladen werden',
    runDetailsTitle: 'Laufdetails',
    runDetailsStatus: 'Status',
    runDetailsStarted: 'Gestartet',
    runDetailsEnded: 'Ende',
    runDetailsFile: 'Datei',
    runDetailsRows: 'Linien',
    runDetailsErrors: 'Fehler',
    runDetailsAndMore: 'und {n} mehr',
    importingFile: 'Importieren...',
    importThisFile: 'Diese Datei importieren',
    noFilesForSource: 'Für diese Quelle wurden keine Dateien gefunden. Synchronisieren Sie zuerst die Quelle.',
    loadingFiles: 'Dateien werden geladen...',
    filesFromSourceTitle: 'Dateien aus der Quelle',
    ftpImportTitle: 'FTP-Import',
    ftpPathLabel: 'Pfad',
    ftpListBtn: 'Liste',
    ftpLoadingText: 'Laden...',
    ftpNoFiles: 'Keine Dateien gefunden.',
    ftpOpen: 'Offen',
    ftpRunImport: 'Import ausführen',
    importingProgress: 'Importieren…',
    rowsSuffix: 'Zeilen',
    colsSuffix: 'Spalte',
    createFirstImport: 'Erstellen Sie Ihren ersten Import',
    importUpdated: 'Import aktualisiert',
    statusSuccess: 'Erfolg',
    statusFailed: 'Fehlgeschlagen',
    statusPartial: 'Teilweise',
    statusRunning: 'Wird ausgeführt',
    statusQueued: 'In der Warteschlange',
    statusCancelled: 'Abgebrochen',
    statusAll: 'Alle',
    colDefinition: 'Definition',
    colFileSource: 'Datei/Quelle',
    colStarted: 'Gestartet',
    colRows: 'Linien',
    colErrors: 'Fehler',
    colAction: 'Aktion',
    showingRuns: 'Anzeige {shown} von {total} Läufe',
    noTransformsAdded: 'Keine Transformationen hinzugefügt.',
    addTransform: 'Transformation hinzufügen',
    sourceLabel: 'Quelle',
    typeLabel: 'Typ',
    paramsLabel: 'Parameter (JSON)',
    moveUp: 'Nach oben verschieben',
    moveDown: 'Nach unten verschieben',
    remove: 'Entfernen',
    livePreview: 'Zu speichernder Wert',
    runDetailsDuplicates: 'Duplikate (übersprungen)',
    downloadFailedRows: 'Fehlerhafte Zeilen herunterladen (CSV)',
    downloadDuplicateRows: 'Duplikate herunterladen (CSV)',
    artifactDownloadError: 'Fehlgeschlagen Datei herunterladen',
    identifiedColumns: 'Identifizierte Spalten:',
    changeFile: 'Datei ändern',
    supportedFormats: 'Unterstützte Formate: Excel, CSV, JSON, XML, TXT, DAT',
    schemaMappingError: 'Schemavalidierung: Zuordnungsfehler',
    sourcePanelTitle: 'Quellfeld (aus Datei)',
    targetPanelTitle: 'Zielfelder',
    examplePrefix: 'Ex',
    fieldsMappedCount: '{n}felder zugeordnet',
    addMappingInStep3: 'Fügen Sie in Schritt 3 mindestens eine Feldzuordnung hinzu, um Transformationen zu konfigurieren.',
    scheduleLabel: 'Planung',
    scheduleExecution: 'Ausführung',
    scheduleManual: 'Nur manuell',
    scheduleDaily: 'Täglich',
    scheduleWeekly: 'Wöchentlich',
    scheduleMonthly: 'Monatlich',
    scheduleTimeLabel: 'Zeit (HH:mm)',
    scheduleDayOfWeek: 'Wochentag (0=Sonntag … 6=Samstag)',
    scheduleDayOfMonth: 'Tag des Monats (1-31)',
    scheduleCronLabel: 'Cron (optional, z. B. 0 6 * * *)',
    fileSourcePathLabel: 'Dateiquelle (Pfad oder Glob, z. B. /var/imports/fuel_*.dat)',
    stableFileTitle: 'Auf stabile Datei warten',
    stableCheckInterval: 'Intervall prüfen (ms)',
    stableStableFor: 'Stabil in (ms)',
    stableTimeout: 'Timeout (ms, 0 = unbegrenzt)',
    retryTitle: 'Wiederholen bei Fehler',
    retryMaxRetries: 'Max. Versuche',
    retryInitialDelay: 'Erste Wartezeit (ms)',
    retryMaxDelay: 'Max. Wartezeit (ms)',
    retryBackoff: 'Backoff-Multiplikator',
    summaryTitle: 'Zusammenfassung',
    summaryName: 'Name',
    summaryTargetTable: 'Zieltabelle',
    summaryMappedFields: 'Zugeordnete Felder',
    summaryFileFormat: 'Dateiformat',
    summarySchedule: 'Planung',
    invalidJsonTransform: 'Ungültiges JSON in Transformationsparametern',
    duplicateActionLabel: 'Bei Duplikaten',
    updateExisting: 'Vorhandenes aktualisieren',
    errorActionLabel: 'Bei Fehler',
    skipErroneousRows: 'Fehlerhafte Zeilen überspringen',
    abortEntireImport: 'Gesamten Import abbrechen',
    wizardTitleCreate: 'Neuen Import erstellen',
    wizardTitleEdit: 'Import bearbeiten',
    wizardStepBasicInfo: 'Grundlegende Informationen',
    wizardStepLoadFile: 'Datei laden',
    wizardStepMapFields: 'Felder zuordnen',
    wizardStepTransforms: 'Transformationen',
    wizardStepSettings: 'Einstellungen',
    wizardCancel: 'Abbrechen',
    wizardBack: 'Zurück',
    wizardNext: 'Weiter',
    wizardSave: 'Import speichern',
    descriptionPlaceholder: 'Optionale Beschreibung...',
    presetsLabel: 'Voreinstellungen (optional)',
    clearPreset: 'Voreinstellung löschen',
    targetTableLabel: 'Zieltabelle *',
    importNameLabel: 'Importname *',
    descriptionLabel: 'Beschreibung',
    step1Title: 'Schritt 1: Grundeinstellungen',
    step2Title: 'Schritt 2: Vorlagendatei hochladen',
    step3Title: 'Schritt 3: Felder zuordnen',
    step4Title: 'Schritt 4: Transformationen pro Feld',
    step5Title: 'Schritt 5: Einstellungen importieren',
    filenameFilterTitle: 'Dateiname Filter',
    filenameFilterHint: 'Welche Dateien aus der Quelle dieser Import übernehmen soll. Globus: *K02*, *K05*. Regex (beginnt mit ^): ^\\d = Der Dateiname muss mit einer Zahl beginnen (schwedisch OKQ8). Leer = alle Dateien.',
    filenameFilterAdd: 'Muster hinzufügen',
    decimalSeparatorLabel: 'Dezimaltrennzeichen',
    decimalComma: 'Komma (1.234,56)',
    decimalDot: 'Punkt (1.234,56)',
    csvSeparatorLabel: 'CSV-Trennzeichen',
    csvSemicolon: 'Semikolon (;)',
    csvComma: 'Komma (,)',
    csvTab: 'Tabulator',
    csvPipe: 'Pipe (|)',
    excelSheetNameLabel: 'Excel Blattname (optional)',
    excelSheetNamePlaceholder: 'Z.B. Blatt1',
    excelSheetIndexLabel: 'Excel Blattindex (0-basiert)',
    excelSheetIndexHint: 'Wenn der Blattname angegeben ist, wird er vor dem Blattindex verwendet.',
    headerCellsTitle: 'Rechnungskopf über der Tabelle',
    headerCellsHint: 'Klicken Sie auf eine Zelle in den Zeilen über der Kopfzeile, um sie einem Zielfeld zuzuordnen. Der Wert wird zu jeder importierten Zeile hinzugefügt.',
    headerCellsClickToMap: 'Klicken Sie zum Zuordnen',
    headerCellsRemove: 'Entfernen',
    headerCellsEditorTitle: 'Zelle zuordnen',
    headerCellsEmpty: '(leere Zelle)',
    headerCellsAsColumn: 'Virtueller Spaltenname',
    headerCellsTargetField: 'Zielfelder',
    headerCellsNoTarget: ' – Kein Zielfeld –',
    headerCellsUseSplit: 'Zellwert aufteilen (z. B. Kundennummer + Name)',
    headerCellsSplitPattern: 'Regex-Muster',
    headerCellsSplitHint: 'Standard: erste Zahlen → Teil 1, Rest → Teil 2 (wie Qstar B3).',
    headerCellsPart1Column: 'Teil 1 (Gruppe 1)',
    headerCellsPart2Column: 'Teil 2 (Gruppe 2)',
    headerCellsReloadHint: 'Zeilen überspringen ist eingestellt, aber der Rechnungskopf fehlt in der Vorschau. Laden Sie die Datei/Quelle neu, damit die Zeilen über der Tabelle zugeordnet werden können.',
    runPendingSource: 'Alle ausstehenden importieren',
    runPendingSourceTitle: 'Alle noch nicht importierten Quelldateien importieren',
    pendingImportDone: 'Ausstehender Import abgeschlossen',
    pendingImportFailed: 'Ausstehende Quelldateien konnten nicht importiert werden',
    pendingImportRunning: 'Ausstehende Dateien werden importiert…',
    pageTitle: 'Importgenerator',
    pageDescription: 'Datenimporte ohne Codierung erstellen und verwalten',
    colName: 'Name',
    colDate: 'Datum',
    colSize: 'Größe',
    colTargetTable: 'Zieltabelle',
    colSchedule: 'Zeitplan',
    colLastRun: 'Letzte Ausführung',
    testImportTitle: 'Testimport ({n} Zeilen)',
    loadingHistory: 'Verlauf wird geladen...',
    cannotSave: 'Speichern nicht möglich',
    importComplete: 'Importieren abgeschlossen: {imported} importiert, {updated} aktualisiert, {failed} fehlgeschlagen',
    testImportComplete: 'Testimport abgeschlossen: {processed} Zeilen getestet, {failed} fehlgeschlagen (keine Daten gespeichert)',
    loadSourceFilesError: 'Dateien aus der Quelle konnten nicht geladen werden',
    loadHistoryError: 'Ausführungsverlauf konnte nicht geladen werden',
    ftpListError: 'FTP-Dateien konnten nicht aufgelistet werden',
    ftpImportFailed: 'FTP-Import fehlgeschlagen',
    importFailed: 'Import fehlgeschlagen',
    latestSourceImportFailed: 'Import aus der letzten Quelldatei fehlgeschlagen',
  },
  sysadmin: {
    loadSlowQueriesError: 'Langsame Abfragen konnten nicht geladen werden',
    clearLogError: 'Protokoll konnte nicht gelöscht werden',
    loadErrorLogError: 'Fehlerprotokoll konnte nicht geladen werden',
    loadAuditLogError: 'Überwachungsprotokoll konnte nicht geladen werden',
  },
  tracking: {
    saveMapViewError: 'Karte konnte nicht gespeichert werden Ansicht',
  },
  support: {
    updateTicketError: 'Fall konnte nicht aktualisiert werden',
    sendReplyError: 'Antwort konnte nicht gesendet werden',
    sendBroadcastError: 'Broadcast konnte nicht gesendet werden',
    deleteBroadcastError: 'Broadcast konnte nicht gelöscht werden',
    closeTicketError: 'Fall konnte nicht geschlossen werden',
    sendMessageError: 'Nachricht konnte nicht gesendet werden',
  },
  deviceManagement: {
    title: 'Geräteverwaltung',
    devices: 'Geräte',
    device: 'Gerät',
    imei: 'IMEI',
    iccid: 'ICCID',
    status: 'Status',
    vehicle: 'Fahrzeuge',
    organization: 'Organisation',
    lastKnownVin: 'Neuer VIN',
    history: 'Verlauf',
    actions: 'Aktionen',
    details: 'Details',
    exportCsv: 'Export CSV',
    exportEmpty: 'Für den ausgewählten Filter konnte nichts exportiert werden',
    exportDone: 'Exportiert {{count}}Einheiten',
    statusStock: 'Lagerbestand',
    statusCustomer: 'Beim Kunden',
    statusVehicle: 'Im Fahrzeug',
    statusLost: 'Verloren',
    statusDecommissioned: 'Entsorgt',
    toStock: 'Auf Lager',
    unmountKeep: 'Demontieren (behält der Kunde)',
    unmountStock: 'Demontieren (auf Lager)',
    markLost: 'Verloren markieren',
    decommission: 'Verwerfen',
    assignOrganization: 'Organisation zuweisen',
    selectOrganization: 'Organisation auswählen',
    organizationFollowsVehicle: 'Folgt dem Fahrzeug Zuweisung',
    obdModeTitle: 'OBD II-Funktion',
    obdModeHint: 'Sendet Setparam über Gateway an das Gerät (in die Offline-Warteschlange gestellt). OBD = Pkw, ELD = schweres Fahrzeug (J1939/FMS), Nicht-OBD = EV/OEM (VIN automatisch/manuell, web_connect). Anti-Alarm = Nicht-OBD + Bewegungsstoppverzögerung 5 s + Zündmittelung aus + Beschleunigungsmesser-Zündung (ID.x/Diebstahlalarm). OBD-Disable = nur 40000:0 (OBD II-Funktion ausschalten).',
    obdModeAuto: 'OBD (automatisch)',
    obdModeEld: 'ELD – Schwere Fahrzeuge',
    obdModeNonObd: 'Nicht-OBD-konform + OEM',
    obdModeAntiAlarm: 'Anti-Alarm',
    obdModeDisable: 'OBD-Deaktivieren',
    obdModeConfirmTitle: 'OBD-Befehl senden',
    obdModeConfirmObdAuto: 'OBD (automatisch) auf {reg} aktivieren? Setparam 40000:1 wird gesendet. Wenn VIN am Fahrzeug steht, ist VIN Manuell (40005:1 + 40003) eingestellt, ansonsten VIN Auto (40005:0). Identisch mit P&P für Pkw/ICE.',
    obdModeConfirmEld: 'ELD (schweres Fahrzeug) auf {reg} aktivieren? Senden von setparam 40000:2 (J1939/FMS). Nur für LKW/Bus mit FMS verwenden – nicht für Pkw, Hybrid oder Elektrofahrzeuge.',
    obdModeConfirmNonObd: 'Nicht-OBD-konforme + OEM-Bereitstellung auf {reg} aktivieren? Warteschlange setparam 40000:3, VIN auto/manual und web_connect.',
    obdModeConfirmAntiAlarm: 'Anti-Alarm an {reg} senden? Stellt setparam 40000:3;19002:5;50005:0;101:2 in die Warteschlange und setzt das Gerät auf die Nicht-OBD-Liste.',
    obdModeConfirmDisable: 'OBD-Disable an {reg} senden? Senden Sie setparam 40000:0 und speichern Sie das Auto in der Problemliste, damit „Disable“ beim FW/CFG-Upgrade zurückgesetzt wird. Blockiert, wenn das Gerät bereits über ELD (40000:2) verfügt – es setzt Anzeigealarme zurück.',
    obdModeSuccess: 'OBD Befehl an Gerät gesendet',
    obdModePartialFail: 'Befehl gesendet, aber Gerät hat nicht auf alle Schritte reagiert (offline/Timeout?)',
    obdModeError: 'OBD-Befehl konnte nicht gesendet werden',
    obdDisableLastSent: 'Letzte Deaktivierung auf diesem Gerät: {when} ({status}) von {user}',
    obdDisableLogShow: 'Deaktivierungsprotokoll anzeigen (zuletzt gesendet)',
    obdDisableLogHide: 'Deaktivierungsprotokoll ausblenden',
    obdDisableLogEmpty: 'Keine Deaktivierungsversand protokolliert noch nicht.',
    obdDisableLogWhen: 'Wenn',
    obdDisableLogDevice: 'Gerät',
    obdDisableLogStatus: 'Status',
    obdDisableLogBy: 'Aus',
    obdBaselineTitle: 'OBD Plug & Play – Basislinie (FW + Konfiguration)',
    obdBaselineHelp: 'Geben Sie die genauen FOTA WEB-Dateinamen für FMM003 ein, bevor Sie P&P aktivieren. Die automatische Ausführung ist deaktiviert, bis OBD_PROVISIONING_ENABLED=true in .env.',
    obdBaselineRuntimeOn: 'P&P global EIN',
    obdBaselineRuntimeOff: 'P&P global AUS (abgesicherter Modus)',
    obdBaselineModels: 'Zulässige Modelle',
    obdBaselineAllProfiles: 'alle Profile',
    obdBaselineFw: 'Ziel-Firmware (FOTA-Dateiname)',
    obdBaselineCfg: 'Grundkonfiguration (FOTA-Dateiname)',
    obdBaselineNote: 'Hinweis',
    obdBaselineSaved: 'Baseline gespeichert',
    obdBaselineLoadError: 'Baselines konnten nicht heruntergeladen werden',
    obdBaselineSaveError: 'Baseline konnte nicht gespeichert werden',
    obdBaselineNeedFile: 'Mindest-Firmware oder Namen der Konfigurationsdatei eingeben',
    obdBaselineEmpty: 'Keine Basislinien. Führen Sie die Migration 345 aus oder erstellen Sie eine Zeile für FMM003.',
    obsTitle: 'HINWEIS-Liste',
    obsHint: 'Einheiten, die bei der Rückgabe auf dem Prüfstand getestet oder überprüft werden sollen.',
    obsOpenCount: '{count} offen',
    obsEmpty: 'Keine offenen OBS-Leitungen.',
    obsBadge: 'HINWEIS',
    obsAdd: 'Zur OBS-Liste hinzufügen',
    obsAddSelected: 'Ausgewähltes Gerät zur OBS-Liste hinzufügen',
    obsNotePlaceholder: 'Was soll getestet werden, wenn das Gerät zurückkommt?',
    obsDefaultNote: 'Sollte bei der Rückkehr auf dem Prüfstand getestet werden.',
    obsAdded: 'Zur OBS-Liste hinzugefügt',
    obsMarkDone: 'Getestet / erledigt',
    obsMarkedDone: 'OSP-Zeile als erledigt markiert',
    obsCancelled: 'OSP-Zeile abgebrochen',
    obsLoadError: 'OSP-Liste konnte nicht abgerufen werden',
    obsSaveError: 'OSP-Zeile konnte nicht gespeichert werden',
    importReturns: 'Retouren importieren',
    importTitle: 'Retoureneinheiten importieren',
    importDescription: 'IMEI-Nummern aus Excel einfügen (eine pro Zeile)',
    importSettings: 'Einstellungen',
    setToStock: 'Status auf LAGER setzen',
    disconnectVehicle: 'Vom Fahrzeug trennen',
    deactivateSim: 'SIM-Karte bei Jasper deaktivieren',
    validImeis: 'gültige IMEI-Nummern gefunden',
    importing: 'Importieren...',
    successful: 'Erfolgreich',
    failed: 'Fehlgeschlagen',
    manualRequired: 'Erfordert manuelle Bearbeitung',
    needsAttention: 'Aktion erforderlich',
    changeHistory: 'Änderungsverlauf',
    noHistory: 'Kein Verlauf',
    statusChanged: 'Status geändert',
    vehicleMounted: 'Im Fahrzeug montiert',
    vehicleUnmounted: 'Demontiert',
    vehicleTransferred: 'In ein anderes Fahrzeug verschoben',
    vinDetected: 'VIN erkannt',
    vehicleCreated: 'Fahrzeug erstellt',
    simActivated: 'SIM aktiviert',
    simSuspended: 'SIM deaktiviert',
    deviceCreated: 'Gerät erstellt',
    deviceImported: 'Einheit importiert',
    searchPlaceholder: 'Suche IMEI (ganz oder teilweise, z. B. die letzten 4), ICCID, Reg.-Nr...',
    allStatuses: 'Alle Status',
    total: 'Gesamt',
    selectAllAvailable: 'Alle verfügbaren markieren',
    selected: 'ausgewählt',
    deselectAll: 'Alle deaktivieren',
    importImeiToOrg: 'Importieren IMEI → Organisation',
    devicesAssigned: 'Geräte zugewiesen',
    deviceDetails: 'Gerätedetails',
    noDevices: 'Keine Geräte gefunden',
    selectDevice: 'Wählen Sie ein Gerät aus, um Details anzuzeigen',
    confirmDecommission: 'Sind Sie sicher? Dies kann nicht rückgängig gemacht werden.',
  },
  deviceAvlCapabilities: {
    title: 'AVL-Funktionen pro Einheit',
    description: 'Welche AVL-Parameter (ID + Name) jede Einheit/jedes Fahrzeug bereitstellt. Eine Zeile pro IMEI+VIN. Klicken Sie auf IMEI, um den Namen und die Beschreibung anzuzeigen.',
    filterImei: 'Filtern nach IMEI',
    filterRegNumber: 'Filtern nach Regnr',
    filterAvlId: 'AVL-ID (z. B. 13)',
    imei: 'IMEI',
    vin: 'VIN',
    regNumber: 'Regnr',
    avlParameters: 'AVL-Parameter',
    firstSeen: 'Erstes Mal',
    lastSeen: 'Letztes Mal',
    noData: 'Noch keine Daten. Daten werden erfasst, wenn Geräte GPS Punkte senden.',
    modalTitle: 'Geräte-AVL-Parameter',
    parameterCountOne: 'Parameter',
    parameterCount: 'Parameter',
  },
  roles: {
    title: 'Rollenverwaltung',
    createRole: 'Neue Rolle erstellen',
    editRole: 'Rolle bearbeiten',
    viewRights: 'Rechte anzeigen',
    roleName: 'Name',
    roleCode: 'Code',
    roleDescription: 'Beschreibung',
    roleAdministrator: 'Rollenadministrator',
    roleAdministratorHelp: 'Fleetmanager kann Benutzer innerhalb seiner eigenen Organisation ändern, um Berechtigungen zu steuern. Aktivieren Sie das Kontrollkästchen, wenn dies auch einer anderen Rolle möglich sein soll.',
    permissions: 'Rechte',
    systemRole: 'Systemrolle',
    customRole: 'Benutzerdefinierte Rolle',
    allActions: 'Alle Aktionen',
    codePlaceholder: 'z.B. CUSTOM_ROLE',
    namePlaceholder: 'zB. Benutzerdefinierte Rolle',
    descriptionPlaceholder: 'Beschreibung der Rolle...',
    codeCannotChange: 'Code kann nicht geändert werden',
    rightsAndAccess: 'Rechte und Zugriffe',
    loadingFeatures: 'Funktionen werden geladen...',
    noActionsAvailable: 'Keine Aktionen verfügbar',
    noAccessToFeature: 'Kein Zugriff auf diese Funktion',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle deaktivieren',
    createRoleButton: 'Rolle erstellen',
    updateRoleButton: 'Änderungen speichern',
    roleCreated: 'Rolle erstellt!',
    roleUpdated: 'Rolle aktualisiert!',
    createRoleError: 'Der Kunde konnte nicht erstellen Rolle',
    updateRoleError: 'Rolle konnte nicht aktualisiert werden',
    loadRoleError: 'Rolle konnte nicht geladen werden',
    systemRoleOnlyGlobalAdmin: 'Systemrollen können nur vom globalen Administrator geändert werden.',
    codeAndNameRequired: 'Code und Name sind obligatorisch',
    loadDataError: 'Daten konnten nicht geladen werden',
    systemRoleNote: ' (Systemrolle)',
    summary: 'Zusammenfassung',
    permissionsCount: 'Berechtigungen',
    noPermissionsSelected: 'Keine Berechtigungen ausgewählt',
    actions: 'Aktionen',
    systemRoles: 'Systemrollen',
    customerRoles: 'Kundenspezifische Rollen',
    visibleToAll: 'Für alle Kunden sichtbar',
    visibleToOrganization: 'Sichtbar für die Organisation und darunterliegend',
    showInactive: 'Inaktive Rollen anzeigen',
    createAsSystemRole: 'Als Systemrolle erstellen',
    customerRoleHint: 'Die Rolle wird für Ihre Organisation und die zugrunde liegende Rolle erstellt',
    systemTemplatesHint: 'Auf neue Kunden kopierte Vorlagen',
    templateStartingPoint: 'Startpunkt (Vorlage)',
    selectTemplate: 'Vorlage auswählen...',
    templateRequired: 'Systemvorlage als Ausgangspunkt auswählen',
    templateHint: 'Systemvorlage auswählen. Anschließend können Sie Module und Funktionen innerhalb Ihrer zugewiesenen Dienste anpassen.',
    loadTemplateError: 'Vorlagenberechtigungen konnten nicht geladen werden',
    permissionCeilingExceeded: 'Berechtigung überschreitet die vom Kunden zugewiesenen Dienste',
    roleActivated: 'Rolle aktiviert!',
    roleDeactivated: 'Rolle deaktiviert!',
    toggleError: 'Rollenstatus konnte nicht geändert werden',
    noRolesFound: 'Keine Rollen gefunden',
    menu: 'Menü',
  },
  organizations: {
    title: 'Organisationsverwaltung',
    chart: 'Organigramm',
    chartDescription: 'Organisationshierarchie grafisch anzeigen und bearbeiten',
    managementDescription: 'Organisationen erstellen und verwalten',
    searchPlaceholder: 'Organisation suchen...',
    selectOrganization: 'Organisation auswählen',
    createTopNode: 'Oberen Knoten erstellen',
    createSubOrganization: 'Kunde erstellen',
    organizationName: 'Name',
    description: 'Beschreibung',
    parentOrganization: 'Übergeordnete Organisation',
    topNode: 'Oberer Knoten',
    customerTopNode: 'Kunde oben Knoten',
    isTopNode: 'Oberer Knoten',
    isTopNodeHint: 'Der oberste Knoten des Kunden kann unter einem Partner (z. B. Dialekt) liegen und eigene Einstellungen haben. Zum Aktivieren ankreuzen und speichern.',
    authSettings: 'Authentifizierungseinstellungen',
    noOrganizations: 'Noch keine Organisationen. Erstellen Sie zunächst einen obersten Knoten.',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Organisation und alle ihre Unterorganisationen löschen möchten? Wenn keine Fahrzeuge verbunden sind, wird der Knoten dauerhaft entfernt, andernfalls wird er deaktiviert (vorläufiges Löschen).',
    editOrganization: 'Organisation bearbeiten',
    addSub: 'Kunde hinzufügen',
    deleteOrganization: 'Entfernen',
    createButton: 'Erstellen',
    updateButton: 'Aktualisieren',
    customerLogo: 'Kundenlogo',
    uploadLogo: 'Logo hochladen',
    removeLogo: 'Logo entfernen',
    logoUploadSuccess: 'Logo hochgeladen',
    logoDeleteSuccess: 'Logo entfernt',
    organizationCreated: 'Organisation erstellt!',
    organizationUpdated: 'Organisation aktualisiert!',
    organizationDeleted: 'Organisation entfernt!',
    organizationDeletedHard: 'Organisation endgültig entfernt!',
    organizationDeletedSoft: 'Organisation deaktiviert (vorläufiges Löschen), da verknüpfte Fahrzeuge vorhanden sind.',
    createError: 'Die Organisation konnte nicht erstellt werden',
    updateError: 'Die Organisation konnte nicht aktualisiert werden',
    deleteError: 'Die Organisation konnte nicht entfernt werden',
    loadHierarchyError: 'Die Hierarchie konnte nicht geladen werden',
    loadChildrenError: 'Unterorganisationen konnten nicht geladen werden',
    nameRequired: 'Name ist Pflicht',
    namePlaceholder: 'Name der Organisation',
    descriptionPlaceholder: 'Beschreibung...',
    noParent: 'Keine (als obersten Knoten erstellen)',
    status: 'Status',
    active: 'Aktiv',
    suspended: 'Unterbrochen',
    inactive: 'Inaktiv',
    loginParameters: 'Anmeldeparameter',
    authMethod: 'Authentifizierungsmethode',
    authMethodAppliesToUsers: 'Wenn dies gespeichert wird, erhalten alle Benutzer im Kunden die gleiche Anmeldemethode.',
    passwordAuth: 'Passwort',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    samlAuth: 'SAML2',
    oidcAuth: 'OpenID Connect (z. B. Entra ID)',
    allowedDomains: 'Zulässige Domänen',
    allowedDomainsPlaceholder: 'z. B. acme.com, intranet.acme.com',
    allowedDomainsHint: 'Mehrere Domänen durch Komma trennen',
    portalHostname: 'Portaladresse',
    portalHostnamePlaceholder: 'kund.deque.se',
    portalHostnameHint: 'https://kund.deque.se überspringt das Passwortfeld und geht direkt zum SSO des Kunden. Die App bleibt unter app.deque.se. Beim Speichern der Adresse wird bei Loopia ein A-Eintrag erstellt.',
    portalHostnameReadOnly: 'Die Adresse wird durch Deque festgelegt. Geben Sie die Absenderadresse unten in Ihrem IdP ein.',
    portalIdpNotice: 'Der Kunde trägt die OIDC-Rücksendeadresse selbst in seinem IdP (zum Beispiel Entra) ein und behält die bereits vorhandenen Adressen. Vorhandenes SSO-Zertifikat ist ausreichend.',
    portalOidcCallbackLabel: 'Vom Kunden hinzugefügte OIDC-Rücksendeadresse',
    portalOidcCallbackPending: 'Wenn die Organisation gespeichert wird, wird die Adresse zu https://{{host}}/api/auth/oidc/{id}/callback',
    organizationIdentifier: 'Organisationskennung',
    organizationIdentifierPlaceholder: 'z. B. acme',
    organizationIdentifierHint: 'Wird zur Identifizierung über den Abfrageparameter (?org=) verwendet',
    additionalInfo: 'Zusätzliche Informationen',
    address: 'Adresse',
    addressPlaceholder: 'z.B. Storgatan 1',
    postNr: 'Postleitzahl',
    postNrPlaceholder: 'z.B. 12345',
    town: 'Stadt',
    townPlaceholder: 'zB. Stockholm',
    orgNr: 'Organisationsnummer',
    orgNrPlaceholder: 'z. B. 556123-4567',
    contact: 'Ansprechpartner',
    contactPlaceholder: 'z. B. Anna Andersson',
    contacttel: 'Kontakttelefon',
    contacttelPlaceholder: 'z.B. 08-123456',
    email: 'E-Mail',
    emailPlaceholder: 'zB. info@example.com',
    carRental: 'Vermietungsunternehmen',
    isBookingPool: 'Buchungspool',
    isBookingPoolHint: 'Fahrzeuge mit geteiltem Firmenwagen und aktive Ressourcen der Gruppe erscheinen im Pool. Fahrzeuge mit Fahrer oder manuell abgewählt bleiben draußen.',
    costNo: 'Kostennummer',
    costNoPlaceholder: 'zB. KST-123',
    move: 'Verschieben',
    moveOrganization: 'Organisation verschieben',
    moveOrganizationDescription: 'Verschieben Sie die Organisation und alle ihre Unterorganisationen in eine neue übergeordnete Organisation. Alle Einstellungen bleiben erhalten.',
    newParent: 'Neue übergeordnete Organisation',
    selectParent: 'Übergeordnete Organisation auswählen',
    moveButton: 'Verschieben',
    organizationMoved: 'Organisation verschoben!',
    moveError: 'Organisation konnte nicht verschoben werden',
    loadDataError: 'Daten konnten nicht geladen werden',
    loadError: 'Organisationen konnten nicht geladen werden',
    importError: 'Datei konnte nicht importiert werden',
    importModalTitle: 'Organisationen importieren',
    importModalSubtitle: 'Unter',
    importDropzone: 'Eine Excel-Datei (.xlsx) hierher ziehen und ablegen, oder Klicken Sie, um die Datei auszuwählen',
    importStart: 'Importieren',
    importNoFile: 'Bitte wählen Sie vor dem Import eine Datei aus',
    importFileError: 'Die Datei konnte nicht gelesen werden. Stellen Sie sicher, dass es sich um eine gültige Excel-Datei',
    importFileSelected: 'Ausgewählte Datei',
    importPreviewTitle: 'Vorschau',
    importPreviewCount: 'zu importierende Zeilen',
    importPreviewScrollHint: 'Zeigt bis zu 20 Zeilen gleichzeitig an – scrollen Sie, um mehr zu sehen',
    importColumnName: 'Name',
    importColumnParent: 'Übergeordnete Organisation',
    importColumnContact: 'Ansprechpartner',
    importColumnPhone: 'Telefon',
    importColumnEmail: 'E-Mail',
    importColumnCostNo: 'Kostennummer',
    importCreated: 'erstellte Organisationen',
    importErrors: 'Fehler',
    importRowError: 'Zeile',
    importOrganizations: 'Organisationen importieren',
    importOrganizationsTooltip: 'Importieren Unterorganisationen aus Excel',
    downloadTemplate: 'Importvorlage herunterladen',
    downloadTemplateTooltip: 'ExcelOrganisationsimportvorlage herunterladen',
    fuelCompanies: {
      tabTitle: 'Kraftstoffunternehmen',
    },
    fuelAccounts: {
      loadError: 'Kraftstoffkonten konnten nicht geladen werden',
      saveError: 'Kraftstoffkonten konnten nicht gespeichert werden',
      saved: 'Gespeichert',
      savedWithLinks: 'Gespeichert. {{count}}Kraftstofftransaktionen wurden mit der Organisation verknüpft.',
      fillAll: 'Kraftstoffunternehmen auswählen und Kundennummer eingeben',
      alreadyAdded: 'Dieses Kraftstoffunternehmen existiert bereits',
      empty: 'Keine Kraftstoffkonten verknüpft. Fügen Sie unten Kraftstoffunternehmen und Kundennummer hinzu.',
      fuelCompany: 'Kraftstoffunternehmen',
      selectCompany: 'Kraftstoffunternehmen auswählen',
      customerNumber: 'Kundennummer',
      customerNumberPlaceholder: 'z.B. 12345',
      add: 'Hinzufügen',
    },
    contactRoles: {
      title: 'Verantwortliche/Kontaktrollen',
      noAssignment: 'Keine zugewiesen',
      addCustomRole: 'Eigene Rolle hinzufügen',
      codeRequired: 'Code erforderlich',
      codePlaceholder: 'z. B. regional_manager',
      roleName: 'Rollenname',
      description: 'Beschreibung',
      createRole: 'Rolle erstellen',
      roleCreated: 'Rolle erstellt',
      roleDeleted: 'Rolle entfernt',
      confirmDeleteRole: 'Diese Rolle entfernen?',
      attestationResponsible: 'Zertifikatsmanager',
      manager: 'Manager',
      localVehicleResponsible: 'Lokaler Fahrzeugmanager',
      fleetManager: 'Flottenmanager',
      maintenanceResponsible: 'Wartungsmanager',
      servicePersonnel: 'Servicepersonal',
    },
    bookingSettings: 'Buchungseinstellungen',
    drivingLog: {
      tabTitle: 'Fahrprotokolleinstellungen',
      title: 'Fahrprotokoll',
      intro: 'Gilt für Fahrzeuge dieser Organisation und der Organisationen darunter. Eine Untergruppe mit eigenen Einstellungen übernimmt ihre Fahrzeuge. Bei einer Fahrzeug-Nutzer-Verbindung gelten die Servicezeiten, sofern nicht manuell etwas anderes angegeben ist.',
      ownSettings: 'Eigene Fahrprotokolleinstellungen',
      ownSettingsHelp: 'Speichert Werte für diese Organisation. Sie gelten für Fahrzeuge, die hier oder in Organisationen darunter verknüpft sind.',
      inheritedFrom: 'Zeigt Einstellungen von {{name}}. Ankreuzen, um eigene zu speichern.',
      serviceHoursTitle: 'Standard-Servicezeit (private andere Zeit)',
      serviceStart: 'Service-Beginn',
      serviceEnd: 'Service-Ende',
      serviceHoursHelp: 'Gilt standardmäßig für alle Fahrzeuge, bis sich etwas pro Fahrzeug oder bei der Verbindung ändert.',
      cutOffEnabled: 'Pausendatum für Übermittlung aktivieren',
      cutOffEnabledHelp: 'Wenn diese Option deaktiviert ist, wird im System für dieses Top kein monatliches Pausendatum verwendet Knoten.',
      cutOffDay: 'Pausedatum (Tag des Monats)',
      cutOffDayHelp: 'Beispiel: 5 = spätestens am 5. eines jeden Monats. Wählen Sie 1–28, um einen kurzen Monat zu vermeiden.',
      reminderDays: 'Erinnerung (Tage vor dem Pausendatum)',
      reminderHelp: 'Anzahl der Tage vor dem Pausendatum, an denen die Erinnerung gesendet wird. Push geht an die App (Fahrer und Benutzer mit Fahrbericht). E-Mail geht an die Weiterleitungsadresse.',
      forwardingEmail: 'Standard-E-Mail für die Weiterleitung',
      forwardingEmailPlaceholder: 'z. B. ekonomi@foretag.se; hr@foretag.se',
      forwardingEmailHelp: 'Wird als vorab ausgefülltes Weiterleitungsziel verwendet, wenn Fahrdatensätze gesendet werden. Mehrere Adressen werden durch ein Semikolon (;) getrennt.',
      lockAfterSubmit: 'Protokoll nach der Übermittlung sperren',
      lockAfterSubmitHelp: 'Sperrt die Bearbeitung, wenn das Protokoll manuell übermittelt wird und wenn der monatliche Bericht am Stichtag abläuft. Die Erinnerung (E-Mail/Push) wird nicht gesperrt.',
      odometerAdjustmentLock: 'Anpassung des Zählerstands während des Abrechnungszeitraums sperren',
      odometerAdjustmentLockHelp: 'Wenn aktiviert, kann der Zählerstand am Ende der 1-3 und 26 Monate (Abrechnungs-/Bescheinigungszeitraum) nicht manuell angepasst werden. Standardmäßig deaktiviert.',
    },
    reminders: {
      tabTitle: 'Abonnements',
      title: 'Abonnements',
      intro: 'Gilt für den gesamten Kundenbaum unter diesem obersten Knoten. Durch den ausgesetzten Dienst werden keine Zuweisungen oder Entsendungen erstellt. Benachrichtigung steuert E-Mail und Push.',
      service: 'Dienst',
      notify: 'Benachrichtigung',
      inspection: 'Inspektion',
      inspectionHelp: 'Erinnerung, wenn die Inspektion innerhalb von 40 Tagen fällig ist.',
      tax: 'Kfz-Steuer',
      taxHelp: 'Erinnerung, wenn die Steuer innerhalb von 45 Tagen bezahlt werden muss.',
      leasing: 'Leasing läuft ab',
      leasingHelp: 'Zeige Fahrzeuge an, deren Leasing innerhalb einer ausgewählten Anzahl von Monaten endet. Standard 6. Gilt für Widget und automatischen Entwurf.',
      monthsAhead: 'Monate im Voraus',
    },
    emailSettings: {
      tabTitle: 'E-Mail',
      title: 'Ausgehende E-Mail',
      intro: 'Zeigt die in den Modulen des Kunden enthaltenen Mailings sowie die Konto-E-Mail. Ein Häkchen bedeutet, dass die E-Mail versendet wird. Gilt für den gesamten Kundenbaum. Push und SMS sind nicht betroffen.',
      kinds: {
        bookingConfirmation: 'Buchungsbestätigung',
        bookingOverdue: 'Verspätete Rückgabe',
        bookingCancellation: 'Systemstornierung',
        bookingAssignment: 'Buchung beim Anbieter',
        welcome: 'Willkommens-E-Mail',
        passwordReset: 'Passwort zurücksetzen',
        emailVerification: 'E-Mail-Bestätigung',
        drivingLog: 'Fahrprotokoll',
        vehicleDue: 'Inspektion und Kfz-Steuer',
        service: 'Service',
        unplug: 'Gerät getrennt',
        rentalReport: 'Mietbericht',
        travelPlanner: 'Reiseplaner',
        scheduledReport: 'Geplant Berichte',
        supportReply: 'Support-Antwort',
      },
      kindHelp: {
        bookingConfirmation: 'Bestätigung und Änderung, einschließlich Schnellbuchung.',
        bookingOverdue: 'E-Mail, wenn die Rückgabezeit abgelaufen ist. Push wird trotzdem gesendet.',
        bookingCancellation: 'E-Mail, wenn das System abbricht, weil keine Ressource verfügbar ist.',
        bookingAssignment: 'E-Mail an Lieferanten oder Autovermietung. Wird vom Kunden des Empfängers kontrolliert.',
        welcome: 'Willkommens-E-Mail mit Link zum Festlegen des Passworts.',
        passwordReset: 'Passwort vergessen. Der Benutzer erhält die gleiche Antwort, aber es wird keine E-Mail verschickt.',
        emailVerification: 'Link zur Bestätigung der E-Mail-Adresse.',
        drivingLog: 'Erinnerung, monatlicher Bericht und Export.',
        vehicleDue: 'E-Mail zu Inspektion und Kfz-Steuer.',
        service: 'Erinnerung an überfälligen oder bevorstehenden Service.',
        unplug: 'Warnung, wenn ein GPS-Gerät getrennt wird.',
        rentalReport: 'Mietbericht als E-Mail.',
        travelPlanner: 'Wegbeschreibung aus dem Reiseplaner.',
        scheduledReport: 'Geplante Berichte vom Berichtsgenerator.',
        supportReply: 'Bestätigung und Antwort auf Supportfälle an den Benutzer.',
      },
    },
    reportModels: {
      tabTitle: 'Datenmodelle',
      title: 'Datenmodelle',
      intro: 'Wählen Sie aus, welche Berichtsmodelle dieser Kunde im Berichtsgenerator verwenden kann. Gilt für den gesamten Kundenbaum.',
      save: 'Modelle speichern',
      saved: 'Die Datenmodelle werden gespeichert',
      empty: 'Es wurden noch keine Modelle hochgeladen.',
    },
    supportForward: {
      tabTitle: 'Supportfälle',
      title: 'Supportfälle weiterleiten',
      intro: 'Wenn diese Organisation einen neuen Supportfall erhält, wird eine Kopie an die unten angegebene Adresse gesendet. Anfragen von anderen Organisationen werden nicht versendet. Es wird nichts gesendet, bis die Weiterleitung aktiviert ist.',
      enabled: 'Weiterleitung aktivieren',
      enabledHelp: 'Muss aktiviert sein, damit die Kopie gesendet werden kann.',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'z. B. support@kund.se',
      emailHelp: 'Das Postfach, das eine Kopie neuer Fälle für diese bestimmte Organisation erhalten soll.',
      partnerIntro: 'Wenn der Wiederverkäufer oder ein Kunde unter ihm einen neuen Support-Fall erhält, wird eine Kopie an die unten stehende Adresse gesendet. Es wird nichts gesendet, bis die Weiterleitung aktiviert ist.',
      partnerEmailHelp: 'Die Mailbox, die eine Kopie neuer Fälle vom Händler und den Kunden unten erhält.',
    },
    automaticService: 'Automatischer Service',
    cabinetSettings: 'Schließfacheinstellungen',
    cabinetHasCabinet: 'Kunde hat Schlüsselschließfach',
    cabinetHasCabinetHelp: 'Aktiviert Schließfach für den oberen Knoten. Beim ersten Mal öffnen Sie den Schrank mit dem in KeyWin integrierten SuperAdmin und stecken die Stifte ein. Dann werden nur die Taps in diesem Schrank mit dem SuperAdmin des Kunden und dem LocalAdmin des Schranks (KeyWin-Benutzer, nicht Webadministrator) synchronisiert.',
    cabinetEnabled: 'Schrank für den Kunden aktiviert',
    cabinetDisabled: 'Schrank für den Kunden deaktiviert',
    cabinetEnableError: 'Die Schrankeinstellung konnte nicht geändert werden',
    cabinetSuperAdminPin: 'SuperAdmin PIN',
    cabinetSuperAdminPinHelp: '8 Ziffern, eindeutig im System. PIN für die Tastatur, nachdem die Wasserhähne im Schrank mit dem SuperAdmin-Benutzer synchronisiert wurden. Bietet keine Web-Anmeldung in KeyWin. Das erste Eingeben von Hähnen erfolgt mit dem integrierten SuperAdmin-Code, der immer alle Schließfächer öffnen kann.',
    cabinetPinCopied: 'PIN kopiert',
    cabinetGeneratePin: 'PIN generieren',
    cabinetPinSync: 'In KeyWin speichern',
    cabinetPinSaved: 'SuperAdmin-PIN in KeyWin gespeichert',
    cabinetPinGenerated: 'Neue eindeutige SuperAdmin-PIN erstellt und in KeyWin gespeichert',
    cabinetPinInvalid: 'Die PIN muss aus genau 8 Ziffern bestehen',
    cabinetPinSaveError: 'SuperAdmin-PIN konnte nicht gespeichert werden',
    cabinetWebAdmin: 'Web-Anmeldung (KeyWin-Administrator)',
    cabinetUsername: 'Benutzername',
    cabinetPassword: 'Passwort',
    cabinetPasswordHelp: 'Wird zur Anmeldung bei der KeyWin-Weboberfläche verwendet.',
    cabinetPasswordCopied: 'Passwort kopiert',
    cabinetRegeneratePassword: 'Neues Passwort generieren',
    cabinetRegenerateConfirm: 'Möchten Sie ein neues Web-Passwort erstellen? Das alte gilt nicht mehr.',
    cabinetRegenerateError: 'Neues Passwort konnte nicht generiert werden',
    cabinetLinkedCabinets: 'Verknüpfte Schließfächer',
    cabinetNoLinkedCabinets: 'Es sind noch keine Schließfächer mit dem Kunden verknüpft. Tun Sie es unter Schlüsselverwaltung.',
    cabinetSyncTags: 'Taps synchronisieren',
    cabinetSyncTagsHelp: 'Verbindet nur Taps, die KeyWin in diesem Schrank sieht, mit LocalAdmin und dem SuperAdmin des obersten Knotens. Schauen Sie in KeyWin unter „Benutzer“ nach, nicht unter „Gruppen“.',
    cabinetSyncTagsSuccess: '{{count}} Taps, die mit SuperAdmin und LocalAdmin verknüpft sind',
    cabinetSyncTagsEmpty: 'Noch keine Taps im Schrank. Mit integriertem SuperAdmin öffnen, Pins einstecken und erneut synchronisieren.',
    cabinetSyncTagsError: 'Pins konnten nicht synchronisiert werden',
    defaultTimelineView: 'Zeitleiste als Standardansicht im Kundenservice',
    defaultTimelineViewHelp: 'Liste ist immer Standard. Aktivieren Sie diese Option, damit die Zeitleiste für diese Organisation zuerst im Kundenservice angezeigt wird. Der Benutzer kann die Ansicht jederzeit selbst ändern.',
    maxRecurringBookings: 'Max. wiederkehrende Buchungen',
    maxRecurringBookingsHelp: 'Max. Anzahl zukünftiger Buchungen pro wiederkehrender Serie (z. B. jede Woche zur gleichen Zeit). 0 oder leer = keine Begrenzung.',
    noBookingsBefore: 'Keine Buchungen vorher',
    noBookingsAfter: 'Keine Buchungen danach',
    noBookingsHelp: '0 oder leer = keine Begrenzung.',
    minLengthHours: 'Mindestdauer (Stunden)',
    maxLengthHours: 'Maximaldauer (Stunden)',
    lengthHelp: '0 oder leer = keine Begrenzung.',
    bookableMonthsForward: 'Monate im Voraus buchbar',
    bookableMonthsHelp: '0 oder leer = keine Begrenzung.',
    cancellationChargeHours: 'Stornierung wird berechnet (Stunden vor Beginn)',
    cancellationChargeHelp: 'Wenn der Kunde innerhalb dieser Zeit vor dem Start storniert, kann die Buchung in Rechnung gestellt werden, das Auto wird jedoch freigegeben. 0 oder leer = keine solche Regel.',
    noShowReleaseMinutes: 'No-show: freier Speicherplatz (min. nach dem Start)',
    noShowReleaseMinutesHelp: 'Sollte das Fahrzeug nicht innerhalb dieser vielen Minuten nach Buchungsbeginn ausgecheckt werden, wird der Platz freigegeben; Die Buchung kann weiterhin in Rechnung gestellt werden. 0 = deaktiviert. Neue Lieferstandorte erhalten den Wert vorausgefüllt (kann pro Standort geändert werden).',
    bookingRestMinutes: 'Ruhezeit zwischen Buchungen (Minuten)',
    bookingRestMinutesHelp: 'Mindestanzahl von Minuten nach Ende einer Buchung, bevor dasselbe Fahrzeug erneut gebucht werden kann. 0 oder leer = keine Ruhezeit.',
    bookingMinLeadTimeHours: 'Mindestvorlaufzeit (Stunden)',
    bookingMinLeadTimeHoursHelp: 'Gilt nur für Anfragen (Anfragen), die an die Autovermietung gehen. Die Buchung muss mindestens so viele Stunden im Voraus beginnen. 0 oder leer = keine Einschränkung.',
    bookingPolicyHtml: 'Buchungsrichtlinien',
    bookingPolicyHtmlHelp: 'Text, den der Bucher vor der Buchung öffnen und bestätigen muss (zusammen mit dem Führerschein). Lassen Sie das Feld leer, wenn keine Richtlinie erforderlich sein soll.',
  },
  moduleSearch: {
    open: 'Modul suchen',
    placeholder: 'Modul suchen...',
    hint: 'Tippen, um in Ihren Modulen zu suchen',
    noResults: 'Kein Modul passt',
  },

  manual: {
    title: 'Benutzerhandbuch',
    intro: 'Dieselbe Einteilung wie im linken Menü. Wählen Sie einen Eintrag und lesen Sie, was das Modul macht.',
    searchPlaceholder: 'Im Handbuch suchen...',
    noDescription: 'Für dieses Modul gibt es noch keine Beschreibung.',
    mainMenu: 'Hauptmenü',
    tools: 'Extras',
    administration: 'Administration',
    path: 'Pfad',
    availableActions: 'Verfügbare Aktionen',
    noResults: 'Keine Ergebnisse gefunden',
    icons: 'Verfügbare Symbole',
    iconsDescription: 'Hier sind alle in der Heroicons-Bibliothek verfügbaren Symbole. Sie können ein beliebiges Symbol zur Verwendung im System auswählen.',
    navigationIcons: 'Navigationssymbole',
    arrowsIcons: 'Pfeilsymbole',
    actionsIcons: 'Aktionssymbole',
    adminIcons: 'Verwaltungssymbole',
    communicationIcons: 'Kommunikationssymbole',
    filesIcons: 'Dateisymbole',
    statusIcons: 'Statussymbole',
    mediaIcons: 'Mediensymbole',
    otherIcons: 'Sonstiges Symbole',
    guides: {
      title: 'Anleitungen und Prozesse',
      deviceVehicleTitle: 'Gerät in ein anderes Auto wechseln',
      deviceVehicleIntro: 'Was passiert, wenn ein GPS-Gerät von einem Auto in ein anderes verschoben wird, und wie man das manuell macht.',
      autoHeading: 'Was automatisch passiert',
      autoSteps: [
        'Wenn ein Gerät in ein anderes Auto verschoben wird, erkennt das System es selbst.',
        'Das Gerät wird vom alten Auto getrennt und mit dem neuen Auto verbunden.',
        'Wenn es sich um ein brandneues Auto handelt, wird es wird automatisch mit den richtigen Informationen (Marke, Modell, Kennzeichen) erstellt.',
        'Wenn sich auf dem alten Auto ein Fahrer befand, begleitet der Fahrer das neue Auto.',
        'Alles wird protokolliert, damit die Fahrten am richtigen Auto und beim richtigen Fahrer landen.',
      ],
      manualHeading: 'Gerät manuell ändern',
      manualSteps: [
        'Gehen Sie zu Verwaltung → Geräteverwaltung.',
        'Suchen Sie nach dem Gerät und verbinden Sie es mit dem neuen Auto.',
        'Wenn das neue Auto bereits über ein Gerät verfügt, können Sie den Standort der Geräte ändern oder das alte Gerät trennen.',
        'Bestätigen – das Gerät wird in das neue Auto verschoben und vom alten getrennt.',
        'Das alte Auto wird frei und das neue Auto zeigt nun das Gerät an.',
      ],
    },
  },
  icons: {
    fleet: 'Fahrzeugflotte',
    statistics: 'Statistiken',
    trips: 'Reise',
    user: 'Benutzer',
    manual: 'Benutzerhandbuch',
    search: 'Suchen',
    notification: 'Benachrichtigungen',
    moon: 'Dunkelmodus',
    sun: 'Hellmodus',
    arrowLeft: 'Zurück',
    eye: 'Anzeigen',
    eyeSlash: 'Ausblenden',
    settings: 'Einstellungen',
    database: 'Datenbank',
    sync: 'Synchronisieren',
    userGroup: 'Benutzer Gruppe',
  },
  translations: {
    title: 'Übersetzungen',
    key: 'Taste',
    swedish: 'Schwedisch',
    english: 'Englisch',
    editTranslation: 'Übersetzung bearbeiten',
    saveSuccess: 'Übersetzung gespeichert',
    saveError: 'Übersetzung konnte nicht gespeichert werden',
    searchPlaceholder: 'Nach Schlüssel oder Text suchen...',
    noTranslations: 'Keine Übersetzungen gefunden',
    noMatchSearch: 'Keine Übersetzungen stimmten mit der Suche überein',
    exportFiles: 'In Dateien exportieren',
    exportNoteLabel: 'Hinweis',
    exportNote: 'Übersetzungen werden in Dateien gespeichert (sv.ts, en.ts, de.ts und lt.ts). Verwenden Sie „In Dateien exportieren“, um aktualisierte Dateien herunterzuladen, oder bearbeiten Sie die Dateien direkt im Code.',
    total: 'Gesamt',
    filtered: 'gefiltert nach',
    updatedNote: 'Übersetzung aktualisiert! (Hinweis: Änderungen müssen manuell in den Dateien gespeichert werden)',
  },
  dashboard: {
    title: 'Dashboard',
    activeVehicles: 'Aktive Fahrzeuge',
    totalDistance: 'Gesamtkilometerstand',
    averageSpeed: 'Durchschnittsgeschwindigkeit',
    liveMap: 'Live-Karte',
    liveTracking: 'Echtzeitüberwachung',
    mapComingSoon: 'OpenStreetMapIntegration folgt in Kürze',
    addressUnavailable: 'Adresse konnte nicht abgerufen werden',
    edit: 'Bearbeiten',
    editDashboard: 'Dashboard bearbeiten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    addWidget: 'Widget hinzufügen',
    addWidgetHint: 'Wird unten auf der Seite eingefügt. Danach an die gewünschte Stelle ziehen.',
    addFirstWidget: 'Fügen Sie Ihr erstes Widget hinzu',
    emptyDashboard: 'Ihr Dashboard ist empty',
    emptyDashboardDescription: 'Fügen Sie Widgets hinzu, um Ihr Dashboard anzupassen. Sie können aus einer Vielzahl von Widgets wählen, die Informationen zu Ihren Fahrzeugen und Ihrer Organisation anzeigen.',
    dragHere: 'Widget hierher ziehen',
    layoutSaved: 'Layout gespeichert',
    layoutSaveFailed: 'Layout konnte nicht gespeichert werden',
    widgetAdded: 'Widget hinzugefügt',
    widgetRemoved: 'Widget entfernt',
    widgetNotAvailable: 'Widget nicht verfügbar',
    widgetNoPermission: 'Sie haben keine Berechtigung für dieses Widget',
    saving: 'Speichern...',
    favorites: 'Favoriten',
    reorderFavorites: 'Reihenfolge der Favoriten ändern',
    reorderFavoritesHint: 'Ziehen, um die Reihenfolge zu ändern',
    greetingMorning: 'Guten Morgen, {{name}}.',
    greetingAfternoon: 'Guten Tag, {{name}}.',
    greetingEvening: 'Guten Abend, {{name}}.',
    greetingMorningPlain: 'Guten Morgen.',
    greetingAfternoonPlain: 'Guten Tag.',
    greetingEveningPlain: 'Guten Abend.',
  },
  liveTracking: {
    title: 'Echtzeitüberwachung',
    description: 'Fahrzeuge in Echtzeit auf der Karte mit Baumansicht für Organisationen anzeigen',
    search: 'Fahrzeuge suchen...',
    searchHits: 'Suchtreffer',
    lists: 'Listen',
    alarms: 'Alarme',
    online: 'Online',
    offline: 'Offline',
    all: 'Alle',
    noVehicles: 'Keine Fahrzeuge ausgewählt',
    loading: 'Laden...',
    fitBounds: 'Kartenansicht anpassen',
    status: 'Status',
    regNumber: 'Reg.Nr',
    name: 'Name',
    receivedTime: 'Empfangszeit',
    location: 'Standort',
    speed: 'Geschwindigkeit',
    direction: 'Richtung',
    acc: 'ACC',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle deaktivieren',
    live: 'Live',
    connecting: 'Verbinden…',
    liveDelayed: 'Live (verzögert)',
    dataStaleWarning: 'Echtzeitdaten haben wurde in {{minutes}} Min. nicht aktualisiert. Der Kartenmodus ist möglicherweise vorübergehend veraltet (Netzwerk, Gerät oder Betrieb). Bei anhaltenden Problemen: Kontaktieren Sie den Support.',
    pollingFallback: 'Aktualisiert Positionen regelmäßig als Backup, wenn Live aktiv ist.',
    saveAsStartView: 'Diese Ansicht als Startansicht speichern',
    goToStartView: 'Gehe zur gespeicherten Startansicht',
    exitFullscreen: 'Vollbild verlassen',
    fullscreen: 'Vollbild',
    driving: 'Fahren',
    noDataOver1h: 'Keine Daten >1 Stunde',
    loadingMap: 'Karte wird geladen...',
    noVehiclesSelected: 'Keine Fahrzeuge ausgewählt',
    regNr: 'Reg.Nr',
    statusDriving: 'Laufen',
    statusStationary: 'Stehen',
    statusStaleParked: 'Geparkt, keine Daten >1h',
    statusLostWhileDriving: 'Fahren, fehlender Kontakt >1h',
    statusNoContact: 'Fehlender Kontakt >6h',
    markerLegendDriving: 'Laufen',
    markerLegendStationary: 'Stand (<1h)',
    markerLegendStaleParked: 'Geparkt, keine Daten >1h',
    markerLegendLostWhileDriving: 'Fahren, fehlender Kontakt >1h',
    markerLegendNoContact: 'Fehlender Kontakt >6h',
    lostWhileDrivingHint: 'Letzte Fahrt – keine Daten zu {{minutes}} Min.',
    lastSeenMinutesAgo: 'Zuletzt gesehen: {{minutes}} Min. seit',
    ignitionOn: 'Ein',
    ignitionOff: 'Aus',
    mapNotReady: 'Karte nicht bereit',
    restoredToSavedView: 'Zur gespeicherten Ansicht wiederhergestellt',
    areaFilter: {
      title: 'Bereich filtern',
      open: 'Bereichsfilter',
      active: '{{count}} Fahrzeuge im Bereich',
      clear: 'Bereichsfilter löschen',
      help: 'Zeichnen Sie einen Bereich auf der Karte (mindestens 3 Punkte). Wählen Sie, ob Sie Fahrzeuge nach Standort oder aktueller Position sehen möchten.',
      modePlacement: 'Standort in der Umgebung',
      modeCurrent: 'Jetzt im Bereich',
      privateExcluded: 'Fahrzeuge, die als privat geplant sind, werden nicht angezeigt.',
      apply: 'Filter',
      resultCount: '{{count}}Fahrzeug entspricht dem Filter',
      error: 'Fahrzeuge im Bereich konnten nicht gefiltert werden',
      placementMarker: 'Standort',
      placementClusterCount: '{{count}}Fahrzeug am selben Standort',
      drawOnMapHint: 'Halten Sie die Maustaste gedrückt und ziehen Sie ein Rechteck auf der Karte.',
      placementModeActive: 'Wird angezeigt Standort (lila Punkte)',
    },
  },
  crm: {
    title: 'CRM',
    crmModule: 'Kundenverwaltung',
    economyModule: 'Wirtschaftlichkeit',
    customers: 'Kunden',
    customersDescription: 'Kundenkarten und Kontakte verwalten',
    projects: 'Projekte',
    projectsDescription: 'Laufende und geplante Projekte',
    procurements: 'Beschaffungen',
    procurementsDescription: 'LOU- und Ausschreibungsprozesse',
    pipeline: 'Sales-Pipeline',
    pipelineDescription: 'Sales-Funnel und Leads',
    economyOverview: 'Finanzübersicht',
    economyOverviewDescription: 'Rolling 12, Trends und Umsatz',
    invoices: 'Rechnungsbasis',
    invoicesDescription: 'Generieren und verwalten Rechnungen',
    pricelist: 'Preisliste',
    pricelistDescription: 'Dienstleistungen, Materialien und Preise',
    scbTesting: 'SCB API Testing',
    scbTestingDescription: 'SCB-API-Endpunkte testen und Ergebnisse anzeigen',
    moduleCatalog: {
      title: 'Modulkatalog',
      dashboardDescription: 'Übersicht aller Module und Funktionen',
      searchPlaceholder: 'Modul, Zweck, Funktion suchen...',
      versionFilter: 'Version',
      allVersions: 'Alle Versionen',
      sync: 'Synchronisierung',
      syncDone: 'Synchronisiert: {{inserted}}neu, {{updated}}aktualisiert',
      syncError: 'Synchronisiert fehlgeschlagen',
      addCustom: 'Eigenes hinzufügen',
      editEntry: 'Modul bearbeiten',
      exportPdf: 'PDF exportieren',
      exportError: 'Export fehlgeschlagen',
      exportGenerated: 'Generierte {{date}}',
      exportPageOf: 'Seite {{page}} von {{pages}}',
      empty: 'Keine Module gefunden.',
      customBadge: 'Benutzerdefiniert',
      appBadge: 'App',
      confirmDelete: 'Diesen Eintrag entfernen/deaktivieren?',
      systemKey: 'System (Schlüssel)',
      systemName: 'Systemname',
      name: 'Modulname',
      purpose: 'Zweck',
      functions: 'Funktionen',
      requirementsNotes: 'Anforderungshinweise (Muss/Sollte)',
    },
    searchCustomerPlaceholder: 'Suche Kunde, Org.-Nr., Stadt...',
    listColOrgNumber: 'Org.-Nr.',
    listColPackage: 'Paket',
    listExtraModules: 'Zusatzmodule',
    listColUserCount: 'Anzahl Benutzer',
    listColContact: 'Ansprechpartner',
    listColDevices: 'Geräte',
    listColDevicesHint: 'Angeschlossen / auf Lager',
    listColDevicesTitle: '{{linked}} verbunden, {{stock}} auf Lager',
    listColBillingFrom: 'Abrechnung von',
    allStatus: 'Alle Status',
    totalLabel: 'Gesamt',
    contactsLabel: 'Kontakte',
    notesLabel: 'Notizen',
    statusAndType: 'Status und Typ',
    signupDomains: 'Registrierungsdomain',
    signupDomainsHelp: 'Maximal eine Domain pro Kunde. Wenn sich ein Benutzer mit E-Mail von dieser Domäne registriert, wird das Konto automatisch mit der Organisation des Kunden mit der Rolle „Betrachter“ verknüpft.',
    signupDomainsEmpty: 'Keine Domäne hinzugefügt',
    signupDomainsListTitle: 'Registrierungsdomäne gespeichert',
    signupDomainsAddedAt: 'Hinzugefügt {{date}}',
    signupDomainsNoOrg: 'Der Kunde benötigt eine verknüpfte Organisation (aktiver Kunde), bevor Sie Registrierungsdomänen hinzufügen können.',
    signupDomainPlaceholder: 'z. foretag.se',
    signupDomainAdd: 'Hinzufügen',
    signupDomainSave: 'Domäne speichern',
    signupDomainSaved: 'Domäne gespeichert',
    signupDomainRemove: 'Domäne entfernen',
    signupDomainsLoadError: 'Domänen konnten nicht geladen werden',
    signupDomainAdded: 'Domäne hinzugefügt',
    signupDomainAddError: 'Domain konnte nicht hinzugefügt werden',
    signupDomainRemoved: 'Domain entfernt',
    signupDomainRemoveError: 'Domain konnte nicht entfernt werden',
    newCustomer: 'Neuer Kunde',
    createCustomer: 'Neuen Kunden erstellen',
    editCustomer: 'Kunde bearbeiten',
    deleteCustomer: 'Kunde löschen',
    deleteCustomerConfirm: 'Sind Sie sicher, dass Sie diesen Kunden löschen möchten?',
    removalTitle: 'Kunde löschen',
    removalIntro: 'Durch die Archivierung wird der Kunde ausgeblendet und alle behalten Daten. Beim Löschen wird der Kunde entfernt. Geräte und Sensoren werden wieder in den Bestand aufgenommen.',
    archiveCustomer: 'Archiv',
    archiveCustomerHint: 'Kunde ist ausgeblendet. Fahrzeuge, Benutzer und Verlauf bleiben erhalten.',
    purgeCustomer: 'Löschen',
    purgeCustomerHint: 'Alle Kundendaten werden gelöscht. GPSGeräte und Sensoren kehren in unseren Bestand zurück.',
    purgeConfirmLabel: 'Geben Sie den zu löschenden Kundennamen ein',
    purgeConfirmAction: 'Löschen Sie den Kunden',
    customerArchived: 'Der Kunde wird archiviert',
    customerPurged: 'Der Kunde wird gelöscht',
    removalCancel: 'Abbrechen',
    contacts: 'Kontakte',
    newContact: 'Neuer Kontakt',
    editContact: 'Kontakt bearbeiten',
    deleteContact: 'Kontakt entfernen',
    statusProspect: 'Interessent',
    statusActive: 'Aktiv',
    statusPaused: 'Pause',
    statusAtRisk: 'Risiko',
    billingStartsOn: 'Abrechnung von',
    billingStartsOnShort: 'Abrechnung von',
    billingStartsOnHelp: 'Datum, ab dem mit der Rechnungsstellung für den Kunden begonnen werden muss. Leer lassen, wenn nicht angegeben.',
    billingStartsOnNotSet: 'Nicht angegeben',
    typeMunicipality: 'Gemeinde',
    typeRegion: 'Region',
    typePrivate: 'Privat',
    typePartner: 'Partner',
    typeCarRental: 'Autovermieter',
    carRental: 'Autovermieter',
    federation: 'Verband',
    federationDescription: 'Single Sign-On (SSO) für den Kunden konfigurieren',
    saml: 'SAML 2.0',
    oidc: 'OpenID Connect',
    samlConfig: 'SAML Konfiguration',
    oidcConfig: 'OIDC-Konfiguration',
    entityId: 'Entitäts-ID/Aussteller',
    ssoUrl: 'SSO URL',
    sloUrl: 'SLO-URL (Einzelabmeldung)',
    certificate: 'IdP-Zertifikat',
    nameIdFormat: 'NameID-Format',
    issuerUrl: 'Aussteller-URL',
    clientId: 'Client-ID',
    clientSecret: 'Client-Geheimnis',
    scopes: 'Bereiche',
    provider: 'Anbieter',
    activateSaml: 'SAML aktivieren 2.0',
    activateOidc: 'OpenID Connect aktivieren',
    spMetadata: 'Dienstanbieter-Metadaten',
    redirectUri: 'Umleitungs-URI',
    configuredButInactive: 'Konfiguriert, aber inaktiv',
    notConfigured: 'Nicht konfiguriert',
    saveSaml: 'SAML speichern',
    updateSaml: 'SAML aktualisieren',
    saveOidc: 'OIDC speichern',
    updateOidc: 'OIDC aktualisieren',
    deleteSaml: 'SAML entfernen',
    deleteOidc: 'OIDC entfernen',
    samlCreated: 'SAML Konfiguration erstellt',
    samlUpdated: 'SAML-Konfiguration aktualisiert',
    samlDeleted: 'SAML-Konfiguration entfernt',
    oidcCreated: 'OIDC-Konfiguration erstellt',
    oidcUpdated: 'OIDC-Konfiguration aktualisiert',
    oidcDeleted: 'OIDC-Konfiguration entfernt',
    customerMustBeActivated: 'Der Kunde muss für die Konfiguration des Verbunds aktiviert sein',
    municipality: 'Gemeinde',
    region: 'Region',
    privateCompany: 'Privates Unternehmen',
    partner: 'Partner',
    loadCustomerError: 'Kunde konnte nicht geladen werden',
    fetchCorporateStructureError: 'Gruppenstruktur konnte nicht abgerufen werden',
    customerUpdated: 'Kunde aktualisiert',
    saveContactError: 'Konnte nicht gespeichert werden Kontakt',
    ssoUrlAndCertRequired: 'SSOURL und Zertifikat erforderlich',
    saveSamlError: 'SAML-Konfiguration konnte nicht gespeichert werden',
    samlConfigRemoved: 'SAML-Konfiguration entfernt',
    deleteSamlError: 'SAML-Konfiguration konnte nicht entfernt werden',
    issuerAndClientIdRequired: 'Aussteller-URL und Client-ID erforderlich',
    saveOidcError: 'OIDC-Konfiguration konnte nicht gespeichert werden',
    oidcConfigRemoved: 'OIDC-Konfiguration entfernt',
    deleteOidcError: 'OIDC-Konfiguration konnte nicht gelöscht werden',
    createApiKeyError: 'API-Schlüssel konnte nicht erstellt werden',
    deactivateApiKeyError: 'API-Schlüssel konnte nicht deaktiviert werden',
    updateEndpointAccessError: 'Endpunktzugriff konnte nicht aktualisiert werden',
    loadPricelistError: 'Preisliste konnte nicht geladen werden',
    saveProductError: 'Konnte nicht gespeichert werden Produkt',
    duplicateProductCode: 'Produktcode existiert bereits – wählen Sie einen eindeutigen Code',
    deleteProductError: 'Produkt konnte nicht entfernt werden',
    tabProducts: 'Produkte und Dienstleistungen',
    tabPackages: 'Systempaket',
    categoriesTitle: 'Kategorien',
    allProducts: 'Alle Produkte',
    colCode: 'Code',
    colName: 'Name',
    colType: 'Typ',
    colPricingModel: 'Preismodell',
    colPrice: 'Preis',
    colUnit: 'Gerät',
    newProduct: 'Neues Produkt',
    noProductsInCategory: 'Keine Produkte in dieser Kategorie',
    editProduct: 'Produkt bearbeiten',
    productTypeService: 'Dienst',
    productTypeMaterial: 'Materialien',
    productTypeBundle: 'Paket',
    pricingHourly: 'Pro Stunde',
    pricingMonthly: 'Pro Monat',
    pricingPerVehicle: 'Pro Fahrzeug',
    pricingPerUser: 'Pro Benutzer',
    pricingOneTime: 'Einweg',
    pricingCustom: 'Benutzerdefiniert',
    labelCode: 'Code',
    labelCategory: 'Kategorie',
    labelName: 'Name *',
    labelDescription: 'Beschreibung',
    labelProductType: 'Produkttyp',
    labelPricingModel: 'Preismodell',
    labelPrice: 'Preis (SEK)',
    labelUnit: 'Gerät',
    noCategory: 'Keine Kategorie',
    unitPlaceholder: 'Stück, Stunde, Monat...',
    productCreated: 'Produkt erstellt',
    productUpdated: 'Produkt aktualisiert',
    productDeleted: 'Produkt entfernt',
    confirmDeleteProduct: 'Entfernen Produkt?',
    customerNotFound: 'Kunde nicht gefunden',
    backToCustomerList: '← Zurück zur Kundenliste',
    activateCustomer: 'Kunde aktivieren',
    activating: 'Aktivieren...',
    edit: 'Bearbeiten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    tabInfo: 'Kundeninfo',
    tabServices: 'Dienstleistungen',
    tabStatistics: 'Statistiken',
    tabFederation: 'Verband',
    companyInfoTitle: 'Firmeninformationen',
    contactsTitle: 'Ansprechpartner',
    addContact: 'Hinzufügen',
    noContacts: 'Keine Ansprechpartner',
    primaryBadge: 'Primär',
    noNotes: 'Keine Notizen',
    labelStatus: 'Status',
    labelCustomerType: 'Kundentyp',
    companyRegister: 'Firmenregister',
    loadingCheckbiz: 'Daten werden von Checkbiz geladen...',
    noCheckbizData: 'Keine Daten für Organisationsnummer gefunden {{orgNumber}}',
    checkbizApiNote: '(Checkbiz API ist möglicherweise nicht konfiguriert oder die Organisationsnummer ist nicht in der Registrierung)',
    vehiclesInGroup: 'Fahrzeuge in der Gruppe ({{total}} gesamt)',
    companyGroupTitle: 'Gruppenstruktur ({{count}} Unternehmen)',
    fetchAndSave: 'Abrufen und speichern',
    orgNumber: 'Org.nr',
    ownerShare: 'Eigentum',
    labelOrgNumber: 'Organisationsnummer',
    labelAddress: 'Adresse',
    labelPostalCode: 'Postleitzahl',
    labelCity: 'Stadt',
    labelWebsite: 'Website',
    partnerSupportTitle: 'Supportkontakt in der App',
    partnerSupportHint: 'Wird in der Chat-Blase für Benutzer dieses Kunden angezeigt. Nicht die E-Mail-Adresse von Deque. Leere Felder werden vom übergeordneten Partner übernommen.',
    partnerSupportShow: 'E-Mail-Adresse und Telefonnummer des Partners in der App anzeigen',
    partnerSupportEmail: 'Partner-Support-E-Mail',
    partnerSupportPhone: 'Partner-Support-Telefonnummer',
    labelSniCode: 'SNI-Code',
    labelSizeClass: 'Größenklasse',
    wizard: {
      basicInfo: 'Grundlegende Informationen',
      addressContact: 'Adresse und Kontakt',
      contactPerson: 'Ansprechpartner',
      pricing: 'Preise',
      summary: 'Zusammenfassung',
      companyName: 'Firmenname *',
      orgNumber: 'Organisationsnummer',
      customerType: 'Kundentyp *',
      statusLabel: 'Status *',
      statusProspect: 'Interessent',
      statusProspectNote: '(es wird keine Organisation erstellt)',
      statusActive: 'Aktiv',
      statusActiveNote: '(erstellt Organisation)',
      address: 'Adresse',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      website: 'Website',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      emailRequired: 'E-Mail ist für die Kontaktperson obligatorisch',
      phone: 'Telefon',
      mobile: 'Mobil',
      role: 'Rolle',
      sendWelcomeEmail: 'Willkommens-E-Mail senden und Benutzerkonto erstellen',
      sendWelcomeEmailDesc: 'Die Kontaktperson erhält eine E-Mail mit einem Link, um ihr Konto als Administrator in DQFleet zu aktivieren.',
      pricingModel: 'Preismodell',
      monthlyFee: 'Monatliche Gebühr (SEK)',
      pricePerVehicle: 'Preis pro Fahrzeug (SEK/Monat)',
      pricePerUser: 'Preis pro Benutzer (SEK/Monat)',
      perVehicle: 'Pro Fahrzeug',
      customPricing: 'Benutzerdefiniert',
      notes: 'Notizen',
      noOrgNumber: 'Keine Organisationsnummer',
      statusActiveLabel: ' ✓ Aktiv (Organisation wird erstellt)',
      pricingLabel: 'Preismodell',
      back: 'Zurück',
      next: 'Weiter',
      creating: 'Wird erstellt...',
      createCustomer: 'Kunde erstellen',
      municipality: 'Gemeinde',
      region: 'Region',
      partner: 'Partner',
      carRental: 'Autovermieter',
      roleDecisionMaker: 'Entscheidungsträger',
      roleTechnical: 'Technischer Kontakt',
      roleBilling: 'Rechnung',
      roleOther: 'Sonstiges',
    },
    loadSystemConfigError: 'Systemkonfiguration konnte nicht geladen werden',
    changeSystemStatusError: 'Systemstatus konnte nicht geändert werden',
    changeModuleStatusError: 'Modulstatus konnte nicht geändert werden',
    loadCustomersError: 'Kunden konnten nicht geladen werden',
    tabs: {
      devices: 'Geräte',
      vehicleOrg: 'Organisationsnr. Fahrzeuge',
    },
    vehicleOrg: {
      title: 'Organisationsnummer für die Fahrzeugverwaltung',
      orgNumber: 'Organisationsnummer',
      companyName: 'Firmenname',
      companyNamePlaceholder: 'Beliebiger Firmenname',
      source: 'Quelle',
      sourceKoncern: 'Gruppe',
      sourceManual: 'Manuell',
      fetchFromKoncern: 'Aus Gruppenstruktur abrufen',
      addManual: 'Manuell hinzufügen',
      empty: 'Keine Organisationsnummer registriert',
      emptyHint: 'Klicken Sie auf „Aus Gruppenstruktur abrufen“, um aus Gruppenunternehmen auszufüllen',
      alreadyExists: 'Die Organisationsnummer ist bereits registriert',
      totalCount: '{{count}}registrierte Organisationsnummern',
    },
    customerDevices: {
      inVehicle: 'Im Fahrzeug',
      customerStock: 'Kundenbestand',
      total: 'Gesamtzahl der Einheiten',
      searchPlaceholder: 'Suche IMEI, regnr...',
      allStatuses: 'Alle Status',
      noDevices: 'Keine Geräte mit diesem Kunden verbunden',
      noMatch: 'Keine Geräte stimmten mit dem Filter überein',
      updated: 'Aktualisiert',
    },
  },
  projects: {
    devTitle: 'Produktentwicklung',
    newProject: 'Neues Projekt',
    projectName: 'Projektname',
    selectCustomer: 'Kunde auswählen',
    searchPlaceholder: 'Projekt suchen...',
    allStatuses: 'Alle Status',
    noProjects: 'Keine Projekte gefunden',
    openTasks: 'offene Aufgaben',
    addTask: 'Aufgabe hinzufügen',
    editTask: 'Aufgabe bearbeiten',
    editProject: 'Projekt bearbeiten',
    taskTitle: 'Aufgabe',
    subtasks: 'Unteraufgaben',
    subtaskPlaceholder: 'Neue Unteraufgabe...',
    subtasksProgress: '{{done}} von {{total}} erledigt',
    milestone: 'Meilenstein',
    milestones: 'Meilensteine',
    milestoneName: 'Meilensteinname',
    priority: 'Priorität',
    plannedStart: 'Geplanter Beginn',
    plannedEnd: 'Geplantes Ende',
    budget: 'Budget',
    actualCost: 'Tatsächliche Kosten',
    billingType: 'Rechnung',
    hourlyRate: 'Stundensatz',
    billingTypes: {
      fixed: 'Fester Satz',
      hourly: 'Pro Stunde',
      milestone: 'Pro Meilenstein',
    },
    totalHours: 'Gesamtstunden',
    timeTracking: 'Zeitberichte',
    hours: 'Stunden',
    logTime: 'Protokollzeit',
    billable: 'Abrechenbar',
    noTask: 'Keine Informationen',
    dependsOn: 'Abhängig vom',
    projectType: 'Projekttyp',
    manager: 'Projektmanager',
    primaryContact: 'Hauptkontakt',
    primaryContactHint: 'Benutzer in der Organisation des Kunden (keine globalen Administratoren).',
    owner: 'Eigentümer',
    assignedTo: 'Zugewiesen an',
    notAssigned: 'Nicht zugewiesen',
    globalAdmin: 'Globaler Administrator',
    managerCandidatesHint: 'Kundenadministratoren und globale Administratoren.',
    ownerCandidatesHint: 'Nur globale Administratoren.',
    releaseTarget: 'Zielversion',
    component: 'Komponente',
    featureCode: 'Funktionscode',
    tabs: {
      overview: 'Übersicht',
      kanban: 'Kanban',
      gantt: 'Gantt',
      milestones: 'Meilensteine',
      time: 'Zeit',
    },
    stats: {
      total: 'Gesamt',
      active: 'Aktiv',
      myTasks: 'Meine Aufgaben',
      overdue: 'Verzögert',
      hoursWeek: 'Stunden dieser Woche',
    },
    status: {
      planned: 'Geplant',
      active: 'Aktiv',
      on_hold: 'Pause',
      completed: 'Abgeschlossen',
      cancelled: 'Abgebrochen',
    },
    taskStatus: {
      backlog: 'Rückstand',
      todo: 'Zu erledigen',
      in_progress: 'In Bearbeitung',
      review: 'Überprüfung',
      done: 'Fertig',
      cancelled: 'Abgebrochen',
    },
    priorityLevel: {
      low: 'Niedrig',
      normal: 'Normal',
      high: 'Hoch',
      urgent: 'Dringend',
    },
    types: {
      implementation: 'Implementierung',
      migration: 'Migration',
      upgrade: 'Upgrade',
      integration: 'Integration',
      consulting: 'Beratung',
      other: 'Andere',
    },
    components: {
      backend: 'Backend',
      frontend: 'Frontend',
      mobile: 'Mobil',
      gateway: 'Gateway',
      infra: 'Infrastruktur',
      other: 'Andere',
    },
    gantt: {
      task: 'Aufgabe',
      noData: 'Kein Zeitplan – Termine zu Aufgaben hinzufügen',
      unassignedTasks: 'Aufgaben ohne Meilenstein',
      holiday: 'Roter Tag',
      dependencies: 'Abhängigkeiten',
      criticalPath: 'Kritischer Pfad',
      tasks: 'Aufgaben',
    },
  },
  fleet: {
    title: 'Fahrzeugflotte',
    overview: 'Fahrzeugflotte',
    backToDeque: 'Zurück zu Deque',
    overviewDescription: 'Alle Fahrzeuge anzeigen und verwalten',
    liveTrackingDescription: 'Fahrzeuge in Echtzeit auf der Karte anzeigen',
    vehicle: 'Fahrzeuge',
    status: 'Status',
    position: 'Position',
    speed: 'Geschwindigkeit',
    noVehicles: 'Keine Fahrzeuge gefunden',
    tryAllOrganizations: 'Versuchen Sie, im Filter „Alle Organisationen“ auszuwählen.',
    loading: 'Fahrzeuge werden geladen...',
    error: 'Konnte nicht geladen werden Fahrzeug',
    searchPlaceholder: 'Regnr suchen, IMEI, Marke, Modell, Organisation, Kraftstofftyp, Postleitzahl, Stadt, Fahrzeugkategorie, Ausrüstung, im Besitz, geleast...',
    searchPlaceholderShort: 'Regnr suchen, IMEI, Marke, Modell, Referenz, Ausrüstung, im Besitz oder geleast...',
    ownershipColumn: 'Im Besitz/geleast/Leasing beendet',
    ownershipOwned: 'Im Besitz',
    ownershipLeased: 'Leasing',
    ownershipLeaseEnded: 'Leasing beendet',
    filterBarLabel: 'Filter',
    columnFilterToggle: 'Spaltenfilter',
    columnFilterToggleHint: 'Ein Suchfeld pro Spalte anzeigen/ausblenden, um die Liste zu filtern',
    showing: 'Anzeige',
    of: 'von',
    vehicles: 'Fahrzeuge',
    page: 'Seite',
    first: 'Erste',
    last: 'Letzte',
    lastSeen: 'Zuletzt gesehen',
    placementCity: 'Stadt',
    referenceNumber: 'Referenz',
    referenceChooseOrType: 'Auswählen oder eingeben',
    organization: 'Organisation',
    connected: 'Verbunden',
    filterAll: 'Alle',
    filterConnected: 'Verbunden',
    filterDisconnected: 'Nicht verbunden',
    filterAllOrganizations: 'Alle Organisationen',
    systemStatus: 'Systemstatus',
    filterPreset: 'Filter',
    filterPresetAll: 'Alle',
    filterPoolcars: 'Alle Poolfahrzeuge',
    filterMil: 'Motorlicht an (MIL)',
    filterTaxDue: 'Steuer innerhalb von 45 Tagen',
    filterInspectionDue: 'Inspektion innerhalb von 40 Tagen',
    filterUsageStatus: 'Status',
    exportVehicleRegister: 'Fahrzeugbestand',
    exportVehicleRegisterExcel: 'Excel',
    exportVehicleRegisterCsv: 'CSV',
    exportVehicleRegisterSuccess: 'Der Export wurde heruntergeladen',
    exportVehicleRegisterError: 'Fahrzeugbestand konnte nicht exportiert werden',
    exportCarInfoVehicleReportExcel: 'Fahrzeugbericht Excel',
    exportCarInfoVehicleReportSuccess: 'Fahrzeugbericht heruntergeladen',
    exportCarInfoVehicleReportError: 'Fahrzeugbericht konnte nicht exportiert werden',
    exportFleetReport: 'Fahrzeugbericht',
    exportFleetReportExcel: 'Excel',
    exportFleetReportCsv: 'CSV',
    exportFleetReportSuccess: 'Fahrzeugbericht heruntergeladen',
    exportFleetReportError: 'Fahrzeugbericht konnte nicht exportiert werden',
    statusActive: 'Aktiv',
    statusMaintenance: 'Wartung',
    statusInactive: 'Inaktiv',
    statusRetired: 'Abgebrochen',
    functions: 'Funktionen',
    deactivate: 'Fahrzeug deaktivieren',
    activateVehicle: 'Fahrzeug reaktivieren',
    confirmActivate: 'Möchten Sie das erneut aktivieren? Fahrzeug {{reg}}?\n\nStatus ist auf aktiv gesetzt. Wenn noch ein GPSGerät verbunden ist, wird in der Gerätehistorie ein neuer Montagebereich geöffnet, damit die Daten wieder dem Auto zugeordnet werden können.',
    activatedSuccess: 'wurde wieder aktiviert',
    connectDevice: 'Gerät koppeln',
    connectKey: 'Schlüssel koppeln',
    connectKeyModal: {
      editTooltip: 'Schlüsselverbindung ändern',
      title: 'Schlüssel verbinden mit {{reg}}',
      editTitle: 'Schlüsselverbindung ändern für {{reg}}',
      pickupLocation: 'Ausgabeort',
      selectPickupLocation: 'Abholort auswählen',
      noPickupLocations: 'Keine Abholorte zur Auswahl.',
      noCabinets: 'Mit diesem Abholort sind keine Schließfächer verknüpft.',
      selectKey: 'Wählen Sie einen kostenlosen grünen Schlüssel aus.',
      selectedKey: 'Ausgewählter Schlüssel: {{name}}',
      saved: 'Schlüssel wurde mit {{reg}}',
      loadError: 'Schlüsseldaten konnten nicht abgerufen werden',
      saveError: 'Der Link konnte nicht gespeichert werden',
    },
    subscribe: 'Berichte abonnieren',
    milError: 'Motorfehler – Licht an',
    milNoData: 'Daten nicht verfügbar',
    milOk: 'Keine Fehler',
    fuelLevel: 'Kraftstoff (%)',
    fuelEvTooltip: 'Kraftstoff % (EV-Batterie %)',
    evRange: 'Reichweite',
    serviceDistance: 'Kilometer bis zur Wartung',
    installedTires: 'Reifen montiert',
    imeiColumn: 'IMEI',
    imeiFirmware: 'Firmware',
    imeiConfig: 'Konfiguration',
    imeiUnknown: 'unbekannt',
    currentOdometer: 'Aktueller Kilometerstand',
    flinkeyBoxColumn: 'flinkey box',
    transmissionColumn: 'Getriebe',
    pickupPlacementColumn: 'Ausgabeort',
    businessResponsibilityColumn: 'Geschäftsverantwortung',
    assignedUserColumn: 'Verbundener Benutzer',
    vehicleCategoryColumn: 'Fahrzeugkategorie',
    alternativeFuelColumn: 'Alternativer Kraftstoff',
    vehicleStatusColumn: 'Status',
    noUsageStatus: 'Kein Status',
    columnSettings: {
      button: 'Spalten',
      title: 'Tabellenspalten',
      description: 'Wählen Sie aus, welche Spalten in welcher Reihenfolge angezeigt werden sollen. Ziehen Sie sichtbare Zeilen, um die Reihenfolge zu ändern. Die Einstellung wird in Ihrem Benutzerkonto gespeichert.',
      fixedHint: 'Die Spalte „Fahrzeug“ wird immer zuerst und „Funktionen“ immer zuletzt angezeigt.',
      searchPlaceholder: 'Suchspalte...',
      noResults: 'Keine Spalten entsprechen der Suche',
      visibleColumns: 'Sichtbare Spalten',
      hiddenColumns: 'Ausgeblendete Spalten',
      dragHint: 'Ziehen, um Reihenfolge zu ändern',
      reset: 'Auf Standard zurücksetzen',
      saveSuccess: 'Spalteneinstellungen gespeichert',
      saveError: 'Spalteneinstellungen konnten nicht gespeichert werden',
      resetSuccess: 'Spalten auf Standard zurückgesetzt',
    },
    make: 'Marke',
    model: 'Modell',
    year: 'Modelljahr',
    fuelType: 'Kraftstofftyp',
    sitplatser: 'Sitze',
    costCenter: 'Kostenstelle',
    initialOdometer: 'Eingehender Zählerstand (km)',
    initialOdometerHint: 'Vermessung bei Anmeldung',
    isPoolcar: 'Poolwagen',
    sharedCompanyCar: 'Gemeinsamer Firmenwagen',
    sharedCompanyCarHint: 'Mehrere Personen können das Auto fahren. Die App hört das GPSGerät und zeigt an, wer da war.',
    registrationNumber: 'Registrierungsnummer',
    fuelTypes: {
      petrol: 'Benzin',
      diesel: 'Diesel',
      electric: 'Elektro',
      hybrid: 'Hybrid',
      pluginHybrid: 'Plug-in-Hybrid',
      gas: 'Gas',
      ethanol: 'Ethanol',
    },
    addVehicle: {
      button: 'Neufahrzeug',
      title: 'Neues Fahrzeug registrieren',
      fetchCarInfo: 'Von Car.info herunterladen',
      fetched: 'Heruntergeladen',
      enterRegNumber: 'Zuerst Kennzeichen eingeben',
      carInfoSuccess: 'Fahrzeugdaten von Car.info heruntergeladen',
      carInfoNotFound: 'Fahrzeug nicht in Car.info gefunden',
      carInfoLoaded: 'Fahrzeugdaten von Car.info geladen',
      stolenWarning: 'WARNUNG: Dieses Fahrzeug wurde als gestohlen gemeldet!',
      drivingBanWarning: 'WARNUNG: Dieses Fahrzeug darf nicht gefahren werden!',
      regRequired: 'Registrierungsnummer erforderlich',
      orgRequired: 'Organisation auswählen',
      selectOrg: 'Organisation auswählen',
      success: 'Fahrzeug registriert!',
      error: 'Fahrzeug konnte nicht erstellt werden',
      save: 'Fahrzeug speichern',
    },
  },
  flinkey: {
    sectionTitle: 'flinkey (digitaler Schlüssel)',
    attach: 'flinkey koppeln',
    detach: 'entkoppeln',
    assignKey: 'Schlüssel zuweisen',
    boxIdPlaceholder: 'flinkey-Box-ID',
    assignModalTitle: 'digitalen Schlüssel zuweisen',
    assignUser: 'Benutzer (ID)',
    validFrom: 'Gültig von (optional)',
    validUntil: 'Gültig bis (optional)',
    assign: 'Zuweisen',
    selectBox: '– Feld auswählen –',
    noBoxesForOrg: 'Keine Flinkey-Felder für die Organisation registriert',
    notLicensedForOrg: 'Keine Flinkey-Felder für die Organisation registriert',
    listLoadError: 'Flinkey-Boxen konnten nicht abgerufen werden. Netzwerk oder Autorisierung prüfen.',
    noBoxLinked: 'Keine FlinkeyBox mit dem Fahrzeug verbunden',
    chooseBox: 'Box auswählen',
    changeBox: 'Box ändern',
    orgBoxCount: '{{count}}Box(en) in der Organisation (inkl. Vorgesetzten)',
    searchBoxesPlaceholder: 'Nach Produkt-ID, Seriennummer oder Kennzeichen suchen...',
    searchNoHits: 'Keine Boxen entsprechen der Suche',
    boxOnOtherVehicle: 'Mit Fahrzeug verbunden {{reg}} – Wählen Sie, um zu diesem Fahrzeug zu wechseln',
    boxUnassigned: 'Freie Box (kein Fahrzeug)',
    currentBoxBadge: 'Dieses Fahrzeug',
  },
  carInfoFilter: {
    title: 'Filter',
    addFilter: 'Filter hinzufügen',
    noFilters: 'Keine Filter ausgewählt',
    noFiltersAdded: 'Keine Filter hinzugefügt',
    addFilterHint: 'Zum Starten auf „Filter hinzufügen“ klicken',
    enterValue: 'Wert eingeben...',
    search: 'Suchen',
    clear: 'Löschen',
    loadError: 'Filter konnte nicht geladen werden',
    searchError: 'Suche fehlgeschlagen',
    vehiclesFound: 'Fahrzeug gefunden',
    filterButton: 'Fahrzeugfilter',
    searchFields: 'Suchfeld...',
    searching: 'Suche...',
    searchButton: 'Suchen',
    cancel: 'Abbrechen',
    noFiltersConfigured: 'Keine Filter konfiguriert',
    enableFiltersHint: 'Filter in SysAdmin → Fahrzeugfilter aktivieren',
    selectFilterValue: 'Mindestens einen Filterwert auswählen',
    vehiclesFoundCount: '{count}Fahrzeug gefunden',
    resultIdsMissing: 'Die Suche hat Fahrzeuge gefunden, konnte sie aber nicht auflisten',
    searchFailed: 'Suche fehlgeschlagen',
    allOption: '-- Alle --',
    otherCategory: 'Andere',
    loadingValues: 'Werte werden geladen...',
  },
  carInfoFilterConfig: {
    title: 'Car.info-Filterkonfiguration',
    subtitle: 'Wählen Sie aus, welche Car.info-Felder im Filter in der Fahrzeugflotte angezeigt werden sollen.',
    activeFilters: 'Aktive Filter',
    totalFields: 'Gesamtzahl der Felder',
    categories: 'Kategorien',
    showActiveOnly: 'Nur aktive anzeigen',
    expandAll: 'Alle erweitern',
    collapseAll: 'Alle reduzieren',
    reload: 'Neu laden',
    fieldsCount: 'Felder',
    noFieldsFound: 'Keine Felder gefunden',
    adjustSearch: 'Versuchen Sie, die Suche zu ändern oder den Filter zu entfernen',
    loadError: 'Filterkonfiguration konnte nicht geladen werden',
    errorToggle: 'Felder konnten nicht aktualisiert werden',
    activated: 'Aktiviert',
    deactivated: 'Deaktiviert',
    fields: 'Felder',
    uncategorized: 'Nicht kategorisiert',
    examplePrefix: 'Ex',
  },
  sms: {
    title: 'SMS-Befehl senden',
    message: 'Nachricht',
    send: 'Senden',
    sending: 'Senden...',
    sent: 'SMS gesendet!',
    sentSuccess: 'SMS gesendet!',
    sentDescription: 'Die Nachricht wurde an das Gerät gesendet.',
    hint: 'Der Befehl beginnt mit zwei Leerzeichen zur Authentifizierung',
    noImei: 'Das Fahrzeug hat kein gekoppeltes Gerät (IMEI fehlt)',
    emptyMessage: 'Die Nachricht darf nicht leer sein',
    messageId: 'Nachrichten-ID',
    status: 'Status',
    statusDelivered: 'Zugestellt',
    statusSent: 'Gesendet',
    statusPending: 'Warten',
    statusFailed: 'Fehlgeschlagen',
    statusCancelled: 'Storniert',
  },
  unbookedTrips: {
    title: 'Fahrten ohne Buchung',
    from: 'Von',
    to: 'Bis',
    organization: 'Organisation',
    all: 'Alle',
    show: 'Anzeigen',
    empty: 'Keine Fahrten ohne Buchung im Zeitraum.',
    vehicle: 'Fahrzeug',
    start: 'Start',
    end: 'Ende',
    distance: 'Km',
    driver: 'Fahrer',
    purpose: 'Zweck',
    extraPersons: 'Weitere Personen',
    create: 'Buchung erstellen',
    print: 'Fahrtenbuch',
    selectTrips: 'Mindestens eine Fahrt wählen',
    sameVehicle: 'Die Fahrten müssen dasselbe Fahrzeug betreffen',
    created: 'Die Buchung wurde gespeichert',
    attached: 'Die Fahrten wurden einer bestehenden Buchung zugeordnet',
    openCount: 'ohne Buchung',
  },
  reports: {
    title: 'Berichte',
    comingSoon: 'Berichte folgen in Kürze...',
    bookingStats: {
      title: 'Buchungsstatistik',
      description: 'Volumen, Belegung, Anfragefluss, Zeitschätzung, Aktivierung bis Flinkey und Trend für Buchungen.',
      from: 'Von',
      to: 'Bis',
      granularity: 'Zeitauflösung',
      granularityDay: 'Tag',
      granularityWeek: 'Woche',
      granularityMonth: 'Monat',
      basis: 'Belegungsbasis',
      basisCalendar: 'Kalendertag',
      basisWorkdays: 'Arbeitstage',
      pickupLocation: 'Ausgabeort',
      allPickupLocations: 'Alle Standorte',
      allOrganizations: 'Alle Organisationen',
      refresh: 'Aktualisieren',
      loadError: 'Buchungsstatistiken konnten nicht abgerufen werden.',
      noData: 'Keine Daten für Zeitraum.',
      totalBookings: 'Buchungen insgesamt',
      requestFlow: 'Anfrage / zugewiesen',
      requestSharePct: 'Anteil der Anfrage: {{pct}}%',
      occupancy: 'Belegungsgrad',
      avgLength: 'Durchschnittliche Dauer',
      uniqueBookers: 'Einzelbucher',
      uniqueBookersSub: 'Konto, RSID oder Name',
      totalKm: 'Entfernung (km)',
      totalKmSub: 'Tatsächliche Entfernung während der Abholung',
      vehicleCount: 'Anzahl der Fahrzeuge',
      noShow: 'Nichterscheinen',
      noShowSub: 'Automatisch freigegeben (nicht rechtzeitig abgeholt)',
      serviceNotUsed: 'Servicebuchungen nicht genutzt',
      serviceNotUsedSub: 'Anteil der Servicebuchungen: {{pct}}%',
      byStatus: 'Volumen pro Status',
      byCarClass: 'Verteilung nach Fahrzeugklasse',
      trend: 'Trend (Volumen)',
      topVehicles: 'Am häufigsten gebuchte Fahrzeuge',
      timingTitle: 'Zeitschätzung und Flinkey',
      timingHint: 'Gilt für Buchungen, die nach Beginn der Speicherung der ursprünglichen Zeit erstellt wurden. Pünktlich = innerhalb von ±{{minutes}} Min. gegenüber der Originalzeit.',
      timingNoSamples: 'Noch keine Buchungen mit Originalzeit im Zeitraum.',
      pickupVsOriginal: 'Abholung vs. Original',
      returnVsOriginal: 'Rückgabe vs. Original',
      activateToUnlock: 'Aktivierung → Flinkey Eröffnung',
      avgDelta: 'Durchschnittliche Abweichung',
      earlier: 'Vorherige',
      onTime: 'I-Zeit',
      later: 'Später',
      sampleCount: '{{count}}Buchungen',
      unlockAvg: 'Durchschnittliche {{minutes}} Minute',
      unlockUnder2: 'Unter 2 Minuten',
      unlock2to5: '2–5 Minuten',
      unlock5to15: '5–15 Minuten',
      unlockOver15: 'Über 15 Minuten',
    },
    energyConsumption: {
      title: 'Energieverbrauch',
      description: 'Kraftstoffverbrauch pro Organisation und Fahrzeug analysieren',
    },
    speedCompliance: {
      title: 'Geschwindigkeit Einhaltung',
      description: 'Analysieren Sie die Einhaltung von Geschwindigkeitsbegrenzungen durch das Fahrzeug',
    },
    vehicleWear: {
      title: 'Fahrzeugverschleiß',
      description: 'Analysieren Sie, wie sich das Fahrverhalten auf den Fahrzeugverschleiß auswirkt',
    },
    underutilized: {
      title: 'Nicht ausgelastete Fahrzeuge',
      description: 'Fahrzeuge mit geringer Auslastung identifizieren',
    },
    co2: {
      title: 'CO₂-Emissionen',
      description: 'CO₂-Emissionen berechnen und analysieren',
    },
    geofenceZone: {
      title: 'Geofence-Zonenbericht',
      description: 'Analysieren Sie, wie oft sich Fahrzeuge in Zonen befinden',
    },
    fuelAnalysis: {
      title: 'Kraftstoffanalyse',
      description: 'Analysieren Sie Kraftstoffkosten und Verbrauch aus importierten Transaktionen',
      totalCost: 'Gesamtkosten',
      totalLiters: 'Gesamtvolumen',
      costPerMil: 'Kosten pro Meile',
      avgPricePerLiter: 'Durchschnittspreis',
      cost: 'Kosten',
      liters: 'Liter',
      fuelType: 'Kraftstofftyp',
      costByOrg: 'Kosten pro Organisation',
      byFuelType: 'pro Kraftstofftyp',
      costTrend: 'Kostentrend (Kr/Meile)',
      costVolumeTrend: 'Kosten und Volumen pro Monat',
    },
    fleetTco: {
      title: 'Flottenkostenanalyse (TCO)',
      description: 'Gesamtbetriebskosten pro Fahrzeug: Kraftstoff, Service, Leasing und Versicherung',
      totalCost: 'Gesamtkosten',
      costPerKm: 'Kosten pro km',
      costPerMonth: 'Kosten pro Monat',
      totalDistance: 'Gesamtkilometerleistung',
      fuel: 'Kraftstoff',
      service: 'Service',
      leasing: 'Leasing',
      insurance: 'Versicherungen',
      tax: 'Steuern/Malus',
      total: 'Gesamt',
      breakdown: 'Kostenaufschlüsselung',
      byFuelType: 'Kosten pro Fahrzeugtyp',
      vehicle: 'Fahrzeuge',
      tabs: {
        overview: 'Übersicht',
        byType: 'pro Fahrzeugtyp',
      },
    },
    executive: {
      title: 'Managementbericht',
      statisticsTitle: 'Statistische Übersicht',
      description: 'Gesamtkennzahlen für die gesamte Flotte mit Kosten, Auslastung und CO₂',
      period: 'Zeitraum',
      periodWeek: 'Woche',
      periodMonth: 'Monat',
      periodQuarter: 'Quartal',
      periodYear: 'Jahr',
      totalDistance: 'Gesamtkilometerleistung',
      totalFuelCost: 'Kraftstoffkosten',
      totalTco: 'Gesamtbetriebskosten',
      utilization: 'Auslastung',
      co2: 'CO₂-Emissionen',
      activeVehicles: 'Aktive Fahrzeuge',
      costTrend: 'Kostentrend',
      co2Trend: 'CO₂-Trend',
      topDeviations: 'Top-5-Abweichungen',
      exportPdf: 'PDF exportieren',
      noDeviations: 'Keine Abweichungen für den Zeitraum',
    },
    vehicleKpi: {
      title: 'Kennzahlen Fahrzeuge',
      description: 'Zusammenfassung der Kennzahlen pro Fahrzeug, Monat und Jahr',
      tabs: {
        overview: 'Organisationsübersicht',
        vehicleYear: 'Jahresbericht/Fahrzeuge',
        vehicleMonth: 'Fahrzeuge/Monat',
      },
      filters: {
        organization: 'Organisation',
        year: 'Jahr',
        vehicle: 'Fahrzeuge',
        month: 'Monat',
      },
      summary: {
        totalVehicles: 'Anzahl der Fahrzeuge',
        totalDistance: 'Gesamtkilometerleistung',
        totalFuel: 'Gesamtkraftstoff',
        avgFuelPer100km: 'Durchschnittlich L/100km',
        avgElectricShare: 'Durchschnittlicher Stromanteil',
        totalCo2: 'Gesamt CO₂',
        totalDuration: 'Gesamtfahrzeit',
        totalIdling: 'Gesamtruhezeit',
        daysDriven: 'Fahrtage',
      },
      columns: {
        registrationNumber: 'RegNr',
        organization: 'Gruppe',
        make: 'Marke',
        model: 'Modell',
        period: 'Zeitraum',
        date: 'Datum',
        month: 'Monat',
        distanceKm: 'Entfernung (km)',
        fuelL: 'Kraftstoff (L)',
        fuelPer100km: 'Durchschnitt (L/100 km)',
        electricSharePct: 'E-Anteil',
        co2Kg: 'CO₂ (kg)',
        daysDriven: 'Fahrtage',
        kmPerDay: 'Km/Tag',
        duration: 'Fahrzeit',
        avgSpeed: 'Durchschnittsgeschwindigkeit.',
        idling: 'Leerlauf',
        status: 'Status',
        fuelType: 'Kraftstofftyp',
        trend: 'Trend',
      },
      status: {
        active: 'Aktiv',
        inactive: 'Inaktiv',
        sold: 'Verkauft',
      },
      breadcrumb: {
        overview: 'Übersicht',
        backToOverview: 'Zurück zur Übersicht',
        backToYear: 'Zurück zum Jahresbericht',
      },
      export: 'Export CSV',
      noData: 'Keine Daten für den ausgewählten Zeitraum gefunden',
      selectOrganization: 'Organisation auswählen, um Fahrzeuge anzuzeigen',
      selectVehicleForYear: 'Jahreszusammenfassung pro Fahrzeug. Klicken Sie auf ein Fahrzeug, um eine monatliche Panne anzuzeigen.',
      selectVehicleForMonth: 'Wählen Sie das Fahrzeug in der Liste aus, um die tägliche Panne für den ausgewählten Monat anzuzeigen.',
    },
    dtc: {
      title: 'DTC-Fehlerbericht',
      description: 'Diagnose-Fehlercodes (DTCs) nach Fahrzeug anzeigen und analysieren',
      activeDtc: 'Aktive DTCs',
      vehiclesWithDtc: 'Fahrzeuge mit DTCs',
      highSeverity: 'Hoch/Kritisch',
      lowSeverity: 'Niedrig/Mittel',
      byCategory: 'Nach Kategorie',
      bySeverity: 'Nach Schweregrad',
      topCodes: 'Häufigste DTCs',
      code: 'DTC-Code',
      category: 'Kategorie',
      severity: 'Schweregrad',
      firstSeen: 'Erstmals',
      lastSeen: 'Zuletzt gesehen',
      resolvedAt: 'Gelöst',
      active: 'Aktiv',
      resolved: 'Gelöst',
      codeSearch: 'DTC-Suche',
      searchTitle: 'DTC-Code suchen',
      whatDoesItMean: 'Was bedeutet das?',
      symptoms: 'Symptome',
      causes: 'Mögliche Ursachen',
      repairSteps: 'Diagnose und Reparatur',
      notAvailable: 'Daten nicht verfügbar',
      notAvailableDetailed: 'DQFleet sind diese Daten derzeit nicht verfügbar. Der Code ist in der Datenbank, hat aber keine Beschreibung.',
      noDetailedInfo: 'Zu diesem Fehlercode sind keine detaillierten Informationen verfügbar.',
    },
    workTrips: {
      title: 'Geschäftsreisen',
      description: 'Reisen mit geteilten Firmenwagen, mit Fahrern und wenn jemand über die App identifiziert wurde',
      filtersTitle: 'Fahrzeug und Zeitraum',
      vehicleLabel: 'Fahrzeuge',
      allVehicles: 'Alle geteilten Fahrzeuge',
      fromDate: 'Von-Datum',
      toDate: 'Bis-Datum',
      identificationLabel: 'Identifikation',
      identificationAll: 'Alle Fahrten',
      identificationIdentified: 'Über App identifiziert',
      identificationUnidentified: 'Keine Identifikation',
      fetch: 'Fahrten abrufen',
      fetchError: 'Geschäftsfahrten konnten nicht abgerufen werden',
      tripCount: 'Reise',
      identifiedCount: 'Über App identifiziert',
      unidentifiedCount: 'Keine Identifikation',
      totalDistance: 'Gefahrene Strecke',
      colVehicle: 'Fahrzeuge',
      colDate: 'Datum',
      colTime: 'Zeit',
      colFrom: 'Von',
      colTo: 'Bis',
      colDistance: 'Entfernung',
      colDuration: 'Fahrzeit',
      colDriver: 'Fahrer',
      colIdentification: 'Identifikation',
      colPresent: 'Im Auto',
      colPurpose: 'Zweck',
      presenceDriver: 'Identifiziert',
      presenceNotChosen: 'Identifiziert, Fahrer nicht ausgewählt',
      presenceSingleScan: 'Identifiziert (ein Scan)',
      presenceUnknown: 'Keine Identifikation',
      presenceNone: 'Keine Identifikation',
      noDriver: 'Unbekannter Fahrer',
      empty: 'Keine Fahrten während des Zeitraums',
      exportSuccess: 'CSV exportiert',
    },
    drivingLog: {
      title: 'Fahrprotokoll',
      description: 'Fahrdatensatz gemäß den Richtlinien der Steuerbehörde für Steuerdokumentation',
      selectVehicle: 'Fahrzeug auswählen',
      fetchError: 'Fahrt konnte nicht abgerufen werden Protokoll',
      purposeUpdateError: 'Zweck konnte nicht aktualisiert werden',
      noteUpdateError: 'Notiz konnte nicht gespeichert werden',
      noDataToSubmit: 'Es ist kein Fahrtenprotokoll zum Senden vorhanden',
      submitConfirm: 'Möchten Sie den Fahrdatensatz für den ausgewählten Zeitraum an die Weiterleitungsadresse der Organisation senden? Nach der Übermittlung ist die Bearbeitung gesperrt.',
      submitSuccess: 'Das Protokoll wurde übermittelt und gesperrt.',
      submitError: 'Das Protokoll konnte nicht übermittelt werden',
      noExportData: 'Keine Daten zum Exportieren',
      csvColType: 'Typ (Privat/Service)',
      csvColPurposeShort: 'Zweck (T/P)',
      csvColNote: 'Hinweis',
      business: 'Dienst',
      private: 'Privat',
      undefined: 'Undefiniert',
      totalDistanceLabel: 'Gesamtstrecke gefahren (km)',
      privateDistanceLabel: 'Gefahren Privat (km)',
      businessDistanceLabel: 'Im Dienst gefahren (km)',
      undefinedDistanceLabel: 'Undefiniert gefahren (km)',
      undefinedDistanceShort: 'Undefiniert gefahren',
      csvSummaryHeading: 'ZUSAMMENFASSUNG',
      tripCountLabel: 'Anzahl der Fahrten',
      periodLabel: 'Zeitraum',
      exportSuccess: 'CSV exportiert',
      filtersTitle: 'Fahrzeug und Zeitraum auswählen',
      vehicleLabel: 'Fahrzeuge',
      fromDate: 'Von-Datum',
      toDate: 'Bis-Datum',
      fetch: 'Fahrdatensatz herunterladen',
      print: 'Drucken',
      submit: 'Senden',
      submitting: 'Senden...',
      periodLockedHint: 'Dieser Zeitraum wurde übermittelt und kann nicht bearbeitet werden.',
      tripCountShort: 'Anzahl der Fahrten',
      totalDistanceShort: 'Gesamtstrecke gefahren',
      privateDistanceShort: 'Privat gefahren',
      businessDistanceShort: 'Eingefahren Dienst',
      colDate: 'Datum',
      colTime: 'Zeit',
      colFrom: 'Von',
      colTo: 'Bis',
      colOdoStart: 'Zähleranfang',
      colOdoEnd: 'Zählerende',
      colDistance: 'Entfernung',
      colDuration: 'Fahrzeit',
      colToll: 'Maut (SEK)',
      tollSummaryTitle: 'Maut (Zeitraum)',
      csvTollBusinessLabel: 'Mautdienst (gesamte SEK)',
      csvTollPrivateLabel: 'Maut privat (gesamte SEK)',
      csvTollUndefinedLabel: 'Maut undefiniert (gesamte SEK)',
      tollFollowsTripPurposeHint: 'Die Maut ist an die Fahrt gebunden. Wählen Sie „Service“ oder „Privat“ für die Fahrt – der gleiche Zweck gilt für Route und Maut.',
      colTripType: 'Service/Privat',
      colPurpose: 'Zweck',
      colNote: 'Zweck/Hinweis',
      adjustmentPurposeDisabledTitle: 'Zähleranpassung – Zweck (Service/Privat) gilt nicht für diese Zeile',
      correctionPurposeLabel: 'Korrektur',
      adjustmentDistanceShort: 'Zähleranpassung',
      adjustmentDistanceLabel: 'Zähleranpassung (Korrektur, nicht fahren)',
      togglePrivateTitle: 'Zu Service wechseln',
      toggleBusinessTitle: 'Zu Privat wechseln',
      toggleUnsetTitle: 'Privat oder Service eingeben',
      notePlaceholder: 'Zweck der Fahrt beschreiben...',
      footerSum: 'Gesamtstrecke',
      emptyTitle: 'Keine Fahrten während des Zeitraums',
      emptyBody: 'Fahrzeug und Zeitraum auswählen und auf Fahraufzeichnung herunterladen klicken.',
      infoTitle: 'Tipps zur Dokumentation',
      infoLine1: 'Zweck (Schalter) für jede Fahrt markieren – die Spalte Service/Privat folgt und ist gespeichert. Zurückgelegte Gesamtstrecke = privat + Service + undefiniert (nur tatsächliche Fahrt; Zähleranpassung wird separat gemeldet, siehe letzter Punkt).',
      infoLine2: 'Geben Sie bei Bedarf den Verwendungszweck in das Notizfeld ein.',
      infoLine3: 'Dokumentation zur Abrechnung exportieren oder drucken.',
      infoLine4: 'Senden sendet an die Weiterleitungsadresse des obersten Knotens und sperrt den Zeitraum.',
      infoLine5: 'Adressen werden angezeigt, wenn sie im System verfügbar sind.',
      infoLine6: '„Gesamt gefahrene Strecke“ und „Privat/Service/Undefiniert“ fassen nur die tatsächliche Fahrt zusammen. Die Zähleranpassung (Korrektur) wird separat ausgewiesen und ist in diesen Summen nicht enthalten.',
    },
    odometerReport: {
      title: 'Zählerstandbericht',
      description: 'Zählerstand pro Fahrzeug an einem bestimmten Datum anzeigen',
      organizationGroup: 'Organisation/Gruppe',
    },
    rentalReport: {
      title: 'Mietbericht',
      description: 'Vollständiger Mietbericht mit Fahrten, Kosten und Status',
      tabs: {
        overview: 'Übersicht',
        trips: 'Reise',
        geofences: 'Geofences',
        warnings: 'Warnungen',
        environment: 'Umgebung',
        status: 'Status',
      },
      vehicle: 'Fahrzeuge',
      period: 'Zeitraum',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      fetchReport: 'Bericht herunterladen',
      downloadPdf: 'PDF herunterladen',
      sendEmail: 'Per E-Mail senden',
      totalDistance: 'Gesamtkilometerleistung',
      totalTrips: 'Anzahl der Fahrten',
      totalWarnings: 'Anzahl der Warnungen',
      geofenceCosts: 'Geofence-Kosten',
      fuelStatus: 'Tankstatus',
      tankFull: 'Tank ist voll',
      tankMissing: 'Ungefähr fehlt',
      milAlarm: 'MIL-Alarm',
      noMilAlarms: 'Keine MIL-Alarme während des Zeitraums',
      milActive: 'MIL-Alarm aktiv',
      co2Emissions: 'CO₂-Emissionen',
      fuelConsumption: 'Kraftstoffverbrauch',
      fuel: 'Kraftstoff',
      fuelKinds: 'Kraftstofftyp',
      consumption: 'Verbrauch',
      perKm: 'Pro km',
      electricShare: 'E-Anteil',
      electricUsed: 'Stromverbrauch',
      electricPerKm: 'Strom pro km',
      emailSent: 'Bericht gesendet!',
      recipientEmail: 'E-Mail-Adresse',
      recipientName: 'Empfängername',
      message: 'Nachricht',
    },
    decodeBinError: 'Bin-Datei konnte nicht entschlüsselt werden',
  },
  co2: {
    title: 'CO₂-Emissionen',
    description: 'CO₂-Emissionen für die Fahrzeugflotte berechnen und analysieren',
    totalCO2: 'Gesamt-CO₂-Emissionen',
    avgPerKm: 'Durchschnittlicher CO₂/km',
    electricVehicles: 'Elektrofahrzeuge',
    fossilVehicles: 'Fossile Fahrzeuge',
    co2Saved: 'CO₂-Einsparungen (Elektrofahrzeuge)',
    trendTitle: 'CO₂-Emissionen im Laufe der Zeit',
    fuelTypeDistribution: 'Kraftstoffverteilung',
    vehicleDetails: 'CO₂ pro Fahrzeug',
    fuelType: 'Kraftstoff',
    fuelUsed: 'Verbrauch',
    totalCO2Short: 'CO₂ (kg)',
    wltpCO2: 'WLTP',
  },
  geofenceZone: {
    title: 'Geofence-Zonenbericht',
    description: 'Analysieren Sie, wie oft sich Fahrzeuge in ausgewählten Zonen befinden',
    selectZone: 'Zone auswählen',
    totalZones: 'Anzahl der Zonen',
    totalVehicles: 'Fahrzeuge',
    totalVisits: 'Gesamtbesuch',
    totalTime: 'Gesamtzeit',
    totalCost: 'Gesamtkosten',
    visitsOverTime: 'Besuch über die Zeit',
    zoneSummary: 'Zusammenfassung pro Zone',
    vehicleDetails: 'Fahrzeuge pro Zone',
    zone: 'Zone',
    vehicles: 'Fahrzeuge',
    visits: 'Besuche',
    costColumn: 'Kosten',
    totalDuration: 'Gesamtzeit',
    avgDuration: 'Durchschnitt/Besuche',
    lastVisit: 'Neueste',
    noData: 'Keine Daten für den ausgewählten Zeitraum',
    fetchError: 'Bericht konnte nicht abgerufen werden',
    globalLabel: 'Global',
    filteredLabel: 'Gefiltert',
    showingRowsCount: 'Zeigt {{count}} von {{total}} Zeilen an',
  },
  underutilized: {
    title: 'Nicht ausgelastete Fahrzeuge',
    description: 'Fahrzeuge mit geringer Auslastung identifizieren und generieren Warnungen',
    totalVehicles: 'Gesamtfahrzeug',
    activeVehicles: 'Aktive Fahrzeuge',
    underutilizedVehicles: 'Mit Warnungen',
    avgUtilization: 'Durchschnittliche Auslastung',
    utilizationOverview: 'Auslastungsübersicht',
    utilizationTrend: 'Auslastungstrend',
    showOnlyWarnings: 'Nur Warnungen anzeigen',
    vehiclesWithWarnings: 'Fahrzeuge mit Warnungen',
    allVehicles: 'Alle Fahrzeuge',
    activeDays: 'Aktive Tage',
    utilization: 'Auslastung',
    warnings: 'Warnungen',
  },
  vehicleWear: {
    title: 'Fahrzeugverschleiß',
    description: 'Analysieren Sie, wie sich das Fahrverhalten auf den Fahrzeugverschleiß auswirkt',
    totalVehicles: 'Anzahl der Fahrzeuge',
    avgWearScore: 'Durchschnittlicher Verschleiß',
    worstCategory: 'Schlechteste Kategorie',
    vehiclesAtRisk: 'Fahrzeuge in der Risikozone',
    wearByVehicle: 'Verschleiß pro Fahrzeug',
    wearProfile: 'Verschleißprofil',
    selectVehicle: 'Wählen Sie ein Fahrzeug für Details',
    clickBarToSelect: 'Klicken Sie auf ein Fahrzeug im Diagramm, um Details anzuzeigen',
    recommendations: 'Empfehlungen für',
    brakes: 'Bremsen',
    engine: 'Motor',
    tires: 'Reifen',
    fuel: 'Kraftstoff',
    overall: 'Gesamt',
  },
  login: {
    title: 'Anmelden',
    subtitle: 'Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein.',
    heroTitleLine1: 'Ihre Fahrzeugflotte.',
    heroTitleLine2: 'Einfacher.',
    heroBody: 'Fahrtagebuch, Buchung und Schlüsselverwaltung in ein und demselben System. Melden Sie sich an und sehen Sie, wie es der Flotte gerade geht.',
    brandFooter: '© {year} DEVIAQ AB · Linköping',
    emailLabel: 'E-Mail',
    passwordLabel: 'Passwort',
    passwordRequired: 'Passwort erforderlich',
    emailPlaceholder: 'name@foretag.se',
    passwordPlaceholder: '',
    showPassword: 'Anzeigen',
    hidePassword: 'Ausblenden',
    forgotPassword: 'Passwort vergessen?',
    loggingIn: 'Anmeldung...',
    loginButton: 'Anmelden',
    noAccount: 'Neuer Benutzer?',
    createAccount: 'Konto erstellen',
    welcomeMessage: 'Willkommen! Sie sind jetzt angemeldet.',
    loginError: 'E-Mail oder Passwort falsch. Bitte versuchen Sie es erneut.',
    verifyEmailTitle: 'E-Mail-Adresse muss bestätigt werden',
    verifyEmailBody: 'Sie müssen Ihre E-Mail-Adresse bestätigen, bevor Sie sich anmelden können. Eine Bestätigungs-E-Mail wurde gesendet.',
    verifyEmailBodyWithEmail: 'Sie müssen Ihre E-Mail-Adresse bestätigen, bevor Sie sich anmelden können. Eine Bestätigungs-E-Mail wurde an {email} gesendet.',
    verifyOrgLinkedNote: 'Ihre Domain ist mit einer Organisation verknüpft. Nach der Verifizierung erhalten Sie Zugriff als Leser (Betrachter) in dieser Organisation.',
    verifyManualOrgNote: 'Wenn Ihre Organisation Ihre E-Mail-Domäne nicht erkennt, muss ein Administrator möglicherweise Ihr Konto verknüpfen, bevor Sie alle Funktionen sehen.',
    resendVerification: 'Neue Bestätigungs-E-Mail senden',
    resendingVerification: 'Senden...',
    resendVerificationSuccess: 'Neue Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet.',
    resendVerificationError: 'Bestätigungs-E-Mail konnte nicht gesendet werden',
  },
  sidebar: {
    user: 'Benutzer',
    logout: 'Abmelden',
    noFeatures: 'Keine Funktionen verfügbar',
    expandMenu: 'Menü erweitern',
    collapseMenu: 'Menü minimieren (nur Symbole)',
    groups: {
      overview: 'Übersicht',
      operations: 'Bedienung',
      followUp: 'Nachverfolgung',
      system: 'System',
      other: 'Andere',
    },
  },
  temperatureMonitoring: {
    overviewTitle: 'Temperaturüberwachung',
    overviewDescription: 'Status der dem Kunden zugewiesenen und mit dem GPS-Tracker verbundenen EYE-Sensoren.',
    sensorsTitle: 'Sensoren & Verbindung',
    sensorsDescription: 'Die Sensoren sind zugewiesen aus der EYE-Ebene. Befestigen Sie einen Sensor an einem Fahrzeug (Steckplätze 1–4). Intervalle und Messungen werden automatisch an den Tracker gesendet.',
    configTitle: 'BLE/EYE-config (intern)',
    configDescription: 'Fehlerbehebung und manuelle Übersteuerung. Kunden sollten Sensoren und Kopplungen nutzen.',
    configInternalBannerTitle: 'Interne Sicht – nicht für den Kunden-Selbstservice',
    configInternalBannerBody: 'Parameter werden beim Verknüpfen und Bearbeiten automatisch im Code festgelegt. Diese Seite ist nur für DeviaQ/Support gedacht, wenn die automatische Bereitstellung debuggt werden muss.',
    recipientsTitle: 'Alarmempfänger',
    schedulesTitle: 'Berichtszeitpläne',
    schedulesComingSoon: 'Geplante wöchentliche und monatliche Berichte werden im nächsten Schritt angezeigt.',
    reportsTitle: 'Kühlkettenberichte',
    reportsDescription: 'Fahrzeug mit angeschlossenem EYE-Sensor auswählen. Der Bericht zeigt Temperatur und Luftfeuchtigkeit der letzten 7 Tage.',
    selectSensorForReport: 'Reg. auswählen. NEIN. / Sensor',
    noLinkedSensorsForReport: 'Keine Fahrzeuge mit angeschlossenen Sensoren. Schließen Sie den Sensor unter Sensoren & Verbindung an.',
    temperature: 'Temperatur',
    humidity: 'Luftfeuchtigkeit',
    battery: 'Batterie',
    lowBatteryLabel: 'Batterie schwach',
    tracker: 'Tracker (IMEI)',
    lastReading: 'Letzte Messung',
    noSensors: 'Noch keine Sensoren zugewiesen.',
    recentExcursions: 'Neueste Abweichungen',
    noExcursions: 'Keine registrierten Abweichungen.',
    sensor: 'Sensor',
    excursionType: 'Typ',
    started: 'Start',
    registerSensor: 'Sensor registrieren',
    organizationRequired: 'Kunde/Organisation auswählen, bevor der Sensor erstellt wird.',
    registeredSensors: 'Zugewiesene Sensoren',
    editName: 'Namen ändern',
    sensorRenamed: 'Anzeigename aktualisiert',
    noSerial: 'Keine Seriennummer',
    sensorName: 'Name (Anzeigename)',
    serialNumber: 'Seriennummer (SN)',
    product: 'Produkt',
    macAddress: 'MAC-Adresse (optional, Doppelpunkt nicht erforderlich)',
    invalidMac: 'MAC-Adresse muss aus 12 Hexadezimalzeichen bestehen, z. B. 7CD9F4142349',
    linkToTracker: 'Mit Tracker verbinden',
    configuredSlot: 'Aktiver Steckplatz in DQFleet',
    slotChangeHint: 'Beim Speichern wird der ausgewählte Steckplatz auf dem Tracker konfiguriert. Wenn Sie den Steckplatz wechseln, wird der alte automatisch ausgeschaltet.',
    willConfigure: 'An Tracker gesendet',
    scanInterval: 'Scanintervall',
    scanIntervalOptions: {
      '30': '30 Sekunden',
      '60': '1 Minute',
      '120': '2 Minuten',
      '300': '5 Minuten',
    },
    measurements: 'Messungen',
    measurement: {
      temperature: 'Temperatur',
      humidity: 'Luftfeuchtigkeit',
      magnet: 'Magnet (Tür/Luke)',
    },
    editLinkTitle: 'Verbindung bearbeiten',
    linkSettingsSaved: 'Einstellungen gespeichert',
    saveAndSendConfig: 'Speichern und an Tracker senden',
    saveWithoutSend: 'Speichern ohne Senden',
    saveOnlyHint: 'Änderungen an den gesendet Tracker nur, wenn Sie auf „Speichern und an Tracker senden“ klicken. Wenn der Tracker offline ist, wird die Konfiguration in die Warteschlange gestellt und bei der nächsten Verbindung gesendet.',
    settingsSavedNotSent: 'Gespeichert in DQFleet. Die Konfiguration wurde noch nicht an den Tracker gesendet – drücken Sie „Speichern und senden“ oder „BLE-Konfiguration senden“.',
    configSentQueuedBanner: 'Konfiguration befindet sich in der Warteschlange – der Tracker ist offline. Wird bei der nächsten Verbindung automatisch gesendet. Siehe Status- und Zustandsprotokoll unten.',
    configSentAppliedBanner: 'Konfiguration vom Tracker empfangen. Neuester Status und Gesundheitsprotokoll unten aktualisiert.',
    configSendLogEmpty: 'Noch keine gesendete Konfiguration.',
    configSyncStatus: 'Konfigurationsstatus',
    configLastSent: 'Zuletzt gesendet',
    configSendLog: 'Sendeprotokoll',
    linkSyncStatus: {
      applied: 'Vom Tracker empfangen',
      pending: 'In der Warteschlange (Tracker offline)',
      applying: 'Wird gesendet…',
      failed: 'Fehlgeschlagen',
      unknown: 'Unbekannt',
    },
    syncLogStatus: {
      applied: 'Empfangen',
      queued: 'Eingegangen Warteschlange',
      failed: 'Fehlgeschlagen',
    },
    selectSensor: 'Sensor auswählen',
    selectVehicle: 'Fahrzeug auswählen',
    selectSensorFirst: 'Sensor zuerst auswählen',
    vehiclePlaceholder: 'Reg.-Nr., Marke oder Modell suchen…',
    imeiFromVehicle: 'Fahrzeug zum Abrufen auswählen IMEI',
    noDeviceOnVehicle: 'Fahrzeug hat kein gekoppeltes GPSGerät (IMEI)',
    deviceId: 'Geräte-ID (devices.id)',
    slot: 'Steckplatz',
    link: 'Paar',
    activeLinks: 'Aktive Kopplungen',
    noLinks: 'Nr Verbindungen.',
    loadError: 'Daten konnten nicht geladen werden',
    saveError: 'Speichern nicht möglich',
    saveForbidden: 'Sie haben keine Berechtigung zum Speichern. Überprüfen Sie, ob Sie als Kunde angemeldet sind und das Recht haben, Sensoren zu erstellen.',
    sensorCreated: 'Sensor erstellt',
    linkCreated: 'Verbindung erstellt',
    linkAndConfigSent: 'Verbindung erstellt und BLE-Konfiguration an den Tracker gesendet',
    sendTrackerConfig: 'BLE-Konfiguration senden',
    provisionError: 'BLE-Konfiguration konnte nicht an den Tracker gesendet werden',
    configSaved: 'Konfiguration wurde in DQFleet',
    configApplied: 'Konfiguration an Gerät gesendet',
    configQueued: 'Gerät offline – Konfiguration muss bei Verbindung gesendet werden',
    syncStatusLabel: 'Synchronisierungsstatus',
    saveInCloud: 'Speichern unter DQFleet',
    sendToDevice: 'An Gerät senden',
    imeiRequired: 'Geben Sie IMEI ein, um die Konfiguration zu senden',
    recipientName: 'Name',
    email: 'E-Mail',
    phone: 'Telefon (SMS)',
    recipientCreated: 'Empfänger erstellt',
    noRecipients: 'Keine Empfänger.',
    exportCsv: 'Export CSV',
    eyeDeviceId: 'Sensor-ID',
    showReport: 'Bericht anzeigen',
    reportLoadError: 'Bericht konnte nicht abgerufen werden',
    noReportReadings: 'Keine Temperaturmessungen im ausgewählten Zeitraum.',
    reportPeriod: 'Zeitraum: {{from}} – {{to}}',
    reportReadingCount: '{{count}} Messungen',
    status: {
      ok: 'OK',
      no_signal: 'Kein Signal',
      out_of_range: 'Außerhalb des Grenzwerts',
      low_battery: 'Batterie schwach',
      sensor_error: 'Sensor Fehler',
      disconnected: 'Verbindung unterbrochen',
    },
  },
  drivers: {
    schedule: {
      title: 'Arbeitsplan',
      description: 'Geben Sie Geschäftszeiten ein, um Reisen automatisch als geschäftlich oder privat zu klassifizieren. Fahrten außerhalb des Zeitplans werden als privat markiert.',
      modeLabel: 'Nutzung',
      mode: {
        privateManual: 'Privat – Geschäftsfahrten manuell markieren',
        privateManualHelp: 'Das Auto ist auf der Karte nicht sichtbar. Alle Fahrten werden privat, bis Sie sie im Fahrtenbuch als Service markieren.',
        workHours: 'Offizielles Auto mit Arbeitszeiten',
        workHoursHelp: 'Das Auto ist innerhalb der angegebenen Arbeitszeiten auf der Karte sichtbar. Fahrten werden automatisch als Service- oder Privatfahrten klassifiziert.',
        companyCar: 'Firmenwagen – immer sichtbar',
        companyCarHelp: 'Der Wagen ist immer auf der Karte sichtbar. Alle Reisen werden als Service klassifiziert.',
        alwaysBusiness: 'Immer Service',
      },
      sameAllDays: 'Jeden Tag zur gleichen Zeit',
      commonTime: 'Arbeitszeiten (gilt für ausgewählte Tage)',
      noWorkTime: 'Privat (keine Arbeitszeiten)',
      noSchedule: 'Kein Zeitplan angegeben – alle Fahrten werden als privat klassifiziert',
      activeInfo: 'Tage mit angegebenen Arbeitszeiten',
      weekdays: 'Wochentage',
      weekend: 'Wochentage',
      weekdaysActive: 'Wochentage',
      weekendActive: 'Feiertage',
      saveSuccess: 'Arbeitsplan gespeichert',
      saveDraft: 'Fertig – gespeichert, wenn der Benutzer erstellt wird',
      saveDraftSuccess: 'Der Zeitplan wird bei der Erstellung einbezogen Klicken Sie auf Benutzer erstellen.',
      applyOrgDefaults: 'Organisationsstandard verwenden (Wochentage)',
      orgDefaultsReady: 'Der Organisationsstandard wird eingegeben. Klicken Sie auf „Speichern“, um auf dem Server zu speichern.',
      emptyPrefilledFromOrg: 'Es wurde kein Zeitplan auf dem Server gespeichert. Nachfolgend finden Sie den Standard der Organisation – klicken Sie auf „Speichern“, um ihn zu verwenden, oder ändern Sie die Zeiten für Ihren eigenen Zeitplan.',
      applyOrgDefaultsHelp: 'Füllt Montag bis Freitag mit der Standard-Servicezeit aus den Fahrdatensatzeinstellungen des Kunden im obersten Knoten. Speichern, um auf den Server zu schreiben.',
      applyOrgDefaultsMissing: 'Kein Organisationsstandard auf dem obersten Knoten konfiguriert.',
      applyOrgDefaultsNoOrg: 'Wählen Sie zuerst die Organisation für den Benutzer aus.',
      days: {
        monday: 'Mo',
        tuesday: 'Di',
        wednesday: 'Mi',
        thursday: 'Do',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'Sonn',
      },
    },
    assignment: {
      title: 'Fahrzeug Zuordnung',
      selectVehicle: 'Fahrzeug auswählen',
      searchVehicle: 'Registrierungsnummer suchen...',
      noVehiclesFound: 'Keine Fahrzeuge gefunden',
      typeToSearch: 'Zu suchendes Fahrzeug eingeben',
      hasDriver: 'Hat Fahrer',
      selectDate: 'Startdatum',
      selectTrip: 'Startfahrt auswählen (optional)',
      currentVehicle: 'Aktuelles Fahrzeug',
      since: 'Dann',
      currentDriverWarning: 'Das Fahrzeug hat bereits einen Fahrer: {{name}}. Diese Zuweisung wird automatisch beendet.',
      newAssignment: 'Neue Zuweisung',
      assign: 'Fahrzeug zuweisen',
      endAssignment: 'Zuweisung beenden',
      confirmEnd: 'Sind Sie sicher, dass Sie diese Zuweisung beenden möchten?',
      assignSuccess: 'Fahrer dem Fahrzeug zugewiesen',
      endSuccess: 'Zuweisung abgeschlossen',
      history: 'Zuweisungsverlauf',
      noUnassignedVehicles: 'Keine verfügbaren Fahrzeuge – jeder hat bereits eine aktive Fahrerzuweisung',
      noTrips: 'Keine Fahrten an diesem Tag',
      modePickUnassigned: 'Verfügbares Fahrzeug in der Organisation',
      modeLinkDevice: 'Gerät mit vorhandenem Fahrzeug verbinden',
      modeRegisterNew: 'Neues Fahrzeug registrieren',
      modeHelpPick: 'Wählen Sie ein Fahrzeug ohne aktive Fahrerzuweisung in Ihrer Kundenstruktur aus.',
      modeHelpLink: 'Suchen Sie nach Fahrzeugen anhand des Kennzeichens, wählen Sie eine nicht montierte Einheit und das Startdatum aus. Der vorhandene Fahrer im Fahrzeug wird bei Zuweisung ersetzt.',
      modeHelpRegister: 'Daten von Car.info abrufen, Zählerstand eingeben, Einheit und Datum auswählen. Das Fahrzeug wird in der ausgewählten Organisation erstellt.',
      orgRequired: 'Organisation ist für diese Aktion erforderlich.',
      searchVehicleInOrg: 'Fahrzeug (Reg.-Nr.) in der Organisation suchen',
      searchDevice: 'Einheit suchen (IMEI)…',
      selectDevice: 'Einheit auswählen',
      noDevicesFound: 'Keine Geräte gefunden',
      deviceGlobalSearch: 'Alle ungepaarten Geräte im System (globaler Administrator)',
      existingDevicePolicy: 'Das Fahrzeug verfügt bereits über ein Gerät',
      unmountExisting: 'Vorhandenes demontieren',
      swapDevices: 'Standort ändern (tauschen)',
      linkDeviceAndAssign: 'Gerät anschließen und Fahrer zuweisen',
      linkDeviceSuccess: 'Gerät angeschlossen und Fahrer zugewiesen',
      registerRegPlaceholder: 'ABC123',
      fetchCarInfo: 'Von Car.info herunterladen',
      initialOdometerKm: 'Anzeigeneinstellung beim Start (km)',
      createVehicleAndAssign: 'Fahrzeug erstellen, Gerät anschließen und zuweisen',
      registerSuccess: 'Fahrzeug erstellt und Fahrer zugewiesen',
      scheduleApplied: 'Fahrerplan gemäß Organisation aktualisiert',
      scheduleApplyWarn: 'Fahrplan der Organisation konnte nicht festgelegt werden (Fahraufzeichnungseinstellungen des obersten Knotens prüfen).',
      regLabel: 'Reg.Nr',
      makePlaceholder: 'Marke',
      modelPlaceholder: 'Modell',
      yearPlaceholder: 'Jahr',
      fuelPlaceholder: 'Kraftstoff',
      fuelPetrol: 'Benzin',
      fuelDiesel: 'Diesel',
      fuelElectric: 'Elektro',
      fuelHybrid: 'Hybrid',
    },
  },
  profile: {
    title: 'Mein Profil',
    edit: 'Bearbeiten',
    personalInfo: 'Persönliche Daten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Mobiltelefon',
    role: 'Rolle',
    organization: 'Organisation',
    cabinetPin: 'PIN-Code',
    cabinetPinHint: 'Ihr Code für den Schlüsselschrank.',
    noCabinetPin: 'Noch keine PIN',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    saveSuccess: 'Profil wurde aktualisiert',
    driverInfo: 'Fahrerinformationen',
    licenseNumber: 'Führerscheinnummer',
    licenseExpiry: 'Führerschein läuft ab',
    licenseCategories: 'Führerscheinkategorien',
    employeeId: 'Beschäftigungs-ID',
    department: 'Abteilung',
    costCenter: 'Kostenstelle',
    currentPasswordRequired: 'Aktuelles Passwort zum Ändern des Passworts erforderlich',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordMinLength: 'Mindestens 6 Zeichen',
    roleDriver: 'Fahrer',
    roleViewer: 'Indikator',
    defaultPickupLocation: 'Vorausgewählte Lieferung Standort',
    defaultPickupLocationHint: 'Der Lieferort, der automatisch für Sie ausgewählt wird, z. B. bei der Buchung.',
    selectPickupLocation: '– Lieferort auswählen –',
    selectPickupLocationRequired: 'Lieferort auswählen',
    noDefaultPickupLocation: 'Keine ausgewählt',
    pickupPromptTitle: 'Wählen Sie Ihren Standardlieferort aus',
    pickupPromptDescription: 'Sie müssen einen Standardlieferort auswählen, bevor Sie fortfahren können. Wählen Sie den Ort aus, den Sie am häufigsten nutzen, und er wird in Zukunft automatisch für Sie ausgefüllt. Sie können die Auswahl jederzeit unter „Mein Profil“ ändern.',
    pickupPromptLater: 'Später',
  },
  sysAdmin: {
    title: 'Systemadministrator',
    manageRoles: 'Rollen und Berechtigungen verwalten',
    manageOrganizations: 'Organisationen verwalten',
    dataMigration: 'Datenmigration',
    migrateData: 'Daten aus alter Datenbank migrieren',
    deviceCommands: 'Gerätebefehle',
    deviceCommandsDescription: 'Befehle an Geräte senden',
    auditLog: 'Audit-Protokoll',
    auditLogDescription: 'Protokoll der gesendeten Daten anzeigen commands',
    generalAuditLog: 'Changelog',
    generalAuditLogDescription: 'Alle Änderungen anzeigen (CREATE, UPDATE, DELETE)',
    errorLog: {
      name: 'Fehlerprotokoll',
      title: 'Fehlerprotokoll',
      description: 'Protokoll aller Systemfehler und Ausnahmen',
      viewDetails: 'Fehlerdetails',
      close: 'Schließen',
      resolutionNotes: 'Lösungshinweise',
      resolutionNotesPlaceholder: 'Optionale Hinweise...',
      saveStatus: 'Status speichern',
      saveStatusSuccess: 'Status aktualisiert',
      loading: 'Laden...',
      noErrorsFound: 'Keine Fehler gefunden',
      noResultsMatchFilters: 'Keine Fehler entsprechen dem aktuellen Filter. Filter löschen oder Schweregrad/Status ändern, um Fehler anzuzeigen.',
      status: 'Status',
      clearFilters: 'Filter löschen',
      searchPlaceholder: 'In Fehlermeldung suchen...',
      searchLabel: 'Suchen',
      severityLabel: 'Schweregrad',
      statusLabel: 'Status',
      clearLog: 'Fehlerprotokoll löschen',
      clearLogTitle: 'Fehlerprotokoll löschen',
      clearLogDescription: 'Wählen Sie, ob alle Fehler oder nur diejenigen gelöscht werden sollen, die älter als eine bestimmte Anzahl von Tagen sind.',
      clearOlderThanLabel: 'Einträge löschen, die älter als (Tage) sind',
      clearOlderThanPlaceholder: 'Leer lassen, um alle zu löschen',
      clearOlderThanHint: 'Einträge löschen, die älter als {days} Tage sind.',
      clearAllHint: 'Leer lassen, um ALLE Einträge zu löschen.',
      deleteAll: 'Löschen alle',
      deleteOlderThan: 'Älter als {days} Tage löschen',
      deleting: 'Löschen...',
      deletedSuccess: '{count} Fehler wurde aus dem Fehlerprotokoll gelöscht.',
      deletedError: 'Fehlerprotokoll konnte nicht gelöscht werden',
      showing: 'Anzeige {from} - {to} von {total}',
      previous: 'Vorherige',
      next: 'Weiter',
      totalLabel: 'Gesamt',
      messageLabel: 'Nachricht',
      errorTypeLabel: 'Fehlertyp',
      errorCodeLabel: 'Code',
      serviceLabel: 'Service',
      moduleLabel: 'Modul',
      functionLabel: 'Funktion',
      timeLabel: 'Zeit',
      requestLabel: 'Anfrage',
      resolvedLabel: 'Gelöst',
    },
    generalAuditLogSection: {
      title: 'Changelog',
      description: 'Alle Änderungen im System protokollieren',
      total: 'Gesamt',
      entityTypeLabel: 'Entitätstyp',
      entityTypePlaceholder: 'zB. Fahrzeug, Benutzer...',
      actionLabel: 'Aktion',
      searchLabel: 'Suchen',
      searchPlaceholder: 'Benutzer, Entität suchen...',
      clearFilters: 'Filter löschen',
      loading: 'Laden...',
      noChanges: 'Keine Änderungen gefunden',
      colTime: 'Zeit',
      colUser: 'Benutzer',
      colAction: 'Aktion',
      colEntity: 'Entität',
      colChanges: 'Änderungen',
      system: 'System',
      fieldsCount: '{count} Feld',
      showing: 'Anzeige {from} - {to} von {total}',
      previous: 'Vorherige',
      next: 'Weiter',
      allActions: 'Alle',
    },
    errorLogDescription: 'Alle Systemfehler und Ausnahmen anzeigen',
    systemMonitor: {
      title: 'Systemüberwachung',
      description: 'CPU, Speicher, Festplatte, Datenbanken und Warteschlangen überwachen',
      docker: {
        title: 'Docker-Container',
        notAvailable: 'Docker ist auf diesem Server nicht verfügbar',
        total: 'Gesamt',
        running: 'Laufen',
        stopped: 'Gestoppt',
        healthy: 'In Ordnung',
        unhealthy: 'Ungesund',
        container: 'Container',
        image: 'Bild',
        status: 'Status',
        health: 'Gesundheit',
        cpu: 'CPU',
        memory: 'Speicher',
        swarm: {
          title: 'Docker Swarm',
          nodes: 'Knoten',
          services: 'Dienstleistungen',
          host: 'Host',
          manager: 'Manager',
          service: 'Dienst',
          replicas: 'Replicas',
        },
      },
      scheduledJobs: {
        title: 'Geplante Jobs',
        jobStatus: 'Jobstatus',
        jobs: 'Job',
        runningNow: 'Wird jetzt ausgeführt',
        successLast24h: 'OK (24h)',
        failedLast24h: 'Fehler (24h)',
        schedule: 'Zeitplan',
        nextRun: 'Weiter',
        recentRuns: 'Letzte Ausführungen',
        noHistory: 'Noch keine Ausführungshistorie',
        job: 'Job',
        startTime: 'Startzeit',
        duration: 'Zeit',
        processed: 'OK/Fehler',
        success: 'OK',
        failed: 'FEHLER',
        running: 'RUN',
      },
    },
    slowQueries: {
      title: 'Langsame Abfragen',
      description: 'Langsame SQL-Abfragen analysieren',
    },
    apiMetrics: {
      title: 'Leistung',
      cardDescription: 'Benutzerwachstum, Buchungen und API-Latenz im Vergleich zum System laden',
      description: 'Diagramme von Benutzern, Buchungen und API-Zeiten. Die Latenz wird in Redis pro normalisierter Route akkumuliert. p50/p95 ist die Oberkante des Dauerbereichs, nicht das genaue Perzentil. Live-Karten werden jede Minute aktualisiert.',
      loadError: 'API-Messung konnte nicht abgerufen werden',
      loadErrorHistory: 'Leistungsverlauf konnte nicht abgerufen werden',
      empty: 'Noch keine Anrufe aufgezeichnet. Surfen Sie eine Weile im System und aktualisieren Sie es.',
      emptyHistory: 'Noch kein Verlauf für den ausgewählten Zeitraum.',
      periodDays: '{{n}} Tage',
      usersTitle: 'Benutzer vs. Systemlast',
      usersHint: 'Neue und aktive Benutzer vs. API-Aufrufe und p95. Aktiv sind Benutzer, deren letzte Anmeldung an diesem Tag erfolgte.',
      cumulativeUsers: 'Kumulative Benutzer',
      newUsers: 'Neue Benutzer',
      activeUsers: 'Aktiv (letzte Anmeldung)',
      activeAccounts: '{{count}}aktive Konten',
      bookingsTitle: 'Buchungen',
      bookingsHint: 'Erstellte Buchungen gegen vorläufiges Löschen (deleted_at). Die gestrichelte Linie stellt den Abbruch ohne vorläufiges Löschen dar.',
      bookingsCreated: 'Erstellt',
      bookingsSoftDeleted: 'Storniert (vorläufiges Löschen)',
      bookingsCancelledOnly: 'Storniert ohne Löschen',
      apiTitle: 'API-Aufrufe und Fehler',
      apiHint: 'Anzahl der Anrufe pro Tag, gewichtet p95 und Anteil 5xx.',
      requestsPerDay: 'Anrufe/Tag',
      p95Ms: 'p95 (ms)',
      errorShare: 'Anteil 5xx',
      watchlistTitle: 'p95 pro Engpass',
      watchlistHint: 'Klicken Sie auf eine Zeile in der Tabelle, um diese Route zum Diagramm hinzuzufügen.',
      selectedRoute: 'Markiert: {{route}}',
      actionTitle: 'Aktionen',
      actionHint: 'Gelb bedeutet Warnung wegen langsamer Reaktion. Rot bedeutet, dass etwas behoben werden sollte. Die Liste zeigt langsame Anrufe und Serverfehler.',
      actionEmpty: 'Nichts über dem Schwellenwert in den letzten 24 Stunden.',
      actionWarn: 'Warnung',
      actionFix: 'Fix',
      actionErrors: 'Serverfehler 5xx:',
      actionTrend: 'Vorheriger Tag:',
      unitMs: 'ms',
      hourP95: 'Stunde p95 {{value}}',
      hourTitle: 'Diese Stunde',
      todayTitle: 'Ganztägig',
      requests: 'Anruf',
      colRoute: 'Pfad',
      colStatus: 'Status',
      colCount: 'Anzahl',
      colP50: 'p50',
      colP95: 'p95',
      colAvg: 'Durchschnitt',
      colMax: 'Max',
      apiHeap: 'API-Heap',
      redisMemory: 'Redis-Speicher',
      redisMax: 'Cap {{value}}',
      tripState: 'trip:state key',
      tripStateSample: 'Durchschnittliche Stichprobe {{value}}',
      gpsWorker: 'GPS-Worker-Heap',
      gpsWorkerWaiting: 'Warten auf Worker-Snapshot',
      gpsPackets: '{{count}}-Paket, bedeutet {{avg}}',
    },
    dataReplay: {
      title: 'Datenwiedergabe',
      description: 'Wiedergabe historischer GPS-Daten',
    },
    importSources: {
      title: 'Importquellen',
      description: 'Postfach und SFTP-Quellen für die Importsynchronisierung verwalten',
      loadError: 'Importquellen konnten nicht geladen werden',
      saveError: 'Importquellen konnten nicht gespeichert werden',
      deleteError: 'Importquellen konnten nicht gelöscht werden',
      testError: 'Verbindungstest fehlgeschlagen',
      testSuccess: 'Verbindung OK',
      created: 'Importquelle erstellt',
      updated: 'Importquelle aktualisiert',
      deleted: 'Quelle importieren gelöscht',
      newSource: 'Neue Quelle',
      createSource: 'Quelle erstellen',
      editSource: 'Quelle bearbeiten',
      create: 'Erstellen',
      saveChanges: 'Änderungen speichern',
      sourcesList: 'Importquellen',
      noSources: 'Noch keine Importquellen erstellt',
      confirmDelete: 'Diese Importquelle löschen?',
      testConnection: 'Verbindung testen',
      syncNow: 'Jetzt synchronisieren',
      syncSuccess: 'Synchronisierung abgeschlossen',
      syncError: 'Synchronisiert fehlgeschlagen',
      type: 'Typ',
      mailbox: 'Postfach',
      sftp: 'SFTP',
      local: 'Lokales Verzeichnis',
      localDirectoryPath: 'Verzeichnispfad (auf dem Server)',
      localDirectoryHint: 'Absoluter Pfad zum Verzeichnis, aus dem das Backend Dateien liest (z. B. ein SFTP-Upload-Verzeichnis).',
      name: 'Name',
      namePlaceholder: 'Zum Beispiel. Geteiltes Postfach Circle K',
      mailboxEmail: 'Postfach-E-Mail',
      sftpHost: 'Host',
      sftpPort: 'Port',
      sftpUsername: 'Benutzername',
      sftpPassword: 'Passwort (optional)',
      sftpPrivateKeyPath: 'Privater Schlüsselpfad (optional)',
      sftpPassphrase: 'Schlüsselpassphrase (optional)',
      sftpBasePath: 'Basispfad',
      allowedExtensions: 'Zulässige Dateierweiterungen (durch Kommas getrennt)',
      filenameExclusions: 'Auszuschließende Dateinamen (durch Kommas getrennt)',
      minDate: 'Mein Datum (Postfach, JJJJ-MM-TT)',
      pathPattern: 'Pfadmuster (SFTP)',
      retentionDays: 'Aufbewahrung (Tage)',
      isActive: 'Aktive Quelle',
      inactive: 'Inaktiv',
      lastFetchAt: 'Letzter Download',
      lastFetchError: 'Aktueller Fehler',
      lastFetchFilesCount: 'Dateien in der Quelle',
      totalFilesInSource: 'Dateien in der Quelle',
      validation: {
        nameRequired: 'Name erforderlich',
        mailboxEmailRequired: 'Postfachadresse für Postfachquelle erforderlich',
        sftpRequired: 'Host, Benutzername und Basispfad für SFTP-Quelle erforderlich',
        localDirectoryRequired: 'Verzeichnispfad für lokale Quelle erforderlich',
      },
    },
    tripValidation: {
      title: 'Reisevalidierung',
      description: 'Reisen zwischen MongoDB und MariaDB validieren',
      resolveTitle: 'Validierungsfehler behandeln',
      errorType: 'Fehlertyp',
      date: 'Datum',
      binAnalysisTitle: 'Bin-Datei-Analyse',
      analyzeBinFile: 'Bin-Datei analysieren',
      analyzing: 'Analysieren...',
      binAnalysisFailed: 'Bin-Datei konnte nicht analysiert werden',
      binAnalysis502Hint: 'Server hat nicht geantwortet (502). Die Analyse der Bin-Datei kann lange dauern oder die Bin-Datei befindet sich nicht auf dem Server (GPS-Daten). Überprüfen Sie die Backend-Protokolle.',
      binSegmentsExcludedNote: '{{count}} Geschwindigkeitssegmente in der Bin-Datei werden nicht aufgeführt (unter {{minDuration}} s oder unter {{minDistance}} m – das gleiche Minimum wie für eine gespeicherte Fahrt).',
      tryAgain: 'Erneut versuchen',
      clearLog: 'Löschen Sie das gesamte Protokoll',
      clearLogConfirm: 'Sind Sie sicher? Alle Einträge im Reisevalidierungsprotokoll werden gelöscht. Dies kann nicht rückgängig gemacht werden.',
      clearLogSuccess: 'Protokoll geleert. {{count}} Datensätze gelöscht.',
      clearLogFailed: 'Protokoll konnte nicht gelöscht werden',
      replayAllDatesQueue: 'Alle Daten wiedergeben (Warteschlange)',
      replayAllDatesQueueTitle: 'Wiedergabe über Warteschlange (gps_worker_*_replay) für alle eindeutigen Daten in der Liste ausführen',
      bulkClean: 'Zusätzliche MariaDB-Reisen löschen',
      bulkCleanTitle: 'MariaDB-Reisen ohne übereinstimmende MongoDB-Reise entfernen und fehlende Reisen synchronisieren. Verarbeitet alle Datensätze zu Synchronisierungskonflikten.',
      bulkCleanSuccess: '{{deleted}} Zusätzliche MariaDB-Reisen entfernt, {{synced}} MongoDB-Reisen synchronisiert.',
      bulkCleanFailed: 'Massenbereinigung fehlgeschlagen',
      syncMismatchInfo: 'Synchronisierungskonflikt bedeutet, dass die Anzahl der Fahrten zwischen MongoDB und MariaDB unterschiedlich ist. Für diesen Fehlertyp ist keine Bin-Dateianalyse verfügbar. Führen Sie eine Wiederholung durch, um die Daten zu synchronisieren.',
      syncMismatchWhyTitle: 'Warum zwei Fahrten in MariaDB, aber die richtige Anzahl in MongoDB?',
      syncMismatchWhyMongo: 'Duplikatprüfung durchführen: Vor dem Speichern die Suche nach doppelter Fahrt prüfen (gleiches Fahrzeug, Startzeit ±10 s, Entfernung ±200 m). Wenn bereits eine passende Reise vorhanden ist, wird die neue nicht gespeichert – nur eine logische Reise pro Zeitfenster landet in Mongo.',
      syncMismatchWhyMaria: 'hatte keine entsprechende Prüfung: Jeder Aufruf von sync führte INSERT aus (mit eigener trip_id). Wenn sync zuvor aufgerufen wurde, auch wenn die Reise nicht in Mongo gespeichert wurde (z. B. für ein abgelehntes Duplikat mit einer anderen trip_id), erhielt MariaDB eine zusätzliche Zeile. Daher können Sie in MariaDB zwei Zeilen sehen (zwei unterschiedliche trip_id), aber nur eine in MongoDB.',
      syncMismatchToday: 'Heute wird die MariaDB-Synchronisierung nur aufgerufen, wenn die Fahrt zum ersten Mal in MongoDB gespeichert wird, und wir haben auch beim MariaDB-Einfügen eine Duplikatprüfung hinzugefügt (gleiches Fahrzeug + Startzeit ±10 s, Entfernung ±200 m). Es sollten daher keine neuen Duplikate entstehen.',
      syncMismatchAction: 'Aktion: Führen Sie „Heutige Daten erneut abspielen (Wiedergabe)“ aus, um MongoDB aus der bin-Datei zu füllen, oder entfernen Sie die zusätzliche MariaDB-Zeile (die in MongoDB fehlt) manuell, wenn es sich um ein echtes Duplikat handelt.',
      syncMismatchMariaMore: 'MariaDB hat mehr Fahrten als MongoDB. Die Liste „MariaDB-Trips“ oben zeigt, welche auch in MongoDB ( ✓ MongoDB) bzw. nur in MariaDB vorhanden sind – diese können durch einen früheren Synchronisierungsfehler oder manuell erstellt worden sein. Analysieren Sie, welche Reise in MongoDB fehlt, bevor Sie die Wiedergabe ausführen. Nach der Wiedergabe müssen zusätzliche Fahrten, die immer noch nur in MariaDB vorhanden sind, möglicherweise manuell entfernt werden.',
      currentPoints: 'Aktuelle Punkte',
      pointsInBinFile: 'Punkte in der Bin-Datei',
      totalInFile: 'Gesamt in der Datei',
      tripTime: 'Zeitraum',
      updateMongoDB: 'MongoDB mit {{count}} Punkten aktualisieren',
      repairing: 'Reparieren...',
      repairSuccess: 'Reise repariert mit {{count}} GPS Punkte',
      repairFailed: 'Reise konnte nicht repariert werden',
      noPointsFound: 'Keine GPS-Punkte in der Bin-Datei für diese Reise gefunden',
      tooFewPoints: 'Nur {{count}}-Punkt gefunden, mindestens 2 erforderlich',
      manualResolveTitle: 'Manuell markieren',
      notes: 'Notizen (optional)',
      notesPlaceholder: 'Beschreiben Sie, wie das Problem gelöst wurde...',
      markResolved: 'Als gelöst markieren',
      mongoTrips: 'MongoDB-Reisen (können entfernt werden)',
      deleteTripTitle: 'Reise löschen',
      deleteTripWarning: 'Sie sind dabei, eine Reise mit {{count}} Punkten zu löschen. Dies kann nicht rückgängig gemacht werden.',
      deleteReason: 'Grund für die Entfernung *',
      deleteReasonPlaceholder: 'Beschreiben Sie, warum diese Reise entfernt wird (mindestens 5 Zeichen)...',
      deleteReasonError: 'Mindestens 5 Zeichen sind erforderlich',
      deleteTrip: 'Reise löschen',
      deletingTrip: 'Entfernen...',
      deleteTripSuccess: 'Reise {{tripId}} entfernt',
      deleteTripFailed: 'Reise konnte nicht gelöscht werden',
      createInMariaDB: 'In MariaDB erstellen',
      creatingInMariaDB: 'Wird erstellt...',
      createInMariaDBSuccess: 'Reise in MariaDB erstellt',
      createInMariaDBFailed: 'Reise konnte in MariaDB nicht erstellt werden',
      replayDay: 'Heutige Daten erneut ausführen (Wiedergabe)',
      replayDaySuccess: 'Wiedergabe gestartet',
      systematicErrorHint: 'Viele Fehler des gleichen Typs können auf einen Systemfehler hinweisen – z. B. Diese Synchronisierung mit MariaDB schlug eine Zeit lang fehl. Überprüfen Sie den Fehlerbericht (Administration → Fehlerbericht) auf „TripSyncService“ oder „syncTripToMariaDB“ und erwägen Sie die Ausführung von Replay für die betroffenen Daten.',
    },
    tripSync: {
      title: 'Reisesynchronisierung',
      description: 'Hintergrundjob synchronisiert Reisen von MongoDB mit MariaDB',
      jobEnabled: 'Hintergrundjob ist aktiviert',
      jobDisabled: 'Hintergrundjob ist deaktiviert',
      intervalInfo: 'Wird alle {{minutes}} ausgeführt Minute(n). Reisen, die in MongoDB vorhanden sind, aber in MariaDB fehlen, werden automatisch synchronisiert.',
      lastRun: 'Letzte Ausführung',
      lastRunTime: 'Laufzeit',
      synced: 'Synchronisiert',
      failed: 'Fehlgeschlagen',
      duration: 'Dauer',
      runManualSync: 'Synchronisierung manuell ausführen',
      syncing: 'Synchronisierung...',
      jobRunning: 'Ein Synchronisierungsjob wird ausgeführt.',
      missingTripsTitle: 'Fehlende Fahrten (Beispiel)',
      missingTripsDescription: 'Anzahl der Fahrten, die in MongoDB vorhanden sind, aber in MariaDB fehlen (maximal 100 angezeigt). Bei der nächsten Ausführung werden diese synchronisiert.',
      manualSyncSuccess: 'Synchronisierung abgeschlossen: {{synced}} synchronisiert, {{failed}} fehlgeschlagen, {{skipped}} übersprungen.',
      manualSyncError: 'Manuelle Synchronisierung fehlgeschlagen',
    },
    carinfoFilter: {
      title: 'Fahrzeugfilter',
      description: 'Wählen Sie aus, welche Car.info-Felder im Filter angezeigt werden sollen',
    },
    deviceQueues: {
      title: 'Gerätewarteschlangen',
      cardDescription: 'Jasper-Sitzungen bis zum Abschluss der Kette',
      description: 'Nur Einheiten von Jasper SESSION_START. getver/getvin geht zuerst über TCP, wenn das Gerät online ist, andernfalls per SMS. getvin N/A: Warten Sie, bis das Auto manuell eingestellt (oder eingeschaltet) wird, dann wird VIN aus der Registrierung übernommen und P&P wird fortgesetzt. Ein Gerät ohne Verbindung für 30 Tage wird aus der Warteschlange entfernt und bei der nächsten Sitzung wieder angezeigt. Gelbe Linien = STUCK (>24 Stunden ohne Fortschritt).',
      refresh: 'Aktualisieren',
      empty: 'Keine aktiven Geräte in der Warteschlange.',
      emptyDone: 'Keine Bereitschaftsereignisse (letzte 14 Tage).',
      viewLabel: 'Anzeigen',
      viewQueue: 'Eingegangen Warteschlange',
      viewDone: 'Fertig',
      sortColumn: 'Sortieren nach {{column}}',
      countsShort: '{{queue}} in der Warteschlange · {{done}} bereit',
      countsHint: '{{queue}} in der Warteschlange, {{done}} bereit (aktuelle Organisation). Filter)',
      colCompleted: 'Fertig',
      loadError: 'Gerätewarteschlangen konnten nicht abgerufen werden',
      searchPlaceholder: 'Reg.-Nr., Modell, IMEI, Gruppe durchsuchen…',
      typeSession: 'Jasper',
      typeCommand: 'Befehlswarteschlange',
      typePnp: 'OBD P&P',
      typeForceNonObd: 'Nicht-OBD',
      colType: 'Phase',
      colReg: 'Reg.Nr',
      colMakeModel: 'Hersteller/Modell',
      colGroup: 'Gruppe',
      colImei: 'Gerätenummer',
      colFw: 'FW',
      colLastSeen: 'Letzte Verbindung',
      colAdded: 'Hinzugefügt',
      colStatus: 'Status',
      colActions: 'Aktionen',
      cmdCount: '{{count}} Befehl(e)',
      actionForce: 'Fortsetzen/Erzwingen',
      actionRemove: 'Abgebrochen',
      actionGetver: 'Fragen Sie FW (getver)',
      confirmForce: 'Pipeline fortsetzen/nächsten Schritt für dieses Gerät erzwingen?',
      confirmRemove: 'Gerätepipeline abbrechen? (Gerät/Fahrzeug nicht gelöscht)',
      forceOk: 'Ausführung abgeschlossen',
      forceQueued: 'Gerät offline – Parameter für nächste Verbindung in der Warteschlange',
      forceFail: 'Fahren konnte nicht erzwungen werden',
      removeOk: 'Abgebrochen/aus der Warteschlange entfernt',
      removeFail: 'Konnte nicht aus der Warteschlange entfernt werden',
      getverTitle: 'Firmware vom Gerät',
      getverOk: 'stellt empfangen bereit',
      getverQueued: 'Gerät offline – in die Warteschlange gestellt',
      getverFail: 'FW konnte nicht abgefragt werden',
      markInteresting: 'Als interessant markieren',
      markOk: 'Als interessant markiert',
      markFail: 'Konnte nicht markiert',
      exportEmpty: 'Keine Daten zum Exportieren',
      exportOk: 'Exportierte {{count}}-Zeilen',
    },
    gpsDataLag: {
      title: 'GPS-Dump-Warteschlange',
      cardDescription: 'Geräte, die verzögerte GPS-Daten senden',
      description: 'Zeigt nur Geräte mit aktiver Dump-Warteschlange an (empfangene Daten liegen hinter der Geräte-GPS-Zeit zurück). Wenn ein Gerät aufholt, verschwindet es aus der Liste. Flush sendet den Teltonika-Befehl per Jasper-SMS.',
      refresh: 'Aktualisieren',
      loading: 'Laden…',
      empty: 'Keine Geräteverzögerung im Moment.',
      loadError: 'Die GPS-Dump-Warteschlange konnte nicht abgerufen werden',
      searchPlaceholder: 'Reg.-Nr., Organisation, IMEI, ICCID suchen…',
      summary: '{{count}} in der Dump-Warteschlange · aktualisiert {{snapped}}',
      colReg: 'Reg.Nr',
      colOrg: 'Organisation',
      colImei: 'IMEI',
      colIccid: 'ICCID',
      colDumpLag: 'Dump Team',
      colDeviceData: 'Daten im Gerät',
      colReceived: 'Empfangen',
      colLastRecs: 'Letzte Aufnahmen',
      colActions: 'Aktionen',
      flush: 'Flush',
      flushing: 'Wird gesendet…',
      flushTitle: 'Flush per SMS senden (leerer Flash)',
      confirmFlush: 'Flush senden an {{reg}}?',
      flushOk: 'Flush gesendet an {{reg}}',
      flushFail: 'Flush konnte nicht gesendet werden',
      smsBadge: 'SMS',
    },
    certMonitor: {
      title: 'Zertifikat Überwachung',
      cardDescription: 'Überwachen Sie ablaufende Zertifikate und wie sie erneuert werden',
      description: 'Überwacht ablaufende Zertifikate – OIDC-Client-Zertifikat wird automatisch erkannt, HTTPS-Hosts werden bei der Aktualisierung live geprüft, andere können manuell mit Erneuerungsanweisung registriert werden.',
      refresh: 'Aktualisieren',
      addManual: 'Zertifikat hinzufügen',
      editTitle: 'Zertifikat bearbeiten',
      empty: 'Es werden noch keine Zertifikate überwacht.',
      colName: 'Name',
      colStatus: 'Status',
      colExpires: 'Läuft ab',
      colSource: 'Quelle',
      colRenewal: 'Erneuerung',
      sourceAuto: 'Automatisch (OIDC)',
      sourceManual: 'Manuell',
      statusOk: 'OK ({{days}} verbleibende Tage)',
      statusExpiring: 'Läuft in {{days}} Tagen ab',
      statusExpired: 'Abgelaufen',
      statusUnknown: 'Unbekannter Ablauf Datum',
      bannerSummary: '{{expired}}Zertifikat ist abgelaufen und {{expiring}} läuft bald ab.',
      bannerLink: 'Zertifikatüberwachung anzeigen',
      fieldName: 'Name',
      fieldOrg: 'Organisation',
      fieldCheckHost: 'HTTPS-Host (automatisch)',
      fieldCheckHostHelp: 'Z.B. dqfleet.deque.se – beim Aktualisieren wird das Ablaufdatum automatisch über TLS abgerufen.',
      fieldPem: 'Zertifikat (PEM)',
      fieldPemHelp: 'Öffentliches Zertifikat einfügen, um Ablaufdatum, Aussteller und Fingerabdruck automatisch auszulesen.',
      fieldValidTo: 'Ablaufdatum',
      fieldWarningDays: 'Anzahl der Tage vor Warnen',
      fieldRenewal: 'Erneuerungsanweisung',
      fieldContact: 'Kontakt (E-Mail)',
      fieldNotes: 'Notizen',
      fieldActive: 'Aktiv (dieses Zertifikat überwachen)',
      nameRequired: 'Name erforderlich',
      created: 'Zertifikat hinzugefügt',
      updated: 'Zertifikat aktualisiert',
      deleted: 'Zertifikat entfernt',
      confirmDelete: '„{{name}}“ entfernen?',
      refreshed: 'Gescanntes {{count}}-Zertifikat',
      refreshedDetail: 'Aktualisiertes {{oidc}}-OIDC- und {{host}}-HTTPS-Zertifikat ({{errors}}-Fehler)',
      loadError: 'Zertifikat konnte nicht abgerufen werden',
      saveError: 'Zertifikat konnte nicht gespeichert werden',
      deleteError: 'Zertifikat konnte nicht gelöscht werden',
      refreshError: 'Zertifikat konnte nicht aktualisiert werden',
    },
    security: {
      title: 'Sicherheit',
      description: 'CrowdSec-Ereignisse auf diesem Server, IP-Adressen freigeben und vertrauenswürdige Adressen auf die Liste setzen',
      loadError: 'Sicherheitsstatus konnte nicht abgerufen werden',
      hostctlMissing: 'Der host-Befehl fail2ban ist auf diesem Server nicht installiert. Die Safelist wird in der Datenbank gespeichert, Sperren und Protokolle sind jedoch nur sichtbar, wenn das CTL-Skript vorhanden ist.',
      fail2ban: 'fail2ban',
      crowdsec: 'CrowdSec',
      crowdsecMissing: 'CrowdSec ist nicht installiert',
      eventsHint: 'Aktive lokale Lanes werden oben angezeigt. Die Community-Blocklist (Tausende von IPs) wird hier nicht angezeigt.',
      localBans: '{{count}}aktive lokale Lanes',
      activeBansHeading: 'Aktive Lanes',
      recentAlertsHeading: 'Neueste Warnungen',
      bansMissingInList: 'CrowdSec hat aktive Lanes, aber sie fehlen in der Liste. Aktualisieren Sie die Seite.',
      noEvents: 'Derzeit keine lokalen CrowdSec-Ereignisse',
      banActive: 'Aktiv',
      banExpired: 'Abgelaufen',
      alertOnly: 'Alarm (kein Verbot)',
      colWhen: 'Wenn',
      colReason: 'Grund',
      colCountry: 'Land',
      colDetail: 'Netzwerk',
      colUntil: 'Status',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      noBans: 'Derzeit keine gesperrten IPs',
      colIp: 'IP',
      colJail: 'Gefängnis',
      unban: 'Frei',
      unbanOk: 'IP freigegeben',
      unbanError: 'IP konnte nicht freigegeben werden',
      safeList: 'Sichere Liste (vertrauenswürdige IPs)',
      comment: 'Kommentar',
      addSafe: 'Als sicher hinzufügen',
      noSafe: 'Keine vertrauenswürdige IP gespeichert',
      safeAddOk: 'IP als sicher hinzugefügt',
      safeAddError: 'IP konnte nicht hinzugefügt werden',
      safeRemoveOk: 'IP aus der sicheren Liste entfernt',
      safeRemoveError: 'IP konnte nicht entfernt werden',
      noLogFile: 'Keine Protokolldatei für diese Quelle gefunden',
      emptyLog: 'Leeres Protokoll',
      log: {
        fail2ban: 'fail2ban',
        ufw: 'UFW',
        crowdsec: 'CrowdSec',
        lifeline: 'Lifeline',
      },
      scenario: {
        'ssh-bf': 'SSH-Brute-Force',
        'ssh-slow-bf': 'SSH-langsames Brute-Force',
        'ssh-time-based-bf': 'SSH extrahiert Brute-Force',
        'http-bad-user-agent': 'HTTP-schlechter Benutzeragent',
        'http-sensitive-files': 'HTTP-sensible Dateien',
        'http-probing': 'HTTP-Prüfung',
        'http-crawl-non_statics': 'HTTP-Crawling',
        'http-path-traversal': 'HTTP-Pfaddurchquerung',
        'http-admin-interface-probing': 'HTTP-Administratorprüfung',
        'http-technology-probing': 'HTTP-Technologieprüfung',
        'http-cve-probing': 'HTTP-CVE-Prüfung',
        'http-generic-test': 'Generischer HTTP-Test',
      },
    },
    ssoLog: {
      title: 'SSO-Protokoll',
      cardDescription: 'Fehlgeschlagene und abgebrochene SSO-Versuche, pro Client und Gerät',
      description: 'Fehlgeschlagene SSO-Anmeldungen anzeigen: Wer hat es versucht, welcher Kunde, warum die Anmeldung gestoppt wurde und ob sie über ein Mobilgerät oder einen Desktop erfolgte.',
      loadError: 'Das SSO-Protokoll konnte nicht abgerufen werden',
      empty: 'Keine SSO-Versuche entsprechen den Filtern',
      period: 'Zeitraum',
      days: '{{count}} Tage',
      customer: 'Kunde',
      allOrgs: 'Alle Kunden',
      user: 'Benutzer',
      userPlaceholder: 'E-Mail-Adresse oder Name',
      channel: 'Kanal',
      deviceLabel: 'Gerät',
      statusLabel: 'Status',
      colCustomer: 'Kunde',
      colWhen: 'Wenn',
      colEmail: 'Anmeldeadresse',
      colSentToIdp: 'An Microsoft gesendet',
      colUser: 'Benutzer',
      unknownEmail: 'Unbekannt (keine E-Mail an Microsoft)',
      nothingSentToIdp: 'Nicht an Microsoft gesendet',
      sentToIdp: 'An Microsoft gesendet: {{value}}',
      sentToIdpNone: 'Gesendet an Microsoft: keine',
      idpUsernameFilledThere: 'Benutzer gibt Benutzernamen beim IdP ein (Skåne: rsid@skane.se)',
      nothingPrefillsIdp: 'Bei Microsoft ist kein Benutzername vorab ausgefüllt',
      exportError: 'Fehler beim Exportieren von CSV',
      colOrg: 'Kunde',
      colChannel: 'Kanal',
      colDevice: 'Gerät',
      colReason: 'Grund',
      showing: 'Anzeige von {{from}}–{{to}} von {{total}}',
      client: {
        web: 'Computer (Web)',
        mobile: 'Mobile App',
        unknown: 'Unbekannter Kanal',
      },
      device: {
        phone: 'Mobiltelefon',
        tablet: 'Tablet',
        computer: 'Computer',
        unknown: 'Unbekanntes Gerät',
      },
      os: {
        ios: 'iOS',
        android: 'Android',
        windows: 'Windows',
        macos: 'macOS',
        linux: 'Linux',
        unknown: 'unbekanntes Betriebssystem',
      },
      status: {
        all: 'Alle',
        unsuccessful: 'Fehlgeschlagen und abgebrochen',
        failed: 'Fehlgeschlagen',
        abandoned: 'Abgebrochen',
        in_progress: 'In Bearbeitung',
        success: 'Erfolgreich',
      },
      reason: {
        none: '–',
        idp_error: 'Abgelehnt bei Microsoft/IdP',
        callback_error: 'Fehler bei der Rückkehr von der Anmeldung',
        initiate_error: 'Konnte nicht gestartet werden SSO',
        app_no_exchange: 'App konnte die Sitzung nicht abrufen',
        abandoned_at_idp: 'Von Microsoft abgebrochen (keine Rückkehr)',
        abandoned_after_callback: 'Nach Rückkehr abgebrochen',
        unknown_error: 'Unbekannter Fehler',
      },
    },
    vehicleCarinfoSync: {
      title: 'Fahrzeug von Car.info synchronisieren',
      description: 'Fahrzeuginformationen vom Car.info-Dienst synchronisieren',
    },
    ecoSettings: {
      title: 'ECO-Einstellungen',
      description: 'Schwellenwerte für ECO-Fahren konfigurieren',
      selectOrganization: 'Organisation auswählen',
      globalDefaults: 'Globale Standardeinstellungen',
      harshDriving: 'Hartes Fahren',
      harshDrivingDescription: 'Schwellenwerte für die Erkennung von hartem Fahren',
      maxAcceleration: 'Maximale Beschleunigung (m/s²)',
      maxBraking: 'Maximales Bremsen (m/s²)',
      maxCornering: 'Maximales Kurvenfahren (m/s²)',
      excessiveIdling: 'Leerlauf (Sekunden)',
      overspeedPercent: 'Geschwindigkeitsbegrenzung (%)',
      greenDriving: 'Umweltfreundliches Fahren',
      greenDrivingDescription: 'Grenzwerte für sanftes Fahren',
      greenMaxAcceleration: 'Maximale Beschleunigung für umweltfreundliches Fahren (m/s²)',
      greenMaxBraking: 'Maximale Verzögerung für umweltfreundliches Fahren (m/s²)',
      greenMinSpeed: 'Mindestgeschwindigkeit (km/h)',
      greenMinDuration: 'Mindestdauer (Sekunden)',
      save: 'Speichern Einstellungen',
      saved: 'Einstellungen gespeichert',
      saveError: 'Einstellungen konnten nicht gespeichert werden',
      infoTitle: 'Über Schwellenwerte',
      infoText: 'Diese Schwellenwerte werden zur Erkennung von ECO-Fahrereignissen verwendet. Teltonika Standardwerte basieren auf Herstellerempfehlungen. Sie können die Werte pro Organisation anpassen oder globale Standardwerte verwenden.',
    },
  },
  systems: {
    noModules: 'Keine Module verfügbar',
    selectModule: 'Wählen Sie ein Modul aus, um fortzufahren',
  },
  deviceCommands: {
    title: 'Befehle an Gerät senden',
    description: 'Befehle auswählen und an ein Gerät senden',
    availableCommands: 'Verfügbare Befehle',
    selectedCommands: 'Ausgewählte Befehle',
    addCommand: 'Befehl hinzufügen',
    removeCommand: 'Entfernen',
    deviceImei: 'Gerät IMEI',
    deviceImeiPlaceholder: 'Geben Sie IMEI ein (z. B. 869616066816375)',
    searchDevicePlaceholder: 'IMEI oder Fahrzeug suchen...',
    searchCommands: 'Befehle suchen...',
    noCommands: 'Keine Befehle gefunden',
    noCommandsSelected: 'Befehle aus Katalog auswählen',
    noDevicesFound: 'Keine Geräte gefunden',
    loadingDevices: 'Geräte werden geladen...',
    loading: 'Laden...',
    sendCommands: 'Befehle werden gesendet',
    sendCount: 'Befehl(e) {count} werden gesendet',
    sending: 'Senden...',
    commandsSent: 'Befehl(e) gesendet',
    errorSending: 'Befehle konnten nicht gesendet werden',
    errorLoading: 'Befehle konnten nicht geladen werden',
    requiredParameter: 'Parameter erforderlich',
    enterImei: 'Geben Sie IMEI für das Gerät ein',
    selectAtLeastOne: 'Wählen Sie mindestens einen Befehl aus',
    vehicleLabel: 'Fahrzeuge',
    selectOption: 'Auswählen...',
    booleanYes: 'Ja',
    booleanNo: 'Nein',
  },
  auditLog: {
    title: 'Meine gesendeten Befehle',
    description: 'Protokollieren Sie alle Befehle und Abfragen, die Sie an Geräte gesendet haben',
    dateTime: 'Datum/Uhrzeit',
    device: 'Gerät (IMEI)',
    command: 'Befehl',
    parameters: 'Parameter',
    status: 'Status',
    response: 'Antwort',
    showParameters: 'Parameter anzeigen',
    showResponse: 'Antwort anzeigen',
    received: 'Empfangen',
    noCommands: 'Keine Befehle gefunden',
    loading: 'Laden...',
    total: 'Gesamt',
    successful: 'Erfolgreich',
    pending: 'Warten',
    failed: 'Fehlgeschlagen',
    devices: 'Geräte',
    commandTypes: 'Befehlstypen',
    filterImei: 'Suchen IMEI...',
    filterCommand: 'Befehl suchen...',
    filterStatus: 'Alle Status',
    filterDateFrom: 'Von-Datum',
    filterDateTo: 'Bis-Datum',
    statusPending: 'Warten',
    statusSent: 'Gesendet',
    statusAcknowledged: 'Bestätigt',
    statusFailed: 'Fehlgeschlagen',
    statusTimeout: 'Zeitüberschreitung',
    showing: 'Anzeige',
    of: 'von',
    previous: 'Vorherige',
    next: 'Weiter',
    queueStatus: 'Warteschlangenstatus',
    lastSeen: 'Letzte Verbindung',
    inQueue: 'Eingegangen Warteschlange',
    showCount: 'Anzeigen ({count})',
    none: 'Keine',
    deleteCommand: 'Befehl entfernen',
    justNow: 'Jetzt gerade',
    minutesAgo: '{count} Minuten her',
    hoursAgo: '{count} Stunden her',
    daysAgo: '{count} Tage vor',
    never: 'Nie',
  },
  migration: {
    title: 'Datenmigration',
    description: 'Daten aus alten Datenbanken in neues System migrieren',
    selectDatabase: 'Datenbank auswählen',
    selectMigrations: 'Wählen Sie aus, was migriert werden soll',
    migrationOrder: 'Migrationen werden in der aufgeführten Reihenfolge ausgeführt. Wählen Sie diejenigen aus, die Sie ausführen möchten.',
    testConnection: 'Verbindung testen',
    testing: 'Testen...',
    connected: 'Verbunden',
    disconnected: 'Nicht verbunden',
    connectionSuccess: 'Verbindung erfolgreich',
    connectionFailed: 'Verbindung fehlgeschlagen',
    connectionError: 'Verbindungstestfehler',
    errorLoadingDatabases: 'Fehler beim Laden der Datenbanken',
    selectDatabaseFirst: 'Wählen Sie zuerst eine Datenbank aus',
    selectMigrationsFirst: 'Wählen Sie mindestens eine Migration zu aus ausführen',
    runSelected: 'Ausgewählte Migrationen ausführen',
    dryRun: 'Testlauf (Probelauf)',
    dryRunDescription: 'Zeigen Sie, was ohne Speichern von Daten migriert werden würde',
    run: 'Migration ausführen',
    rerun: 'Erneut ausführen',
    running: 'Wird ausgeführt',
    completed: 'Abgeschlossen',
    failed: 'Fehlgeschlagen',
    sso: 'SSO',
    success: 'Migration erfolgreich: {succeeded} von {processed} Datensätzen',
    error: 'Fehler während der Migration',
    runAll: 'Alle ausführen Migrationen',
    records: 'Datensätze',
    processed: 'Verarbeitet',
    succeeded: 'Erfolgreich',
    errors: 'Fehler',
    warnings: 'Warnungen',
    users: 'Benutzer',
    usersDescription: 'Benutzer aus alter Datenbank migrieren',
    organizations: 'Organisationen',
    organizationsDescription: 'Organisationen aus alter Datenbank migrieren (muss zuerst ausgeführt werden)',
    vehicles: 'Fahrzeuge',
    vehiclesDescription: 'Fahrzeug aus alter Datenbank migrieren',
    deviceVehicleHistory: 'Geräte-Fahrzeugverlauf',
    deviceVehicleHistoryDescription: 'Importieren, wann IMEI mit welchem ​​Auto verbunden war (obd_config_logger). Erfordert zuerst die Fahrzeugmigration.',
    deviceOrganizations: 'Geräte mit Organisationen',
    deviceOrganizationsDescription: 'Verbinden Sie IMEI-Geräte mit Organisationen von tobd. Setzt den Status „KUNDE“ auf Geräte, die noch nicht in Fahrzeugen vorhanden sind.',
    mongoTripsVehicleBackfill: 'Mongo: Fahrtfahrzeug-ID synchronisieren',
    mongoTripsVehicleBackfillDescription: 'Aktualisiert MongoDB „trips.vehicleId“ basierend auf der aktiven devices.vehicle_id per IMEI (dasselbe Prinzip wie „trip-sync“ IMEI-remap). Fahrt nach Fahrzeugmigration; wirkt sich auf die gesamte Datenbank aus, nicht nur auf die ausgewählte Organisation.',
    bookingPlaces: 'Buchung: Abgabestellen',
    bookingPlacesDescription: 'Erstellt Abgabestellen aus DQBooking und verbindet vorhandene Autos und andere Ressourcen. Angetrieben durch Organisationen und Fahrzeuge. Aktualisierungen ohne Duplikate überschreiben.',
    bookingUsers: 'Booking: Benutzer',
    bookingUsersDescription: 'Erstellt einen Benutzer aus DQBooking ohne Passwort. Wenn die E-Mail bereits vorhanden ist, wird dieser Benutzer verwendet. Name und Telefonnummer werden aktualisiert. Neuen Benutzern wird die Standardrolle der Organisation zugewiesen. Die Anmeldemethode wird vom Kunden gewählt und gilt dann für alle Benutzer. Bereits in DQFleet festgelegte Passwörter werden nicht berührt.',
    bookingBookings: 'Buchung: Buchungen',
    bookingBookingsDescription: 'Erstellt Buchungen ab dem 01.01.2025. Beim Überholen wird die gleiche Buchung aktualisiert. Gelöschte Buchungen werden storniert.',
    fuelCards: 'Tankkarten',
    fuelCardsDescription: 'Verbindet Tankkarten mit bereits importierten Autos. Ein Kartenwechsel wird mit Start und Stopp gespeichert. Andere Autos sind nicht enthalten.',
    step1: 'Datenbank auswählen',
    step2: 'Organisationen auswählen',
    step3: 'Migrationen ausführen',
    selectOrganizations: 'Organisationen zum Importieren auswählen',
    selectOrganizationsDescription: 'Die Liste ist nach oberstem Knoten gruppiert. Erweitern Sie einen oberen Knoten, um zu sehen, was dazu gehört. Zugrunde liegende Organisationen werden automatisch einbezogen.',
    loadingOrganizations: 'Organisationen abrufen...',
    noOrganizationsFound: 'Keine Organisationen in der Datenbank gefunden',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle deaktivieren',
    selectedCount: '{count} ausgewählt',
    next: 'Weiter',
    back: 'Zurück',
    searchOrganizations: 'Nach Organisationen suchen...',
    selectOrganizationsFirst: 'Mindestens eine Organisation zum Importieren auswählen',
    children: 'zugrunde liegend',
    topNode: 'Oberster Knoten',
    expandAll: 'Alle erweitern',
    collapseAll: 'Alle reduzieren',
    otherOrganizations: 'Andere Organisationen',
    noSearchResults: 'Keine Organisationen entsprechen der Suche',
    preview: 'Vorschau/Validierung',
    previewing: 'Validierung...',
    previewTitle: 'Vorschau/Validierung',
    previewDescription: 'Überprüfen Sie Namenskollisionen, Strukturkonflikte und Fahrzeug-zu-Gruppe vor dem scharfen Durchlauf. Ändert keine Daten.',
    previewError: 'Vorschaufehler',
    previewOrgs: 'Organisationen',
    previewCollisions: 'Namenskollisionen',
    previewConflicts: 'Strukturkonflikte',
    previewVehicles: 'Fahrzeuge (OK/Gesamt)',
    previewVehicleIssues: 'Fahrzeuge werden übersprungen',
    previewColName: 'Name',
    previewColPath: 'Quelle o_path',
    previewColExisting: 'Im Ziel vorhanden',
    previewColCurrentParent: 'Aktuelles übergeordnetes Element',
    previewColSourceParent: 'Übergeordnetes Element in der Quelle',
    previewColReg: 'Reg.Nr',
    previewColImei: 'IMEI',
    previewColStatus: 'Status',
    previewStatusUnmapped: 'Org nicht zugeordnet (übersprungen)',
    previewStatusNoImei: 'Fehlendes IMEI (übersprungen)',
    previewCollisionNote: 'Derselbe Name existiert bereits im Ziel (andere). Struktur/Quelle). Beim Import wird ein separater Knoten erstellt – keine Zusammenführung von Namen.',
    previewNoIssues: 'Keine Probleme gefunden.',
    previewGroups: 'Gruppen (vorhanden/insgesamt)',
    previewNewShort: 'neu',
    previewGroupOverview: 'Gruppen – im System vorhanden?',
    previewColInSystem: 'Im System',
    previewGroupExists: 'Existiert',
    previewGroupNameCollision: 'Name existiert (andere Gruppe)',
    previewGroupNew: 'Fehlt – erstellt',
    previewGroupWillCreate: 'Während des Imports erstellt',
    previewGroupNote: 'Gruppen mit der Markierung „Fehlt – erstellt“ sind im System nicht vorhanden und werden während des Imports erstellt. „Name existiert (andere Gruppe)“ = derselbe Name existiert bereits, aber auf einem anderen Knoten.',
    previewVehiclesOtherGroup: 'Autos in einer anderen Gruppe',
    previewVehiclesOtherGroupNote: 'Diese Autos sind bereits im System vorhanden, befinden sich jedoch in einer anderen Gruppe als der, der sie zugeordnet werden sollten.',
    previewVehiclesSameRegistration: 'Gleiche Reg.-Nr.',
    previewVehiclesSameRegistrationNote: 'Das Kennzeichen ist bereits vorhanden, oft weil das Auto die Einheiten geändert hat oder weil eine VIN-Shell erstellt wurde. Der Import aktualisiert das vorhandene Fahrzeug und erstellt keine neue Zeile. Zusätzliche Linien mit derselben Registrierungsnummer werden gelöscht, wenn sie keine eigene Einheit haben. Das Gerät, das nicht mehr zum Auto gehört, wird in das Auto verschoben, das bereits über dieses IMEI verfügt.',
    previewColExistingVehicle: 'Vorhandenes Fahrzeug',
    previewColExistingImei: 'Vorhandenes IMEI',
    previewColExtraRows: 'Zusätzliche Leitungen',
    previewColCurrentGroup: 'Jetzt gefunden in',
    previewColTargetGroup: 'Würden zugeordnet werden zu',
  },
  devices: {
    imei: 'IMEI',
    model: 'Modell',
    currentFirmware: 'Aktuelle Firmware',
    fotaStatus: 'FOTA-Status',
    currentConfiguration: 'Aktuelle Konfiguration',
    gsmNumber: 'GSM-Nummer',
    searchPlaceholder: 'Suche nach IMEI (ganz oder teilweise), Modell, Firmware, Konfiguration oder GSM...',
    showingResults: 'Wird angezeigt {count} von {total} Geräten',
    lastSync: 'Zuletzt synchronisiert',
    lastSeen: 'Zuletzt gesehen',
    seenAt: 'Zuletzt gesehen',
    online: 'Online',
    offline: 'Offline',
    noResults: 'Keine Geräte stimmten mit der Suche überein',
    noDevices: 'Keine Geräte gefunden',
    loadCommandsError: 'Befehle konnten nicht geladen werden',
    loadDevicesError: 'Geräte konnten nicht geladen werden',
    sendCommandsError: 'Befehle konnten nicht gesendet werden',
    simStatus: 'SIM-STATUS',
    simStatusChanged: 'SIM-Status geändert',
    couldNotChangeStatus: 'Status konnte nicht geändert werden',
    statusChangeError: 'Fehler beim Ändern des Status',
    noSim: 'Keine SIM',
    deviceDetailsTitle: 'Gerätedetails',
    firmware: 'Firmware',
    configuration: 'Konfiguration',
    simCardJasper: 'SIM-Karte (Jasper)',
    fetchingSimStatus: 'SIM-Status wird abgerufen...',
    ratePlan: 'Tarifplan',
    commPlan: 'Comm-Plan',
    usageThisPeriod: 'Nutzung in diesem Zeitraum',
    sessions: 'Sitzungen',
    couldNotFetchSimStatus: 'SIM-Status konnte nicht abgerufen werden',
    simStatusActivated: 'Aktiviert',
    simStatusReady: 'Bereit',
    simStatusInactive: 'Inaktiv',
    simStatusInventory: 'Lagerbestand',
    simStatusRetired: 'Fertig',
    simStatusTest: 'Test',
    syncNow: 'Geräte jetzt synchronisieren',
    syncStarted: 'Gerätesynchronisierung gestartet',
    syncStartedBody: 'Update von Teltonika und Jasper läuft im Hintergrund (kann einige Minuten dauern). Felder wie der FOTA-Status und die letzte Synchronisierung werden aktualisiert, wenn der Auftrag abgeschlossen ist.',
    syncForbidden: 'Sie haben keine Berechtigung zum Starten der Gerätesynchronisierung.',
    syncFailed: 'Gerätesynchronisierung konnte nicht gestartet werden',
  },
  vehicles: {
    loadError: 'Konnte nicht geladen werden Fahrzeug',
    deviceLink: {
      modalTitle: 'Gerät mit {{reg}}',
      successTitle: 'Gerät verbunden',
      successMessage: 'Gerät mit {{reg}}',
      successAssigned: 'Gerät ist jetzt zugewiesen {{org}}',
      existingDeviceWarning: 'Fahrzeug hat bereits Gerät: ',
      unmountToStock: 'Vorhandenes demontieren (auf Lager)',
      swap: 'Austauschen (SWAP)',
      searchPlaceholder: 'Suchen IMEI, Modell, ICCID...',
      filterAvailable: 'Verfügbar (nicht eingebaut)',
      filterStock: 'Lagerbestand',
      filterCustomer: 'Kunde',
      filterReturned: 'Zurückgegeben',
      countAvailable: 'Wird angezeigt {{count}}freie Einheiten',
      countAvailablePaged: 'Zeige {{shown}} von {{total}}freien Einheiten',
      loadMore: 'Mehr anzeigen',
      countFilteredOrg: 'Eigene kostenlose Einheiten und DequeBestände',
      platformStock: 'DequeBestände',
      assignedToOrg: 'Beim Verbinden wurde „{{org}}“ zugewiesen',
      noDevicesFound: 'Keine freien Geräte gefunden',
      loadingDevices: 'Geräte werden geladen...',
      statusCurrent: 'Aktuell',
      selectedDevice: 'Ausgewähltes Gerät: ',
      deviceMountedElsewhere: 'Hinweis: Das Gerät ist auf {{reg}} montiert – es wird von dort demontiert',
      linking: 'Verbinden...',
      linkButton: 'Gerät mit Fahrzeug verbinden',
      statusStock: 'Lagerbestand',
      statusCustomer: 'Kunde',
      statusVehicle: 'Montiert',
      statusReturned: 'Zurückgegeben',
    },
  },
  simCards: {
    title: 'SIM-Kartenverwaltung',
    description: 'SIM-Karten verwalten, Nutzung anzeigen und Berichte erstellen',
    overview: 'Übersicht',
    simCards: 'SIM-Karten',
    reports: 'Berichte',
    totalSimCards: 'Gesamtzahl der SIM-Karten',
    totalDataUsage: 'Gesamtdatennutzung',
    totalSms: 'Gesamt-SMS',
    billingCycle: 'Abrechnungszeitraum',
    ratePlans: 'Tarifpläne',
    refresh: 'Aktualisieren',
    fetch: 'Download',
    allStatuses: 'Alle Status',
    searchPlaceholder: 'Suche ICCID, MSISDN, IMEI...',
    ratePlan: 'Tarifplan',
    dataMB: 'Daten (MB)',
    activated: 'Aktiviert',
    noSimCards: 'Keine SIM-Karten gefunden',
    loading: 'Laden...',
    createReport: 'Bericht erstellen',
    creatingReport: 'Bericht wird erstellt...',
    reportCreated: 'Bericht erstellt',
    latestReport: 'Letzter Bericht',
    deviceCount: 'Anzahl der Einheiten',
    totalData: 'Gesamtdaten',
    period: 'Zeitraum',
    invoiceNote: 'Rechnungen können nicht automatisch abgerufen werden. Melden Sie sich beim Jasper Control Center an, um Rechnungen herunterzuladen.',
    statusActivated: 'Aktiviert',
    statusActivationReady: 'Bereit',
    statusDeactivated: 'Inaktiv',
    statusInventory: 'Lagerbestand',
    statusRetired: 'Fertig',
    statusTestReady: 'Test',
    statusDistribution: 'Statusverteilung',
    activatedCount: 'Aktiviert',
    deactivatedCount: 'Deaktiviert',
    otherCount: 'Sonstige',
    lastSynced: 'Zuletzt synchronisiert',
    showingRange: 'Zeigt {start}-{end} von {total}',
    previous: 'Vorherige',
    next: 'Weiter',
    createUsageReport: 'Nutzungsbericht erstellen',
    createUsageReportDesc: 'Erstellen Sie einen aggregierten Bericht über die gesamte SIM-Nutzung für den aktuellen Abrechnungszeitraum.',
    noteLabel: 'HINWEIS:',
    fetchError: 'Daten konnten nicht abgerufen werden',
    createReportError: 'Bericht konnte nicht erstellt werden',
  },
  geofences: {
    title: 'Geofences',
    subtitle: 'Geofences verwalten',
    list: 'Geofences',
    create: 'Geofences erstellen',
    edit: 'Geofences bearbeiten',
    delete: 'Geofences entfernen',
    noGeofences: 'Keine Geofences erstellt',
    searchPlaceholder: 'Geofences suchen...',
    showSystemGeofences: 'System-Geofences anzeigen',
    area: 'Bereich',
    polygonWith: 'Polygon mit',
    points: 'Punkte',
    editPoints: 'Punkte bearbeiten',
    redraw: 'Neu zeichnen',
    drawPolygon: 'Polygon auf Karte zeichnen',
    editModeActive: 'Bearbeitungsmodus aktiv',
    dragPoints: 'Ziehen',
    redPointsToMove: 'rote Punkte zum Verschieben',
    clickGreenPoints: 'Grüne Punkte anklicken',
    toAdd: 'zum Hinzufügen',
    rightClickRedPoint: 'Rechtsklick',
    onRedToRemove: 'roter Punkt zum Entfernen',
    doneBackToForm: 'Fertig – Zurück zum Formular',
    events: {
      title: 'Geofence Ereignisse',
      subtitle: 'Alle Eintritts- und Austrittsereignisse mit Ort, Zeit und Kosten anzeigen',
      filter: 'Filter',
      vehicle: 'Fahrzeuge',
      allVehicles: 'Alle Fahrzeuge',
      geofence: 'Geofence',
      searchGeofence: 'Geofence suchen...',
      allGeofences: 'Alle Geofences',
      geofencesMatch: 'Geofences stimmen überein',
      eventType: 'Ereignistyp',
      allTypes: 'Alle Typen',
      enter: 'Eintritt',
      exit: 'Austritt',
      fromDate: 'Von-Datum',
      toDate: 'Bis-Datum',
      clearFilters: 'Filter löschen',
      refresh: 'Aktualisieren',
      vehicleColumn: 'Fahrzeuge',
      geofenceColumn: 'Geofence',
      eventTypeColumn: 'Typ',
      locationColumn: 'Standort',
      timeColumn: 'Zeit',
      durationColumn: 'Dauer',
      costColumn: 'Kosten',
      totalCost: 'Gesamtkosten',
      noEvents: 'Keine Ereignisse gefunden',
      loading: 'Ereignisse werden geladen...',
      error: 'Geofence-Ereignisse konnten nicht geladen werden',
      totalEvents: 'Gesamtzahl der Ereignisse',
      enterEvents: 'Eintritt',
      exitEvents: 'Austritt',
      error404: 'Geofence-Ereignis-API fehlt (404)',
      error401: 'Authentifizierung erforderlich (401)',
      searchVehicle: 'Fahrzeuge suchen...',
      vehicleFallback: 'Fahrzeuge',
      eventColumn: 'Ereignis',
      durationInside: 'Zeit in',
      showing: 'Anzeige',
      of: 'von',
      events: 'Ereignisse',
      page: 'Seite',
      vehiclesMatch: 'Fahrzeugübereinstimmungen',
    },
    name: 'Name',
    description: 'Beschreibung',
    scope: 'Umfang',
    scopeGlobal: 'Global (alle Organisationen)',
    scopeOrganization: 'Spezifische Organisation',
    organization: 'Organisation',
    isActive: 'Aktiv',
    alarmOnEnter: 'Alarm beim Betreten',
    alarmOnExit: 'Alarm beim Verlassen',
    filterCoordinates: 'Koordinaten innerhalb des Bereichs ausblenden',
    isToll: 'Zollgebiet',
    costPerEntry: 'Kosten pro Einreise (SEK)',
    costPerMinute: 'Kosten pro Minute (SEK)',
    polygonDrawn: 'Polygon gezeichnet',
    finishDrawing: 'Ziel',
    cancelDrawing: 'Abbrechen',
    minPoints: 'Ein Polygon muss mindestens 3 Punkte haben',
    hide: 'Ausblenden',
    show: 'Anzeigen',
    inactive: 'Inaktiv',
    alarmIn: 'Alarm ein',
    alarmOut: 'Alarm aus',
    activated: 'Geofence aktiviert',
    deactivated: 'Geofence deaktiviert',
    created: 'Geofence erstellt',
    updated: 'Geofence aktualisiert',
    deleted: 'Geofence entfernt',
    errorLoading: 'Geofences konnten nicht geladen werden',
    errorSaving: 'Geofence konnte nicht gespeichert werden',
    errorDeleting: 'Geofence konnte nicht entfernt werden',
    confirmDelete: 'Möchten Sie Geofence entfernen',
    minPointsRequired: 'Mindestens 3 Punkte erforderlich',
    pointRemoved: 'Punkt entfernt',
    pointAdded: 'Neuer Punkt hinzugefügt',
    loadError: 'Geofences konnten nicht geladen werden',
  },
  tripAnalysis: {
    title: 'Analysieren Fahrten',
    description: 'Vergleichen Sie aufgezeichnete Fahrten mit der Behälterdatei des Fahrzeugs, um Anomalien zu identifizieren',
    analyze: 'Analysieren',
    replay: 'Wiederholen',
    replayHint: 'Fahrterkennung aus Bin-Datei erneut ausführen (Fahrten erstellen/aktualisieren)',
    replayStarted: 'Wiedergabe gestartet',
    replayFailed: 'Wiedergabe konnte nicht gestartet werden',
    selectVehicleFirst: 'Fahrzeug zum Starten auswählen',
    registered: 'Registriert',
    fromBin: 'Aus Bin-Datei',
    diff: 'Unterschied',
    records: 'Punkte',
    registeredTrips: 'Registrierte Fahrten',
    binTrips: 'Fahrten aus Bin-Datei',
    noRegistered: 'Keine Fahrten registriert',
    noBinTrips: 'Keine Fahrten in der Bin-Datei (siehe Warnungen oben)',
    loadBinHint: 'Parsen, um die Bin-Datei zu lesen',
    maxSpeed: 'max',
    gpsPoints: 'GPS Punkte',
    noAvl250: 'Keine AVL250',
    warnNoRecords: 'Keine GPS Punkte in der Bin-Datei',
    warnNoSpeed: 'Geschwindigkeit = 0 an allen Punkten (kein Fahrtenbuch)',
    warnNoAvl250: 'AVL250 (Fahrtsignal) fehlt vollständig',
    warnNoGpsFix: 'GPSFix fehlt oft (Sat=0)',
    warnSparse: 'Spärliche Punkte – nur Herzschläge',
    reconstructed: 'Rekonstruiert',
    reconstructedHint: 'Rekonstruierte Fahrt (GPS fehlte beim Kaltstart) – Entfernung vom OEM-Messgerät oder OSRM-Schätzung',
    warnNoBinFile: 'Keine Bin-Datei für Fahrzeug/Datum auf Gateway',
    underDetectedTitle: 'Weniger Bin-Fahrten als aufgezeichnet – wahrscheinlicher Erkennungsfehler',
    underDetectedBody: 'Bin-Datei enthält Lauf (Rate > 0), aber die Batch-/Wiederholungserkennung hat weniger Fahrten gefunden als aufgezeichnet. Die Rohdaten sind korrekt – es ist die Fahrterkennung (wie sie bei der Wiedergabe verwendet wird), die Untersegmente, z. B. für Geräte mit spärlichem AVL250. Spielen Sie dieses Fahrzeug NICHT noch einmal ab: Dadurch würden korrekte Fahrten durch weniger Fahrten ersetzt.',
    replayDestructiveConfirm: 'Warnung: Die Bin-/Replay-Erkennung hat weniger Fahrten gefunden als aufgezeichnet, obwohl die Bin-Datei den Lauf enthält. Eine Wiederholung würde wahrscheinlich korrekte Fahrten durch weniger ersetzen. Möchten Sie immer noch fortfahren?',
  },
  obdVehicles: {
    title: 'OBDFahrzeugliste',
    description: 'Durchsuchen Sie Teltonikas OBD OEM-Support nach Marke und Modell. Die Liste gilt für FMX001/FMM00A/FMX003, nicht für die FMM003-Zertifizierung.',
    deviceFamilyNote: 'Quelle: Teltonika Wiki für FMX001, FMM00A und FMX003. DQFleet P&P führt FMM003 aus – Liste als OEM-Referenz verwenden.',
    checkNow: 'Jetzt prüfen',
    import: 'Importieren',
    checkFailed: 'Wiki konnte nicht überprüft werden',
    searchFailed: 'Konnte nicht suchen',
    syncFailed: 'Liste konnte nicht importiert werden',
    detailFailed: 'Details konnten nicht abgerufen werden',
    alreadyLatest: 'Bereits neueste Version',
    imported: 'Importiert {{count}} Zeilen',
    wikiDate: 'Wiki-Datum',
    ourDate: 'Unsere Version',
    none: 'Keine',
    rows: 'Linien',
    newerAvailable: 'Neue Datei gefunden',
    allMakes: 'Alle Marken',
    allParameters: 'Alle Parameter',
    make: 'Marke',
    model: 'Modell',
    year: 'Jahr',
    fuelType: 'Kraftstoff',
    resultCount: '{{count}} Treffer',
    scrollHint: 'Seitwärts scrollen für alle Parameter',
    deviceFamily: 'Quelleinheiten',
    relatedKb: 'Verwandte Wiki-Seiten',
    fleetMatches: 'Fahrzeuge in der Flotte',
    forceNonObd: 'erzwungenes Nicht-OBD',
  },
  obdKnowledge: {
    title: 'OBDWissen',
    description: 'Durchsuchbare Kopie von Teltonika OBD Solutions. Verlinken Sie immer zurück zum Wiki.',
    sources: 'Quellen',
    sync: 'Jetzt synchronisieren',
    loadFailed: 'Quellen konnten nicht heruntergeladen werden',
    searchFailed: 'Konnte nicht suchen',
    syncFailed: 'Konnte nicht synchronisiert werden',
    pageMissing: 'Seite noch nicht heruntergeladen – Synchronisierung ausführen',
    synced: 'Synchronisierung durchgeführt: {{updated}} aktualisiert von {{checked}}',
    notFetched: 'nicht heruntergeladen',
    openWiki: 'Öffnen unter Teltonika',
    searchPlaceholder: 'Suche z.B. Nicht-OBD, EV, Kia...',
    vehicleHits: '{{count}}Fahrzeuge in der Liste',
    openVehicleList: 'Fahrzeugliste öffnen',
    vehicleListPageNote: 'Die Wiki-Seite ist eine große Tabelle. Verwenden Sie die OBDFahrzeugliste, um nach Marke, Modell und Parametern zu suchen.',
    noVehicleHits: 'Keine Zeilen in der importierten Fahrzeugliste. Importieren Sie xlsx unter der OBDFahrzeugliste.',
    askAi: 'Ask AI',
    askPlaceholder: 'Z.B. Welche OEM-Parameter werden für Kia Niro unterstützt und wie behebe ich Fehler, wenn sie fehlen?',
    ask: 'Frage',
    askFailed: 'KI konnte nicht antworten',
  },
  trips: {
    private: 'Private Reise',
    business: 'Geschäftsreise',
    privateHidden: 'Privat – Details ausgeblendet',
    privateNoMap: 'Kartenansicht für Privatfahrten nicht verfügbar',
    title: 'Fahrten',
    description: 'Anzeigen und analysieren Fahrten für Ihre Fahrzeuge',
    selectVehicle: 'Fahrzeug auswählen',
    selectVehiclePlaceholder: '-- Fahrzeug auswählen --',
    tripsList: 'Fahrten',
    loading: 'Fahrten werden geladen...',
    noTrips: 'Keine Fahrten für dieses Fahrzeug gefunden',
    selectVehicleFirst: 'Wählen Sie ein Fahrzeug aus, um Fahrten anzuzeigen',
    fromDate: 'Von-Datum',
    toDate: 'Bis-Datum',
    clearDateFilter: 'Datumsfilter löschen',
    selectTripToView: 'Wählen Sie eine Fahrt zur Anzeige auf der Karte aus',
    selectVehicleToView: 'Fahrzeug zum Starten auswählen',
    completed: 'Fertig',
    alarms: 'Alarme',
    alarmCount: '{{count}}Alarme',
    alarmCountTitle: 'Fahrverhaltensalarme auf dieser Fahrt',
    noAlarms: 'Keine Alarme',
    electricShare: 'Elektrischer Anteil {{pct}} %',
    electricDistance: '{{km}} km elektrisch',
    electricShareTitle: 'Anteil der zurückgelegten Strecke im Elektrobetrieb ({{km}} km elektrisch)',
    errorLoadingVehicles: 'Konnte nicht geladen werden Fahrzeug',
    errorLoadingTrips: 'Fahrten konnten nicht geladen werden',
    speedChart: 'Geschwindigkeitskurve',
    showSpeedChart: 'Geschwindigkeitskurve anzeigen',
    hideSpeedChart: 'Geschwindigkeitskurve ausblenden',
    vehicleSpeed: 'Fahrzeuggeschwindigkeit',
    speedLimit: 'Geschwindigkeitsbegrenzung',
    showOverSpeed: 'Geschwindigkeitsüberschreitung anzeigen',
    overSpeed: '10 % über dem Limit',
    speedUnit: 'km/h',
    playTrip: 'Wiedergabe',
    pauseTrip: 'Stopp',
    resetTrip: 'Zurücksetzen',
    jammingLegend: 'Störung (AVL 249) – {count} GPS Punkte',
    speed: 'Geschwindigkeit',
    routePointCount: 'Anzahl der Routenpunkte',
    noSpeedLimitData: 'Geschwindigkeitsbegrenzung fehlt für alle Punkte dieser Reise. Möglicherweise fehlen Daten für ältere Fahrten oder wenn der OSM-Dienst keine Geschwindigkeitsbegrenzungen abrufen konnte.',
    speedLimitRefreshHint: 'Geschwindigkeitsbegrenzungen werden nach Abschluss der Fahrt im Hintergrund hinzugefügt. Laden Sie die Reise in wenigen Sekunden neu (Fahrt ändern und zurück oder laden Sie die Seite neu), wenn sie noch fehlen.',
    partialSpeedLimitData: 'Geschwindigkeitsbegrenzung existiert nur für {withLimit} von {total} Punkten.',
    loadRouteError: 'Reiseroute konnte nicht geladen werden',
    loadingRoute: 'Route wird geladen...',
    showPointsTable: 'Punktetabelle anzeigen',
    hidePointsTable: 'Punktetabelle ausblenden',
    pointsTableTitle: 'Punkte (Zeit, Geschwindigkeit, gefahrene Strecke)',
    avl199: 'Gefahrene Strecke (km)',
    time: 'Zeit',
    binData: 'Behälterdaten',
    binDataModalTitle: 'Behälterdaten – Fahrt',
    binDataLoading: 'Behälterdaten werden abgerufen...',
    binDataFetchError: 'Behälterdaten konnten nicht heruntergeladen werden',
    saveAsCsvColon: 'Speichern als CSV (durch Semikolon getrennt)',
    close: 'Schließen',
    binDataTimestamp: 'Zeitstempel',
    binDataAvl: 'AVL',
    binDataParameter: 'Parameter',
    binDataDescription: 'Beschreibung',
    binDataValue: 'Wert',
  },
  eco: {
    title: 'ECO-Fahren',
    description: 'Fahrgewohnheiten und Umweltauswirkungen analysieren',
    score: 'ECO-Punkte',
    overview: 'Übersicht',
    events: 'Ereignisse',
    trends: 'Trends',
    comparison: 'Vergleich',
    totalEvents: 'Gesamtereignisse',
    harshAcceleration: 'Starke Beschleunigung',
    harshBraking: 'Hartes Bremsen',
    harshCornering: 'Harte Kurvenfahrt',
    overspeed: 'Beschleunigung',
    excessiveIdling: 'Leerlauf',
    coasting: 'Segeln',
    greenDriving: 'Umweltfreundliches Fahren',
    fuelWaste: 'Kraftstoffverlust',
    energyLoss: 'Energieverlust',
    fuelSaved: 'Kraftstoffeinsparung',
    energySaved: 'Energieeinsparung',
    estimatedExtraCo2: 'Geschätzter zusätzlicher CO₂-Ausstoß',
    estimatedFuelLoss: 'Geschätzter Kraftstoffverlust',
    noTailpipeEmissions: 'Elektroauto – keine Abgasemissionen des Fahrzeugs',
    comparisonWithinOrg: 'Vergleich innerhalb Ihrer Organisation',
    fuelLossPerDay: 'Kraftstoffverlust pro Tag (ml)',
    energyLossPerDay: 'Energieverlust pro Tag (kWh)',
    co2Emission: 'CO₂-Emissionen',
    scoreImpact: 'Punktauswirkung',
    eventsPerTrip: 'Ereignisse pro Fahrt',
    environmentImpact: 'Umweltauswirkungen',
    distributionByType: 'Verteilung nach Typ',
    eventsPerDay: 'Ereignisse pro Tag',
    noEvents: 'Keine Ereignisse im ausgewählten Zeitraum',
    basedOnTrips: 'Basierend auf {trips}Reisen und {events}Ereignissen',
    of100: 'von 100',
    totalScoreImpact: 'Auswirkungen auf die Gesamtbewertung',
  },
  speedCompliance: {
    title: 'Geschwindigkeit Einhaltung',
    description: 'Geschwindigkeitseinhaltung nach Organisation und Fahrzeug analysieren',
    overview: 'Übersicht',
    organizations: 'Pro Organisation',
    vehicles: 'Pro Fahrzeug',
    trend: 'Trend',
    complianceRate: 'Einhaltung',
    overspeeds: 'Verstöße',
    trips: 'Reise',
    distance: 'Entfernung',
    timeOverLimit: 'Zeitüberschreitung',
    exportExcel: 'Exportieren Excel',
    topOffenders: 'Die meisten Verstöße (Fahrzeuge)',
    complianceByOrg: 'Compliance durch Organisation',
    trendOverTime: 'Compliance im Laufe der Zeit',
    newSystem: 'DQFleet (Neues System)',
    oldSystem: 'Altes System',
    noLegacyConnection: 'Das Fahrzeug hat keine Verbindung zum alten System',
    tripsFound: 'Fahrten gefunden',
    noTripsForDate: 'Keine Fahrten für ausgewähltes Datum',
    selectVehicle: 'Fahrzeug auswählen',
    loadingTrips: 'Fahrten werden geladen...',
    loadingOldTrips: 'Fahrten aus dem alten System laden...',
    source: 'Quelle',
    oldId: 'Alte ID',
    notMigrated: 'Nicht migriert',
    gpsPoints: 'GPS Punkte',
    totalDistance: 'Gesamtstrecke',
  },
  energyConsumption: {
    title: 'Energieverbrauch',
    description: 'Kraftstoffverbrauch pro Organisation und Fahrzeug analysieren',
    totalVehicles: 'Anzahl der Fahrzeuge',
    totalDistance: 'Gesamtstrecke',
    totalFuel: 'Gesamtkraftstoffverbrauch',
    avgConsumption: 'Durchschnittsverbrauch',
    fuel: 'Kraftstoff (L)',
    wltp: 'WLTP gemischt',
    consumption: 'Verbrauch',
    avgSpeed: 'Durchschnittsgeschwindigkeit',
    fuelByOrg: 'Kraftstoff pro Organisation',
    consumptionDist: 'Verbrauchsverteilung',
    consumptionTrend: 'Konsumtrend',
    distanceTrend: 'Entfernungstrend',
    lowConsumption: 'Geringer Verbrauch',
    mediumConsumption: 'Mittlerer Verbrauch',
    highConsumption: 'Hoher Verbrauch',
  },
  jamDetection: {
    title: 'Störungserkennung',
    from: 'Von',
    to: 'Bis',
    refresh: 'Aktualisieren',
    markers: 'Markierungen',
    heatmap: 'Wärmekarte',
    totalPoints: 'Störungspunkte',
    affectedVehicles: 'Betroffene Fahrzeuge',
    vehicle: 'Fahrzeuge',
    truncated: 'Zeigt maximal 20.000 Punkte an – Datumsbereich begrenzen',
    noData: 'Keine Störungen im Zeitraum',
    loadError: 'Störungsdaten konnten nicht abgerufen werden',
  },
  heatmap: {
    title: 'Heatmap',
    description: 'GPSDaten und Geschwindigkeitsverstöße visualisieren',
    organization: 'Organisation',
    selectOrganization: 'Auswählen Organisation...',
    vehicles: 'Fahrzeuge',
    selectVehicle: 'Fahrzeug auswählen...',
    selectVehicleFromOrg: 'Fahrzeug aus Organisation auswählen...',
    allVehicles: 'Alle',
    allVehiclesInOrg: 'Alle Fahrzeuge in der Organisation',
    vehiclesInOrg: 'Fahrzeuge in der Organisation',
    fromDate: 'Von-Datum',
    toDate: 'Bis-Datum',
    mode: 'Standort',
    modeAll: 'Alle Punkte',
    modeOverspeed: 'Geschwindigkeitsverstöße',
    modeIdling: 'Leerlauf/Leerlauf',
    modeParking: 'Parken',
    modeEco: 'ECO-Ereignisse',
    modeTimePattern: 'Zeitbasierte Muster',
    modeGeofence: 'Geofence-Verstöße',
    modeIncidents: 'Unfälle/Vorfälle',
    modeCharging: 'Aufladen Stationen',
    modeRiskScore: 'Kombinierte Risikobewertung',
    timePattern: 'Zeitmuster',
    timePatternAll: 'Alle Zeiten',
    timePatternMorning: 'Morgen (06:00–09:00)',
    timePatternDay: 'Tag (09:00–17:00)',
    timePatternEvening: 'Abend (17:00–22:00)',
    timePatternNight: 'Nacht (22:00–06:00)',
    loadData: 'Daten laden',
    loading: 'Laden...',
    loadingData: 'Heatmap-Daten werden geladen...',
    dataLoaded: '{count} Punkte geladen',
    tripCount: '{count} Auslösung, {points} Punkte',
    errorLoadingVehicles: 'Konnte nicht geladen werden Fahrzeug',
    errorLoadingData: 'Heatmap-Daten konnten nicht geladen werden',
    showInfo: 'Informationen zum Analysemodus anzeigen',
    infoTitle: 'Informationen zum Analysemodus',
    infoAll: 'Zeigt alle GPS-Punkte von ausgewählten Fahrzeugen während des ausgewählten Zeitraums an. Die Intensität basiert auf der Anzahl der Punkte pro Bereich.',
    infoOverspeed: 'Zeigt an, wo Fahrzeuge die Geschwindigkeitsbegrenzung überschritten haben. Die Intensität richtet sich nach der Anzahl der Verstöße und der maximalen Überschreitung.',
    infoIdling: 'Zeigt an, wo Fahrzeuge mit eingeschalteter Zündung gestanden haben. Die Intensität basiert auf der gesamten Leerlaufzeit pro Standort.',
    infoParking: 'Zeigt, wo Fahrten enden (Parkplätze). Jeder Pin repräsentiert einen Parkplatz mit einem Radius von 100 Metern. Die Farbe basiert auf der Anzahl Ihrer Parkvorgänge: Grün (1–2), Gelb (3–5), Orange (6–10), Rot (11+).',
    infoEco: 'Zeigt hartes Fahren an (starkes Beschleunigen, Bremsen, Kurvenfahrten). Die Intensität basiert auf der Anzahl der Ereignisse und dem Schweregrad.',
    infoTimePattern: 'Zeigt Verkehrsmuster basierend auf der Tageszeit an. Wählen Sie Morgen, Tag, Abend oder Nacht, um zu sehen, wann Fahrzeuge am aktivsten sind.',
    infoGeofence: 'Zeigt an, wo Fahrzeuge Geofence-Bereiche verlassen oder betreten haben. Die Intensität basiert auf der Anzahl der Verstöße.',
    infoIncidents: 'Zeigt schwerwiegende Ereignisse wie Panikalarme, Unfälle oder Abstürze an. Die Intensität richtet sich nach dem Schweregrad und der Anzahl der Vorfälle.',
    infoCharging: 'Zeigt, wo Fahrzeuge aufgeladen wurden (EV). Basierend auf langen Stopps (mindestens 5 Minuten). Die Intensität basiert auf der Anzahl der Anklagen und einzelnen Fahrzeugen.',
    infoRiskScore: 'Kombiniert mehrere Risikofaktoren (Geschwindigkeitsverstöße, ECO-Ereignisse, Vorfälle), um Gebiete mit hohem Risiko anzuzeigen. Die Intensität basiert auf der kombinierten Risikobewertung.',
  },
  heatmapImport: {
    title: 'Heatmap-Import',
    selectFile: 'Wählen Sie CSV die zu importierende Datei aus',
    fileFormat: 'Format: Zeitstempel;Breitengrad;Längengrad;Registrierungsnummer;Geschwindigkeit;Geschwindigkeitsbegrenzung',
    selectFileButton: 'Datei auswählen',
    uploading: 'Laden...',
    uploadSuccess: '{valid}von {total}Zeilen wurden importiert',
    invalidRows: '{count} Zeilen konnten nicht importiert werden',
    uploadError: 'Datei konnte nicht hochgeladen werden',
    invalidFileType: 'Nur CSV-Dateien sind zulässig',
    fileTooLarge: 'Datei ist zu groß (max. 100 MB)',
    importComplete: 'Import vollständig',
    importStats: '{valid} Punkte, {vehicles} Fahrzeug',
    clear: 'Löschen',
    cleared: 'Importdaten gelöscht',
    clearError: 'Daten konnten nicht gelöscht werden',
    selectVehicle: 'Fahrzeug auswählen...',
  },
  realtime: {
    loading: 'Positionen werden geladen...',
    fetchError: 'Echtzeitpositionen konnten nicht abgerufen werden',
    speed: 'Geschwindigkeit',
    heading: 'Richtung',
    ignition: 'Zündung',
    movement: 'Bewegung',
    voltage: 'Spannung',
    battery: 'Batterie',
    on: 'Ein',
    off: 'Aus',
    moving: 'Move',
    still: 'Quiet',
  },
  supportAdmin: {
    title: 'Support Administration',
    subtitle: 'Supportfälle und Systemmeldungen verwalten',
    openKeywin: 'KeyWin-Verwaltung',
    openKeywinTitle: 'KeyWin-Verwaltung in neuem Tab öffnen',
    openProvisioning: 'Schrankbereitstellung',
    openProvisioningTitle: 'Offene Schrankbereitstellung (intern/nur VPN)',
    queue: 'Support-Warteschlange',
    broadcasts: 'Broadcasts',
    stats: 'Statistiken',
    allTickets: 'Alle Fälle',
    assignToMe: 'Nehmen Sie die case',
    internalNote: 'Interne Notiz',
    sendReply: 'Antwort senden',
    sendBroadcast: 'Broadcast senden',
    targetAll: 'Alle Benutzer',
    targetOrg: 'Spezifische Organisation',
    includeChildren: 'Unterorganisationen einschließen',
    pinMessage: 'Nachricht anpinnen',
    newBroadcast: 'Neue Übertragung senden',
    sentBroadcasts: 'Gesendete Übertragungen',
    readBy: 'gelesen',
    selectOrg: 'Organisation auswählen',
    priorityInfo: 'Info (blau)',
    priorityWarning: 'Warnung (gelb)',
    priorityCritical: 'Kritisch (rot)',
    faq: 'FAQ',
    faqQuestion: 'Frage',
    faqAnswer: 'Antwort',
    faqQuestionPlaceholder: 'Frage...',
    faqAnswerPlaceholder: 'Antwort...',
    addToFaq: 'Zu FAQ hinzufügen',
    addToFaqFromTicket: 'Diese Angelegenheit als FAQ hinzufügen',
    saveToFaq: 'In FAQ speichern',
    newFaq: 'Neue FAQ',
    faqList: 'FAQ-Liste',
    sortOrder: 'Sortierreihenfolge',
    fillQuestionAnswer: 'Frage und Antwort ausfüllen',
    deleteFaqConfirm: 'Möchten Sie diese FAQ löschen?',
    deleteBroadcastConfirm: 'Möchten Sie diese Übertragung löschen?',
    searchTickets: 'Fall, Name oder E-Mail suchen...',
    noTickets: 'Keine Fälle',
    messageTitlePlaceholder: 'Titel der Nachricht',
    categoryPlaceholder: 'z. B. Installation und Einrichtung',
    queueTab: 'Support-Warteschlange',
    partnerHandling: 'Partner verwaltet',
    handlingFilter: 'verwaltet von',
    handlingAll: 'Alle',
    organizationAll: 'Alle Organisationen',
    organizationExternal: 'ohne Organisation',
    handlingPartner: 'Partner',
    handlingDeque: 'Deque',
    escalateToDeque: 'Übergabe an Deque',
    returnToPartner: 'Übergabe an Partner',
    escalateSuccess: 'Fall übergeben an Deque',
    returnSuccess: 'Fall zurückgegeben an Partner',
    partnerReplyLocked: 'Der Partner kümmert sich um die Angelegenheit. Sie können eine interne Notiz schreiben, aber nicht auf den Kunden antworten.',
    transferError: 'Der Fall konnte nicht verschoben werden',
    broadcastTab: 'Broadcasts',
    broadcastSendTitle: 'Neue Übertragung senden',
    broadcastSentTitle: 'Gesendete Übertragungen',
    noBroadcasts: 'Keine Broadcasts gesendet',
    broadcastMessage: 'Nachricht *',
    broadcastMessagePlaceholder: 'Schreiben Sie Ihre Nachricht...',
    broadcastTitle: 'Titel *',
    broadcastPinned: 'Pin-Nachricht (oben angezeigt)',
    broadcastScope: 'Zielgruppe',
    broadcastPriority: 'Priorität',
    broadcastOrg: 'Organisation',
    broadcastSelectOrg: 'Organisation auswählen',
    broadcastScopeAll: 'Alle Benutzer',
    broadcastScopeOrg: 'Spezifische Organisation',
    sendBroadcastButton: 'Broadcast senden',
    statusAll: 'Alle Status',
    statusOpen: 'Offen',
    statusInProgress: 'In Bearbeitung',
    statusWaiting: 'Warten auf Kunden',
    statusResolved: 'Gelöst',
    statusClosed: 'Geschlossen',
    markComplete: 'Als abgeschlossen markieren',
    ticketStatusOpen: 'Offen',
    ticketStatusInProgress: 'In Bearbeitung',
    ticketStatusWaiting: 'Warten auf Kunden',
    ticketStatusResolved: 'Gelöst',
    ticketStatusClosed: 'Bereit markiert',
    priorityAll: 'Alle Prioritäten',
    priorityCritical2: 'Kritisch',
    priorityHigh: 'Hoch',
    priorityMedium: 'Mittel',
    priorityLow: 'Niedrig',
    ticketCountsOpen: 'Offen',
    ticketCountsInProgress: 'In Bearbeitung',
    ticketCountsWaiting: 'Warten',
    ticketCountsResolved: 'Gelöst',
    unknownUser: 'Unbekannt',
    assignedTo: 'Zugewiesen',
    selectCategory: 'Kategorie auswählen',
    categoryLabel: 'Kategorie',
    assignLabel: 'Zuweisen',
    notAssigned: 'Nicht zugewiesen',
    internalNoteLabel: 'Interne Notiz',
    internalNotePlaceholder: 'Interne Notiz schreiben...',
    replyPlaceholder: 'Antwort an den Kunden schreiben...',
    replyEmailPlaceholder: 'Antwort schreiben (als E-Mail gesendet)...',
    viaEmail: 'Per E-Mail',
    viaChat: 'Per Chat',
    viaPhone: 'Via Konversation',
    forwarded: 'Weitergeleitet',
    forwardedTo: 'Weitergeleitet an {{email}}',
    telephonyTab: 'Telefonie',
    telephonyNumberTitle: 'Support-Nummer',
    telephonyNumberHelp: 'Wählen Sie aus, welche 46elks-Nummer Supportanrufe entgegennimmt. Die Nummer muss bereits bei 46elks gemietet sein.',
    telephonyActiveNumber: 'Aktive Nummer',
    telephonyActive: 'Aktiv',
    telephonyUseNumber: 'Als Support-Nummer verwenden',
    telephonyDisabled: 'Sprache ist deaktiviert (ELKS_VOICE_ENABLED). Der Webhook bleibt hängen, bis die Flagge aktiviert wird.',
    telephonyNoElksNumbers: 'Noch keine Nummern mit 46elks.',
    telephonyNumberActivated: 'Supportnummer aktiviert',
    telephonyAgentsTitle: 'Jagdliste',
    telephonyAgentsHelp: 'Der Anruf wird mit dem ersten Mobiltelefon verbunden. Bei besetzt geht es sofort weiter, wenn nach {seconds} Sekunden keine Antwort erfolgt.',
    callEvent: {
      incoming: 'Eingehende Anrufe',
      greeting: 'Begrüßung abgespielt',
      ringing: 'Klingeln',
      busy: 'Besetzt',
      noanswer: 'Keine Antwort',
      answered: 'Beantwortet',
      hangup: 'Anruf beendet',
      abandoned: 'Beendet, bevor wir antworten konnten',
    },
    callState: {
      ringing: 'In Bearbeitung',
      answered: 'Beantwortet',
      missed: 'Verpasst',
      busy: 'Besetzt',
      failed: 'Fehlgeschlagen',
      abandoned: 'Beendet vor Antwort',
    },
    telephonySelectAgent: 'Person auswählen',
    telephonyPhonePlaceholder: 'Mobil +46…',
    telephonyAgentSaved: 'Mobiltelefon hinzugefügt',
    telephonySaveError: 'Speichern nicht möglich',
    telephonyNoAgents: 'Keine Mobiltelefone in der Suchliste.',
    telephonyMoveUp: 'Nach oben verschieben',
    telephonyMoveDown: 'Nach unten verschieben',
    telephonyCallsTitle: 'Letzter Anruf',
    telephonyCallFrom: 'Von',
    telephonyCallState: 'Status',
    telephonyCallAnswered: 'Beantwortet',
    telephonyCallStarted: 'Start',
    telephonyCallDuration: 'Anrufzeit',
    statsPerSource: 'Nach Quelle',
    statsTelephony: 'Telefonie',
    statsCallsTotal: 'Anrufe',
    statsCallOffered: 'Angerufen',
    statsCallAnswered: 'Beantwortet',
    statsCallAnsweredSomeone: 'Jemand hat geantwortet',
    statsCallReceived: 'Empfangen',
    statsCallMissedByAgent: 'Verpasst',
    statsCallNobodyAnswered: 'Niemand hat geantwortet',
    statsCallAbandoned: 'Beendet vor Antwort',
    telephonyNoticeTitle: 'Begrüßung vor der Verbindung',
    telephonyNoticeHelp: 'Laden Sie eine benutzerdefinierte WAV-Aufnahme hoch, die dem Anrufer statt der integrierten Sprachdatei vorgespielt wird.',
    telephonyNoticeCustom: 'Benutzerdefinierte Aufnahme: {{name}}',
    telephonyNoticeDefault: 'Die Standarddatei (synthetische Stimme) wird verwendet, bis Sie Ihre eigene hochladen.',
    telephonyNoticeUpload: 'WAV hochladen',
    telephonyNoticeReset: 'Auf Standard zurücksetzen',
    telephonyNoticeSaved: 'Begrüßung gespeichert',
    telephonyNoticeRemoved: 'Benutzerdefinierte Begrüßung entfernt',
    statsCallUnanswered: 'Unbeantwortet',
    statsCallNotTried: 'Nicht verbunden',
    statsCallRinging: 'In Bearbeitung',
    statsAvgCallDuration: 'Durchschnittliche Anrufzeit',
    statsPerCallAgent: 'Pro Person in der Jagdliste',
    statsPerCallAgentHelp: 'Eingegangen sind Anrufe, die die Person beantwortet hat. Verpasst bedeutet, dass der Hörer klingelt, die Person den Anruf jedoch nicht angenommen hat. „Niemand beantwortet“ ist ein Anruf, bei dem niemand in der Jagdliste geantwortet hat.',
    statsHandlingTab: 'Bearbeitungszeit',
    statsHandlingHelp: 'Zeit von der Annahme oder dem Empfang eines Falls bis zum Schließen oder Weiterleiten. Die Zeit, in der wir auf einen Kunden warten, wird nicht gezählt.',
    statsHandlingYear: 'Jahr',
    statsHandlingMonth: 'Monat',
    statsHandlingAllMonths: 'Das ganze Jahr',
    statsHandlingPerson: 'Person',
    statsHandlingCompany: 'Das gesamte Unternehmen',
    statsHandlingAvg: 'Durchschnittliche Bearbeitungszeit',
    statsHandlingClosed: 'Abgeschlossen / weitergeleitet',
    statsHandlingWaitExcluded: 'Ohne Warten auf einen Kunden',
    statsHandlingTotal: 'Gesamtbearbeitungszeit',
    statsHandlingCompanyYear: 'Das Unternehmen {{year}}',
    statsHandlingPersonYear: '{{name}} {{year}}',
    statsHandlingByPersonYear: 'Pro Person, das ganze Jahr',
    statsHandlingByPersonMonth: 'Pro Person, {{month}}',
    statsHandlingEmpty: 'Keine abgeschlossene Verarbeitung im ausgewählten Zeitraum.',
    statsNoCallData: 'Noch keine Anrufdaten.',
    telephonyNoCalls: 'Noch keine Anrufe.',
    telephonyTicket: 'Fall',
    replyAfterStatus: 'Nach Antwort',
    replyStatusWaiting: 'Warten auf Antwort',
    replyStatusResolved: 'Gelöst',
    sendEmailAria: 'E-Mail senden',
    sendReplyAria: 'Antwort senden',
    replySent: 'Antwort gespeichert',
    replySentEmail: 'Antwort als E-Mail gesendet',
    internalNoteSaved: 'Intern Notiz gespeichert',
    internalNoteBadge: '🔒 Interne Notiz',
    callTranscriptBadge: '🔒 Anrufaufzeichnung – intern',
    callTranscriptNeverToCustomer: 'Nie an Kunden gesendet',
    telephonyRecordingOn: 'Anrufe werden aufgezeichnet. Transkript und Zusammenfassung sind immer intern.',
    editInternalNote: 'Interne Notiz bearbeiten',
    internalNoteUpdated: 'Interne Notiz aktualisiert',
    editInternalNoteError: 'Interne Notiz konnte nicht aktualisiert werden',
    editedLabel: 'bearbeitet',
    statsOverview: 'Übersicht',
    statsTotalTickets: 'Gesamtzahl der Fälle',
    statsOpenTickets: 'Offene Fälle',
    statsResolvedTickets: 'Gelöste Fälle',
    statsAvgResponse: 'Durchschnittliche Zeit bis zur Antwort',
    statsMin: 'min',
    statsPerCategory: 'Nach Kategorie',
    statsPerPriority: 'Pro Priorität',
    statsPerOrg: 'Pro Organisation',
    statsPerAssignee: 'Pro Zuweisung',
    statsPerCategoryTab: 'Nach Kategorie',
    statsOrgColumn: 'Organisation',
    statsPersonColumn: 'Person',
    statsCategoryColumn: 'Kategorie',
    statsTotal: 'Gesamt',
    statsOpen: 'Offen',
    statsResolved: 'Gelöst',
    statsAvgTime: 'Durchschnittliche Zeit',
    statsSolvePct: 'Lösungsrate',
    statsLoading: 'Statistiken werden geladen...',
    addCategoryTitle: 'Kategorie hinzufügen',
    categoryNameLabel: 'Name (intern) *',
    categoryNamePlaceholder: 'z. B. Installation',
    categoryDescLabel: 'Beschreibung',
    confirmLabel: 'Bestätigen',
    createTicketButton: 'Neuer Fall',
    createTicketTitle: 'Fall manuell erstellen',
    createTicketSubtitle: 'Für Anrufe, Zähler oder E-Mails, die nicht automatisch eingegangen sind',
    createTicketName: 'Ansprechpartner',
    createTicketNamePlaceholder: 'Name der Person, der Sie antworten werden',
    createTicketReplyTo: 'Antworten an',
    createTicketReplyToHint: 'Geben Sie Telefon und/oder E-Mail ein. Mindestens eine ist erforderlich.',
    createTicketPhone: 'Telefon',
    createTicketPhonePlaceholder: '070-123 45 67',
    createTicketRegNumber: 'Registernummer',
    createTicketRegNumberPlaceholder: 'ABC123',
    createTicketBookingNumber: 'Buchungsnummer',
    createTicketBookingNumberPlaceholder: 'z.B. 1812',
    createTicketEmail: 'E-Mail',
    createTicketEmailPlaceholder: 'kund@exempel.se',
    createTicketOrg: 'Organisation',
    createTicketOrgNone: 'Keine/unbekannte Organisation',
    createTicketSubject: 'Betreff',
    createTicketMessage: 'Beschreibung',
    createTicketMessagePlaceholder: 'Worum geht es? Zeichnen Sie das Gespräch hier auf.',
    createTicketAssignMe: 'Weisen Sie mir den Fall zu',
    createTicketSubmit: 'Fall erstellen',
    createTicketSuccess: 'Fall erstellt',
    createTicketError: 'Fall konnte nicht erstellt werden',
  },
  chat: {
    title: 'Nachrichten & Support',
    support: 'Support',
    chat: 'Chat',
    broadcasts: 'Info',
    newTicket: 'Neuer Fall',
    partnerContactTitle: 'Support kontaktieren:',
    noTickets: 'Keine Fälle',
    noBroadcasts: 'Keine Nachrichten',
    subject: 'Betreff',
    phoneOptional: 'Telefon (optional)',
    emailOptional: 'E-Mail (optional)',
    regNumberOptional: 'Registrierungsnummer (optional)',
    bookingNumberOptional: 'Buchungsnummer (optional)',
    message: 'Beschreiben Sie Ihren Fall...',
    send: 'Senden',
    typeReply: 'Antwort schreiben...',
    fillAllFields: 'Alle Felder ausfüllen',
    ticketCreated: 'Fall erstellt',
    justNow: 'Jetzt gerade',
    statusOpen: 'Offen',
    statusInProgress: 'In Bearbeitung',
    statusWaiting: 'Warten auf Antwort',
    statusResolved: 'Gelöst',
    statusClosed: 'Geschlossen',
    priorityLow: 'Niedrig',
    priorityMedium: 'Mittel',
    priorityHigh: 'Hoch',
    priorityCritical: 'Kritisch',
    chatComingSoon: 'Interner Chat folgt bald!',
    chatDescription: 'Chat mit Kollegen in Ihrer Organisation',
    broadcastTitle: 'Systemnachrichten',
    markAsRead: 'Als gelesen markieren',
    newConversation: 'Neue Konversation',
    noConversations: 'Nein Konversationen',
    startConversation: 'Neue Konversation starten',
    searchUsers: 'Benutzer suchen (Name, E-Mail oder RSID)...',
    noUsers: 'Keine Benutzer gefunden',
    noMessages: 'Noch keine Nachrichten',
    typeMessage: 'Nachricht schreiben...',
    closeTicket: 'Als abgeschlossen markieren',
    ticketClosed: 'Fall geschlossen',
    ticketClosedByUser: 'Fall vom Benutzer geschlossen.',
    ticketIsClosed: 'Dieser Fall ist geschlossen',
    closeConversation: 'Konversation beenden',
    conversationClosed: 'Konversation geschlossen',
    couldNotClose: 'Konversation konnte nicht beendet werden',
    minChars: 'Geben Sie mindestens 2 Zeichen ein Suche',
    noUsersFound: 'Keine Benutzer gefunden',
    searchToFind: 'Beginnen Sie mit der Eingabe, um nach Benutzern zu suchen',
    faq: 'FAQ',
    faqSearchPlaceholder: 'Suchen Sie in den FAQ...',
    noFaqFound: 'Keine Treffer',
    noFaqYet: 'Noch keine FAQ hinzugefügt',
  },
  version: {
    title: 'Version',
    fleetManagement: 'Flottenmanagementsystem',
    currentRelease: 'Aktuelle Version',
    viewChangelog: 'Änderungsprotokoll anzeigen',
    releaseHistory: 'Versionsverlauf',
    current: 'Aktuell',
    upcoming: 'In Vorbereitung',
    released: 'Veröffentlicht',
    unreleased: 'Nicht in Version',
    noReleases: 'Kein Versionsverlauf',
    releaseAction: 'Release-Version',
    releaseLoadError: 'Nächste Version konnte nicht gezählt werden',
    releaseSaved: 'v{{version}} ist freigegeben',
    releaseError: 'Version konnte nicht veröffentlicht werden',
    confirmLower: 'Ausstehende Module verweisen auf eine höhere Ebene. Trotzdem veröffentlichen?',
    pendingCount: '{{count}}Module ohne Version enthalten.',
    level: 'Ebene',
    releaseDate: 'Datum',
    releaseTitle: 'Überschrift',
    summary: 'Kurztext',
    summaryEn: 'Kurztext (Englisch)',
    notes: 'Punkte, einer pro Zeile',
    bump: {
      patch: 'Patch',
      minor: 'Minor',
      major: 'Groß',
    },
    release: {
      upcoming: {
        drivingLogApp: 'Fahrprotokoll-App',
      },
      v500: {
        newPlatform: 'Deque neue Plattform',
        dashboard: 'Anpassbares Drag-and-Drop-Dashboard',
        fleet: 'Fahrzeugflotte mit vollständiger Übersicht',
        liveTracking: 'Echtzeitverfolgung mit OSM-Karten',
        reports: 'Berichte (Fahrten, Fahrprotokoll, sparsames Fahren, Geschwindigkeit, Energie, Verschleiß, CO2)',
        analysis: 'Analysetools (Routenanalyse, Heatmap, Unfallerkennung)',
        crm: 'CRM mit Kundenverwaltung und Hierarchie',
        geofences: 'Geofence-Management mit Ereignissen',
        homecare: 'Home-Service-Modul',
        deviceManagement: 'Geräteverwaltung mit SIM-Karte',
        admin: 'Administration (Benutzer, Rollen, Organisationen)',
        rbac: 'Rollenbasierte Zugriffskontrolle (RBAC)',
        osmMaps: 'OpenStreetMap Integration',
      },
    },
  },
  scbTesting: {
    title: 'SCB API Testing',
    description: 'SCB-API-Endpunkte testen und Ergebnisse anzeigen',
    selectEndpoint: 'Endpunkt auswählen',
    parameters: 'Parameter',
    execute: 'Endpunkt ausführen',
    executing: 'Ausführen...',
    result: 'Ergebnis',
    success: 'Erfolgreich',
    error: 'Fehler',
    responseData: 'Antwort Daten',
    noResult: 'Noch keine Ergebnisse. Wählen Sie einen Endpunkt aus und klicken Sie auf „Endpunkt ausführen“.',
  },
  vehicleCard: {
    refresh: 'Update von Car.info',
    vehicleInfo: 'Fahrzeugdaten',
    engineInfo: 'Motor & Leistung',
    dates: 'Datum',
    deviceInfo: 'Gerät',
    specifications: 'Technische Daten',
    notes: 'Notizen',
    tags: 'Zusätzliche Informationen',
    vin: 'VIN',
    brand: 'Marke',
    model: 'Modell',
    year: 'Modelljahr',
    vehicleType: 'Fahrzeugtyp',
    fuelType: 'Kraftstoff',
    engine: 'Motor',
    engineType: 'Motortyp',
    gearbox: 'Getriebe',
    horsepower: 'Leistung',
    mileage: 'Anzeigenstand',
    registerDate: 'Registriert',
    manufacturedDate: 'Hergestellt',
    lastUpdated: 'Letzte Aktualisierung',
    externalVoltage: 'Externe Spannung',
    batteryLevel: 'Batterie',
    fuelLevel: 'Kraftstoffstand',
    stolenWarning: 'FAHRZEUG WIRD GESTOHLEN GEMELDET!',
    drivingBanWarning: 'DAS Dem Fahrzeug ist das Fahren verboten!',
    statusActive: 'Aktiv',
    statusMaintenance: 'Wartung',
    statusInactive: 'Inaktiv',
    statusDeregistered: 'Abgebrochen',
    systemStatus: 'Systemstatus:',
    tabGeneral: 'Allgemeine Informationen',
    tabEconomy: 'Wirtschaftlichkeit',
    tabCards: 'Tankkarte',
    tabSpec: 'Kurze Spezifikation',
    tabProperties: 'Funktionen',
    tabPlacement: 'Standort',
    tabHistory: 'Verlauf',
    tabBooking: 'Buchungsinformationen',
    tabBookingBadge: 'NEU',
    tabDevicePnP: 'Gerät / P&P',
    tabNotes: 'Notizen',
    tabAttachments: 'Anhänge',
    pnp: {
      globalOff: 'Plug & Play ist global deaktiviert (OBD_PROVISIONING_ENABLED≠true). Konfigurieren Sie die FMM003-Basislinie unter Geräteverwaltung, markieren Sie Geräte mit P&P und aktivieren Sie sie dann in .env.',
      baselineMissing: 'Für dieses Modell wurde keine FW-/Konfigurationsdatei angegeben. Füllen Sie die Grundlinie unter Geräteverwaltung aus, bevor Sie P&P aktivieren.',
      noDevice: 'Kein Gerät mit dem Fahrzeug verbunden.',
      sectionDevice: 'Gerät und Firmware',
      sectionProfile: 'Kraftstoffprofil',
      sectionEye: 'EYE-Parameter',
      sectionParams: 'Parameter festlegen',
      paramsHint: 'Parameter, die P&P nach genehmigter FW/CFG einstellt. Sa = im letzten erfolgreichen Schritt geliefert. Geplant = im Profil enthalten, aber noch nicht bestätigt.',
      paramId: 'ID',
      paramValue: 'Wert',
      paramLabel: 'Bedeutung',
      paramGroup: 'Paket',
      paramStatus: 'Status',
      groupIce: 'ICE',
      groupEv: 'EV / PHEV / ID.x',
      groupProblem: 'Problemliste',
      groupVin: 'VIN',
      statusApplied: 'Eingestellt',
      statusPlanned: 'Geplant',
      statusSkipped: 'Gesprungen',
      onProblemList: 'Auf Problemliste (Renault Trafic/Master – Nicht-OBD)',
      onProblemListDisable: 'Auf Problemliste (OBD-Disable 40000:0 / VW ID.x / BMW i4 / Mercedes)',
      problemListPending: 'Die Einstellung wurde noch nicht übermittelt – das Auto bleibt stehen, bis es sie erhält.',
      problemListApplied: 'Die Einstellung wurde übermittelt {when}. Das Auto bleibt auf der Problemliste stehen.',
      notOnProblemList: 'Nicht auf der Problemliste',
      imei: 'IMEI',
      model: 'Modell',
      currentFw: 'Aktuelle Firmware',
      targetFw: 'Ziel-Firmware',
      targetConfig: 'Zielkonfiguration',
      status: 'P&P-Status',
      fuelType: 'Kraftstoff (Fahrzeug)',
      profile: 'Profil',
      profileSource: 'Profilquelle',
      profileIce: 'ICE',
      profilePheV: 'PHEV',
      profileEv: 'EV',
      eyeParams: 'EYE auf Gerät',
      eyeYes: 'Ja (aktiv Links)',
      eyeNo: 'Nein',
      eyeReset: 'Von P&P wiederhergestellt',
      eyeLinks: 'Aktive EYE-Links',
      enablePnp: 'Als P&P markieren',
      disablePnp: 'P&P deaktivieren',
      pnpEnabled: 'Gerät für Plug & Play markiert',
      pnpDisabled: 'P&P für Gerät deaktiviert',
      simulate: 'Kette simulieren',
      simulateDone: 'Simulation abgeschlossen',
      profileSaved: 'Profil gespeichert',
      loadError: 'P&P-Status konnte nicht abgerufen werden',
      saveError: 'Speichern nicht möglich',
      runError: 'Konnte nicht ausgeführt werden Bereitstellung',
    },
    placement: {
      description: 'Speichern, wo das Fahrzeug normalerweise steht (Standort). Wird für Bereichsfilter in der Echtzeitkarte verwendet. Geben Sie die Adresse ein, wählen Sie einen Punkt auf der Karte aus oder rufen Sie die aktuelle GPS-Position des Fahrzeugs ab.',
      pickOnMap: 'Auf der Karte auswählen',
      mapHelp: 'Klicken Sie auf die Karte, um den Standort festzulegen. Mindestens ein Punkt ist erforderlich.',
      geocodeFromAddress: 'Koordinate von Adresse abrufen',
      geocodeSuccess: 'Koordinate abgerufen',
      geocodeNotFound: 'Adresse konnte nicht gefunden werden',
      geocodeError: 'Fehler bei der Geokodierung',
      addressRequired: 'Mindestens Adresse, Postleitzahl oder Stadt eingeben',
      coordinates: 'Koordinate',
      clear: 'Standort löschen',
      fromGps: 'Abruf von GPS',
      fromGpsSuccess: 'Standort abgerufen von GPS des Fahrzeugs. Klicken Sie auf Speichern.',
      fromGpsMissing: 'Keine aktuelle GPS-Position für das Fahrzeug (fehlendes Gerät, private Fahrt oder noch keine Daten)',
      fromGpsError: 'Koordinaten wurden von GPS festgelegt, aber die Adresse konnte nicht nachgeschlagen werden',
      gpsTime: 'Letzte GPS-Position: {{time}}',
    },
    booking: {
      banner: 'Einstellungen für die Buchung, wenn das Fahrzeug Teil eines Lieferorts ist. Bearbeiten Sie Pool und Standort unter „Buchung“.',
      sectionDescription: 'Buchungsbeschreibung',
      descriptionHint: 'Bearbeitbarer Text, der dem Buchungspersonal angezeigt wird (maximal 50 Zeichen). Wenn das Feld leer ist, werden die Registrierungsnummer und das Getriebe verwendet.',
      charCount: '{{current}}/{{max}} Zeichen',
      charCountLong: '{{current}}/{{max}} Zeichen',
      sectionEmailNote: 'Nachricht in der Buchungsbestätigung (E-Mail)',
      emailNoteHint: 'Erscheint nur in der E-Mail an den Benutzer, wenn Sie die Kalendereinladung/Buchungsbestätigung senden. Maximal 2000 Zeichen.',
      emailNotePlaceholder: 'Optionale Informationen für die Person, die gebucht hat...',
      previewForStaff: 'Vorschau (wie die Buchung sieht)',
      saveBookingDesc: 'Buchungsdetails speichern',
      bookingDescSaved: 'Buchungsdetails gespeichert',
      noDescription: '–',
      sectionSlot: 'Slot-Zeit',
      slotHint: 'Standardlänge, minimale/maximale Buchungszeit, Puffer und buchbare Stunden werden im Buchungsmodul gesteuert pro Ort und Kalender – ggf. dort ergänzen.',
      restMinutesLabel: 'Ruhezeit zwischen Buchungen',
      restMinutesHint: 'Minuten, die dieses Fahrzeug zwischen Buchungen ruhen sollte (z. B. Elektroauto, das aufgeladen werden muss). Handlung = Pool/Organisation erben. 0 = keine Ruhezeit. Wert überschreibt Pool/Organisation.',
      restMinutesPlaceholder: 'Erben',
      restMinutesUnit: 'Minuten',
      restMinutesSave: 'Ruhezeit sparen',
      restMinutesSaved: 'Ruhezeit gespart',
      restMinutesInvalid: 'Eine positive Anzahl von Minuten eingeben (oder leer lassen)',
      sectionPoolLocker: 'Pool und Schlüsselschließfach',
      poolTitle: 'Pool/Lieferort',
      lockerTitle: 'Schlüsselschließfach (Flinkey)',
      keyTagTitle: 'Schlüsselanhänger',
      keyTagNone: 'Kein Schlüsselanhänger mit dem Fahrzeug verbunden.',
      keyTagInHome: 'Im Schrank',
      keyTagTaken: 'Entfernt',
      keyTagInOther: 'In einem anderen Schrank',
      keyTagUnknown: 'Status unbekannt',
      keyTagHomeCabinet: 'Zugehörigkeit zu {{name}}',
      keyTagSlot: 'Ort {{slot}}',
      keyTagOtherAllowed: 'Der Pin befindet sich möglicherweise in einem anderen Schrank.',
      goToPickupLocations: 'Ausstellungsorte',
      goToVehiclePools: 'Fahrzeugpools',
      available: 'Zur Buchung verfügbar',
      unavailable: 'Nicht zur Buchung verfügbar',
      noLockerLinked: 'Keine Flinkey-Box mit dem Fahrzeug verbunden.',
      sectionBlock: 'Auto für Buchung sperren',
      blockHint: 'Geben Sie unten Start und Ende ein. Das Auto wird im Buchungskalender als grauer Block angezeigt. Überlappende Buchungen bleiben erhalten, jedoch ohne zugewiesenes Auto, und werden unter Kollisionsbuchungen (vorheriger Pool und vorheriges Auto gespeichert) aufgeführt.',
      blockStart: 'Start',
      blockEnd: 'Ende',
      blockCreate: 'Sperren',
      blockRemove: 'Entfernen',
      blockRemoveConfirm: 'Diese Sperrung entfernen?',
      blockSaved: 'Sperrung erstellt',
      blockRemoved: 'Sperrung entfernt',
      blockListTitle: 'Anstehende Sperren',
      blockNone: 'Keine bevorstehenden Sperren.',
      blockCollisionLink: 'Kollisionsbuchungen →',
      openCalendar: 'Buchungskalender',
      regHint: 'Aktuelle Regenzahl: {{reg}}',
    },
    general: {
      sectionVehicleAttributes: 'Fahrzeugdetails',
      alternativeFuel: 'Alternativer Kraftstoff',
      noAlternativeFuel: 'Nichts ausgewählt',
      usageStatus: 'Status',
      noUsageStatus: 'Kein Status',
      businessResponsibility: 'Geschäftsverantwortung',
      noBusinessResponsibility: 'Nichts ausgewählt',
      businessResponsibilitySearch: 'VERANTWORTUNGS-ID oder Text durchsuchen...',
      businessResponsibilityIkpart: 'Einsatzbereich',
      businessResponsibilityShowHistory: 'Verlauf anzeigen',
      businessResponsibilityHideHistory: 'Verlauf ausblenden',
      businessResponsibilityNoHistory: 'Noch kein Verlauf.',
      businessResponsibilityFrom: 'Vorherige',
      businessResponsibilityCleared: 'Deaktiviert',
      tempFordonsansvarigSection: 'Fahrzeugmanager',
      tempFordonsansvarigRsid: 'RSID',
      tempFordonsansvarigName: 'Name',
      tempFordonsansvarigEmail: 'Mail',
      tempFordonsansvarigPhone: 'Telefon',
      sectionInspection: 'Inspektion',
      sectionTax: 'Steuer',
      sectionReferences: 'Referenznummer',
      lastInspection: 'Letzte Inspektion',
      inspectionResult: 'Ergebnis',
      odometerAtInspection: 'Zählerstand bei Inspektion',
      nextInspectionDue: 'Spätestens nächste Inspektion',
      inspectionStation: 'Kontrollstation',
      registeredForUse: 'Eingebaut / im Verkehr',
      emergencyVehicle: 'Einsatzfahrzeug',
      hasDrivingBan: 'Fahrverbot',
      ternaryYes: 'Ja',
      ternaryNo: 'Nein',
      ternaryNA: 'Nicht anwendbar',
      annualVehicleTax: 'Jährliche Kfz-Steuer',
      malus: 'Malus',
      taxationMonths: 'Zahlungsmonat/e',
      nextTaxDue: 'Spätestens nächste Steuer',
      taxDueHint: 'Die Steuer muss spätestens am letzten Tag des Zahlungsmonats gezahlt werden. Benachrichtigung 45 Tage vorher.',
      taxPeriod: 'Steuerzeitraum',
      noCarInfo: 'Keine Car.info-Daten für dieses Fahrzeug.',
      noTaxAttrs: 'Keine Steuerfelder in Car.info für dieses Fahrzeug.',
      noEconomyRefs: 'Es wurden noch keine Referenzen im Finanzwesen ausgefüllt.',
      ownership: 'Im Besitz oder geleast',
      leasingAgreementNo: 'Vertragsnummer (Leasing)',
      contractNo: 'Vertragsnummer',
      costCenter: 'Kostenstelle',
    },
    color: 'Farbe:',
    changeDevice: 'Ändern',
    selectDevice: 'Auswählen',
    removeDeviceLink: 'entkoppeln',
    searchImei: 'Suchen IMEI...',
    odometerFromOem: 'Der Zählerstand wird abgerufen aus dem OEM-Cluster des Fahrzeugs',
    distanceDriven: 'Gefahrene Strecke:',
    currentOdometer: 'Aktueller Anzeigewert:',
    saveOdometer: 'Anzeigewert speichern',
    tripsRecalculated: 'Fahrten werden nach dem Speichern automatisch neu berechnet',
    noSpecifications: 'Keine Spezifikationen verfügbar',
    propertiesSearchPlaceholder: 'Alle Eigenschaften durchsuchen (Name oder Wert)…',
    propertiesSearchClear: 'Suche löschen',
    propertiesSearchNoResults: 'Keine Eigenschaften entsprechen der Suche.',
    propertiesSearchMatchCount: '{{count}} Treffer',
    propertiesSearchMatchesInCategory: '{{count}} Treffer',
    propertiesAttributeCount: '{{count}} Attribute',
    propertiesBasicCategory: 'Grundlegende Informationen (Car.info)',
    propertiesExtendedCategory: 'Weitere Informationen (Car.info)',
    propertiesPackagesCategory: 'Ausstattungspakete (Car.info)',
    propertiesTiresCategory: 'Reifen und Felgen (Car.info)',
    propertiesAlertsCategory: 'Warnhinweise (Car.info)',
    historyActive: 'Aktiv',
    historyIsCompany: 'Unternehmen',
    historyCompanyUrl: 'Unternehmenswebsite',
    carInfoBasic: {
      brand: 'Marke',
      series: 'Serie',
      model: 'Modell',
      generation: 'Generation',
      car_name: 'Autoname',
      chassis: 'Fahrgestell',
      engine: 'Motor',
      engine_type: 'Motortyp',
      horsepower: 'PS',
      engine_start_year: 'Motor nach Baujahr',
      engine_end_year: 'Motor nach Baujahr',
      model_year: 'Modelljahr',
      trim_package: 'Ausstattungsniveau',
      licence_plate: 'Registrierungsnummer',
      vin: 'VIN',
      vehicle_type: 'Fahrzeugtyp',
      engine_name: 'Motorname',
      body_code: 'Karosserie Code',
      sales_name: 'Verkaufsname',
      emergency_vehicle: 'Einsatzfahrzeug',
      has_driving_ban: 'Fahrverbot',
      is_rebuilt: 'Umgebaut',
      milage_km: 'Spurweite (Car.info)',
      is_stolen: 'Gestohlen',
      is_stolen_date: 'Gestohlen, Datum',
      exported_date: 'Exportdatum',
      last_updated: 'Letzte Aktualisierung bei Car.info',
      is_active: 'Im Register aktiv',
      manufactured_date: 'Herstellungsdatum',
      register_date: 'Zulassungsdatum',
      pre_register_date: 'Vorzulassung',
      on_organization_numbers: 'Organisationsnummer des Eigentümers',
      owned_by_company: 'Im Besitz des Unternehmens',
    },
    carInfoJson: {
      trim: 'Ausrüstungspaket',
      center_bore: 'Mittelloch',
      bolt_circle: 'Lochkreis',
      bolts: 'Anzahl der Schrauben',
      tpms: 'Reifendrucküberwachung',
      tpms_type: 'Art der Reifendrucküberwachung',
      tires: 'Reifenoptionen',
      front: 'Vorne',
      rear: 'Hinten',
      tire: 'Reifen',
      rim: 'Felge',
      tire_pressure: 'Reifendruck',
      load_index: 'Last Index',
      speed_rating: 'Geschwindigkeitsindex',
      warnings: 'Warnungen',
      errors: 'Fehler',
      message: 'Nachricht',
      type: 'Typ',
    },
    noHistory: 'Keine Historie verfügbar',
    ownerChange: 'Eigentümerwechsel',
    writeNotesHere: 'Hier Notizen eingeben...',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    updateFromCarInfo: 'Update von Car.info',
    tryAgain: 'Erneut versuchen',
    vehicleReportedStolen: 'FAHRZEUG WIRD GESTOHLEN GEMELDET!',
    userId: 'Benutzer (ID)',
    userIdPlaceholder: 'Benutzer-ID',
    validFrom: 'Gültig von (optional)',
    costCenter: 'Kostenstelle',
    organizationGroup: 'Organisation (Gruppe)',
    vehicleCategory: 'Fahrzeugkategorie',
    noVehicleCategory: 'Keine Kategorie',
    replacesVehicleReg: 'Ersetzt Fahrzeug (Revnr)',
    replacesVehicleRegPlaceholder: 'Revnr, die dieses Fahrzeug ersetzt',
    viewDequeVehicleLog: 'Anzeigen in Deque log',
    orgMoveTitle: 'Fahrzeug verschieben',
    orgMoveSameTopBody: 'Das Fahrzeug wird zur ausgewählten Organisation innerhalb desselben Kunden verschoben. Die Historie (Fahrten, GPS) kann mit dem Fahrzeug fortgeführt werden oder auf der alten Karte verbleiben. Die montierte Einheit wird mit dem Fahrzeug geliefert.',
    crossTopTitle: 'Zu einem anderen Kunden wechseln (oberster Knoten)',
    crossTopBody: 'Das Fahrzeug wird in die ausgewählte Organisation unter einem anderen Oberknoten verschoben. Flinkey und aktive Tankkarten werden getrennt. Wählen Sie aus, ob der Verlauf einbezogen werden soll und ob das Gerät auf den neuen oberen Knoten verschoben werden soll.',
    crossTopMoveDeviceLabel: 'Soll das Gerät auf den neuen oberen Knoten verschoben werden?',
    crossTopMoveDeviceYes: 'Ja, das Gerät verschieben',
    crossTopMoveDeviceYesHelp: 'Das Gerät wird der neuen Organisation hinzugefügt und bleibt am Fahrzeug montiert.',
    crossTopMoveDeviceNo: 'Nein, das Gerät zurücklassen',
    crossTopMoveDeviceNoHelp: 'Das Gerät wird zerlegt und verbleibt beim alten Organisation.',
    crossTopMoveDeviceRequired: 'Wählen Sie, ob das Gerät mit dabei sein soll.',
    crossTopKeepDataLabel: 'Daten mit dem Fahrzeug behalten',
    crossTopKeepDataHelp: 'Die gleiche Fahrzeugkarte und -historie (Fahrten, GPS) sind enthalten, auch wenn Sie sich innerhalb desselben oberen Knotens bewegen.',
    crossTopStartFreshLabel: 'Von vorne beginnen',
    crossTopStartFreshHelp: 'Eine neue Fahrzeugkarte wird erstellt. Der Verlauf bleibt auf der alten Karte.',
    crossTopNoteLabel: 'Hinweis (optional)',
    crossTopConfirm: 'Umzug bestätigen',
  },
  dequeVehicleLog: {
    title: 'Deque – Fahrzeugprotokoll',
    description: 'Org-Umzug innerhalb des Kunden, Austausch des Fahrzeugs, Änderung des obersten Knotens und Status (aktiv/inaktiv).',
    scopeNote: 'Aktivierung/Deaktivierung wird unter „Status“ oder „Alle“ (aus der Prüfung) angezeigt. Superadmin sieht mehr unter Changelog. Der Geräteverlauf (device_change_log) erfordert ein gemountetes GPS-Gerät.',
    scopeNoteUpdated: 'Aktivierung/Deaktivierung (Statusänderung) wird unter der Registerkarte „Status“ oder in „Alle“ angezeigt. Superadmin sieht die gleichen Ereignisse mit mehr Kontext unter Changelog.',
    auditLogLink: 'Changelog öffnen',
    tabAll: 'Alle',
    tabOrgMove: 'Org Move',
    tabReplacement: 'Replacement',
    tabCrossTop: 'Top Node Replacement',
    tabVehicleStatus: 'Status',
    vehicleActivated: 'Aktiviert',
    vehicleInactivated: 'Disabled',
    vehicleId: 'Vehicle ID',
    registrationNumber: 'Registernummer',
    registrationNumberPlaceholder: 'ABC123',
    dateFrom: 'Von-Datum',
    dateTo: 'Bis-Datum',
    colWhen: 'Zeit',
    colType: 'Typ',
    colVehicle: 'Fahrzeuge',
    colDetail: 'Detail',
    colUser: 'Ausgeführt von',
    empty: 'Keine Ereignisse für ausgewählte Filter.',
    loadError: 'Protokoll konnte nicht abgerufen werden',
    showing: 'Anzeige von {{from}}–{{to}} von {{total}}',
    replaces: 'Ersetzt',
    replacedReg: 'Regenzahl ersetzt',
  },
  replacementChain: {
    title: 'Ersatzkette',
    description: 'Nach Regenzahlen suchen und anzeigen, welche Fahrzeuge in einer Kette ersetzt wurden.',
    searchPlaceholder: 'Reg Nummer…',
    emptyState: 'Suchen Sie eine Registrierungsnummer, um die Ersatzkette anzuzeigen.',
    loadError: 'Ersatzkette konnte nicht abgerufen werden',
    resultHint: 'Ältere ersetzte Fahrzeuge links, spätere Ersatzfahrzeuge rechts.',
    noChain: 'Keine Ersatzkette mit diesem Fahrzeug verbunden.',
    legendLeft: 'Links: Fahrzeug, das das gesuchte Fahrzeug ersetzt (Feld „Ersetzt Fahrzeug“).',
    legendRight: 'Rechts: Fahrzeug, das das gesuchte Fahrzeug ersetzt.',
    legendCurrent: 'Markiertes Fahrzeug',
    openVehicle: 'Offene Fahrzeuge',
    notInSystem: 'Existiert nicht als Fahrzeug im System',
    noAccess: 'Sie sind nicht berechtigt, Ersatz anzuzeigen Ketten.',
  },
  vehicleCategories: {
    title: 'Fahrzeugkategorien',
    description: 'Auswählbare Fahrzeugkategorien für Ihren obersten Knoten verwalten.',
    newCategoryPlaceholder: 'Neue Fahrzeugkategorie',
    categoryName: 'Kategoriename',
    empty: 'Noch keine Fahrzeugkategorien.',
    saved: 'Fahrzeugkategorie gespeichert',
    loadError: 'Fahrzeugkategorien konnten nicht abgerufen werden',
    saveError: 'Fahrzeugkategorie konnte nicht gespeichert werden',
  },
  alternativeFuels: {
    title: 'Alternative Kraftstoffe',
    description: 'Auswählbare alternative Kraftstoffe für Ihren obersten Knoten verwalten (z. B. Region Skåne).',
    newFuelPlaceholder: 'Neuer Kraftstoff, z. B. HVO',
    fuelName: 'Kraftstoff',
    empty: 'Noch kein Alternativkraftstoff verfügbar.',
    saved: 'Alternativkraftstoff gespart',
    loadError: 'Alternativkraftstoff konnte nicht heruntergeladen werden',
    saveError: 'Alternativkraftstoff konnte nicht gespeichert werden',
  },
  nordeaLeasing: {
    title: 'Nordea-Leasingimport',
    description: 'Monatliche TXT-Datei von Nordea importieren. Aktualisiert die Fahrzeugfinanzen, speichert die Datei im Archiv und den Zahlungsverlauf pro Zeitraum.',
    uploadTitle: 'Datei hochladen',
    uploadHint: 'Wählen Sie eine durch Semikolons getrennte .txt-Datei aus (z. B. 2026-04.TXT). Dieselbe Datei wird nur einmal importiert. Die nächste Miete wird durch die Spalte Pro (Abrechnungszeitraum in Monaten) in monatliche Miete unterteilt.',
    selectFile: 'Datei auswählen',
    importHistory: 'Vorherige Importe',
    noImports: 'Noch keine Importe',
    colFilename: 'Dateiname',
    colPeriodEnd: 'Datum bis',
    colRows: 'Linien',
    colUpdated: 'Aktualisiert',
    colSkipped: 'Überspringen',
    colImportedAt: 'Importiert',
    loadError: 'Importliste konnte nicht abgerufen werden',
    importError: 'Import fehlgeschlagen',
    importSuccess: 'Import abgeschlossen: {{updated}}Fahrzeuge aktualisiert, {{skipped}}übersprungen',
    duplicateFile: 'Datei bereits importiert – keine neue Speicherung oder Historie',
    skippedRegistrations: 'Regn kein passendes Fahrzeug',
  },
  protectorInsurance: {
    title: 'Protector-Versicherungsimport',
    description: 'Versicherungsdateien (Excel) aus Protector importieren. Entspricht Fahrzeugen auf Regnr (Spalte F), aktualisiert die Fahrzeugversicherung und den Bauverlauf pro Zeitraum.',
    uploadTitle: 'Dateien hochladen',
    uploadHint: 'Wählen Sie eine oder mehrere .xls/.xlsx-Dateien aus. RegNo (Spalte F) ist der Schlüssel. Monatliche Kosten = Betrag (Spalte V) / 12. Dieselbe Datei wird nur einmal importiert.',
    selectFiles: 'Dateien auswählen',
    importHistory: 'Vorherige Importe',
    noImports: 'Noch keine Importe',
    colFilename: 'Dateiname',
    colPeriodEnd: 'Bis heute',
    colRows: 'Linien',
    colUpdated: 'Aktualisiert',
    colSkipped: 'Überspringen',
    colImportedAt: 'Importiert',
    loadError: 'Importliste konnte nicht abgerufen werden',
    importError: 'Import fehlgeschlagen',
    importSuccess: 'Import abgeschlossen: {{updated}}Fahrzeuge aktualisiert, {{skipped}}übersprungen',
    duplicateFile: 'Datei bereits importiert – keine neue Speicherung oder Historie',
    skippedRegistrations: 'Regn kein passendes Fahrzeug',
  },
  vehicleUsageStatuses: {
    title: 'Fahrzeugstatus',
    description: 'Auswählbare Status pro Top-Knoten verwalten (Leasing, Außerbetriebnahme usw.).',
    newStatusPlaceholder: 'Neuer Status, z. B. Wird bearbeitet',
    statusName: 'Status',
    empty: 'Noch keine Status verfügbar.',
    saved: 'Fahrzeugstatus gespeichert',
    loadError: 'Fahrzeugstatus konnte nicht abgerufen werden',
    saveError: 'Fahrzeugstatus konnte nicht gespeichert werden',
  },
  personalTrackers: {
    title: 'Persönliche Tracker',
    description: 'Registrieren Sie sich für persönliche Tracker. SIM-Karte einlegen und Organisation zuweisen.',
    orgDescription: 'Sehen Sie, wo sich die Tracker der Organisation befinden, verbinden Sie sie mit einem Benutzer und steuern Sie die Schaltfläche.',
    add: 'Tracker hinzufügen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Entfernen',
    imei: 'IMEI',
    serial: 'Seriennummer',
    iccid: 'SIM (ICCID)',
    organization: 'Organisation',
    noOrganization: 'Keine Organisation',
    user: 'Benutzer',
    noUser: 'Kein Benutzer',
    searchUser: 'Benutzer suchen',
    needsOrganization: 'Organisation oben auswählen. Dann kann ein Benutzer in dieser Organisation verbunden werden.',
    model: 'Modell',
    lastSeen: 'Zuletzt gesehen',
    battery: 'Batterie',
    charging: 'Laden',
    empty: 'Keine Tracker in der Registrierung.',
    emptyOrg: 'Der Organisation sind keine Tracker zugewiesen.',
    saved: 'Gespeichert',
    deleted: 'Tracker entfernt',
    loadError: 'Tracker konnten nicht heruntergeladen werden',
    saveError: 'Speichern nicht möglich',
    confirmDelete: 'Tracker aus der Registrierung entfernen?',
    mapEmpty: 'Noch keine Position eingegeben.',
    buttonTitle: 'Schaltfläche',
    click1: '1 Klick',
    click2: '2 Klicks',
    longPress: 'Fern drücken (2–5 s)',
    powerOff: 'Herunterfahren per Taste (>5 s gedrückt halten)',
    actionNone: 'Keine',
    actionAlarm: 'Alarme',
    priority: 'Priorität',
    priorityOff: 'Aus',
    priorityLow: 'Niedrig',
    priorityHigh: 'Hoch',
    configStatus: 'An Gerät gesendet',
    configDelivered: 'Zugestellt',
    configQueued: 'In der Warteschlange, bis das Gerät online ist',
    configFailed: 'Fehler beim Senden',
    configPending: 'Warten',
    alarm: 'Neueste Warnungen',
    iccidHint: 'ICCID vom Konfigurator. Wird aktualisiert, wenn das Gerät eine andere SIM-Karte meldet.',
    alarmType: {
      fall: 'Sturz',
      button: 'Schaltfläche',
      alarm: 'Alarme',
    },
    alarmClick1: '1 Klick',
    alarmClick2: '2 Klicks',
    alarmLong: 'Langes Drücken',
    alarmTitle: 'Alarm des persönlichen Trackers',
    alarmEmpty: 'Keine unbestätigten Alarme.',
    alarmWho: 'Person',
    alarmPhone: 'Telefon',
    alarmNoPhone: 'Keine Telefonnummer',
    alarmNoPosition: 'Keine Position begleitet den Alarm.',
    alarmAck: 'Bestätigen',
    alarmAcked: 'Der Alarm wurde bestätigt',
    alarmBell: 'Unbestätigte Alarme',
  },
  licenseCheck: {
    title: 'Führerscheinprüfung',
    description: 'Berechtigungsprüfung über BKY für Organisationen, die die Fahrerberechtigung prüfen müssen.',
    apiWaiting: 'Anrufe bei BKY warten auf Konto und Nachrichtenplan. Personen und Verbindung können bereits jetzt gespeichert werden.',
    organization: 'Organisation',
    connection: 'BKY-Verbindung',
    questionUrl: 'Frage-URL',
    answerUrl: 'Antwort-URL',
    username: 'Benutzername',
    password: 'Passwort',
    passwordKept: 'Leer lassen, um das gespeicherte Passwort beizubehalten',
    active: 'Aktiv',
    saveConnection: 'Verbindung speichern',
    saved: 'Gespeichert',
    subjects: 'Personen',
    name: 'Name',
    personnummer: 'Sozialversicherungsnummer',
    addSubject: 'Person hinzufügen',
    competence: 'Berechtigung',
    tachograph: 'Fahrtenschreiberkarte (16 Ziffern)',
    addCompetence: 'Berechtigung hinzufügen',
    wouldAsk: 'Gefragt',
    inactive: 'Inaktiv',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    emptySubjects: 'Keine Personen registriert.',
    previewCount: 'Anzahl der zu sendenden Fragen: {{count}}',
    history: 'Verlauf',
    emptyHistory: 'Es wurden noch keine Fragen gesendet.',
    questions: 'Fragen',
    answers: 'Antwort',
    yes: 'JA',
    no: 'NEIN',
    askedBy: 'Gestellt von',
    when: 'Wenn',
    run: 'Fragen senden',
    purge: 'Alle Daten löschen',
    purgeHelp: 'Verbindung, Personen, Berechtigungen und Verlauf für diese Organisation entfernen. Geben Sie zur Bestätigung den Namen der Organisation ein.',
    purgeConfirm: 'Name der Organisation',
    purged: 'Alle Führerscheinprüfungen für die Organisation werden gelöscht',
    loadError: 'Führerscheinprüfung konnte nicht heruntergeladen werden',
    saveError: 'Speichern nicht möglich',
    deleteConfirm: 'Person und Berechtigungen der Person entfernen?',
  },
  impersonation: {
    title: 'Zum Benutzer wechseln',
    switchUser: 'Benutzer wechseln',
    searchPlaceholder: 'Nach Benutzern suchen...',
    partnerSearchHint: 'Zeigt Benutzer im Verzeichnis Ihrer Kunden an. Organisationen',
    noUsers: 'Keine Benutzer gefunden',
    viewingAs: 'Wird angezeigt als',
    returnToAdmin: 'Zurück zu Ihrem Konto',
    returnButton: 'Zurück',
    fetchError: 'Benutzer konnte nicht abgerufen werden',
    startError: 'Benutzer konnte nicht gewechselt werden',
    stopError: 'Konnte nicht zum Administrator zurückkehren',
    showingFirst: 'Erstes {{count}}',
  },
  track: {
    title: 'Track-Wiedergabe',
    subtitle: 'Historisches GPSTracking für mehrere Fahrzeuge',
    addVehicle: 'Fahrzeug hinzufügen',
    selectVehicle: 'Fahrzeug auswählen...',
    selectedVehicles: 'Ausgewählte Fahrzeuge',
    timePeriod: 'Zeitraum',
    interval: 'Intervall',
    search: 'Suchen',
    noData: 'Fahrzeug und Zeitraum zur Anzeige des Tracks auswählen',
    play: 'Wiedergabe',
    pause: 'Pause',
    stop: 'Stopp',
    reset: 'Zurücksetzen',
    speed: 'Geschwindigkeit',
    currentTime: 'Aktuelle Zeit',
    pointsLoaded: 'GPSGeladene Punkte',
    maxVehicles: 'Maximal 10 Fahrzeuge können gleichzeitig verfolgt werden',
    vehicleAlreadyAdded: 'Fahrzeug bereits hinzugefügt',
    jammingLegend: 'Störung (AVL 249) – {count} GPS Punkte',
  },
  ai: {
    title: 'KI-Assistent',
    pageTitle: 'KI-Analyse',
    pageDescription: 'Verwenden Sie KI, um die Flotte zu analysieren und Empfehlungen zu erhalten. Alle Daten werden lokal verarbeitet.',
    welcomeMessage: 'Hallo! Ich kann Ihnen bei der Analyse der Flotte helfen, Metriken erklären und Empfehlungen aussprechen.',
    inputPlaceholder: 'Stellen Sie eine Frage zur Flotte...',
    clearChat: 'Chat löschen',
    selectOrganization: 'Wählen Sie eine Organisation aus, um die Analyse zu starten',
    allOrganizations: 'Alle Organisationen',
    organization: 'Organisation',
    analyzing: 'Analysieren...',
    runAnalysis: 'Führen Sie eine KI-Analyse durch',
    aiAnalysis: 'KI-Analyse',
    analysisResult: 'Analyseergebnisse',
    analysisError: 'Analyse fehlgeschlagen',
    fleetOverview: 'Flottenübersicht',
    topVehicles: 'Fahrzeuge',
    vehicleAnalysis: 'Fahrzeuganalyse',
    noVehicles: 'Keine Fahrzeuge mit Daten gefunden',
    status: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Prüfung...',
    },
    period: {
      label: 'Zeitraum',
      week: 'Woche',
      month: 'Monat',
      quarter: 'Quartal',
    },
    stats: {
      vehicles: 'Gesamtfahrzeuge',
      activeVehicles: 'Aktive Fahrzeuge',
      distance: 'Gesamtkilometerleistung',
      totalKm: 'Gesamtkilometerstand (km)',
      fuelConsumption: 'Durchschnittlicher Verbrauch',
      fuelCost: 'Kraftstoffkosten',
      ecoScore: 'Öko-Score',
    },
    log: {
      title: 'KI-Protokoll',
      description: 'Alle KI-Anfragen anzeigen im System vorgenommen',
      question: 'Frage',
      response: 'Antwort',
      user: 'Benutzer',
      organization: 'Organisation',
      requestType: 'Typ',
      responseTime: 'Reaktionszeit',
      success: 'Status',
      createdAt: 'Zeit',
      noLogs: 'Keine AI-Anfragen gefunden',
      viewDetails: 'Details anzeigen',
      types: {
        chat: 'Chat',
        analyze_vehicle: 'Fahrzeuganalyse',
        analyze_driver: 'Fahreranalyse',
        analyze_fleet: 'Flottenanalyse',
        compare_vehicles: 'Fahrzeugvergleich',
        explain_metric: 'Metrikerklärung',
      },
    },
  },
  routeAnalysis: {
    title: 'Routenanalyse',
    pageTitle: 'Routenanalyse – Verifizierung',
    description: 'Wählen Sie ein Auto und ein Datum aus. Sehen Sie, wie lange die Fahrzeit und die Entfernung gedauert hat – vergleichen Sie sie mit der straßenoptimierten Route (gleiche Stopps, gleiche Reihenfolge).',
    selectTrips: 'Zu analysierende Fahrten auswählen',
    selectVehicle: 'Fahrzeug auswählen',
    selectDate: 'Datum auswählen',
    tripsOnDate: 'Fahrten an diesem Tag',
    noTripsFound: 'Für das ausgewählte Datum wurden keine Fahrten gefunden',
    selectedTrips: 'Ausgewählte Fahrten',
    selectAll: 'Alle auswählen',
    selectMorning: 'Vormittag auswählen',
    selectAfternoon: 'Nachmittag auswählen',
    analyze: 'Analysieren',
    analyzing: 'Analysieren...',
    analyzeSelected: 'Ausgewählte Fahrten analysieren',
    quickCompare: 'Schneller Vergleich',
    result: 'Vergleich',
    actualRoute: 'Ist',
    actualRouteSubtitle: 'so dass das Auto gefahren ist',
    optimalRoute: 'Route optimiert',
    optimalRouteSubtitle: 'gleicher Stopp, gleiche Reihenfolge',
    comparison: 'Unterschied',
    comparisonIntro: 'Unterschied zwischen tatsächlichem und routenoptimiertem Fahren.',
    emptyState: 'Fahrzeug und Datum auswählen, mindestens 2 Fahrten auswählen und auf Analysieren klicken.',
    routeMapPerVehicle: 'Routenvergleich pro Fahrzeug',
    routeMapClickHint: 'Klicken Sie auf ein Fahrzeug, um Karten mit gefahrener und optimaler Route anzuzeigen',
    totalDistance: 'Gesamtstrecke',
    drivingTime: 'Fahrzeit',
    stopTime: 'Stoppzeit',
    sameStopTime: 'gleich',
    serviceTime: 'Servicezeit',
    stopCount: 'Anzahl der Stopps',
    routeOrder: 'Reihenfolge der Besuche',
    freedPotential: 'Freigegebenes Potenzial',
    freedTime: 'Freigegebene Zeit',
    freedTimeDescription: 'Freigegebene Zeit bereit für andere Aufgaben',
    reducedDistance: 'Reduzierte Kilometerleistung',
    reducedDrivingTime: 'Reduzierte Fahrzeit',
    distanceSimilar: 'Entfernung ähnlich',
    freedTimeUsage: 'Freigewordene Zeit kann für',
    potentialExtraVisits: 'zusätzliche Kundenbesuche',
    potentialExtraTimePerStop: 'zusätzliche Zeit pro Kunde',
    betterService: 'besserer Service',
    bufferTime: 'Puffer für Unerwartetes',
    economicEffect: 'Wirtschaftliche Auswirkungen',
    fuelSavings: 'geringere Kraftstoffkosten',
    co2Reduction: 'CO₂-Reduktion',
    annualPotential: 'Jährliches Potenzial',
    annualFreedTime: 'Gesparte Zeit pro Jahr',
    annualReducedDistance: 'Reduzierte Kilometerleistung pro Jahr',
    workDaysPerYear: 'Arbeitstage',
    showActualRoute: 'Gefahrene Route anzeigen',
    showOptimalRoute: 'Optimale Route anzeigen',
    compareRoutes: 'Routen vergleichen',
    exportReport: 'Bericht exportieren',
    shareAnalysis: 'Analyse teilen',
    vroomAvailable: 'Routenoptimierung verfügbar',
    vroomUnavailable: 'Routenoptimierung nicht verfügbar',
    minTripsRequired: 'Mindestens 2 Fahrten zum Vergleich erforderlich',
    noOptimalRoute: 'Zeigt nur tatsächliche Fahrdaten an (optimale Route nicht verfügbar)',
    minutes: 'min',
    hours: 'Std.',
    kilometers: 'km',
    liters: 'Liter',
    sek: 'kr',
    kg: 'kg',
    percent: '%',
    methodologyDisclaimer: 'Wichtig zu wissen: „Gefahrene Route“ ist die Gesamtreisezeit (vom Reisebeginn bis zum Reiseende) und kann die Zeit an jedem Stopp umfassen (z. B. Besuchszeit). „Optimale Route“ ist nur die geschätzte Fahrzeit zwischen Haltestellen in optimaler Reihenfolge (A-B-Route). Der Unterschied stellt somit eine theoretische Obergrenze dar – bei der häuslichen Pflege lässt sich Besuchszeit nicht durch einen besseren Weg „einsparen“. Das tatsächliche Potenzial hängt vom Zeitfenster, den Besuchszeiten und der Abgrenzung der Fahrten ab.',
    methodologyNote: 'Pro Distanz (Start→Stopp): Tatsächlich = Distanz und Zeit, die das Fahrzeug zurückgelegt hat. Routenoptimiert = beste Route und geschätzte Fahrzeit aus dem Straßennetz. Gleiche Punkte, vergleichbar.',
    calculatingRoute: 'Optimale Route berechnet...',
    vroomRequired: 'VROOM-Optimierung für diese Ansicht erforderlich',
    checkingVroom: 'Prüfung...',
    stopsCount: '{{count}} Stopps',
    stopsAnalyzed: '{{count}} Stopps analysiert',
    showingTrip: 'Reise anzeigen {{num}}',
    showAllTrips: 'Alle Reisen anzeigen',
    showOnlyThisTrip: 'Nur diese Reise anzeigen',
    showAll: 'Alle anzeigen',
    vehicles: 'Fahrzeuge',
    trips: 'Fahrten insgesamt',
    selected: 'ausgewählt',
    expandAll: 'Alle erweitern',
    collapseAll: 'Alle reduzieren',
    stopStart: 'Haltestelle {{num}} (Start)',
    stopEnd: 'Haltestelle {{num}} (Ende)',
    start: 'Start',
    goal: 'Ziel',
    actualRouteLabel: 'Gefahrene Route (GPS von MongoDB)',
    gpsPoints: '{{count}} GPS Punkte',
    optimalRouteLabel: 'Optimale Route (VROOM)',
    points: '{{count}} Punkte',
  },
  mapServices: {
    title: 'Kartendienste',
    liveTracking: 'Echtzeitkarte',
    liveTrackingDescription: 'Fahrzeuge in Echtzeit auf der Karte verfolgen',
    track: 'Track',
    trackDescription: 'Historische GPS-Verfolgung mit Multi-Fahrzeug-Wiedergabe',
    geofence: 'Geofence',
    geofenceDescription: 'Geografische Zonen und Bereichsüberwachung verwalten',
    heatmap: 'Heatmap',
    heatmapDescription: 'Aktivitätsmuster als Wärmekarte visualisieren',
    opensInNewWindow: 'Wird in neuem Fenster geöffnet',
  },
  analysis: {
    stopTime: {
      title: 'Stoppzeitanalyse – Polplanung',
      description: 'Analyse der Fahrzeugstoppzeiten zur optimalen Platzierung der Ladeinfrastruktur',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      organization: 'Organisation',
      selectOrganization: 'Organisation auswählen',
      update: 'Aktualisieren',
      loading: 'Laden...',
      totalLocations: 'Gesamtzahl der Orte',
      totalHours: 'Gesamthaltezeit',
      totalStops: 'Gesamtzahl der Stopps',
      vehiclesAnalyzed: 'Analysierte Fahrzeuge',
      tabHeatmap: 'Heatmap',
      tabMap: 'Karte',
      emptyState: 'Datum und Organisation auswählen, um die Analyse anzuzeigen',
    },
    trends: {
      title: 'Trends',
      description: 'Trendanalyse, Entwicklung im Zeitverlauf und Kilometerstand im Vergleich zum Leasingvertrag',
      distance: 'Kilometerstand',
      fuelCost: 'Kraftstoffkosten',
      vsPrevious: 'Im Vergleich zum vorherigen Zeitraum',
      forecastLiters: 'Prognose für den nächsten Zeitraum',
      forecastHint: 'Linearer Trend aus der Historie',
      costTrend: 'Kilometer und Kosten',
      seasonal: 'Saisonale Variation (12 Monate)',
      behaviorTitle: 'Fahrzeuge mit geändertem Verhalten',
      previousKm: 'Vorheriger km',
      recentKm: 'Letzter km',
      change: 'Änderung',
      reason: 'Grund',
      noBehavior: 'Keine wesentlichen Abweichungen zum Vorzeitraum',
      tabTrends: 'Trends',
      tabLeasing: 'Leasingkilometerstand',
      leasing: {
        vehicle: 'Fahrzeuge',
        selectVehicle: 'Kennzeichen auswählen (optional)',
        clearVehicle: 'Alle Fahrzeuge anzeigen',
        vehicles: 'Fahrzeuge',
        tableTitle: 'Kilometerstand gemäß Leasingvertrag',
        allowed: 'Vereinbarte km',
        measured: 'Gemessene km',
        estimatedUsed: 'Geschätzte Nutzung',
        forecastEnd: 'Prognose bei Ende',
        delta: 'Abweichung',
        extraCost: 'Zusätzliche Kosten',
        status: 'Status',
        statusOver: 'Risikoüberschreitung',
        statusUnder: 'Risikounterschreitung',
        statusOnTrack: 'Laut Vertrag',
        statusMissing: 'Fehlende Daten',
        budgetLine: 'Vertragsbudget',
        measuredLine: 'Gemessen',
        forecastLine: 'Prognose (Tempo)',
        rateHint: 'Die Prognose basiert auf den gemessenen km/Tag während des Zeitraums, in dem das Gerät Daten gesendet hat – kein Startzähler erforderlich.',
        lateInstallHint: 'Das Gerät scheint dies zu tun nach Vertragsbeginn eingebaut wurden. Erstlaufdaten:',
        shortHistoryHint: 'Kurzer Messzeitraum – die Prognose ist ungewiss.',
      },
    },
    benchmarks: {
      title: 'Vergleiche',
      description: 'Vergleichen Sie die Leistung zwischen Abteilungen und Organisationen',
      bestPractice: 'Best Practice',
      improve: 'Verbesserungsbereiche',
      ranking: 'Ranking nach Organisation',
      eco: 'ECO',
      lPer100: 'L/100 km',
      utilization: 'Auslastung',
      drillHint: 'Klicken Sie auf eine Organisation, um deren Fahrzeug zu vergrößern.',
      vehicles: 'Fahrzeuge in der Stichprobe',
    },
    crashDetection: {
      title: 'Unfallerkennung',
      description: 'Liste und Visualisierung von Unfallereignissen (Unfallverfolgung von Einheiten).',
      regNumber: 'Registernummer',
      imei: 'IMEI',
      date: 'Datum',
      samples: 'Anzahl der Proben',
      triggerCount: 'Trigger',
      timeSpan: 'Zeitspanne',
      triggerPositions: '{{count}}Position(en)',
      fromDate: 'Von-Datum',
      toDate: 'Bis-Datum',
      imeiPlaceholder: 'Filtern nach IMEI',
      noEvents: 'Es wurden keine Absturzereignisse gefunden.',
      detailTitle: 'Daten rund um den Absturz',
      speedAtCrash: 'Geschwindigkeit beim Absturz',
      speedAtCrashHint: 'Die Geschwindigkeit stammt vom Auslöser beim Ereignis selbst.',
      xyzChart: 'Beschleunigungsmesser X/Y/Z (mG)',
      xyzHint: 'Bremsen wird als negatives Ergebnis gewertet (z. B. Z). Seitliche Bewegung ist als Ausschlag auf Y oder X sichtbar.',
      tripMap: 'Die Fahrt zum Zeitpunkt der Kollision',
      mapTitle: 'Karte',
      speedChart: 'Geschwindigkeitskurve',
      speedChartHint: 'Geschwindigkeit (km/h). Für Reisedaten: ±2 Minuten rund um das Ereignis. Ansonsten: bei jedem Trigger.',
      brakeChart: 'Bremskurve',
      brakeChartHint: 'Positiver Wert = Bremsen (m/s²). Berechnet aus Geschwindigkeitsänderung.',
      noRouteForCharts: 'Keine Fahrtdaten – Geschwindigkeit und Bremsen erfordern eine Auslösung mit GPS Punkten.',
      speedAtEventOnly: 'Geschwindigkeit bei Ereignis: {{speed}} km/h. Keine Fahrtdaten für Kurve.',
    },
  },
  service: {
    title: 'Service',
    overview: 'Serviceübersicht',
    servicePoints: 'Servicepunkte',
    addPoint: 'Servicepunkt hinzufügen',
    saveFailed: 'Servicepunkt konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    noCreatePermission: 'Sie haben keine Berechtigung zum Hinzufügen von Servicepunkten.',
    syncCarInfo: 'Synchronisierung von Car.info',
    noServicePoints: 'Keine Servicepunkte. Klicken Sie zum Importieren auf „Von Car.info synchronisieren“.',
    noServiceDue: 'Keine Servicepunkte zur Anzeige',
    horizonHint: 'Zeigt den Service innerhalb von 300 km oder 60 Tagen an. Die Inspektion wird 40 Tage vor dem Ablaufdatum angezeigt (nur Datum).',
    horizonListEmpty: 'Keine Aktion läuft innerhalb von 300 km oder 60 Tagen ab und keine Inspektion innerhalb von 40 Tagen.',
    inspectionDateOnly: 'Datum',
    inspectionBookHint: 'Buchen Sie bei der Firma, geben Sie Station, Datum und Uhrzeit ein und bestätigen Sie. Anschließend wird die Buchung sofort gespeichert. Die Bestätigungs-E-Mail an besiktning@deviaq.se kommt selten rechtzeitig an – wenn doch, füllen wir die Felder für Sie aus.',
    inspectionConfirmEmailLabel: 'Rücksendeadresse kopieren',
    inspectionConfirmEmailHint: 'Fügen Sie es bei der Inspektionsfirma als E-Mail zur Bestätigung ein.',
    inspectionCopyEmail: 'Adresse kopieren',
    inspectionAppliesTo: 'Gilt für {reg}',
    inspectionCompare: 'Stationen vergleichen (bokabesiktning.nu)',
    inspectionSwedac: 'Von Swedac akkreditierte Unternehmen',
    inspectionStation: 'Station',
    inspectionStationPlaceholder: 'Z.B. Malmö Innerstaden',
    inspectionBookingTime: 'Zeit',
    inspectionOpenedHint: 'Die Buchungsseite wurde in einem neuen Tab geöffnet. Geben Sie Station, Datum und Uhrzeit ein und bestätigen Sie – dann ist die Buchung gespeichert.',
    inspectionWaitingEmail: 'Während Sie warten, kommt die E-Mail selten an. Geben Sie die Details ein und bestätigen Sie. Die Buchung wird gespeichert.',
    inspectionFilledFromEmail: 'Die Details wurden aus der Bestätigungs-E-Mail übernommen.',
    inspectionBookedFromEmail: 'Die Inspektion wurde aus der Bestätigungs-E-Mail gebucht.',
    inspectionCompanyRequired: 'Wählen Sie ein Inspektionsunternehmen aus.',
    inspectionStationRequired: 'Geben Sie den von Ihnen gebuchten Bahnhof ein.',
    inspectionDateRequired: 'Geben Sie das Buchungsdatum ein.',
    inspectionBookFailed: 'Die Buchung konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    allPointsHint: 'Zeigt alle Servicepunkte am Fahrzeug und wann diese als nächstes durchgeführt werden.',
    totalActions: 'Aktionen gesamt',
    vehicles: 'Fahrzeuge',
    actions: 'Aktionen',
    searchPlaceholder: 'Fahrzeug, Service finden...',
    allStatuses: 'Alle Status',
    interval: 'Intervall',
    nextDue: 'Weiter',
    lastPerformed: 'Zuletzt durchgeführt',
    reminder: 'Erinnerung',
    booking: 'Buchung',
    bookingInfo: 'Buchungsinformationen',
    bookingDate: 'Buchungsdatum',
    book: 'Buch',
    bookedFor: 'Gebucht',
    confirmBooking: 'Buchung bestätigen',
    markComplete: 'Erledigt markieren',
    confirmComplete: 'Als abgeschlossen markieren',
    performedDate: 'Durchführungsdatum',
    performedKm: 'Zählerstand (km)',
    cost: 'Kosten (kr)',
    notes: 'Notizen',
    history: 'Verlauf',
    editReminder: 'Erinnerung',
    updateReminder: 'Aktualisierungserinnerung',
    warningKm: 'Warnung bei (km vorher)',
    warningDays: 'Warnung bei (Tage vorher)',
    workshopLabel: 'Workshop',
    noWorkshop: '-- Workshop auswählen --',
    days: 'Tage',
    intervalKm: 'Intervall (km)',
    intervalMonths: 'Intervall (Monat)',
    intervalHint: 'Geben Sie mindestens ein Intervall ein – km, Zeit (Monat) oder beides.',
    existingType: 'Vorhandener Typ',
    customType: 'Benutzerdefinierter Typ',
    selectType: 'Diensttyp auswählen',
    chooseType: '-- Wählen Sie --',
    typeName: 'Name des Diensttyps',
    categoryLabel: 'Kategorie',
    categoryCustom: 'Benutzerdefiniert',
    categoryMaintenance: 'Wartung',
    lastPerformedDate: 'Zuletzt durchgeführt (Datum)',
    lastPerformedKm: 'Zuletzt durchgeführt (km)',
    status: {
      ok: 'OK',
      warning: 'Läuft bald ab',
      overdue: 'Läuft ab',
      booked: 'Gebucht',
      completed: 'Fertig',
    },
    attachments: {
      title: 'Anhänge',
      noAttachments: 'Keine Anhänge hochgeladen',
      uploadHint: 'Klicken Sie auf „Hochladen“, um Dateien hinzuzufügen',
      upload: 'Hochladen',
      uploading: 'Laden...',
      descriptionOptional: 'Beschreibung (optional)',
      descriptionPlaceholder: 'z. B. Inspektionsbericht 2026',
      all: 'Alle',
      categoryInsurance: 'Versicherungen',
      categoryInspection: 'Inspektion',
      categoryDamage: 'Schaden',
      categoryInvoice: 'Rechnung',
      categoryContract: 'Vereinbarung',
      categoryService: 'Service',
      categoryOther: 'Andere',
    },
    tires: {
      title: 'Reifen',
      add: 'Hinzufügen',
      addNew: 'Neuer Reifensatz',
      type: 'Reifentyp',
      brand: 'Marke',
      model: 'Modell',
      size: 'Dimension',
      treadDepth: 'Profiltiefe',
      treadDepthVf: 'VF (vorne links)',
      treadDepthHf: 'HF (vorne rechts)',
      treadDepthVb: 'VB (Links Hinten)',
      treadDepthHb: 'HB (Rechts Hinten)',
      treadDepthMm: 'mm',
      treadDepthSection: 'Profiltiefe pro Radposition',
      storageType: 'Lagertyp',
      storageLocation: 'Standort',
      storage: 'Lagerung',
      summer: 'Sommerreifen',
      winterFriction: 'Schneereifen (Reibung)',
      winterStudded: 'Spikereifen',
      hotel: 'Reifenhotel',
      installed: 'Montiert',
      stored: 'Gespeichert',
      other: 'Andere',
      installedSince: 'Dann montiert',
      lastChanged: 'Letzte Änderung',
      mount: 'Einbau',
      unmount: 'Demontage',
      save: 'Speichern',
      none: 'Keine Reifen registriert',
      noTireInfo: 'Reifeninformationen fehlen',
      manage: 'Reifen verwalten',
      edit: 'Reifen bearbeiten',
      currentTires: 'Reifen montiert',
      tireChangeSection: 'Reifeninformationen (beim Wechsel registriert)',
      newTires: 'Neue Reifen',
      newTiresHint: 'Markieren Sie die Reifen, die neu sind. Profiltiefe und Spurweiteneinstellung werden zunächst gespeichert und die Reifen am Auto montiert.',
      allFour: 'Alle vier',
      frontAxle: 'Vorderachse',
      rearAxle: 'Hinterachse',
      clearNew: 'Keine neue',
      mountTread: 'Profiltiefe bei der Montage',
      mountTreadRequired: 'Profiltiefe (0-20 mm) für jeden neuen Reifen eingeben',
      newBadgeAll: 'Neue Reifen',
      newBadgeFront: 'Neu: Vorderachse',
      newBadgeRear: 'Neu: Hinterachse',
      newBadgePositions: 'Neu: {{positions}}',
      minTread: 'Schlechteste Profiltiefe',
      changeHistory: 'Änderung Verlauf',
      noHistory: 'Noch keine Reifenwechsel protokolliert',
      removed: 'Demontiert',
      installedNew: 'Eingebaut',
      kmDriven: 'Fahrtkilometer mit abmontiertem Reifen',
      odometerAtChange: 'Messstand beim Wechsel',
      treadWorn: 'Verschleiß pro Rad (mm)',
      treadWornAvg: 'Durchschnittlicher Verschleiß',
      treadDepthAutoMin: 'Der niedrigste Wert wird automatisch als schlechteste Profiltiefe gespeichert',
      treadDepthLabel: 'Profiltiefe',
      storageHotel: 'Reifenhotel',
      storageStorage: 'Lagerung',
      storageVehicle: 'Am Fahrzeug',
      storageOther: 'Sonstiges',
    },
    viewList: 'Liste',
    viewCalendar: 'Kalender',
    viewCosts: 'Kosten',
    category: {
      all: 'Alle Kategorien',
      tire: 'Reifenwechsel',
      maintenance: 'Service',
      inspection: 'Inspektion',
      custom: 'Andere',
    },
    filter: {
      allStatuses: 'Alle Status',
    },
    bulk: {
      selected: 'markiert',
      action: 'Fix markiert',
      title: 'Servicepunkte reparieren',
      points: 'Punkte',
      book: 'Buch',
      complete: 'Als abgeschlossen markieren',
      bookingDate: 'Buchungsdatum',
      performedDate: 'Ausführungsdatum',
      totalCost: 'Gesamtkosten',
      costNote: 'gilt für die gesamte Gruppe',
      confirmBook: 'Buchung bestätigen',
      confirmComplete: 'Als abgeschlossen markieren',
    },
    calendar: {
      title: 'Servicekalender',
      regNr: 'Registernummer',
      type: 'Typ',
      station: 'Station',
      place: 'Standort',
      time: 'Zeit',
      workshop: 'Workshop',
      due: 'Fällig',
      note: 'Hinweis',
    },
    workshop: {
      create: 'Workshop erstellen',
      edit: 'Workshop bearbeiten',
      name: 'Name',
      type: 'Typ',
      extern: 'Extern',
      intern: 'Intern',
      internalPerson: 'Interne Person (Servicemitarbeiter)',
      selectPersonnel: '-- Servicepersonal auswählen --',
      noPersonnelHint: 'Kein Servicepersonal gefunden. Fügen Sie die Rolle über Kontaktrollen hinzu.',
      contactPerson: 'Ansprechpartner',
      address: 'Adresse',
      city: 'Stadt',
      phone: 'Telefon',
      email: 'E-Mail',
      listTitle: 'Werkstätten',
      listDescription: 'Werkstätten und Servicepersonal verwalten',
      searchPlaceholder: 'Nach Name, Stadt oder Kontakt suchen',
      empty: 'Noch keine Werkstätten',
      loadError: 'Werkstätten konnten nicht geladen werden',
    },
    internal: 'Intern',
    invoice: {
      upload: 'Rechnung (PDF/Bild) für KI-Interpretation hochladen',
      uploadShort: 'Hochladen',
      parsed: 'KI hat die Rechnung interpretiert',
      supplier: 'Lieferant',
      number: 'Rechnungsnummer',
      total: 'Gesamt',
      vat: 'Mehrwertsteuer',
    },
    costs: {
      month: 'Monat',
      category: 'Kategorie',
      categoryName: 'Kategoriename',
      totalSek: 'Kosten (kr)',
      serviceCount: 'Anzahl',
      grandTotal: 'Gesamtkosten',
      monthlyChart: 'Kosten pro Monat',
      exportExcel: 'Exportieren Excel',
      noData: 'Keine Kostendaten für den ausgewählten Zeitraum',
      reportPageTitle: 'Servicekosten',
      reportSubtitle: 'Kosten pro Kategorie und Zeitraum',
    },
    autoTire: {
      title: 'Automatischer Reifenservice',
      description: 'Erstellen Sie automatisch Servicepunkte für Winterreifen und Sommerreifen basierend auf schwedischen Regeln.',
      enable: 'Automatischen Reifenservice aktivieren',
      enableHint: 'Erstellt Servicepunkte für alle Fahrzeuge innerhalb der angegebenen Anzahl von Tagen vor Ablauf der Frist.',
      winterDeadline: 'Winterreifen – spätestens montiert',
      summerDeadline: 'Spikereifen/Winterreifen – spätestens abmontiert',
      winterHint: 'Winterreifen müssen bis zu diesem Datum montiert werden (laut Zentralamt für Transportwesen: 1. Dezember)',
      summerHint: 'Spikereifen und Winterreifen müssen bis zu diesem Datum abmontiert werden (laut Zentralamt für Transportwesen: 15. April)',
      advanceDays: 'Tage im Voraus',
      advanceDaysUnit: 'Tage',
      advanceDaysHint: 'Anzahl der Tage vor dem Stichtag, an dem der Serviceauftrag erstellt wird. Standard: 60 Tage (2 Monate).',
    },
    responsible: 'Servicemanager',
    selectResponsible: 'Servicemanager auswählen...',
  },
  vehicleEconomy: {
    leasing: 'Leasing',
    ownershipType: 'Im Besitz oder geleast',
    ownershipHint: 'Von Car.info abgerufen (Leasing begonnen/beendet). Hier können Sie den Status ändern.',
    insurance: 'Versicherungen',
    disposal: 'Abrechnung',
    disposalType: 'Typ',
    disposalTypeSale: 'Verkauf',
    disposalTypeReturn: 'Rückgabe',
    disposalNotes: 'Hinweis',
    saveSuccess: 'Finanzen gespeichert',
    agreementNo: 'Vertragsnr.',
    contractNo: 'Vertragsnr.',
    leasingCompany: 'Leasingunternehmen',
    insuranceCompany: 'Versicherungsunternehmen',
    vehicleSupplier: 'Autohändler',
    addVehicleSupplier: 'Autohändler hinzufügen…',
    newVehicleSupplierPlaceholder: 'Name des Autohändlers',
    vehicleSupplierCustomerHint: 'Auf dem Kunden gespeichert und kann auf anderen Fahrzeugen ausgewählt werden.',
    supplierSaveFailed: 'Der Autoverkäufer konnte nicht gespeichert werden',
    rentStart: 'Leasing starten',
    rentEnd: 'Leasingende',
    termMonths: 'Vertragslaufzeit (Monate)',
    leasingProduct: 'Produkt',
    originalBasePrice: 'Ursprünglicher Grundpreis',
    bookValue: 'Buchwert',
    guaranteedResidualValue: 'Garantierter Restbetrag Wert',
    importHistory: 'Verlauf (Nordea-Import)',
    readOnlyDeque: 'Ansichtsmodus – Sie können importierte Leasingdaten sehen, haben aber keine Berechtigung zum Bearbeiten von Finanzen.',
    historyPeriod: 'Zeitraum (Datum bis)',
    historyInvoice: 'Rechnungsnummer',
    historyPer: 'Per',
    costMonthLeasing: 'Monatliche Leasingkosten',
    costMonthMaintenance: 'Monatliche Betriebskosten Vereinbarung',
    allowedDistance: 'Zulässige km',
    costPerExtraKm: 'Kosten für zusätzliche Kilometer',
    costCenter: 'Kostenstelle',
    costCenterLeasing: 'Kostenstelle (Leasing)',
    costCenterInsurance: 'Kostenstelle (Versicherung)',
    costCenterTax: 'Kostenstelle (Steuer)',
    costCenterTaxMalus: 'Kostenstelle (Malus)',
    insuranceStartDate: 'Startdatum',
    insuranceEndDate: 'Enddatum',
    insuranceAgreementNo: 'Vereinbarung',
    costMonthInsurance: 'Monatliche Kostenversicherung',
    costMonthTax: 'Monatliche Kostensteuer',
    costMonthTaxMalus: 'Monatlicher Kostensteuer-Malus',
    insuranceImportHistory: 'Historie (Protector-Import)',
    insHistoryPeriod: 'Zeitraum (Bis heute)',
    insHistoryAgreement: 'Vereinbarung',
    insHistoryTrafficTotal: 'Verkehrssumme',
    insHistoryDelkasko: 'Teil',
    insHistoryVagnskada: 'Wagen',
    insHistoryPremiumYear: 'Betrag',
    insHistoryTotal: 'Gesamt',
    insHistoryCostMonth: 'Monat',
    disposalDate: 'Datum der Entsorgung',
    disposalSaleAmount: 'Verkäufe Betrag',
    disposalExtraCosts: 'Zusätzliche Kosten bei der Entsorgung',
    exportTitle: 'Wirtschaftlichkeit des Exportfahrzeugs',
    exportDescription: 'Organisation und Zeitraum auswählen. Der Export basiert auf importierten Kostenzeilen und erstellt eine Unit4-Datei (Konto, Verantwortlichkeit, Aktivität, Gegenpartei).',
    period: 'Zeitraum (Jahr-Monat)',
    exportBokforing: 'Dokument zur Buchhaltung (Unit4)',
    exportBokforingDesc: 'CSV gemäß Unit4-Codeplan, aggregiert nach Konto und Verantwortlichkeit – zum Import in die Buchhaltung.',
    exportFakturering: 'Dokument zur Rechnungsstellung (Unit4)',
    exportFaktureringDesc: 'CSV mit interner Rechnung (Soll/Haben) pro Fahrzeug und Kostenart – zum Laden in Unit4.',
    exportSelectOrg: 'Organisation zum Erstellen des Dokuments auswählen.',
    exportError: 'Export konnte nicht heruntergeladen werden.',
    costInvoiceLines: 'Importierte Rechnungszeilen',
    costInvoiceSummary: 'Importierte Kosten',
    costInvoiceSummaryMeta: '{{count}} Zeilen · Zeitraum {{period}}',
    costInvoiceSummaryCount: 'Linien',
    costInvoiceSummaryTotal: 'Gesamt',
    costInvoiceDate: 'Rechnungsdatum',
    costInvoiceNumber: 'Rechnungsnummer',
    costInvoiceCategory: 'Kostenelemente',
    costInvoiceDescription: 'Beschreibung',
    costInvoiceAmount: 'Betrag exkl. MwSt.',
  },
  costInvoice: {
    title: 'Kostenrechnungsimport',
    cardDescription: 'Ayvens-Rechnungen importieren und Kostenelemente abbilden',
    description: 'Gemischte Fahrzeugkosten von Leasinggesellschaften (z. B. Ayvens) importieren. Ordnen Sie Kostenarten zu und laden Sie eine oder mehrere Dateien oder einen ganzen Ordner hoch. Jede Datei wird nur einmal importiert.',
    uploadTitle: 'Dateien hochladen',
    uploadHint: 'Wählen Sie Excel-Dateien (.xlsx) oder einen Ordner aus. Der gleiche Dateiinhalt wird nur einmal pro Organisation importiert. Tankkartenzeilen sind standardmäßig deaktiviert.',
    selectFiles: 'Dateien auswählen',
    selectFolder: 'Ordner auswählen',
    mappingTitle: 'Kostenelementzuordnung (Ayvens)',
    mappingHint: 'Der Lieferantencode wird einem DQFleet-Kostenelement zugeordnet. Deaktivieren Sie „Einschließen“, wenn die Zeilen nicht gespeichert werden sollen (z. B. kommt bereits Kraftstoff aus Kreis K).',
    saveMapping: 'Zuordnung speichern',
    mappingSaved: 'Die Zuordnung wird gespeichert',
    mappingSaveError: 'Die Zuordnung konnte nicht gespeichert werden',
    importHistory: 'Vorherige Importe',
    noImports: 'Noch keine Importe',
    colFilename: 'Dateiname',
    colInvoiceDate: 'Rechnungsdatum',
    colRows: 'Linien',
    colImported: 'Importiert',
    colSkipped: 'Überspringen',
    colUnmapped: 'Nicht zugeordnet',
    colUnmatched: 'Unbekannte Regnr',
    colImportedAt: 'Importiert',
    colSourceCode: 'Code',
    colSourceLabel: 'Anbietertyp',
    colCategory: 'DQFleetTyp',
    colInclude: 'Einschließen',
    loadError: 'Import oder Zuordnung konnte nicht abgerufen werden',
    importError: 'Import fehlgeschlagen',
    importTimeout: 'Der Import hat zu lange gedauert. Probieren Sie jeweils eine Datei aus.',
    fileTooLarge: 'Die Datei ist zu groß für den Server (nginx). Bitten Sie den Administrator, „client_max_body_size“ zu erhöhen.',
    importSuccess: 'Import für {{count}}-Datei(en) abgeschlossen',
    duplicateFiles: '{{count}}-Datei(en) wurden bereits importiert',
    noSpreadsheetFiles: 'Der Ordner enthielt keine .xls/.xlsx-Dateien',
    unmappedCodesHint: 'Nicht zugeordnete Codes: {{codes}} – fügen Sie sie der Zuordnung hinzu und importieren Sie sie erneut.',
    autoMappedHint: 'Neue Codes wurden automatisch zugeordnet: {{codes}}. Überprüfen Sie die Tabelle auf Änderungen.',
    createdVehiclesHint: '{{count}} fehlende Fahrzeuge wurden auf dem obersten Knoten erstellt und von car.info abgerufen',
    carInfoFailedHint: '{{count}} Fahrzeuge wurden erstellt, aber car.info konnte nicht ausgefüllt werden',
  },
  ayvensFuel: {
    title: 'Ayvens Tankkarte (manueller Import)',
    description: 'Laden Sie Ayvens „Tankkarte, Details“ hoch. Transaktionen werden als Ayvens gespeichert. Wenn die gleiche Betankung bereits bei Circle K, OKQ8 oder einem anderen Unternehmen vorhanden ist, wird die Zeile als Duplikat markiert – es könnte sich um eine doppelte Abrechnung handeln.',
    selectFiles: 'Kraftstoffdatei auswählen',
    importSuccess: '{{count}}Importierte Kraftstoffzeilen',
    duplicateHint: '{{count}}Zeilen, die als Duplikat für ein anderes Unternehmen markiert sind',
    nothingImported: 'Keine neuen Zeilen (die Datei ist möglicherweise bereits importiert)',
    importError: 'Import von Ayvens-Kraftstoff fehlgeschlagen',
  },
  vehicleCostAnalysis: {
    title: 'Fahrzeugwirtschaftlichkeit',
    cardDescription: 'Importierte Kosten pro Organisation, Gruppe und Fahrzeug analysieren',
    description: 'Wählen Sie eine Organisation oder Gruppe aus, um alle Autos zusammengefasst anzuzeigen. Wählen Sie ein oder mehrere Autos aus, um Kostentypen und Rechnungszeilen zu analysieren.',
    totalCost: 'Gesamtkosten',
    vehiclesWithCost: 'Autos mit Kosten',
    lineCount: 'Linien',
    unmatched: 'Nicht übereinstimmend (unbekannte Regenzahl)',
    groupBreakdown: 'Kostentypen in Gruppe',
    vehiclesTitle: 'Autos in Gruppe',
    onlyWithCosts: 'Nur Autos mit Kosten anzeigen',
    clearSelection: 'Auswahl löschen',
    noVehicles: 'Keine Fahrzeuge in ausgewählter Gruppe',
    selectionTitle: 'Analyse von {{count}}ausgewählte(s) Auto(s)',
    selectedVehicles: 'Ausgewählte Autos',
    selectionBreakdown: 'Kostenarten für die Stichprobe',
    linesTitle: 'Rechnungsposten',
    noLines: 'Keine Rechnungsposten für die Auswahl im Zeitraum',
    colReg: 'Regnr',
    colVehicle: 'Fahrzeuge',
    colOrg: 'Organisation',
    colLines: 'Linien',
    colTotal: 'Gesamt exkl. MwSt.',
    colCategory: 'Kostenelemente',
    colInvoiceDate: 'Rechnungsdatum',
    colInvoiceNumber: 'Rechnungsnummer',
    colDescription: 'Beschreibung',
    colAmount: 'Betrag exkl. MwSt.',
    loadError: 'Kostenzusammenfassung konnte nicht abgerufen werden',
    tabs: {
      overview: 'Übersicht',
      vehicles: 'Autos',
      analysis: 'Analyse',
    },
    goToAnalysis: 'Ausgewählte analysieren',
    selectVehiclesHint: 'Wählen Sie auf der Registerkarte „Autos“ ein oder mehrere Autos aus, um sie zu analysieren.',
  },
  contractDocument: {
    title: 'Vertragsbestätigungen (PDF)',
    description: 'Ayvens-Bestätigungen hochladen. KI liest Fahrer, Verträge und Leasingdetails. Das PDF ist mit dem Auto verknüpft und die Informationen werden unter Economy ausgefüllt.',
    selectFiles: 'PDF-Dateien auswählen',
    selectFolder: 'Ordner auswählen',
    noPdfFiles: 'Der Ordner enthielt keine PDF-Dateien',
    noImports: 'Noch keine Vertragsdokumente',
    loadError: 'Vertragsdokumente konnten nicht abgerufen werden',
    importError: 'Import von Vertragsdokumenten fehlgeschlagen',
    importSuccess: 'Importierte {{count}}Vertragsdokumente',
    unmatchedHint: '{{count}}-Datei(en) konnten nicht an ein Fahrzeug angehängt werden',
    attachedHint: '{{count}}PDF an Fahrzeug angehängt',
    aiSkipped: 'AI-Server hat nicht geantwortet – Regnr- und Basisfelder wurden aus der Datei gelesen sowieso',
    duplicateFile: '{{name}} wurde bereits importiert',
    colFilename: 'Dateiname',
    colReg: 'Regnr',
    colDriver: 'Fahrer',
    colContract: 'Vertrag',
    colStart: 'Start',
    colEnd: 'Ende',
    colAi: 'AI',
  },
  booking: {
    title: 'Buchung',
    pickupLocations: 'Ausstellungsorte',
    pickupLocationsTitle: 'Ausstellungsorte',
    pickupLocationsDescription: 'Unter Buchung: Standorte, an denen Fahrzeuge abgeholt und abgegeben werden',
    addPickupLocation: 'Abgabeort hinzufügen',
    editPickupLocation: 'Lieferort bearbeiten',
    noPickupLocations: 'Keine Lieferorte. Fügen Sie einen hinzu, um loszulegen.',
    pickupTopNodeFilter: 'Oberer Knoten',
    pickupTopNodePlaceholder: 'Wählen Sie den obersten Knoten aus',
    pickupTopNodeAll: 'Alle Kunden',
    pickupChooseTopNode: 'Wählen Sie einen obersten Knoten aus, um die Lieferorte dieses Kunden anzuzeigen.',
    noPickupLocationsCalendar: 'Keine Lieferorte erstellt. Öffnen Sie „Buchung“ und wählen Sie „Abgabeorte“ aus, um Pools zu erstellen und Fahrzeuge zu verbinden.',
    goToPickupLocations: 'Buchung öffnen',
    managedBySupplier: 'Von der Autovermietung verwaltet',
    managedBySupplierNone: 'Eigener Pool (keine Autovermietung)',
    managedBySupplierHelp: 'Wählen Sie eine Autovermietung aus, damit diese den Pool verwalten und Autos für Anfragen zuweisen kann. Die Autos im Pool sind Eigentum der Autovermietung.',
    managedBySupplierNoLinks: 'Für diese Organisation bestehen keine Autovermietungsverbindungen. Erstellen Sie zunächst eine Verbindung unter Autovermietung.',
    pickupAllowedCarClasses: 'Fahrzeugklassen (buchbar/angefragt)',
    pickupAllowedCarClassesHelp: 'Geben Sie hier die Fahrzeugklassen ein, die gebucht oder angefragt werden können. Bleibt die Liste leer, werden die Wagenklassen der Autovermietungsverbindung vererbt, ist sie ebenfalls leer, kann der Bucher die Wagenklasse frei eintragen.',
    pickupLocationResponsibles: 'Verantwortliche',
    pickupLocationResponsiblesHelp: 'Personen, die für den Lieferort verantwortlich sind. Sie können FlinkeyBoxen für die Fahrzeuge des Pools in der mobilen App (FlinkyBoxen) verwalten, wenn sie dazu berechtigt sind.',
    pickupLocationResponsiblesSearch: 'Benutzer suchen',
    pickupLocationResponsiblesSearchPlaceholder: 'Name oder E-Mail-Adresse…',
    pickupLocationResponsiblesNone: 'Keine Manager ausgewählt',
    pickupLocationActiveLabel: 'Aktiv (in Buchungen und Pools angezeigt)',
    pickupLocationActiveHelp: 'Durch Deaktivieren wird der Standort deaktiviert. Zukünftige Buchungen mit dem Status „Gebucht“, die noch ein Auto aus diesem Pool haben, verlieren das Auto und werden unter Kollisionsbuchungen aufgeführt, sodass Sie einen anderen Pool zuweisen oder stornieren können.',
    pickupBookingsLockedLabel: 'Sichtbar, aber gesperrt',
    pickupBookingsLockedHelp: 'Der Pool ist im Kalender sichtbar und Benutzer sehen ihre Buchungen, aber niemand kann erstellen, ändern oder stornieren, bis die Sperre aufgehoben wird.',
    pickupBookingsLockedBadge: 'Gesperrt',
    poolBookingsLockedHint: 'Der Pool ist gesperrt. Sie können Buchungen einsehen, aber nicht erstellen, ändern oder stornieren, bis die Sperre aufgehoben wird.',
    pickupLocationOpens: 'öffnet {{date}}',
    pickupLocationNotYetOpenHint: 'Der Freigabeort öffnet sich {{date}}. Sie können es in der Liste sehen, aber erst buchen, wenn es gültig ist.',
    pickupValidFrom: 'Gültig von',
    pickupValidTo: 'Gültig bis',
    pickupValidDatesHelp: 'Steuert, wann der Ort angezeigt und buchbar ist. Für keine Einschränkung leer lassen (gilt ab sofort). Außerhalb des Zeitraums ist der Platz in der Buchung ausgeblendet und kann nicht gebucht werden. Der Administrator sieht es hier immer noch.',
    showBookerNameInResourceManager: 'Name der Person anzeigen, die im Ressourcenmanager gebucht hat',
    showBookerNameInResourceManagerHelp: 'Wenn aktiviert, wird der Name des Buchers (und der Mitreisenden per Hover) auf den Buchungsblöcken im Ressourcenmanager angezeigt. Standardmäßig wird der Name nicht angezeigt.',
    fellowTravelers: 'Mitreisende',
    pickupInactiveBadge: 'Inaktiv',
    pickupDeactivate: 'Deaktivieren',
    pickupActivate: 'Aktivieren',
    pickupDelete: 'Löschen',
    pickupExportPools: 'Poolliste herunterladen',
    pickupExportPoolsLoading: 'Exportieren…',
    pickupActivateConfirm: '"{{name}}" wieder aktivieren?',
    pickupDeleteConfirm: '"{{name}}" endgültig löschen? Dies kann nicht rückgängig gemacht werden.',
    pickupDeleteHasBookings: 'Der Ort hat {{count}} Buchung(en) im Verlauf und kann nicht gelöscht werden. Stattdessen deaktivieren.',
    pickupDeactivateSuccess: 'Problemort deaktiviert',
    pickupActivateSuccess: 'Problemort aktiviert',
    pickupDeleteSuccess: 'Problemort gelöscht',
    pickupDeactivateConfirm: '„{{name}}“ deaktivieren? Die Seite ist deaktiviert. Bei allen zukünftigen Buchungen (Status „Gebucht“, „nicht ausgecheckt“), denen ein Auto in diesem Pool zugewiesen ist, wird das Auto gelöscht und unter „Kollisionsbuchungen“ angezeigt. Möchten Sie fortfahren?',
    pickupDeactivateStripped: '{{count}} Buchung(en) wurden in die Kollisionsbehandlung verschoben.',
    pickupLocationSaveError: 'Abgabeort konnte nicht gespeichert werden.',
    createUnderOrganization: 'Unter Organisation erstellen',
    loadingOrganizations: 'Organisationen werden geladen...',
    noTopNodesFound: 'Keine Top-Knoten gefunden. Überprüfen Sie die Berechtigung oder versuchen Sie es erneut.',
    drawGeofenceArea: 'Bereich auf der Karte zeichnen',
    startDrawing: 'Zeichnen beginnen',
    finishArea: 'Fertig – Bereich speichern',
    geofenceAreaHelp: 'Klicken Sie auf die Karte, um Punkte festzulegen. Es sind mindestens 3 Punkte erforderlich. Der Bereich wird zum Betreten/Verlassen und zur Bestätigung verwendet, dass die Buchung am richtigen Ort endet.',
    geofenceEnforceOnReturn: 'Erfordert, dass sich das Auto beim Check-in im Bereich befindet',
    geofenceEnforceOnReturnHelp: 'Wenn aktiviert, muss sich das Auto im Kartenbereich befinden, wenn die Buchung über die App eingecheckt/beendet wird. Andernfalls ist der Ausgang gesperrt. Der Kundendienst mit der Rückgabe an einen anderen Standort kann Ausnahmen zulassen (z. B. verzögertes GPS). Erfordert eine gezeichnete Fläche.',
    nearbyPoolSearchRadiusM: 'Suche nach verfügbaren Autos in nahegelegenen Pools (Meter)',
    nearbyPoolSearchRadiusMHelp: 'Bei einer neuen Buchung werden auch verfügbare Autos von anderen Pools angezeigt, deren Parkplatz in dieser Entfernung vom Parkplatz dieses Pools liegt. Standard 2000 m. Legen Sie 0 fest, um nur diesen Pool anzuzeigen.',
    nearbyPoolSearchRadiusMPlaceholder: '2000',
    pickupHasGeofenceArea: 'Hat Kartenbereich',
    pickupShowAreasOnMap: 'Kartenbereiche anzeigen',
    pickupAreasMapTitle: 'Kartenbereiche für Release-Standorte',
    pickupAreasMapNoAreas: 'Keine Release-Standorte haben Kartenbereiche gezeichnet.',
    pickupAreasMapListHint: 'Klicken Sie auf einen Namen, um auf den Bereich zu zoomen.',
    pickupAreasMapListCount: '{{count}} Standorte mit Karte Bereich',
    pickupAreasMapShowAll: 'Alle Bereiche anzeigen',
    selectOrgGroup: 'Gruppe (Organisation) auswählen',
    vehiclesInPool: 'Fahrzeuge im Pool',
    bookingResourcesInPool: 'Ressourcen im Pool',
    bookingResourcesInPoolHelp: 'Fahrräder, Anhänger und andere Kundenressourcen. Der Ressourcentyp wird von der Ressourcenregistrierung geerbt.',
    addBookingResourceToPool: 'Ressource hinzufügen',
    selectBookingResource: 'Ressource auswählen',
    noUnassignedResources: 'Keine nicht zugewiesenen Ressourcen. Erstellen Sie Ressourcen unter Buchungsressourcen.',
    bookingResourceAdded: 'Ressource zum Pool hinzugefügt',
    bookingResourceRemoved: 'Ressource aus dem Pool entfernt',
    vehiclesInGroup: 'Fahrzeuge in der Gruppe',
    pickupLinkedTotal: '{{count}}Fahrzeuge, die mit dem Abgabepunkt verbunden sind',
    pickupLinkedInList: 'von {{total}} Fahrzeugen sind verbunden',
    pickupLinkedOtherOrgsTitle: '{{count}} verbundene Fahrzeuge erscheinen nicht in der Liste (andere Organisation als die ausgewählte Gruppe)',
    pickupLinkedOtherOrgsHint: '{{count}} verbundene Fahrzeuge gehören einer anderen Organisation als der ausgewählten Gruppe (in der Liste markiert).',
    pickupLinkedOtherOrgBadge: 'Andere Organisation',
    pickupVehicleSearch: 'Fahrzeug suchen',
    pickupVehicleSearchPlaceholder: 'Reg. Nr., Marke oder Modell…',
    pickupVehicleSearchResults: 'Zeigt {{shown}} von {{total}} Fahrzeugen',
    pickupVehicleSearchNoHits: 'Keine Fahrzeuge entsprechen der Suche.',
    pickupLinkedBadge: 'Verbunden',
    pickupVehicleOrgLimit: 'Nur Fahrzeuge, die zu {{org}} oder einer Gruppe darunter gehören, können hier verlinkt werden.',
    pickupVehiclesApplyOnSave: 'Fahrzeuge hier ein- oder auschecken. Die Änderung wird erst wirksam, wenn Sie auf Speichern klicken. Abbrechen lässt die Liste unverändert.',
    pickupRemoveVehiclesConfirm: '{{count}} Fahrzeug vom Abgabeort entfernen? Zukünftige Buchungen für diese Autos werden umgebucht oder werden zu Kollisionen.',
    pickupPoolResourceTypeHeading: 'Ressourcentyp bei der Buchung (pro Fahrzeug im Pool)',
    pickupPoolResourceTypeHelp: 'Leer = zählt als Auto in der Buchungssuche. Wählen Sie z.B. Fahrrad, wenn der Pool Fahrräder enthält.',
    pickupPoolResourceTypeDefault: 'Standard (Auto)',
    pickupBookingInfo: 'Info zur Buchung',
    pickupBookingInfoHelp: 'Dieser Text wird mit der Buchungsbestätigung an die Person gesendet, die ein Auto vom Pool gebucht hat.',
    pickupLocationMapShow: 'Abgabeort auf Karte anzeigen',
    pickupLocationMapTitle: 'Abgabeort auf Karte',
    pickupLocationMapNoAddress: 'Keine Adresse angegeben.',
    pickupLocationMapNoCoords: 'Hierfür gibt es keine Karte Standort.',
    pickupTabSettings: 'Einstellungen',
    pickupTabBooking: 'Buchung',
    pickupTabVehicles: 'Fahrzeuge',
    pickupTabResources: 'Ressourcen',
    pickupTabKeyCabinet: 'Schlüsselschränke',
    pickupTabKeyCabinetPlaceholder: 'Schlüsselschränke sind hier mit dem Lieferort verbunden. Die Funktion wird in Kürze erweitert.',
    pickupTabKeyCabinetHelp: 'Angeschlossene Schränke sind hier sichtbar. Sie können auch Schließfächer verknüpfen, die zur selben Organisation gehören, aber nicht mit einem Lieferort verknüpft sind.',
    pickupKeyCabinetsConnected: 'Verknüpfte Schließfächer',
    pickupKeyCabinetsNone: 'Mit diesem Abholort sind keine Schließfächer verknüpft.',
    pickupKeyCabinetsAvailable: 'Verfügbare Schließfächer in der Organisation',
    pickupKeyCabinetsNoneAvailable: 'Es gibt keine nicht verknüpften Schließfächer in der Organisation.',
    pickupKeyCabinetSelect: 'Schließfach auswählen',
    pickupKeyCabinetConnect: 'Schließfach verknüpfen',
    pickupKeyCabinetDisconnect: 'entkoppeln',
    pickupKeyCabinetConnectSuccess: 'Das Schließfach wurde mit dem Lieferort verbunden.',
    pickupKeyCabinetDisconnectSuccess: 'Die Schließfachverbindung wurde entfernt.',
    pickupKeyCabinetConnectError: 'Das Schließfach konnte nicht verbunden werden.',
    pickupKeyCabinetDisconnectError: 'Die Schließfachverbindung konnte nicht entfernt werden.',
    pickupKeyCabinetLoadError: 'Der Schlüsselschließfach konnte nicht abgerufen werden.',
    pickupTabResponsibles: 'Verantwortliche',
    addVehiclesToPool: 'Ausgewählte zum Pool hinzufügen',
    name: 'Name',
    address: 'Adresse',
    postalCode: 'Postleitzahl',
    city: 'Stadt',
    pickupMappedVehicleCount: 'Fahrzeuge',
    nearbyPoolSearchRadiusMeters: 'Nach nahegelegenen Pools suchen (Meter)',
    nearbyPoolSearchRadiusPlaceholder: 'z. B. 5000',
    nearbyPoolSearchRadiusHelp: 'Bei der Buchung werden verfügbare Fahrzeuge auch in anderen Lieferorten innerhalb dieser Entfernung (gemessen von der Mitte des Kartenbereichs) gesucht. Lassen Sie das Feld leer oder geben Sie 0 ein, um nur diesen Pool zu verwenden. Erfordert gezeichneten Kartenbereich.',
    displayOrder: 'Sortierung',
    suppliers: 'Lieferanten',
    suppliersTitle: 'Lieferanten',
    suppliersDescription: 'Konfigurieren Sie Ihre Lieferanten und eigene Fahrzeuggruppennamen. Derselbe Autovermieter im CRM kann durch mehrere Kunden verknüpft werden – jeder Kunde hat seine eigene Liste und Bezeichnung.',
    addSupplier: 'Anbieter hinzufügen',
    addCarRentalFromCrm: 'Autovermieter aus CRM hinzufügen',
    selectCarRental: 'Autovermieter auswählen',
    noCarRentalCustomers: 'Keine Kunden mit dem Typ „Autovermieter“ im CRM. Legen Sie zunächst unter CRM → Kunden einen Kunden mit dem Kundentyp Autovermietung an.',
    deliversToAllPools: 'Liefert an alle Pools',
    editSupplier: 'Lieferanten bearbeiten',
    noSuppliers: 'Keine Lieferanten. Fügen Sie eines hinzu, um loszulegen.',
    supplierType: 'Typ',
    supplierTypeCarRental: 'Autovermietung',
    supplierTypeOther: 'Sonstiges',
    supplierEmail: 'E-Mail',
    supplierPhone: 'Telefonnummer',
    supplierEmailPlaceholder: 'zB. bokning@avis.se',
    supplierPhonePlaceholder: 'z.B. 011-123 45 67',
    supplierCarClasses: 'Fahrzeuggruppen',
    supplierCarClassesHelp: 'Ihre eigenen Namen von Fahrzeuggruppen beim Lieferanten, z.B. Kleinwagen oder Mittelwagen. Wird für Buchungsanfragen verwendet.',
    supplierCarClassPlaceholder: 'zB. Kleinwagen',
    supplierCarClassAdd: 'Hinzufügen',
    supplierCarClassRemove: 'Entfernen {{name}}',
    rentalManagementTitle: 'Autovermieter',
    rentalManagementDescription: 'Kundenorganisationen mit einem Autovermieter verbinden, um Autos zu bündeln und Mietanfragen zu stellen. Die Zugriffsebene steuert, ob der Kunde selbst bucht oder nur Statistiken sieht.',
    addRentalLink: 'Verbindung hinzufügen',
    editRentalLink: 'Verbindung bearbeiten',
    noRentalLinks: 'Noch keine Autovermietungsverbindungen. Fügen Sie eine hinzu, um loszulegen.',
    rentalCompany: 'Autovermieter',
    rentalCustomer: 'Kundenorganisation',
    rentalSelectCompany: 'Autovermieter auswählen',
    rentalSelectCustomer: 'Kundenorganisation auswählen',
    rentalAccessLevel: 'Zugriffsebene',
    rentalAccessFullBooking: 'Vollständige Buchung (Buchen/Anfrage erstellen)',
    rentalAccessStatsOnly: 'Nur Statistik',
    rentalAccessFullBookingHelp: 'Die Benutzer des Kunden buchen vorhandene Poolwagen oder erstellen Anfragen. Der Autovermieter stellt ein Auto zur Verfügung. Der Kunde kann die Fahrzeuge nicht verwalten.',
    rentalAccessStatsOnlyHelp: 'Die Mitarbeiter des Kunden können Anfragen buchen/erstellen, der Kunde verwaltet die Fahrzeuge jedoch nicht. Der Kundenadministrator sieht Buchungsstatistiken und Umweltbericht.',
    rentalLinkSelectBoth: 'Wählen Sie sowohl die Autovermietung als auch die Kundenorganisation aus.',
    rentalLinkSaveError: 'Die Verbindung konnte nicht gespeichert werden.',
    rentalLinkDeleteConfirm: 'Möchten Sie diese Verbindung zur Autovermietung entfernen?',
    requestedCarClass: 'Gewünschte Fahrzeuggruppe',
    requestedCarClassPlaceholder: 'Fahrzeuggruppe auswählen',
    requestedCarClassFreePlaceholder: 'Gewünschte Fahrzeuggruppe eingeben',
    requestedCarClassNoOptionsHint: 'Keine mit Ihren Lieferanten konfigurierten Fahrzeuggruppen – manuell eingeben oder unter Lieferanten hinzufügen.',
    requestedCarClassRequired: 'Gewünschte Fahrzeuggruppe auswählen oder eingeben',
    supplierCrmCustomer: 'Kunde (Autovermietung im CRM)',
    supplierCrmNone: 'Keine Verbindung – unabhängiger Lieferant',
    supplierCrmCustomerHelp: 'Optionale Verbindung zur Autovermietung im CRM. Derselbe CRM-Datensatz kann von mehreren Kunden verwendet werden – Sie konfigurieren Ihre eigenen Fahrzeuggruppen und Kontaktdaten pro Kunde.',
    supplierNameFromCrm: 'Der Name wird vom CRM-Kunden übernommen.',
    destinations: 'Ziele',
    destinationsTitle: 'Ziele',
    destinationsDescription: 'Vordefinierte Reiseziele bei der Buchung',
    addDestination: 'Ziel hinzufügen',
    editDestination: 'Ziel bearbeiten',
    noDestinations: 'Keine Ziele. Fügen Sie eines hinzu, um loszulegen.',
    vehiclesAtLocation: 'Fahrzeuge vor Ort',
    addVehicle: 'Fahrzeug hinzufügen',
    calendarTitle: 'Buchungskalender',
    calendarDescription: 'Gantt-Diagramm der Belegung nach Pool – verfügbare Zeiten anzeigen und Buchungen erstellen',
    weekTitle: 'Woche {{week}} ({{start}} - {{end}})',
    calendarViewAll: 'Alle Tage',
    calendarViewWorkdays: 'Nur Wochentage',
    viewWeek: 'Woche',
    viewDay: 'Tag',
    today: 'Heute',
    prevDay: 'Vorheriger Tag',
    nextDay: 'Nächster Tag',
    openDayView: 'Ansicht Tag der offenen Tür',
    vehicleColumn: 'Fahrzeuge',
    redDay: 'Roter Tag (arbeitsfreier Feiertag)',
    status: 'Status',
    statusBooked: 'Gebucht',
    statusCheckedOut: 'Ausgecheckt',
    statusReturned: 'Zurückgegeben',
    statusCancelled: 'Storniert',
    statusCancelledBySystem: 'Vom System storniert',
    statusNoShow: 'Nichterscheinen (nicht abgeholt)',
    statusNotReturned: 'Nicht zurückgegeben',
    statusOverdue: 'Zeitüberschreitung',
    checkedOutAt: 'Ausgecheckt',
    returnedAt: 'Zurückgegeben um',
    checkoutButton: 'Check-out',
    checkoutDialogTitle: 'Check-out-Reservierung',
    checkoutTimeLabel: 'Zeitpunkt des Check-outs',
    ksMarkPickedUp: 'Als ausgecheckt markieren',
    ksMarkPickedUpTitle: 'Als ausgecheckt markieren',
    ksMarkPickedUpConfirm: 'Möchten Sie um die Buchung als ausgecheckt zu markieren?',
    ksReturnTitle: 'Buchung zurückgeben',
    ksReturnConfirm: 'Möchten Sie die Buchung zurückgeben?',
    returnButton: 'Zurück',
    changeResource: 'Ressource ändern',
    changeResourceTitle: 'Ressource ändern',
    changeResourceCurrent: 'Aktuelle Ressource',
    changeResourceNew: 'Neue Ressource',
    changeResourceSearchPlaceholder: 'Fahrzeug suchen (z. B. 197, GNB563, Handbuch)…',
    changeResourceSelected: 'Ausgewählt',
    changeResourceNoneAvailable: 'Keine verfügbaren Fahrzeuge im Pool für den Zeitraum',
    changeResourceSave: 'Ressource ändern',
    changeResourceSuccess: 'Die Ressource wurde geändert.',
    changeResourceError: 'Konnte nicht Ressource ändern.',
    vehicleMapShow: 'Auf Karte anzeigen',
    vehicleMapTitle: 'Fahrzeugposition',
    vehicleMapSourceLive: 'Aktuelle Position',
    vehicleMapSourceStored: 'Letzte gespeicherte Position',
    vehicleMapUpdatedAt: 'Aktualisiert',
    vehicleMapNoPosition: 'Für das Fahrzeug ist keine Position gespeichert.',
    vehicleMapLoadError: 'Fahrzeugposition konnte nicht abgerufen werden.',
    legendVehicleBlock: 'Fahrzeugblockierung (admin)',
    legendImportedBooking: 'Importierte Buchung (JSON)',
    legendQuickBooking: 'Schnellbuchung',
    vehicleBlockShort: 'Blockierung',
    noVehicleAssigned: 'Kein Auto zugewiesen',
    ownCar: {
      formTitle: 'Fahrt mit eigenem erstellen Auto',
      listTitle: 'Reisen mit eigenem Auto',
      listIntro: 'Ihre eigenen Reisen und solche, für die Sie Bewertungsrechte haben.',
      listEmpty: 'Keine Reisen zum Anzeigen.',
      listLoadError: 'Fahrten konnten nicht abgerufen werden.',
      loadError: 'Formular konnte nicht geladen werden.',
      toList: 'Alle Fahrten anzeigen',
      newTrip: 'Neue Fahrt',
      bookedFor: 'Gebucht für',
      phone: 'Telefonnummer',
      car: 'Auto',
      selectCar: 'Wählen Sie Ihr Auto aus',
      newCar: 'Neues Auto…',
      lookupCar: 'Von car.info herunterladen',
      regRequired: 'Zuerst Kennzeichen eingeben',
      carInfoSuccess: 'Fahrzeugdetails abgerufen von car.info',
      carInfoError: 'Fahrzeug konnte nicht von car.info abgerufen werden',
      model: 'Modell',
      year: 'Modelljahr',
      color: 'Farbe',
      fuel: 'Kraftstofftyp',
      co2PerKm: 'CO₂',
      reimbursement: 'Entschädigung pro Kilometer',
      odometerStart: 'Zählerstand - Fahrtbeginn',
      odometerEnd: 'Zählerstand - Ende der Fahrt',
      directKm: 'Alternativ geben Sie die Länge der Fahrt direkt ein (in ganzen km)',
      totalReimbursement: 'Gesamtvergütung',
      from: 'Buchung von',
      to: 'Buchung bis',
      costCenter: 'Kostenstelle',
      selectCostCenter: 'Kostenstelle auswählen',
      project: 'Projekt Anzahl',
      emission: 'Emissionen',
      km: 'Km',
      total: 'Gesamt',
      co2: 'CO₂',
      travelFrom: 'Reise - Von',
      travelTo: 'Reise - Bis',
      purpose: 'Zweck',
      ownCarReason: 'Grund für die Wahl des eigenen Autos',
      save: 'Speichern',
      saveAndSubmit: 'Speichern und absenden',
      saveSuccess: 'Die Reise wurde gespeichert und kann noch bearbeitet werden.',
      submitSuccess: 'Die Reise wurde zur Überprüfung eingereicht.',
      saveError: 'Die Reise konnte nicht gespeichert werden.',
      approve: 'Genehmigen',
      reject: 'Ablehnen',
      approveSuccess: 'Die Reise ist genehmigt.',
      rejectSuccess: 'Die Reise wurde abgelehnt.',
      reviewError: 'Die Reise konnte nicht überprüft werden.',
      sendPayroll: 'An Lohnbuchhaltung senden',
      payrollSuccess: 'Die Reise ist als an die Lohn- und Gehaltsabrechnung gesendet markiert.',
      payrollError: 'Konnte nicht an die Lohn- und Gehaltsabrechnung gesendet werden.',
      export: 'Export CSV',
      exportError: 'Konnte nicht exportiert werden.',
      searchPlaceholder: 'Suchname, Regnr, von/bis…',
      allStatuses: 'Alle Status',
      statusLabel: 'Status',
      status: {
        draft: 'Entwurf',
        submitted: 'Eingereicht',
        approved: 'Genehmigt',
        rejected: 'Abgelehnt',
        sent_to_payroll: 'An die Gehaltsabrechnung gesendet',
      },
    },
    collisionTitle: 'Kollisionsbuchungen',
    collisionIntro: 'Buchungen ohne zugeordnetes Fahrzeug, die heute oder später starten (z. B. nachdem ein Auto für die Buchung gesperrt wurde). Der vorherige Pool und das vorherige Auto werden angezeigt, sodass Sie ein neues Auto zuweisen oder stornieren können.',
    collisionBack: 'Zurück zur Buchung',
    collisionEmpty: 'Keine aktuellen Kollisionsbuchungen.',
    collisionLoadError: 'Kollisionsbuchungen konnten nicht geladen werden.',
    collisionDetailLoadError: 'Buchung konnte nicht geöffnet werden.',
    collisionColPool: 'Pool',
    collisionColCustomer: 'Gebucht für',
    collisionColTime: 'Zeit',
    collisionColPriorVehicle: 'Vorheriges Auto',
    collisionColAvailableResource: 'Freie Ressource',
    collisionAssignVehicle: 'Zuweisen',
    collisionAssignSuccess: 'Fahrzeug zugewiesen.',
    collisionAssignError: 'Fahrzeug konnte nicht zugewiesen werden.',
    collisionCancelBySystem: 'Abbrechen',
    collisionCancelConfirm: 'Es ist keine Ressource verfügbar. Möchten Sie die Buchung stornieren? E-Mail wird an Bucher und Mitreisende gesendet.',
    collisionCancelSuccess: 'Die Buchung wurde vom System storniert.',
    collisionCancelError: 'Die Buchung konnte nicht storniert werden.',
    collisionColStatus: 'Status',
    collisionColAction: 'Aktion',
    collisionOpenBooking: 'Buchung öffnen',
    assignVehicleTitle: 'Auto im Pool zuweisen',
    assignVehicleHint: 'Wählen Sie ein verfügbares Fahrzeug zum Zeitpunkt der Buchung aus. Sie können die Buchung auch entfernen oder den Kunden zum Stornierungslink unten weiterleiten.',
    assignVehicleSelectPlaceholder: 'Fahrzeug auswählen…',
    assignVehicleButton: 'Zuweisen',
    assignVehicleSuccess: 'Auto zugewiesen.',
    assignVehicleError: 'Auto konnte nicht zugewiesen werden.',
    assignVehicleNoneAvailable: 'Für diese Zeit sind keine Fahrzeuge im Pool verfügbar (Blockierungen und andere Buchungen prüfen).',
    staffCancelLinkHint: 'Link für den Kunden, um die Buchung selbst zu stornieren (neuer Tab):',
    staffCancelLinkOpen: 'Stornierungsseite',
    newBooking: 'Neue Buchung',
    newBookingSubtitle: 'Füllen Sie die Fahrzeugbuchung mit Zweck, Ziel und wiederkehrenden Optionen aus.',
    organization: 'Organisation',
    pool: 'Pool',
    date: 'Datum',
    vehicle: 'Fahrzeuge',
    selectPoolAndDate: 'Wählen Sie Pool und Datum aus, um die Verfügbarkeit anzuzeigen.',
    noVehiclesInPool: 'Keine Fahrzeuge in diesem Pool. Fügen Sie unter Buchung → Lieferorte ein Fahrzeug hinzu.',
    start: 'Start',
    end: 'Ende',
    customerName: 'Gebucht von/für',
    bookerRsid: 'RSID',
    bookerPhone: 'Telefonnummer',
    customerNamePlaceholder: 'Name oder Einheit',
    bookedFor: 'Gebucht für',
    searchUserPlaceholder: 'Suchname, E-Mail oder RSID...',
    primaryBooker: 'Hauptbucher',
    createdBy: 'Gebucht von',
    cancelledBy: 'Storniert von',
    cancelledBySystem: 'System',
    actorUnknown: 'Unbekannt',
    createdChannel: 'Gebucht von',
    createdChannelApp: 'App',
    createdChannelWeb: 'Computer',
    bookingTypeSingle: 'Buchung',
    bookingTypeGroup: 'Gruppenbuchung',
    bookingTypePool: 'Fahrzeugpark',
    tripPurpose: 'Zweck der Fahrt',
    tripPurposePlaceholder: 'z. B. Kundenbesuch',
    notes: 'Notizen',
    estimatedKm: 'Geschätzte Entfernung (km)',
    passengerCount: 'Anzahl der Passagiere',
    destination: 'Ziel',
    destinationPlaceholder: 'Standort auswählen oder eingeben',
    destinationTypeFree: 'Geben Sie Freitext ein, wenn keine Übereinstimmung vorliegt',
    driverLicenseConfirmed: 'Ich habe einen gültigen Führerschein',
    bookingPolicyCheckbox: 'Ich habe die Buchungsrichtlinien gelesen und stimme ihnen zu',
    bookingPolicyCheckboxHelp: 'Aktivieren Sie das Kästchen, um die zu öffnen Politik. Bestätigen Sie unten im Fenster, wenn Sie mit dem Lesen fertig sind.',
    isServiceBooking: 'Service / Jour',
    isServiceBookingHelp: 'Kreuzen Sie an, ob sich die Buchung auf den Service am Fahrzeug bezieht. Solche Buchungen sind von der No-Show-Regel nicht betroffen, die andernfalls zur Räumung des Platzes nach der angegebenen Zeit führt.',
    bookingPolicyTitle: 'Buchungsrichtlinien',
    bookingPolicyReadConfirm: 'Ich habe die Richtlinien gelesen',
    approvedBy: 'Genehmigt durch (Bescheinigung)',
    approvedByPlaceholder: '– Optional –',
    noAvailableVehicles: 'Keine verfügbaren Fahrzeuge für den ausgewählten Zeitraum',
    recurrence: 'Wiederkehrend',
    recurrenceDaily: 'Tag',
    recurrenceWeekly: 'Woche',
    recurrenceMonthly: 'Monat',
    recurrenceCount: 'Anzahl von Malen',
    loadingAvailableVehicles: 'Verfügbare Fahrzeuge werden geladen...',
    filterByEquipment: 'Nach Ausrüstung filtern',
    filterAutomaticTransmission: 'Nur Automatikgetriebe',
    filterAutomaticTransmissionHelp: 'Wenn aktiviert, nur Fahrzeuge mit Automatikgetriebe registriert.',
    filterByResourceType: 'Ressourcentyp',
    resourceTypeFilterAll: 'Alle Typen',
    resourceTypeFilterCar: 'Auto',
    resource: 'Ressource',
    loadingAvailableResources: 'Verfügbare Ressourcen werden geladen…',
    noAvailableResources: 'Keine verfügbaren Ressourcen für den ausgewählten Zeitraum',
    noAutomaticTransmissionVehicles: 'Keine verfügbaren Fahrzeuge mit Automatikgetriebe für den ausgewählten Zeitraum. Deaktivieren Sie den Filter oder wählen Sie einen anderen Zeitpunkt.',
    noVehicleCreateRental: 'Kein verfügbares Auto – Miete vom Anbieter erstellen',
    createRentalAndBooking: 'Miete und Buchung erstellen',
    externalDisplayName: 'Anzeigename (z. B. Mietwagen)',
    externalDisplayNamePlaceholder: 'z. B. Mietwagen A',
    selectSupplier: 'Anbieter auswählen',
    costCenter: 'Kostenstelle',
    project: 'Projekte',
    costCenterPlaceholder: '– Kostenstelle auswählen –',
    costCentersTitle: 'Kostenstellen',
    costCentersDescription: 'Kostenstellen pro Organisation – bei der Buchung ausgewählt. Kann deaktiviert, aber nie entfernt werden.',
    addCostCenter: 'Kostenstelle hinzufügen',
    editCostCenter: 'Kostenstelle bearbeiten',
    noCostCenters: 'Keine Kostenstellen. Fügen Sie einen hinzu, um loszulegen.',
    costCenterCode: 'Code (max. 15 Zeichen)',
    costCenterDescription: 'Beschreibung (max. 50 Zeichen)',
    costCenterValidFrom: 'Gültig von',
    costCenterActive: 'Aktiv',
    costCenterInactive: 'Deaktiviert',
    saveError: 'Buchung konnte nicht gespeichert werden',
    resourceTypesTitle: 'Ressourcentypen pro Kunde',
    resourceTypesDescription: 'Ressourcentypen (Auto, Fahrrad, Konferenzraum usw.) werden systemweit definiert. Hier wählen Sie aus, welche Ressourcentypen jeder Kunde (Organisation) bei der Buchung nutzen darf.',
    resourceTypesOrganization: 'Organisation (Kunde)',
    resourceTypesSelectOrg: 'Organisation auswählen',
    resourceTypesSelectOrgFirst: 'Wählen Sie eine Organisation aus, um anzugeben, welche Ressourcentypen verwendet werden dürfen.',
    resourceTypesMyOrg: 'Meine Organisation',
    resourceTypesForOrg: 'Aktive Ressourcentypen für',
    resourceTypeLabel: 'Ressourcentyp',
    resourceTypeEnabled: 'Für diesen Kunden aktiviert',
    resourceTypeDisabled: 'Für diesen Kunden deaktiviert',
    resourceTypesSaved: 'Ressourcentypen gespeichert',
    resourceTypesSaveError: 'Ressourcentypen konnten nicht gespeichert werden',
    bookingCreated: 'Buchung erstellt',
    sendCalendarInvitePrompt: 'Möchten Sie die Kalendereinladung an den Kunden senden? E-Mail mit Kalenderanhang wird an die Adresse des Kunden gesendet.',
    noEmailForCalendarInvite: 'Der Kunde hat keine E-Mail-Adresse verknüpft – die Kalendereinladung kann nicht gesendet werden.',
    sendCalendarInvite: 'Kalendereinladung senden',
    done: 'Fertig',
    calendarInviteSent: 'Die Kalendereinladung wurde an die E-Mail-Adresse des Kunden gesendet.',
    calendarInviteError: 'Kalendereinladung konnte nicht gesendet werden.',
    bookingDetailsTitle: 'Buchung Details',
    notesShow: 'Notizen anzeigen',
    notesHide: 'Notizen ausblenden',
    cancelBookingTitle: 'Buchung stornieren',
    cancelBookingConfirm: 'Möchten Sie diese Buchung stornieren? Sie wird nicht gelöscht, sondern als inaktiv markiert.',
    cancelBookingSuccess: 'Die Buchung ist storniert (inaktiv).',
    cancelBookingInvalid: 'Ungültiger oder bereits verwendeter Stornierungslink.',
    cancelBookingError: 'Konnte nicht storniert werden.',
    cancelBookingPast: 'Die Buchung ist bereits abgelaufen und kann nicht storniert werden.',
    cancelBookingAlready: 'Die Buchung ist bereits storniert.',
    cancelBookingButton: 'Abbrechen',
    importLockedHint: 'Importierte Buchung ist am Fahrzeug gesperrt, bis sie mit einer Person verknüpft wird. Dann wird es wie eine normale Buchung behandelt.',
    cancelBookingHelp: 'Stornieren markiert die Buchung als inaktiv (nicht gelöscht) und gibt Zeit frei. „Schließen“ schließt das Fenster.',
    keyCabinetAccessActive: 'Zugang zum Schlüsselschrank während des Buchungszeitraums aktiv.',
    noShowReleasePoolOverride: 'No-Show-Freigaben (Pool)',
    noShowReleasePoolOverridePlaceholder: 'Leer = von Organisation übernehmen, 0 = deaktiviert, z. B. 30 = min',
    noShowReleasePoolOverrideHelp: 'Organisationsregel für diesen Pool überschritten. Leer = org verwenden (oberster Knoten). 0 = Die Regel gilt hier nicht. Andere = Anzahl der Minuten nach dem Start.',
    poolBookingRulesHeading: 'Buchungsregeln (Organisation überschreiben)',
    poolOverrideInheritHelp: 'Leer = von der Organisation übernehmen (oberster Knoten). 0 = keine Einschränkung.',
    poolClosuresHeading: 'Schließungsfristen',
    poolClosuresEmpty: 'Keine Schließfristen.',
    closureFrom: 'Geschlossen von',
    closureToOptional: 'Geschlossen bis (optional)',
    closureOpenEnded: 'Bis auf weiteres',
    closureReasonPlaceholder: 'Grund (optional)',
    closureAdd: 'Schließung hinzufügen',
    closureDeleteConfirm: 'Schließungszeitraum entfernen?',
    closureStripped: '{{count}}Zukünftige Buchung(en) wurden in Kollisionsbuchungen verschoben.',
    fallbackSuppliersHeading: 'Lieferanten bei Fahrzeugmangel',
    allowExternalBookingWhenNoCars: 'Buchung über Lieferanten zulassen, wenn keine Autos verfügbar sind',
    fallbackSuppliersHelp: 'Alle ausgewählten Lieferanten werden benachrichtigt, wenn eine Buchung ohne verfügbares Auto erstellt wird.',
    noSuppliersInOrg: 'Keine Lieferanten in der Organisation.',
    supplierFallbackPrompt: 'Kein Auto verfügbar – Buchung an konfigurierte Lieferanten senden.',
    createSupplierFallbackBooking: 'Buchung über Lieferanten erstellen',
    managedRequestPrompt: 'Kein Auto verfügbar – Anfrage an die Autovermietung senden, die das Auto zuweist.',
    createManagedRequest: 'Anfrage an Autovermietung erstellen',
    requestsRow: 'Anfragen',
    requestShort: 'Anfrage',
    pastBookingNotDeletable: 'Bestandene Buchungen können nicht storniert werden.',
    bookingHistoryLimitHint: 'Sie sehen Buchungen der letzten 3 Monate.',
    vehicleReplacementTitle: 'Fahrzeugtausch',
    replaceWithVehicle: 'Durch Fahrzeug ersetzen',
    replaceVehicle: 'Fahrzeug tauschen',
    takeOutOfService: 'Außer Betrieb nehmen',
    returnToService: 'Wieder in Betrieb nehmen',
    removeFromPool: 'Aus dem Pool entfernen',
    outOfService: 'Außer Betrieb nehmen Service',
    futureBookingsCount: '{{count}} zukünftige/aktuelle Buchung(en) für das Fahrzeug.',
    vehicleReplaceConfirm: 'Fahrzeug ändern und {{count}} Buchung(en) verschieben?',
    vehicleReplaceDone: '{{count}} Buchung(en) auf neues Fahrzeug verschoben.',
    vehicleOutOfServiceConfirm: 'Außer Betrieb markieren und {{count}} Buchung(en) neu zuweisen?',
    vehicleOutOfServiceDone: '{{reassigned}} neu zugewiesen, {{collisions}} in Kollisionsbuchungen.',
    vehicleReturnToServiceDone: 'Fahrzeug ist wieder in Betrieb.',
    vehicleRemoveFromPoolConfirm: 'Fahrzeug entfernen und {{count}} Buchung(en) neu zuweisen?',
    vehicleRemoveFromPoolDone: '{{reassigned}} neu zugewiesen, {{collisions}} in Kollisionsbuchungen.',
    requestsTitle: 'Buchungsanfragen',
    requestsDescription: 'Buchungen, die zum Zeitpunkt der Buchung nicht zugewiesen werden konnten Buchung - Auto zuweisen oder über Lieferanten verwalten.',
    requestsBack: 'Zurück zur Buchung',
    requestsEmpty: 'Im Moment keine Buchungsanfragen.',
    requestsLoadError: 'Buchungsanfragen konnten nicht geladen werden.',
    requestsDetailLoadError: 'Buchung konnte nicht geöffnet werden.',
    requestsColPool: 'Pool',
    requestsColCustomer: 'Gebucht für',
    requestsColOrganization: 'Kunde/Gruppe',
    bookingOrganization: 'Kunde/Gruppe',
    requestsColTime: 'Zeit',
    requestsColCarClass: 'Autogruppe',
    requestsColSuppliers: 'Lieferanten',
    requestsColStatus: 'Status',
    requestsColAction: 'Aktion',
    requestsOpenBooking: 'Buchung öffnen',
    fleetAssignTitle: 'Auto aus Flotte zuordnen',
    fleetAssignHint: 'Der Autovermieter kann diesem Lieferort sein eigenes Auto zuordnen. Der Kunde kann nur seine eigenen Autos hinzufügen.',
    fleetAssignEmpty: 'Zurzeit keine freien Autos in der Flotte.',
    fleetAssignPlaceholder: 'Wählen Sie ein Auto aus der Flotte',
    fleetAssignButton: 'Zuweisen',
    fleetAssignSuccess: 'Das Auto ist zugewiesen.',
    fleetAssignError: 'Das Auto konnte nicht zugewiesen werden.',
    fleetAssignFromRequestHint: 'Oder weisen Sie für diese bestimmte Buchung ein kostenloses Auto aus der Flotte zu.',
    basisTitle: 'Buchungsunterlagen',
    basisBack: 'Zurück zur Buchung',
    basisBackToList: 'Zurück zur Liste',
    basisDescriptionOwn: 'Suchen Sie in Ihren zurückgegebenen Buchungen und Öffnen Sie den Datensatz.',
    basisDescriptionAll: 'Suchen Sie unter zurückgegebenen Buchungen in der Organisation und öffnen Sie den Datensatz.',
    basisSearch: 'Suchen',
    basisSearchPlaceholder: 'Name, Steuernummer, Lieferort...',
    basisEmpty: 'Es wurden keine zurückgegebenen Buchungen gefunden.',
    basisLoadError: 'Buchungsdatensatz konnte nicht geladen werden.',
    basisDetailLoadError: 'Dokument konnte nicht geöffnet werden.',
    basisOpen: 'Dokument öffnen',
    basisColVehicle: 'Fahrzeuge',
    basisColPeriod: 'Zeitraum',
    basisDownloadPdf: 'Drucken / PDF',
    basisPdfError: 'PDF konnte nicht erstellt werden.',
    basisBookedFor: 'Gebucht für',
    basisLoanHint: 'Das Auto wurde vorübergehend aus der Flotte der Autovermietung zugewiesen.',
    basisKpiDistance: 'Kilometerstand',
    basisKpiOdometer: 'Anzeigenstand',
    basisKpiWarnings: 'Warnungen',
    basisKpiCo2: 'CO₂',
    basisSectionTrips: 'Reise',
    basisSectionGeofences: 'Geofences',
    basisSectionWarnings: 'Warnungen',
    basisSectionEnvironment: 'Umgebung',
    basisNoTrips: 'Keine Fahrten während des Zeitraums.',
    poolLinkedTripsEmpty: 'Noch keine Fahrten mit der Buchung verknüpft.',
    poolLinkedTripBusiness: 'Dienstlich',
    poolLinkedTripTrack: 'GPS-Spur',
    basisNoWarnings: 'Keine Warnungen.',
    basisGeofenceCost: 'Kosten',
    basisPassages: 'Passagiere',
    basisFuel: 'Kraftstoff',
    requestsSearchPlaceholder: 'Name suchen, Zweck...',
    requestsCount: 'Buchungen',
    requestsNoResults: 'Keine Buchungsanfragen gefunden',
    requestsBookedBy: 'Gebucht von',
    resourceManagerTitle: 'Der Ressourcenmanager',
    resourceManagerDescription: 'Tagesübersicht pro Fahrzeug – Belegungs- und Buchungsstatus für alle Autos im Pool sehen',
    resourceManagerStatus: 'Status',
    resourceManagerToday: 'Heute',
    resourceManagerNowLine: 'Aktuelle Zeit',
    resourceManagerSearchOrg: 'Organisation suchen...',
    resourceManagerShowAllPools: 'Alle Pools anzeigen',
    oldBookingTitle: 'Alte Buchung',
    oldBookingDescription: 'Tagesübersicht pro Fahrzeug – historische Buchungsdaten (temporäres Modul)',
    oldBookingTemporaryNotice: 'Temporäres Modul mit historischem Export. Wird gelöscht, wenn die Migration abgeschlossen ist.',
    oldBookingDateRange: 'Daten: {{from}} – {{to}}',
    bookingSearchTitle: 'Kundendienst',
    bookingSearchDescription: 'Buchungen verwalten und unterstützen – suchen, anzeigen und ändern (Referenz, Pool, Datum, Fahrer, Fahrzeug, Ressourcentyp).',
    bookingSearchPrompt: 'Filter auswählen und auf Suchen klicken, um Treffer anzuzeigen.',
    bookingSearchReference: 'Referenz (Buchungs-ID)',
    bookingSearchReferencePlaceholder: 'UUID oder Teil der ID',
    bookingSearchAllPools: 'Alle Pools',
    bookingSearchDateFrom: 'Buchung von',
    bookingSearchDateTo: 'Buchung bis',
    timelineSpan: 'Zeitfenster',
    timelineSpan1Day: '1 Tag',
    timelineSpan2Days: '2 Tage',
    timelineSpan14Days: '14 Tage',
    timelineSpan40Days: '40 Tage',
    bookingSearchBookedFor: 'Gebucht für (Fahrer / Anzeigename)',
    bookingSearchBookedForPlaceholder: 'Name oder E-Mail',
    bookingSearchBookedForHelp: 'Sucht im Kundennamen und im Benutzer, der die Buchung erstellt hat.',
    bookingSearchVehicle: 'Ressource (Fahrzeug)',
    bookingSearchVehiclePlaceholder: 'Interne Nummer, Reg.-Nr. oder Zeilentext',
    bookingSearchVehicleHelp: 'Sucht in der internen Nummer und im Text, der zuerst in der Fahrzeugzeile erscheint, zum Beispiel 195 oder EPP03P.',
    bookingSearchResourceTypeAll: 'Alle Ressourcentypen',
    bookingSearchResourceTypeHint: 'Der Ressourcentyp wird pro Fahrzeug im Pool (Lieferort) gesteuert. Leerer Typ = wird als Auto mit Filter „Auto“ gezählt. Für Fahrräder usw. muss der Ressourcentyp auf dem Poolfahrzeug festgelegt werden.',
    bookingSearchStatusAll: 'Alle Status',
    bookingSearchStatusNotReturnedHint: 'Nur ausgecheckte Buchungen, deren Rückgabezeit verstrichen ist. Zukünftige Buchungen, die nicht abgeholt wurden, werden nicht angezeigt.',
    bookingSearchRun: 'Suchen',
    bookingSearchResults: 'Suchergebnisse',
    bookingSearchNoHits: 'Keine Buchungen stimmten mit den Filtern überein.',
    bookingSearchLoadError: 'Suchergebnisse konnten nicht aktualisiert werden. Vorherige Liste wird angezeigt.',
    bookingSearchColReference: 'Referenz',
    bookingSearchColPickupLocation: 'Lieferort',
    bookingSearchColBookingFrom: 'Buchung von',
    bookingSearchColBookingTo: 'Buchung bis',
    bookingSearchColResource: 'Ressource',
    bookingSearchColTripCount: 'Anzahl der Fahrten',
    bookingSearchColBookedBy: 'Gebucht von',
    viewList: 'Liste',
    viewTimeline: 'Zeitleiste',
    timelineDragHint: 'Ziehen Sie eine Buchung, um sie zu verschieben, ziehen Sie am rechten Rand, um die Endzeit zu ändern, oder ziehen Sie in einen leeren Bereich, um eine neue Buchung zu erstellen.',
    timelineResizeHint: 'Ziehen, um die Endzeit zu ändern',
    timelineMoveFailed: 'Die Buchung konnte nicht verschoben werden.',
    timelineMoveConfirmTitle: 'Verschieben durch Buchung bestätigen',
    timelineMoveConfirmQuestion: 'Möchten Sie die Buchung verschieben? Bestätigen Sie, um die Änderung zu speichern.',
    timelineMoveFrom: 'Von',
    timelineMoveTo: 'Bis',
    timelineMoveNewTime: 'Neue Zeit',
    timelineMoveNewVehicle: 'Neufahrzeug',
    timelineMoveConfirmButton: 'Umzug bestätigen',
    timelineParticipants: 'Teilnehmer',
    userConflictWarningTitle: 'Der Benutzer hat in dieser Zeit bereits eine Buchung:',
    editBooking: 'Buchung ändern',
    editButton: 'Bearbeiten',
    editBookingTitle: 'Buchung ändern',
    editBookingSelfSubtitle: 'Ändern Sie Ihre Buchung – Zeit, Zweck und Teilnehmer. Mit der Autorisierung können Sie den Abgabeort und das verfügbare Auto vor dem Start ändern.',
    editBookingStaffSubtitle: 'Ändern Sie die Buchung – Zeit, Abgabeort, Fahrzeug, Zweck und Teilnehmer.',
    extendConflictTitle: 'Die Zeit steht in Konflikt mit der nächsten Buchung für dasselbe Auto.',
    extendConflictMax: 'Sie können bis {{time}} verlängern.',
    extendConflictUseMax: 'Diese Zeit nutzen',
    extendConflictContactCs: 'Wenn Sie mehr Zeit benötigen, müssen Sie sich an den Kunden wenden Service.',
    deleteBooking: 'Buchung löschen',
    deleteBookingConfirm: 'Möchten Sie die Buchung löschen? Es ist deaktiviert, aber nicht entfernt.',
    deleteBookingSuccess: 'Buchung deaktiviert',
    deleteBookingError: 'Buchung konnte nicht gelöscht werden',
    startTooFarInPast: 'Die Startzeit darf nicht mehr als 5 Minuten vor dem jetzigen Zeitpunkt liegen.',
    assignedVehicleLocked: 'Zugewiesenes Fahrzeug (kann bei Verlängerung nicht geändert werden)',
    bookedForRequired: 'Wählen Sie, wer das Auto haben soll',
    editBookingLoadError: 'Buchung konnte nicht zur Bearbeitung geöffnet werden',
    startLockedHint: 'Buchung hat bereits begonnen – Startzeit kann nicht geändert werden.',
    editBookingStartAt: 'Buchung von',
    editBookingEndAt: 'Buchung bis',
    editBookingCustomerName: 'Kundenname',
    editBookingNotes: 'Kommentar',
    editBookingSaveSuccess: 'Die Buchung wurde aktualisiert',
    editBookingSaveError: 'Die Buchung konnte nicht aktualisiert werden',
    expiredEndOnlyHint: 'Die Buchungszeit ist abgelaufen. Nur die Endzeit kann verschoben werden, und die neue Zeit muss in der Zukunft liegen und frei sein.',
    expiredEndMustBeFuture: 'Neue Endzeit muss in der Zukunft liegen',
    expiredEndNoAccess: 'Vergangene Buchungen können mit Ihrer Rolle nicht bearbeitet werden',
    editBookingInvalidRange: 'Die Endzeit muss nach der Startzeit liegen',
    editBookingPersonSearch: 'Person suchen (Name, E-Mail oder RSID)…',
    editBookingNoMatches: 'Keine Treffer',
    editBookingFreeTextHint: 'Wählen Sie eine Person aus der Liste aus oder geben Sie einen freien Namen ein.',
    editBookingMembers: 'Weitere Teilnehmer',
    editBookingAddMember: 'Teilnehmer hinzufügen (Name, E-Mail oder RSID)…',
    editBookingMembersHint: 'Fügen Sie maximal 4 zusätzliche Personen hinzu. Durchgekreuzter „Schlüssel“ ermöglicht die Abholung/Rückgabe. Dieselbe Person kann nicht mehr als einmal hinzugefügt werden.',
    editBookingGroupBadge: 'Gruppenbuchung',
    newBookingButton: 'Neue Buchung erstellen',
    newBookingSelectPoolFirst: 'Wählen Sie zuerst einen Pool aus, um eine neue Buchung zu erstellen.',
    guideButton: 'Anleitung',
    guideMenuTitle: 'Anleitung starten',
    guideSearch: 'Suchen und Filtern',
    guideList: 'Listenansicht',
    guideTimeline: 'Zeitleiste',
    blockButton: 'Sperren',
    blockButtonHint: 'Fahrzeug sperren und Anspruch erstellen',
    blockNoVehicle: 'Der Buchung ist kein zu sperrendes Fahrzeug zugeordnet',
    blockTitle: 'Fahrzeug sperren',
    blockVehicleLabel: 'Fahrzeuge',
    blockDamageType: 'Schadensart',
    blockDamageType_collision: 'Zusammenstoß',
    blockDamageType_theft: 'Diebstahl',
    blockDamageType_fire: 'Feuer',
    blockDamageType_vandalism: 'Vandalismus',
    blockDamageType_other: 'Andere',
    blockDamageTypeRequired: 'Schadensart auswählen',
    blockDescription: 'Beschreibung',
    blockLocation: 'Ort (optional)',
    blockDuration: 'Blockieren Sie die Ressource für',
    blockHours_12: '12 Stunden',
    blockHours_24: '24 Stunden',
    blockHours_120: '120 Stunden',
    blockUntilPreview: 'Die Sperrung gilt für',
    blockConfirm: 'Sperren',
    blockSaveSuccess: 'Das Fahrzeug wurde gesperrt. Umgebucht auf verfügbares Auto: {{reassigned}}. Warten auf Bearbeitung: {{collisions}}',
    blockSaveSuccessReassigned: 'Das Fahrzeug wurde blockiert. {{reassigned}} Reservierung(en) wurden auf verfügbares Auto verschoben. Die Autos anderer Buchungen wurden nicht berührt.',
    blockSaveSuccessWaiting: 'Das Fahrzeug wurde blockiert. Kein verfügbares Auto – {{collisions}} Reservierung(en) warten auf Bearbeitung.',
    blockSaveSuccessNone: 'Das Fahrzeug wurde blockiert.',
    blockSaveSuccessEnded: 'Die Reservierung wurde beendet, da das Fahrzeug nicht betriebsbereit ist. Die Endzeit wurde auf jetzt eingestellt.',
    blockSaveError: 'Das Fahrzeug konnte nicht blockiert werden',
    blockedListButton: 'Blockierte Autos',
    blockedListButtonHint: 'Blockierte Fahrzeuge des Kunden anzeigen',
    collisionListButtonHint: 'Buchungen ohne Fahrzeug anzeigen, die heute oder später starten',
    blockedListTitle: 'Blockierte Fahrzeuge',
    blockedListEmpty: 'Keine aktiven Sperren',
    blockedListLoadError: 'Blockierte Fahrzeuge konnten nicht abgeholt werden',
    blockedListVehicle: 'Fahrzeuge',
    blockedListStart: 'Start',
    blockedListEnd: 'Stopp',
    blockedListDamage: 'Schadensbericht',
    blockedListDamageLink: 'Schadensbericht #{{id}}',
    blockedListDamageInline: 'Schadensbericht #{{id}}',
    blockedListNoDamage: 'Keine Schadensmeldung',
    blockedListRelease: 'Freigeben',
    blockedListReleaseConfirm: 'Die Sperre aufheben, damit das Fahrzeug erneut gebucht werden kann?',
    blockedListReleased: 'Die Sperre freigegeben',
    blockedListReleaseError: 'Block konnte nicht freigegeben werden',
    blockedListUpdated: 'Block aktualisiert',
    blockedListUpdateError: 'Block konnte nicht aktualisiert werden',
    fuelPinTooltipTitle: 'Tankkarte (PIN)',
    fuelPinLoading: 'Tankkarte abrufen…',
    fuelPinNone: 'Keine Tankkarte',
    fuelPinError: 'Tankkarte konnte nicht heruntergeladen werden',
    fuelPinNoPin: '(keine PIN)',
    fuelCardsTitle: 'Tankkarten',
    optimizationTitle: 'Buchungsoptimierung',
    optimizationDescription: 'Heute Belegung pro Pool einsehen und Fahrzeugauslastung mit KI optimieren.',
    optimizationDate: 'Datum',
    optimizationAllPools: 'Alle Pools',
    optimizationCurrentTitle: 'Aktueller Status',
    optimizationProposedTitle: 'So funktioniert es',
    optimizationKpiBookings: 'Buchungen',
    optimizationKpiUsedVehicles: 'Genutzte Autos',
    optimizationKpiTotalVehicles: 'Gesamtanzahl der Autos',
    optimizationKpiUtilization: 'Auslastung',
    optimizationRun: 'Optimieren',
    optimizationRunning: 'Optimieren…',
    optimizationResultTitle: 'Ergebnisse (vorher/nachher)',
    optimizationBefore: 'Vorher',
    optimizationAfter: 'Nachher',
    optimizationFreedVehicles: 'Freigegebene Autos',
    optimizationSuggestions: 'Vorschläge',
    optimizationNoSuggestions: 'Keine Verbesserungsvorschläge für den ausgewählten Tag.',
    optimizationSuggestionMove: '{{booking}}: {{from}} → {{to}}',
    optimizationNoData: 'Keine Buchungen für den ausgewählten Tag.',
    optimizationAiUnavailable: 'Der AI-Dienst ist derzeit nicht verfügbar. Der aktuelle Status wird immer noch angezeigt – versuchen Sie es später erneut mit der Optimierung.',
    optimizationError: 'Optimierung konnte nicht ausgeführt werden',
    optimizationLoadError: 'Belegung konnte nicht abgerufen werden',
    optimizationApply: 'Optimierung ausführen',
    optimizationApplying: 'Ausführen…',
    optimizationApplyConfirm: 'Dies verschiebt die Buchungen entsprechend dem Vorschlag zur Fahrzeugfreigabe. Möchten Sie fortfahren?',
    optimizationApplied: 'Optimierung abgeschlossen: {{moves}} Buchung(en) verschoben, {{freed}} Fahrzeug freigegeben.',
    optimizationApplyError: 'Optimierung konnte nicht abgeschlossen werden',
    optimizationApplyNeedsPool: 'Wählen Sie oben einen Pool aus, um die Optimierung abschließen zu können.',
    fitTitle: 'Platz für eine Buchung finden',
    fitDescription: 'Geben Sie die gewünschte Zeit und Anforderungen ein. Das System prüft, ob die Buchung berücksichtigt werden kann, indem bestehende Buchungen zwischen den Fahrzeugen des Pools verschoben werden (ohne deren Zeiten zu ändern).',
    fitStart: 'Gewünschter Beginn',
    fitEnd: 'Gewünschtes Ende',
    fitCustomerName: 'Name/Referenz',
    fitCustomerNamePlaceholder: 'Beliebiger Name oder Referenz',
    fitBookedFor: 'Gebucht für (Person)',
    fitSelectPerson: 'Person auswählen',
    fitSelectPersonRequired: 'Wählen Sie eine Person aus, für die die Buchung gilt.',
    fitResourceType: 'Ressourcentyp',
    fitAnyResourceType: 'Beliebiger Ressourcentyp',
    fitAutomaticOnly: 'Nur automatisches Feld',
    fitEquipment: 'Ausrüstungsanforderungen',
    fitCheck: 'Passung prüfen',
    fitChecking: 'Prüfung…',
    fitCheckError: 'Passung konnte nicht überprüft werden',
    fitFeasible: 'Die Buchung passt auf {{vehicle}}.',
    fitInfeasible: 'Die Buchung kann auch mit nicht berücksichtigt werden Umzug.',
    fitNoMoves: 'Es müssen keine bestehenden Buchungen verschoben werden.',
    fitMovesTitle: 'Die folgenden {{count}} Buchung(en) werden verschoben:',
    fitApply: 'Buchung erstellen und verschieben',
    fitApplying: 'Gilt…',
    fitApplyConfirm: 'Dadurch wird die neue Buchung erstellt und bestehende Buchungen auf andere Fahrzeuge verschoben. Möchten Sie fortfahren?',
    fitApplyError: 'Anpassung konnte nicht angewendet werden',
    groupMembers: 'Gruppenmitglieder',
    canCheckoutKey: 'Kann Schlüssel abrufen',
    addMemberPlaceholder: 'Mitglied hinzufügen (Name, E-Mail oder RSID)...',
    maxExtraMembersHint: 'Es können maximal 4 zusätzliche Personen hinzugefügt werden.',
    memberAlreadyAdded: 'Die Person wurde bereits zur Buchung hinzugefügt.',
    groupMemberCount: '{{count}} Personen',
    groupOrganizerRole: 'Verantwortlich · kann jederzeit Schlüssel abrufen',
    groupDriverLicenseConfirmed: 'Mindestens ein Gruppenmitglied verfügt über einen gültigen Führerschein',
    groupFooterStatus: '{{members}}Gruppenmitglieder · {{keys}} mit Schlüsselberechtigung',
    newGroupBookingSubtitle: 'Füllen Sie die Fahrzeugbuchung für mehrere Personen mit einer gemeinsamen Fahrt aus.',
    settingsTitle: 'Buchungseinstellungen',
    settingsDescription: 'Konfigurieren Sie Buchungsformulare, Projekte, Ziele, Kostenstellen, Zwecke und Buchungsbedingungen pro Organisations-Oberknoten.',
    settingsTopNode: 'Organisation (Oberknoten)',
    settingsSaved: 'Einstellungen gespeichert',
    settingsSaveError: 'Einstellungen konnten nicht gespeichert werden',
    tabFormFields: 'Buchungsformular',
    tabQuickGuest: 'Schnellbuchung',
    quickGuestSettingsHelp: 'Standardmäßig wird das Gastkonto 60 Minuten nach Abschluss der Buchung gelöscht. Name, Telefonnummer und E-Mail bleiben bei der Buchung erhalten.',
    quickGuestReuseLabel: 'Gastkonten zur Wiederverwendung aufbewahren',
    quickGuestReuseHint: 'Wenn das Kästchen angekreuzt ist, wird das Konto nicht gelöscht. Dieselbe E-Mail trägt den Namen und die Telefonnummer ein und verwendet das Konto bei der nächsten Schnellbuchung wieder.',
    quickGuestReusedHint: 'Gespeichertes Gastkonto gefunden – es wird wiederverwendet.',
    quickSavedReused: 'Schnellbuchung erstellt, gespeichertes Gastkonto wiederverwendet',
    tabProjectImport: 'Projekt importieren',
    tabDestinations: 'Ziele',
    tabCostCenters: 'Kostenstellen',
    tabCostSettings: 'Buchungskosten',
    costSettings: {
      orgHelp: 'Allgemeine interne Abrechnung pro Ressourcentyp für den Kunden. Gilt für alle Lieferstandorte, wenn für den Standort kein eigener Wert angegeben ist.',
      pickupHeading: 'Buchungskosten (Standort)',
      pickupHelp: 'Leeres Feld = allgemeine Einstellung für den Ressourcentyp erben. Geben Sie den Wert ein, der an dieser Stelle überschrieben werden soll.',
      noResourceTypes: 'Für den Kunden sind keine Ressourcentypen aktiviert. Aktivieren Sie Systemtypen oder erstellen Sie Kundentypen unter Buchungsressourcen.',
      inheritPlaceholder: 'Erben',
      inheritedValue: 'Allgemein',
      legacyCancellationNote: 'Stornierungsregel auf Organisationsebene (Verwaltung) ist separat; Hier wird die Abrechnung pro Ressourcentyp gesteuert.',
      baseCostPerBooking: 'Grundkosten (SEK/Buchung)',
      hourlyCost: 'Gesamtstundenkosten (SEK/Stunde)',
      kmCost: 'Kilometerkosten (SEK/km)',
      cancellationFee: 'Stornierungsdisp. (kr/Buchung)',
      cancellationHours: ' Kann innerhalb von (Stunden) storniert werden',
      maxDailyCost: 'Höchstpreis pro Tag (SEK)',
      monthlyCost30d: 'Monatliche Kosten pro 30 Tage (SEK)',
      billingTimeFrom: 'Stündliche Abrechnung nach Uhr',
      billingTimeTo: 'Stündliche Abrechnung nach Uhr',
      offHoursHourlyCost: 'Stündliche Abrechnung zu anderen Zeiten (SEK/Stunde)',
    },
    tabTerms: 'Buchungsbedingungen',
    tabTripPurposes: 'Zwecke',
    tripPurposesTitle: 'Zwecke',
    tripPurposesDescription: 'Verwalten Sie vordefinierte Zwecke mit der Reise pro Organisations-Oberknoten.',
    purposeSetsService: 'Bereitschaft/Service',
    purposeSetsServiceHelp: 'Markieren Sie Zwecke, die Bereitschaft/Service automatisch setzen, wenn der Zweck gewählt wird.',
    newTripPurposePlaceholder: 'Neuer Zweck der Reise',
    noTripPurposes: 'Es wurden noch keine Zwecke hinzugefügt.',
    costCenterFreeTextPlaceholder: 'Oder schreiben Sie Ihre eigene Kostenstelle',
    formSettingsHelp: 'Die Einstellungen gelten für alle Benutzer unter dem ausgewählten Organisations-Oberknoten.',
    formSettingsField: 'Feld',
    formSettingsVisible: 'Sichtbar',
    formSettingsRequired: 'Obligatorisch',
    formSettingsListOnly: 'Nur Liste',
    formSettingsListOnlyForced: 'Dieses Feld liest immer nur aus der Liste.',
    formSettingsLocked: 'gesperrt',
    projectImportDescription: 'Laden Sie die Vorlage herunter, schließen Sie das Projekt ab und laden Sie die Datei hoch. Vorhandene Projektnummern werden aktualisiert.',
    downloadProjectTemplate: 'Projektvorlage herunterladen',
    importProjects: 'Projekt importieren',
    importProjectsSuccess: 'Import abgeschlossen: {{created}} neu, {{updated}} aktualisiert',
    importProjectsError: 'Import fehlgeschlagen',
    importProjectsResult: 'Erstellt {{created}}, aktualisiert {{updated}}',
    importRowError: 'Zeile {{row}}: {{message}}',
    projectSearchPlaceholder: 'Projekt suchen...',
    projectCode: 'Projnr',
    projectDescription: 'Projektbeschreibung',
    projectAccountString: 'Kontozeichenfolge',
    projectValidFrom: 'Gültig von',
    projectNumber: 'Projekt Anzahl',
    projectPlaceholder: 'Projekt suchen...',
    noProjects: 'Keine Projekte. Aus Vorlage importieren, um loszulegen.',
    downloadTemplateError: 'Vorlage konnte nicht heruntergeladen werden',
    footerRequiredHint: 'Mit * markierte Felder sind Pflichtfelder',
    saveBlockedTitle: 'Kann noch nicht speichern:',
    saveBlockedPolicy: 'Buchungsrichtlinien akzeptieren (Formular nach unten scrollen)',
    saveBlockedTerms: 'Buchungsbedingungen akzeptieren (Formular nach unten scrollen)',
    saveBlockedDriverLicense: 'Bestätigen Sie, dass Sie über einen gültigen Führerschein verfügen',
    saveBlockedNoVehicle: 'Kein Fahrzeug Verfügbar für die ausgewählte Zeit',
    saveBlockedProject: 'Wählen Sie die Projektnummer aus der Liste (klicken Sie nach der Suche auf „Hit“)',
    section: {
      booking: 'Buchung',
      group: 'Gruppenmitglieder',
      vehicle: 'Fahrzeuge',
      resource: 'Ressource',
      trip: 'Reise',
      admin: 'Verwaltung',
    },
    formField: {
      booking_type: 'Typ (Buchung / Gruppenbuchung)',
      booked_for: 'Gebucht von/für',
      start_end: 'Start und Ende',
      recurrence: 'Wiederkehrende Buchung',
      group_members: 'Gruppenmitglieder',
      vehicle: 'Fahrzeuge',
      automatic_transmission_filter: 'Nur Automatikgetriebe',
      equipment_filter: 'Nach Ausrüstung filtern',
      trip_purpose: 'Zweck der Fahrt',
      destination: 'Ziel',
      estimated_km: 'Geschätzte Entfernung',
      passenger_count: 'Anzahl der Passagiere',
      driver_license: 'Führerschein bestätigt',
      service_booking: 'Service / Jour',
      approved_by: 'Genehmigt durch (Bescheinigung)',
      cost_center: 'Kostenstelle',
      project: 'Projekt Anzahl',
      notes: 'Notizen',
      booking_policy: 'Buchungsrichtlinien',
      terms: 'Buchungsbedingungen',
    },
    acceptTerms: 'Ich akzeptiere die Buchungsbedingungen',
    status_BOOKED: 'Gebucht',
    status_CHECKED_OUT: 'Abgerufen',
    status_RETURNED: 'Zurückgegeben',
    owner: 'Eigentümer',
    checkedOut: 'Abgerufen',
    returned: 'Zurückgegeben',
    checkedOutSuccess: 'Die Buchung wurde ausgecheckt',
    returnedSuccess: 'Die Buchung wurde zurückgegeben',
    checkoutError: 'Die Buchung konnte nicht ausgecheckt werden',
    returnError: 'Die Buchung konnte nicht zurückgegeben werden',
    returnOverrideButton: 'Rückgabe ohne Schlüssel zulassen',
    returnOverrideHint: 'Ermöglicht das Beenden der Buchung, auch wenn der Schlüssel/die Karte in der Box fehlt.',
    returnOverrideTitle: 'Rückgabe ohne Schlüssel zulassen',
    returnOverrideDescription: 'Der Benutzer kann die Buchung beenden, auch wenn der Schlüssel/die Karte fehlt oder die Tür nicht verschlossen ist. Geben Sie einen Grund ein (Gas protokollieren).',
    returnOverrideReasonLabel: 'Grund',
    returnOverrideReasonPlaceholder: 'Z. B. Schlüssel verloren, Karte fehlt...',
    returnOverrideConfirm: 'Rückgabe zulassen',
    returnOverrideSuccess: 'Rückgabe ohne Schlüssel für Buchung erlaubt',
    returnOverrideError: 'Rückgabe ohne Schlüssel konnte nicht zugelassen werden',
    returnOffsiteButton: 'Rückgabe an anderem Ort',
    returnOffsiteHint: 'Beenden der Buchung zulassen, auch wenn GPS nicht anzeigt, dass sich das Auto am Abgabeort befindet (verzögertes Signal).',
    returnOffsiteTitle: 'Rückgabe an anderem Ort',
    returnOffsiteDescription: 'Der Benutzer kann die Buchung beenden, auch wenn GPS zeigt an, dass sich das Auto nicht in der Nähe befindet. Geben Sie einen Grund ein (Gas protokollieren).',
    returnOffsiteReasonPlaceholder: 'Z. B. GPS-Verzögerung, das Auto ist am Standort...',
    returnOffsiteConfirm: 'Anderen Standort zulassen',
    returnOffsiteSuccess: 'Rückgabe an einem anderen für die Buchung zulässigen Ort',
    returnOffsiteError: 'Rückgabe an einem anderen Ort konnte nicht zugelassen werden',
    postReturnAccessButton: '15 Minuten Zugang gewähren',
    postReturnAccessHint: 'Dem Kunden erneut 15 Minuten lang Zugang zum Auto gewähren (z. B. vergessenes Gepäck). Nur innerhalb von 60 Minuten nach Rückgabe.',
    postReturnAccessConfirm: 'Dem Kunden erneut 15 Minuten Zugang zum Auto gewähren? Dies funktioniert auch, wenn das Fahrzeug von einer anderen Person gebucht wird.',
    postReturnAccessSuccess: 'Dem Kunden wurden erneut 15 Minuten Zutritt gewährt',
    postReturnAccessError: 'Neuer Zutritt konnte nicht gewährt werden',
    postReturnAccessTooLate: 'Neuer Zutritt kann nur innerhalb von 60 Minuten nach Rückgabe gewährt werden',
    postReturnAccessReturnedHint: 'Die Buchung wurde zurückgegeben. Verwenden Sie „15 Minuten Zugang gewähren“ für vergessenes Gepäck – ändern Sie nicht nur die Endzeit.',
    termsTitle: 'Buchungsbedingungen',
    termsDescription: 'Buchungsbedingungen für Buchungen verwalten',
    addTerms: 'Neue Version',
    noTerms: 'Es wurden noch keine Buchungsbedingungen erstellt.',
    termsVersion: 'Version',
    termsVersionTitle: 'Titel',
    termsContent: 'Inhalt',
    termsVersionPlaceholder: 'Version (z. B. 1.0)',
    termsTitlePlaceholder: 'Titel',
    termsContentPlaceholder: 'Inhalt (HTML oder Text)',
    termsActivate: 'Aktivieren',
    termsDeactivate: 'Deaktivieren',
    termsActive: 'Aktiv',
    vehiclePoolTitle: 'Fahrzeugpark',
    vehiclePoolsTitle: 'Fahrgemeinschaften',
    vehiclePoolDescription: 'Fahrzeuggemeinschaften verwalten mit automatischer Buchung bei Schlüsselentnahme',
    vehiclePoolsDescription: 'Eine Fahrzeuggemeinschaft ist ein separater Lieferort, der nicht gebucht werden kann. Der Spind kann mit buchbaren Plätzen geteilt werden. Buchungen bei der Schlüsselübergabe sind wie gewohnt sichtbar.',
    createPool: 'Pool erstellen',
    addPool: 'Fahrgemeinschaft erstellen',
    noPools: 'Noch keine Fahrgemeinschaften',
    poolName: 'Poolname',
    poolNamePlaceholder: 'Name der Fahrzeuggemeinschaft...',
    pickupLocation: 'Ausgabeort',
    cabinetViaPickupLocation: 'Schließfach über Lieferort',
    cabinetViaPickupLocationHint: 'Wählen Sie den buchbaren Standort aus, dessen Schlüsselschließfach der Pool gemeinsam nutzen soll.',
    poolCabinet: 'Schlüsselschließfach',
    poolCabinetHint: 'Optional. Wählen Sie das Schließfach, das der Pool verwenden soll. Dasselbe Schließfach kann auch an einem buchbaren Standort hängen.',
    poolDefaultPurpose: 'Standardzweck',
    poolDefaultPurposeHint: 'Wird in der Buchung angezeigt, zum Beispiel Hausbesuch. Gilt erst als ausgefüllt, wenn jemand den Zweck speichert.',
    selectCabinetFirst: 'Wählen Sie zuerst ein Schlüsselschließfach.',
    noCabinetsForOrg: 'Dieser Organisation sind keine Schlüsselschließfächer zugeordnet.',
    selectOrgFirstForUsers: 'Wählen Sie zuerst die Organisation aus, um Benutzer anzuzeigen',
    selectKeysHint: 'Nur Fahrzeuge mit Schlüsselhaken, die noch keinem Lieferort zugeordnet sind. Mit Schließfach nur Haken, die gerade im Schließfach sitzen.',
    noCandidateKeys: 'Keine Fahrzeuge oder Haken zum Anzeigen.',
    poolCandidateSearch: 'Fahrzeug, Ressource oder Haken suchen',
    poolUserSearch: 'Name oder E-Mail suchen',
    poolSearchNoHits: 'Nichts entspricht der Suche.',
    tapPlace: '{{id}} · Liste {{list}} · Loch {{hole}}',
    linkTap: 'Verknüpfen',
    linkTapTitle: 'Haken mit Fahrzeug oder Ressource verknüpfen',
    noLinkTargets: 'Keine freien Fahrzeuge oder Ressourcen.',
    maxHoursPerCheckout: 'Max. Stunden pro Ausleihe',
    maxHours: 'Max. Stunden',
    poolMembers: 'Mitglieder',
    members: 'Mitglieder',
    addMember: 'Mitglied hinzufügen',
    removeMember: 'Entfernen',
    selectUser: 'Benutzer auswählen',
    activeCheckouts: 'Aktive Ausleihe',
    noPoolsYet: 'Es wurden noch keine Fahrzeugpools erstellt',
    noMembers: 'Noch keine Mitglieder',
    noMembersYet: 'Keine Mitglieder in diesem Pool',
    memberName: 'Name',
    memberEmail: 'E-Mail',
    pinCode: 'PIN-Code',
    editPool: 'Pool bearbeiten',
    linkedCabinet: 'Verknüpftes Schließfach',
    noCabinet: 'Kein Schließfach verknüpft – in der Schlüsselverwaltung zuweisen',
    selectKeys: 'Welche Schlüssel?',
    selectUsers: 'Benutzer',
    noCabinetAtLocation: 'Kein Schließfach mit diesem Lieferort verknüpft',
    confirmDeletePool: 'Möchten Sie diese Fahrgemeinschaft löschen? Der Schlüsselkorb in KeyWin wird ebenfalls entfernt.',
    cannotDeleteActiveCheckouts: 'Kann nicht gelöscht werden – aktive Kredite vorhanden',
    validFrom: 'Gültig von',
    validTo: 'Gültig bis',
    poolWatchTitle: 'Fehlende Daten',
    poolWatchDescription: 'Sammelabhebungen, bei denen Verwendungszweck oder andere Pflichtfelder nicht ausgefüllt sind.',
    poolWatchEmpty: 'Es warten keine Buchungen auf den Abschluss.',
    poolWatchComplete: 'Abschließen',
    poolWatchCompleteTitle: 'Buchung abschließen',
    poolWatchCompleteHint: 'Geben Sie nach der Schlüsselübergabe den Zweck und die Notizen ein.',
    poolWatchSaved: 'Die Daten werden gespeichert.',
    poolWatchLoadError: 'Die Merkliste konnte nicht abgerufen werden.',
    poolWatchSaveError: 'Die Daten konnten nicht gespeichert werden.',
    poolWatchAll: 'Alle',
    poolWatchSelectAll: 'Alle angezeigten auswählen',
    poolWatchApprove: 'Ausgewählte genehmigen',
    poolWatchApproved: '{count} Buchungen genehmigt.',
    poolWatchNoSelection: 'Mindestens eine Zeile auswählen.',
    poolWatchTrips: 'Fahrten',
    poolWatchAllTrips: 'Alle Fahrten',
    poolWatchShowText: 'Text',
    poolWatchShowMap: 'Karte',
    poolWatchKm: 'Km',
    poolWatchWorkTime: 'Arbeitszeit',
    poolWatchIdle: 'Standzeit',
    needsPurposeFilter: 'Nur fehlende Daten',
    needsPurposeBadge: 'Fehlende Daten',
    quickTitle: 'Schnellbuchung',
    quickDescription: 'Reservieren Sie einen kostenlosen Transporter oder Flinkey Auto für einen Gast. PIN wird als SMS versendet. Zumindest Name, Telefonnummer oder E-Mail-Adresse.',
    quickCabinet: 'Schlüsselschränke',
    quickAccessCabinet: 'Van',
    quickAccessFlinkey: 'FlinkeyBox',
    quickGuestName: 'Gastname',
    quickGuestPhone: 'Mobil',
    quickGuestEmail: 'E-Mail',
    quickSubmit: 'Buchen und senden',
    quickBookOnly: 'Buch',
    quickSmsCost: 'SMS {{price}}',
    quickSaved: 'Die Buchung wird erstellt',
    quickLoadError: 'Verfügbare Autos konnten nicht abgeholt werden.',
    quickSaveError: 'Die Buchung konnte nicht erstellt werden.',
    quickMissingFields: 'Geben Sie Fahrzeug und Schrank ein (wenn es sich um einen Lieferwagen handelt).',
    quickMissingIdentity: 'Geben Sie mindestens Namen, Telefonnummer oder E-Mail-Adresse ein.',
    quickIdentityHint: 'Mindestens einen Namen, Telefon oder E-Mail erforderlich.',
    quickPhoneHint: 'Ländercode, z. B. +47 oder +1',
    quickSaveCustomer: 'Kunden speichern',
    quickPinLabel: 'PIN',
    quickSmsPreview: 'SMS zum Kopieren',
    quickSmsCopy: 'Kopieren',
    quickSmsCopied: 'SMS kopiert',
    quickSmsSent: 'PIN als SMS gesendet.',
    quickSmsFailed: 'Die Buchung wurde erstellt, aber die SMS konnte nicht gesendet werden. PIN für Gast anzeigen.',
    quickTabNew: 'Neue Buchung',
    quickNew: 'Neu',
    quickCloseForm: 'Formular schließen',
    quickCreated: 'Erstellt',
    quickRegistration: 'Regnr',
    quickPeriod: 'Zeitraum',
    quickChannel: 'Wird gesendet',
    quickChannelSms: 'Per SMS gesendet',
    quickChannelEmail: 'Per E-Mail gesendet',
    quickChannelBooked: 'Gerade gebucht',
    quickTabCurrent: 'Aktuell',
    quickTabPrevious: 'Vorherige',
    quickEmptyCurrent: 'Keine aktuellen Schnellbuchungen.',
    quickEmptySent: 'Noch keine Schnellbuchungen.',
    quickEmptyPrevious: 'Keine vorherigen Schnellbuchungen.',
    quickListError: 'Buchungen konnten nicht abgerufen werden.',
    quickCancel: 'Abbrechen',
    quickCancelConfirm: 'Diese Buchung stornieren?',
    quickCancelled: 'Die Buchung wurde storniert.',
    quickCancelError: 'Konnte nicht storniert werden.',
    quickNoCreateAccess: 'Sie haben keine Berechtigung, eine Schnellbuchung zu erstellen.',
    quickNoVehicles: 'Keine offenen Stellen für Lieferwagen oder FlinkeyAutos in ausgewählter Zeit.',
  },
  workOrders: {
    title: 'Arbeitsaufträge',
    pageTitle: 'Arbeitsauftragsverwaltung',
    description: 'Arbeitsaufträge, Lieferungen und Reinigungsaufgaben verwalten',
    create: 'Arbeitsaufträge erstellen',
    edit: 'Bearbeiten',
    delete: 'Entfernen',
    deleteConfirm: 'Arbeitsauftrag löschen? Dies kann nicht rückgängig gemacht werden.',
    deleteBlocked: 'Gestarteter Arbeitsauftrag kann nicht gelöscht werden.',
    deleteError: 'Arbeitsauftrag konnte nicht gelöscht werden.',
    assign: 'Zuweisen',
    unassign: 'Zuweisung abbrechen',
    start: 'Starten',
    complete: 'Ziel',
    cancel: 'Abbrechen',
    optimize: 'Route optimieren',
    types: {
      SERVICE: 'Serviceauftrag',
      DELIVERY: 'Lieferung',
      HOMECARE: 'Heimservice',
      INSPECTION: 'Inspektion',
      INSTALLATION: 'Installation',
    },
    status: {
      DRAFT: 'Entwurf',
      PENDING: 'Warten',
      ASSIGNED: 'Zugewiesen',
      OPTIMIZED: 'Optimiert',
      IN_PROGRESS: 'In Bearbeitung',
      ARRIVED: 'Weiter',
      PAUSED: 'Pause',
      COMPLETED: 'Abgeschlossen',
      CANCELLED: 'Abgebrochen',
      FAILED: 'Fehlgeschlagen',
    },
    priority: {
      LOW: 'Niedrig',
      NORMAL: 'Normal',
      HIGH: 'Hoch',
      URGENT: 'Dringend',
    },
    colType: 'Typ',
    colStatus: 'Status',
    colStops: 'Stopp',
    allStatuses: 'Alle Status',
    allTypes: 'Alle Typen',
    searchPlaceholder: 'Bestellnummer, Titel, Kunde suchen...',
    orderNumber: 'Bestellnummer',
    customer: 'Kunde',
    customerName: 'Kundenname',
    customerPhone: 'Telefon',
    customerEmail: 'E-Mail',
    jobTitle: 'Titel',
    jobDescription: 'Beschreibung',
    notes: 'Notizen',
    plannedDate: 'Geplantes Datum',
    timeWindow: 'Zeitfenster',
    estimatedDuration: 'Geschätzte Zeit',
    assignedVehicle: 'Zugewiesenes Fahrzeug',
    assignedDriver: 'Zugeordneter Fahrer',
    stops: 'Stopp',
    addStop: 'Halt hinzufügen',
    stopAddress: 'Adresse',
    stopContact: 'Ansprechpartner',
    stopTimeWindow: 'Zeitfenster',
    stopDuration: 'Geschätzte Zeit',
    routes: 'Routen',
    route: 'Route',
    routeDate: 'Datum',
    routeVehicle: 'Fahrzeuge',
    routeDriver: 'Fahrer',
    routeStatus: 'Status',
    routeDistance: 'Entfernung',
    routeDuration: 'Zeit',
    optimizeRoute: 'Route optimieren',
    routeOptimized: 'Route optimiert',
    routeNotOptimized: 'Keine Route optimiert',
    optimization: {
      title: 'Routenoptimierung',
      optimize: 'Optimieren',
      optimizing: 'Optimierung...',
      freedTime: 'Freigegebene Zeit',
      reducedDistance: 'Reduzierte Distanz',
      newOrder: 'Neuer Auftrag',
      originalOrder: 'Ursprünglicher Auftrag',
      vroomAvailable: 'VROOM verfügbar',
      vroomUnavailable: 'VROOM nicht verfügbar',
    },
    stats: {
      total: 'Gesamt',
      today: 'Heute',
      completed: 'Abgeschlossen',
      pending: 'Warten',
      overdue: 'Verzögert',
      avgTime: 'Durchschnittliche Zeit',
    },
    noOrders: 'Keine Arbeitsaufträge gefunden',
    selectVehicle: 'Fahrzeug auswählen',
    selectDriver: 'Fahrer auswählen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Arbeit löschen möchten? Auftrag?',
    deleteSuccess: 'Arbeitsauftrag gelöscht',
    createSuccess: 'Arbeitsauftrag erstellt',
    updateSuccess: 'Arbeitsauftrag aktualisiert',
    assignSuccess: 'Arbeitsauftrag zugewiesen',
    completeSuccess: 'Arbeitsauftrag abgeschlossen',
    cancelSuccess: 'Arbeitsauftrag storniert',
    optimizeSuccess: 'Route optimiert',
    delivery: {
      title: 'Paketzustellung',
      subtitle: 'Arbeitsauftrag für Pakete und Lieferungen',
      recipient: 'Empfänger',
      address: 'Adresse',
      stop: 'Stopp',
      searchPlaceholder: 'Auftragsnummer, Empfänger, Adresse suchen...',
      newDelivery: 'Neue Lieferung',
      noDeliveries: 'Keine Lieferungen gefunden',
    },
    craftsman: {
      title: 'Handwerker',
      subtitle: 'Arbeitsauftrag für Handwerker und Service',
      customer: 'Kunde',
      address: 'Adresse',
      time: 'Zeit',
      searchPlaceholder: 'Auftragsnummer, Kunde, Adresse suchen...',
      newWorkOrder: 'Neuer Arbeitsauftrag',
      noWorkOrders: 'Keine Arbeitsaufträge gefunden',
      assigned: 'Zugewiesen',
      unassigned: 'Nicht zugewiesen',
      assignPlaceholder: 'Person suchen...',
      assignSuccess: 'Arbeitsauftrag zugewiesen',
      assignError: 'Konnte nicht zugewiesen werden',
      edit: 'Bearbeiten',
      detail: 'Details / Ausführung',
      viewList: 'Liste',
      viewGantt: 'Gantt',
      viewCalendar: 'Kalender',
      ordersShort: 'Bestellungen',
    },
    form: {
      newTitle: 'Neuer Arbeitsauftrag',
      editTitle: 'Arbeitsauftrag bearbeiten',
      title: 'Titel',
      titleRequired: 'Titel erforderlich',
      organization: 'Organisation',
      orgRequired: 'Organisation auswählen',
      serviceType: 'Servicetyp',
      serviceTypeRequired: 'Wählen Sie einen Servicetyp aus oder fügen Sie ihn hinzu',
      serviceTypeEmpty: 'Noch keine Typen – wählen Sie „Hinzufügen…“',
      serviceTypeAdd: 'Hinzufügen…',
      serviceTypeSelectOrgFirst: 'Zuerst Organisation auswählen',
      serviceTypeNamePlaceholder: 'Name des Diensttyps',
      serviceTypeNameRequired: 'Namen des Servicetyps eingeben',
      serviceTypeCreateError: 'Servicetyp konnte nicht erstellt werden',
      customerName: 'Kundenname',
      customerPhone: 'Telefon',
      address: 'Adresse',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      plannedDate: 'Geplantes Datum',
      timeWindowStart: 'Zeitfenster von',
      timeWindowEnd: 'Zeitfenster bis',
      description: 'Beschreibung',
    },
    detail: {
      assignment: 'Auftrag',
      person: 'Person',
      vehicleOptional: 'Fahrzeug (optional)',
      noVehicle: 'Kein Fahrzeug',
      assign: 'Zuweisen',
      gpsHint: 'Bei zugewiesenem Fahrzeug werden Fahrzeit und Kilometer automatisch aus dem Fahrzeug erfasst GPS. Ohne Fahrzeug wird die Zeit manuell in der App gestempelt.',
      start: 'Starten',
      pause: 'Pause',
      resume: 'Lebenslauf',
      complete: 'Ziel',
      accounting: 'Buchhaltung',
      actualStart: 'Ist-Start',
      actualEnd: 'Tatsächliches Ende',
      timeline: 'Start und Ende',
      historyStarted: 'Gestartet',
      historyPaused: 'Pause',
      historyResumed: 'Lebenslauf',
      historyCompleted: 'Abgeschlossen',
      totalTime: 'Gesamtzeit',
      travelTime: 'Fahrzeit',
      workTime: 'Arbeitszeit',
      distance: 'Entfernung',
      manualTime: 'Manuelle Zeiteingabe',
      segmentType: 'Typ',
      minutes: 'Minuten',
      segments: 'Zeitabschnitte',
      completionNotes: 'Endkommentare',
    },
    import: {
      title: 'Importieren',
      selectFile: 'Datei auswählen (Excel/CSV)',
      dropHint: 'Klicken Sie, um eine auszuwählen Excel- oder CSV-Datei',
      emptyFile: 'Die Datei enthält keine Zeilen',
      parseError: 'Die Datei konnte nicht gelesen werden',
      mapping: 'Spaltenzuordnung',
      rows: 'Zeilen',
      row: 'Zeile',
      ignore: 'Ignorieren',
      import: 'Importieren',
      importing: 'Importieren...',
      created: 'Erstellt',
      failed: 'Fehlgeschlagen',
      titleMappingRequired: 'Spalte für Titel zuordnen',
      field: {
        title: 'Titel',
        customerName: 'Kundenname',
        customerPhone: 'Telefon',
        customerEmail: 'E-Mail',
        address: 'Adresse',
        postalCode: 'Postleitzahl',
        city: 'Stadt',
        plannedDate: 'Geplantes Datum',
        timeWindowStart: 'Zeit von',
        timeWindowEnd: 'Zeit bis',
        estimatedDurationMinutes: 'Geschätzte Zeit (Min.)',
        notes: 'Hinweis',
      },
    },
  },
  serviceAgreements: {
    title: 'Serviceverpflichtung',
    subtitle: 'Wiederkehrende Serviceaufgabe mit Intervall',
    new: 'Neue Serviceverpflichtung',
    newTitle: 'Neue Serviceverpflichtung',
    editTitle: 'Service bearbeiten Verpflichtung',
    empty: 'Keine Serviceverpflichtung',
    titleField: 'Titel',
    titlePlaceholder: 'zB. Abluftpumpe prüfen',
    customerSection: 'Kunden- und Serviceadresse',
    serviceAddress: 'Serviceadresse',
    billingSection: 'Rechnungsadresse',
    billingName: 'Rechnungsname',
    billingAddress: 'Rechnungsadresse',
    billingReference: 'Rechnungsreferenz',
    scheduleSection: 'Zeitplan und Preis',
    intervalMonths: 'Intervall (Monate)',
    monthsShort: 'Monat',
    nextDueDate: 'Nächstes Fälligkeitsdatum',
    pricingType: 'Preise',
    hourly: 'Stundensatz',
    fixed: 'Fester Satz',
    estimatedMinutes: 'Geschätzte Zeit (Min.)',
    estimatedHours: 'Berechnete Zeit (Stunden)',
    estimatedHoursHint: 'Wie lange der Auftrag voraussichtlich dauern wird, z. B. 1,5',
    hourlyRate: 'Stundenpreis (SEK/Stunde)',
    fixedPrice: 'Fester Preis (SEK)',
    dueWidgetTitle: 'Fällig innerhalb von 30 Tagen',
    noneDue: 'Keine Verpflichtungen, fällig innerhalb von 30 Tagen',
    dueInDays: 'Fällig in {{days}} Tagen',
    overdueBy: 'Verzögerte {{days}} Tage',
    assign: 'Person zuweisen',
    assignTitle: 'Arbeitsauftrag zuweisen und erstellen',
    createWorkOrder: 'Arbeitsaufträge erstellen',
    personRequired: 'Wählen Sie einen aus Person',
    confirmDelete: 'Möchten Sie diese Serviceverpflichtung entfernen?',
  },
  homecare: {
    title: 'Heimservice',
    subtitle: 'Routenplanung und Terminplanung für die häusliche Pflege',
    date: 'Datum',
    tabs: {
      planning: 'Planung',
      gantt: 'Gantt-Diagramm',
      map: 'Karte',
      roster: 'Dienstplan',
      clients: 'Benutzer',
      staff: 'Personal',
    },
    planning: {
      visits: 'Besuche',
      requiresMultiStaff: 'erfordert 2+ Mitarbeiter',
      teams: 'Team',
      pairTeams: 'Paarteam',
      soloTeams: 'Einzelteam',
      pairTeam: 'Paarteam',
      vehicles: 'Fahrzeuge',
      vehicleShortage: 'fehlt',
      vehiclesOk: 'Ausreichend',
      distance: 'Kilometerstand',
      suggestTeams: 'Vorschlag Teams',
      optimizeRoutes: 'Routen optimieren',
      suggestedTeams: 'Vorgeschlagene Teams',
      optimizationResult: 'Optimierungsergebnisse',
      unassignedVisits: 'Nicht zugewiesene Besuche',
      teamError: 'Teams konnten nicht vorgeschlagen werden',
      optimizeError: 'Routen konnten nicht optimiert werden',
      timeWindow: 'Zeitfenster',
      duration: 'Zeit',
      staff: 'Personal',
      priority: 'Priorität',
      strategy: 'Strategie',
      strategyBalanced: 'Ausgewogen',
      strategyBalancedDesc: 'Optimiert mit den Qualifikationsanforderungen. Einige Besuche werden möglicherweise nicht zugewiesen.',
      strategyCoverAll: 'Alle Besuche abdecken',
      strategyCoverAllDesc: 'Alle Besuche werden unabhängig von der Kompetenz zugewiesen. Warnungen werden angezeigt.',
      strategyCalculateExtra: 'Ressourcenbedarf berechnen',
      strategyCalculateExtraDesc: 'Zeigt an, wie viele zusätzliche Teams für eine vollständige Abdeckung erforderlich sind.',
      optimizationRuns: 'Optimierungsverlauf',
      noRuns: 'Keine gespeicherten Optimierungen',
      selectRun: 'Diesen Plan auswählen',
      deleteRun: 'Entfernen',
      selectedRun: 'Aktiv',
      archivedRun: 'Archiviert',
      draftRun: 'Entwurf',
      runStrategy: 'Strategie',
      runCreated: 'Erstellt',
      extraTeamsNeeded: 'Zusätzliches Team erforderlich',
      competenceWarnings: 'Fertigkeitswarnungen',
      competenceWarningDetail: 'fehlende Fertigkeit',
      missingCompetences: 'Fehlende Fertigkeit',
      reassignVisit: 'Verschieben nach',
      reassignSuccess: 'Besuch verschoben',
      reassignError: 'Besuch konnte nicht verschoben werden',
      reoptimize: 'Neu optimieren',
      manualChanges: 'Manuelle Änderungen vorgenommen',
    },
    vehicleSource: 'Fahrzeuge abrufen von',
    selectVehicleSource: 'Fahrzeugorganisation auswählen',
    gantt: {
      team: 'Team',
      summary: 'Zusammenfassung',
      noData: 'Kein Gantt-Diagramm verfügbar',
      noDataHint: 'Optimierung zuerst im Planungs-Tab ausführen',
      travel: 'Transport',
      visit: 'Bei Benutzern',
      break: 'Ruhe',
      unplanned: 'Nicht geplant',
      totalTeams: 'Team',
      totalVisits: 'Besuche',
      totalTravel: 'Kilometerstand',
      visitsLabel: 'Besuch',
      planned: 'geplante Zeit',
    },
    roster: {
      staff: 'Personal',
      week: 'Woche',
      copyWeek: 'Auf nächste Woche kopieren',
      weekCopied: 'Der Zeitplan dieser Woche wurde kopiert',
      confirmCopyWeek: 'Möchten Sie den Zeitplan für die nächste Woche kopieren? Vorhandene Einträge für die nächste Woche sind nicht betroffen.',
      nothingToCopy: 'Nichts zu kopieren – der Zeitplan dieser Woche ist leer oder die nächste Woche enthält bereits dieselben Einträge.',
      copyFailed: 'Zeitplan konnte nicht kopiert werden',
    },
    clients: {
      searchPlaceholder: 'Benutzer suchen...',
      add: 'Neuer Benutzer',
      newClient: 'Neuer Benutzer',
      editClient: 'Benutzer bearbeiten',
      name: 'Name',
      firstName: 'Vorname',
      lastName: 'Nachname',
      personalNumber: 'Sozialversicherungsnummer',
      address: 'Adresse',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      phone: 'Telefon',
      doorCode: 'Portcode',
      floor: 'Etage',
      specialInstructions: 'Speziell Anleitung',
      emergencyContact: 'Ansprechpartner',
      emergencyPhone: 'Kontakttelefon',
      competences: 'Kompetenzanforderungen',
      noClients: 'Keine Benutzer gefunden',
      saved: 'Benutzer gespeichert',
      coordinates: 'Koordinaten',
      allocatedHours: 'Erlaubte Pflegezeit',
      hoursPerWeek: 'Stunden/Woche',
    },
    careNeeds: {
      title: 'Pflegebedarf',
      add: 'Pflegebedarf hinzufügen',
      edit: 'Pflegebedarf bearbeiten',
      name: 'Name',
      duration: 'Dauer (Min.)',
      timeWindowStart: 'Zeitfensterbeginn',
      timeWindowEnd: 'Zeitfensterende',
      frequency: 'Häufigkeit',
      weekdays: 'Wochentage',
      requiredStaff: 'Anzahl der Mitarbeiter',
      priority: 'Priorität',
      description: 'Beschreibung',
      competences: 'Kompetenzanforderungen',
      mandatory: 'Obligatorisch',
      noNeeds: 'Kein Pflegebedarf hinzugefügt',
      saved: 'Pflegebedarf gespeichert',
      deleted: 'Pflegebedarf entfernt',
      confirmDelete: 'Möchten Sie diesen Pflegebedarf entfernen?',
      generateVisits: 'Besuche generieren',
      generateVisitsDesc: 'Besuche aus Pflegebedarf für einen Zeitraum erstellen',
      fromDate: 'Von-Datum',
      toDate: 'Bis-Datum',
      generated: 'Besuche generiert',
      noVisitsGenerated: 'Keine neuen Besuche zu generieren',
      frequencies: {
        DAILY: 'Täglich',
        WEEKDAYS: 'Wochentage',
        WEEKLY: 'Wöchentlich',
        BIWEEKLY: 'Alle zwei Wochen',
        MONTHLY: 'Monatlich',
        CUSTOM: 'Benutzerdefiniert',
      },
      priorities: {
        LOW: 'Niedrig',
        NORMAL: 'Normal',
        HIGH: 'Hoch',
        URGENT: 'Dringend',
      },
      weekdayNames: {
        '1': 'Mo',
        '2': 'Di',
        '3': 'Mi',
        '4': 'Do',
        '5': 'Fr',
        '6': 'Sa',
        '7': 'Sonn',
      },
    },
    staff: {
      searchPlaceholder: 'Suchen Sie nach Personal...',
      startsFromHome: 'Startet von zu Hause',
      startsFromOffice: 'Startet vom Büro',
      startType: 'Startposition',
      homeAddress: 'Heimatadresse',
      homeLat: 'Breitengrad (Heimat)',
      homeLng: 'Längengrad (Heimat)',
      shiftStart: 'Arbeitsschichtbeginn',
      shiftEnd: 'Arbeitsschichtende',
      workHours: 'Arbeitszeit',
      competences: 'Fähigkeiten',
      editStaff: 'Personal bearbeiten',
      noCompetences: 'Keine Fähigkeiten',
      noStaff: 'Keine Mitarbeiter gefunden',
      saved: 'Personal gespart',
    },
  },
  charging: {
    title: 'Laden',
    description: 'Abrechnung von Ladevorgängen für Elektrofahrzeuge (kWh) und Standort',
    tab: 'Laden',
    month: 'Monat',
    organization: 'Organisation',
    allOrganizations: 'Alle Organisationen',
    selectVehicle: 'Fahrzeuge',
    vehiclePlaceholder: 'Alle Fahrzeuge – suchen oder auswählen...',
    export: 'Export',
    estimateNote: 'kWh wird basierend auf dem Ladezustand der Batterie (SoC) geschätzt, nicht auf einem gemessenen Wandwert. Für eine genaue Steuerbasis ist die Messung der Ladebox erforderlich.',
    loadError: 'Ladesitzungen konnten nicht heruntergeladen werden',
    exportError: 'Ladesitzungen konnten nicht exportiert werden',
    noData: 'Keine Ladesitzungen für den Zeitraum',
    location: {
      label: 'Standort',
      all: 'Alle Standorte',
      home: 'Zuhause',
      work: 'Job',
      public: 'Öffentlich',
      unknown: 'Unbekannt',
    },
    summary: {
      homeKwh: 'Aufladung zu Hause (kWh)',
      totalKwh: 'Gesamtladung (kWh)',
      sessions: 'Anzahl der Sitzungen',
    },
    table: {
      vehicle: 'Fahrzeuge',
      start: 'Start',
      end: 'Ende',
      soc: 'Ladezustand',
      wallKwh: 'kWh (Wand)',
      location: 'Standort',
    },
    config: {
      description: 'Konfigurieren Sie Batteriekapazität, Ladeverlust sowie Zuhause und Arbeitsplatz für genaue Ladeberichte. Wenn der Wert in Car.info fehlt, können Sie kWh manuell eingeben – Car.info überschreibt, wenn die Informationen verfügbar sind.',
      batteryCapacity: 'Batteriekapazität (kWh)',
      batteryFromCarInfo: 'Verwenden Sie den angezeigten Wert von Car.info: {{value}} kWh',
      batterySourceManual: 'Quelle: manuell eingegeben (überschrieben, wenn Car.info kWh empfängt)',
      batterySourceCarInfo: 'Quelle: Car.info',
      efficiency: 'Ladeverlust (Batterie/Wand, 0–1)',
      homeLatitude: 'Breitengrad des Heimladestandorts',
      homeLongitude: 'Längengrad des Heimladestandorts',
      homeRadius: 'Radius des Heimladestandorts (m)',
      homeLocation: 'Heimladestandort',
      workLocation: 'Arbeitsort',
      pickOnMap: 'Auf der Karte auswählen',
      changeOnMap: 'Auf der Karte ändern',
      clear: 'Löschen',
      address: 'Adresse',
      addressPlaceholder: 'Klicken Sie auf die Karte, um die Adresse zu erhalten',
      radius: 'Radius',
      pickerHelp: 'Suchen Sie nach einer Adresse oder klicken Sie auf die Karte/ziehen Sie den Cursor, um den Ort auszuwählen. Die Adresse wird automatisch abgerufen.',
      pickerNoPoint: 'Kein Standort ausgewählt',
      searchPlaceholder: 'Adresse oder Standort suchen…',
      publicNote: 'Laden außerhalb von Zuhause und am Arbeitsplatz wird automatisch als öffentlich klassifiziert.',
    },
  },
  fuelCards: {
    title: 'Tankkarten',
    description: 'Register der Tankkarte, OKQ8-Nummer und Fahrzeugverbindung',
    create: 'Neue Karte',
    createTitle: 'Tankkarte registrieren',
    editTitle: 'Tankkarte bearbeiten',
    fuelCompany: 'Kraftstoffunternehmen',
    selectCompany: 'Auswählen Kraftstoffunternehmen…',
    cardNumber: 'Kartennummer',
    invoiceNumber: 'Rechnungsnummer',
    embossedNumber: 'Eingeprägte Nummer',
    cardName: 'Kartenname',
    pinCode: 'PIN-Code',
    expiresAt: 'Ablaufdatum',
    status: 'Status',
    statusActive: 'Aktiv',
    statusBlocked: 'Gesperrt',
    statusCancelled: 'Verschlossen',
    notes: 'Hinweis',
    vehicle: 'Fahrzeuge',
    selectVehicle: 'Fahrzeug auswählen…',
    missingOrganization: 'Die Karte ist nicht organisiert, daher kann das Fahrzeug nicht verbunden werden.',
    notLinked: 'Nicht verbunden',
    link: 'Paar',
    unlink: 'Trennen',
    linkTitle: 'Karte mit dem Fahrzeug verbinden',
    cancel: 'Entsorgen',
    expiringFilter: 'Läuft in 60 Tagen ab',
    noCards: 'Keine Tankkarten gefunden',
    loadError: 'Tankkarte konnte nicht heruntergeladen werden',
    createSuccess: 'Tankkarte registriert',
    saveSuccess: 'Tankkarte aktualisiert',
    saveError: 'Tankkarte konnte nicht gespeichert werden',
    linkSuccess: 'Karte mit Fahrzeug verbunden',
    linkError: 'Karte konnte nicht verbunden werden',
    unlinkSuccess: 'Karte getrennt',
    unlinkError: 'Karte konnte nicht getrennt werden',
    confirmUnlink: 'Karte vom Fahrzeug trennen? Die Karte ist noch im Register.',
    cancelSuccess: 'Die Karte ist storniert',
    cancelError: 'Karte konnte nicht storniert werden',
    confirmCancel: 'Diese Tankkarte stornieren?',
    historyTitle: 'Verbindungsverlauf',
    historyVehicle: 'Fahrzeuge',
    historyFrom: 'Getrennt',
    historyTo: 'Verbindung unterbrochen',
    historyUnlinked: 'Getrennt',
    historyOngoing: 'In Bearbeitung',
    historyCurrent: 'Aktuell',
    historyPast: 'Fertig',
    historyEmpty: 'Kein Verbindungsverlauf',
    historyLoadError: 'Verbindungsverlauf konnte nicht abgerufen werden',
  },
  fuel: {
    title: 'Kraftstoffmanagement',
    description: 'Rechnungen, Kraftstofftransaktionen und Kartenverbindungen',
    invoices: {
      tab: 'Rechnungen',
      invoiceNumber: 'Rechnungsnummer',
      invoiceDate: 'Rechnungsdatum',
      transactionCount: 'Anzahl',
      totalExclVat: 'Exkl. MwSt.',
      vat: 'Mehrwertsteuer',
      total: 'Gesamt',
      noInvoices: 'Keine Rechnungen gefunden',
      loadError: 'Rechnungen konnten nicht abgerufen werden',
      date: 'Datum',
      station: 'Station',
      product: 'Produkt',
      quantity: 'Liter',
      priceExclVat: 'Preis exkl. MwSt. MwSt.',
      vatAmount: 'Mehrwertsteuer',
      company: 'Firma',
    },
    duplicate: {
      badge: 'Duplikat',
      tooltip: 'Gleiche Betankung bereits bei einem anderen Unternehmen verfügbar – mögliche doppelte Rechnungsstellung',
      tooltipCompany: 'Gleiche Betankung bereits bei {{company}} verfügbar – mögliche doppelte Rechnungsstellung',
    },
    cards: {
      tab: 'Tankkarte',
      cardNumber: 'Kartennummer',
      invoiceNumber: 'Rechnungsnummer',
      embossedNumber: 'Eingeprägte Nummer',
      cardName: 'Kartenname',
      pinCode: 'PIN-Code',
      fuelCompany: 'Kraftstoffunternehmen',
      linkedVehicle: 'Verbundenes Fahrzeug',
      linkedSince: 'Verbunden und dann getrennt',
      notLinked: 'Nicht verbunden',
      link: 'Paar',
      unlink: 'Trennen',
      noCards: 'Keine Tankkarte gefunden',
      loadError: 'Konnte nicht abgerufen werden Karte',
      confirmUnlink: 'Möchten Sie diese Karte wirklich trennen?',
      unlinkSuccess: 'Karte getrennt',
      unlinkError: 'Karte konnte nicht getrennt werden',
      linkModal: {
        title: 'Karte mit dem Fahrzeug verbinden',
        vehicle: 'Fahrzeuge',
        validFrom: 'Getrennt',
        selectVehicle: 'Fahrzeug auswählen...',
        pinCode: 'PIN-Code',
        pinCodePlaceholder: 'PIN-Code',
        save: 'Paar',
        success: 'Karte mit Fahrzeug verbunden',
        error: 'Karte konnte nicht verbunden werden',
      },
      history: {
        title: 'Verbindungsverlauf',
        vehicle: 'Fahrzeuge',
        from: 'Von',
        to: 'Bis',
        active: 'Aktiv',
        inactive: 'Fertig',
        noHistory: 'Kein Verlauf',
        loadError: 'Verlauf konnte nicht abgerufen werden',
      },
    },
    vehicleCard: {
      noCards: 'Mit diesem Fahrzeug wurden keine Tankkarten verknüpft',
      loadError: 'Tankkarte konnte nicht abgerufen werden',
      noTransactions: 'Keine Tanktransaktionen für den ausgewählten Zeitraum gefunden',
      outsidePeriod: 'Keine Transaktionen im ausgewählten Zeitraum. Es gibt {{count}}Transaktionen außerhalb des Zeitraums – Datum erweitern.',
      loadTxError: 'Kraftstofftransaktionen konnten nicht abgerufen werden',
      totalLiters: 'Gesamtliterzahl',
      totalCost: 'Gesamtkosten',
      addCard: 'Karte hinzufügen',
      cardNumber: 'Kartennummer',
      invoiceNumber: 'Rechnungsnummer',
      embossedNumber: 'Eingeprägte Nummer',
      okq8BothRequired: 'OKQ8 erfordert sowohl Rechnungsnummer als auch geprägte Nummer',
      validFrom: 'Gültig von',
      linkSuccess: 'Tankkarte verknüpft',
      linkError: 'Tankkarte konnte nicht verknüpft werden',
      unlinkSuccess: 'Tankkarte getrennt',
      unlinkError: 'Tankkarte konnte nicht getrennt werden',
      confirmUnlink: 'Möchten Sie diese Karte wirklich trennen?',
      unlink: 'Trennen',
    },
  },
  modules: {
    addFavorite: 'Als Favorit hinzufügen',
    removeFavorite: 'Aus Favoriten entfernen',
    roles: {
      title: 'Rollen',
      description: 'Rollen und Berechtigungen',
    },
    organizations: {
      title: 'Organisationen',
      description: 'Organisationen verwalten',
    },
    users: {
      title: 'Benutzer',
      description: 'Benutzerverwaltung',
    },
    translations: {
      title: 'Übersetzungen',
      description: 'Übersetzungen und Sprachen',
    },
    imports: {
      title: 'Importieren',
      description: 'Daten aus Dateien importieren',
    },
    packages: {
      title: 'Paket',
      description: 'Pakete und Abonnements verwalten',
    },
    devices: {
      title: 'Geräte',
      description: 'Geräte verwalten',
    },
    'device-management': {
      title: 'Geräteverwaltung',
      description: 'Erweitertes Gerät Verwaltung',
    },
    'sim-cards': {
      title: 'SIM-Karten',
      description: 'SIM-Karten verwalten, Nutzung anzeigen und Berichte über Jasper API erstellen',
    },
    geofences: {
      title: 'Geofences',
      description: 'Geofences verwalten',
    },
    'geofence-events': {
      title: 'Geofence Ereignisse',
      description: 'Geofence-Ereignisse anzeigen',
    },
    support: {
      title: 'Support',
      description: 'Supportfunktionen',
    },
    'service-workshops': {
      title: 'Werkstätten',
      description: 'Werkstätten und Servicepersonal verwalten',
    },
    'ai-log': {
      title: 'KI-Protokoll',
      description: 'KI-Protokolle anzeigen',
    },
    'data-migration': {
      title: 'Datenmigration',
      description: 'Daten zwischen Systemen migrieren',
    },
    'device-commands': {
      title: 'Gerätebefehle',
      description: 'Befehle an Geräte senden',
    },
    'audit-log': {
      title: 'Überwachungsprotokolle',
      description: 'Überwachungsprotokolle anzeigen',
    },
    'general-audit-log': {
      title: 'Changelog',
      description: 'Änderungsprotokoll anzeigen',
    },
    'error-log': {
      title: 'Fehlerprotokoll',
      description: 'Fehlerprotokolle anzeigen',
    },
    'eco-settings': {
      title: 'ECO-Einstellungen',
      description: 'ECO-Einstellungen konfigurieren',
    },
    'system-monitor': {
      title: 'Systemüberwachung',
      description: 'System überwachen Status',
    },
    'slow-queries': {
      title: 'Langsame Abfragen',
      description: 'Langsame Datenbankabfragen anzeigen',
    },
    'data-replay': {
      title: 'GPSWiedergabe',
      description: 'GPSDaten wiedergeben',
    },
    'trip-validation': {
      title: 'Reisevalidierung',
      description: 'Reisen validieren',
    },
    'import-sources': {
      title: 'Importquellen',
      description: 'Importquellen verwalten',
    },
    'sso-log': {
      title: 'SSO-Protokoll',
      description: 'Fehlgeschlagene und abgebrochene SSO-Versuche, pro Client und Gerät',
    },
    'gps-data-lag': {
      title: 'GPS-Dump-Warteschlange',
      description: 'Geräte, die aktiv nachlaufende GPS-Daten senden; Spülung per SMS',
    },
    'api-metrics': {
      title: 'Leistung',
      description: 'Benutzerwachstum, Buchungen und API-Latenz im Vergleich zum System laden',
    },
    trips: {
      title: 'Fahrten',
      description: 'Anzeigen und analysieren Fahrten für Ihre Fahrzeuge',
    },
    'eco-driving': {
      title: 'ECO-Fahren',
      description: 'Fahrgewohnheiten und Umweltauswirkungen analysieren',
    },
    'speed-compliance': {
      title: 'Geschwindigkeit Einhaltung',
      description: 'Geschwindigkeitseinhaltung nach Organisation und Fahrzeug analysieren',
    },
    'energy-consumption': {
      title: 'Energieverbrauch',
      description: 'Kraftstoffverbrauch pro Organisation und Fahrzeug analysieren',
    },
    'vehicle-wear': {
      title: 'Fahrzeugverschleiß',
      description: 'Analysieren Sie, wie sich das Fahrverhalten auf den Fahrzeugverschleiß auswirkt',
    },
    underutilized: {
      title: 'Nicht ausgelastete Fahrzeuge',
      description: 'Fahrzeuge mit geringer Auslastung identifizieren',
    },
    co2: {
      title: 'CO2-Emissionen',
      description: 'CO2-Emissionen berechnen und analysieren',
    },
    'geofence-zones': {
      title: 'Geofence-Zonenbericht',
      description: 'Analysieren Sie, wie oft sich Fahrzeuge in Zonen befinden',
    },
    'driving-log': {
      title: 'Fahrprotokoll',
      description: 'Fahrtagebuch gemäß den Richtlinien der schwedischen Steuerbehörde',
    },
    'work-trips': {
      title: 'Geschäftsreisen',
      description: 'Reisen mit gemeinsam genutzten Firmenwagen',
    },
    odometer: {
      title: 'Zählerstandbericht',
      description: 'Zählerstand pro Fahrzeug an einem bestimmten Datum anzeigen',
    },
    rental: {
      title: 'Mietbericht',
      description: 'Vollständiger Mietbericht mit Fahrten, Kosten und Status',
    },
    'rental-report': {
      title: 'Mietbericht',
      description: 'Mietstatistiken und Berichte',
    },
    'stop-time': {
      title: 'Stoppzeitanalyse',
      description: 'Fahrzeugstoppzeiten analysieren',
    },
    'route-analysis': {
      title: 'Routenanalyse',
      description: 'Routenoptimierung und -analyse',
    },
    'vehicle-kpi': {
      title: 'Kennzahlen Fahrzeuge',
      description: 'Kennzahlen pro Fahrzeug',
    },
    dtc: {
      title: 'DTC-Fehlerbericht',
      description: 'Diagnose-Fehlercodes (DTCs) nach Fahrzeug anzeigen und analysieren',
    },
    'dtc-report': {
      title: 'DTC-Bericht',
      description: 'Diagnosefehlercodes',
    },
    customers: {
      title: 'Kunden',
      description: 'Kunden verwalten',
    },
    projects: {
      title: 'Projekte',
      description: 'Projekte verwalten',
    },
    procurements: {
      title: 'Beschaffungen',
      description: 'Beschaffung verwalten',
    },
    pipeline: {
      title: 'Pipeline',
      description: 'Sales-Pipeline',
    },
    economy: {
      title: 'Wirtschaftlichkeit',
      description: 'Finanzübersicht',
    },
    invoices: {
      title: 'Rechnungen',
      description: 'Rechnungen verwalten',
    },
    pricelist: {
      title: 'Preisliste',
      description: 'Preisliste verwalten',
    },
    organization: {
      title: 'Organisation',
      description: 'Organisationsstruktur verwalten',
    },
    fleet: {
      title: 'Fuhrpark',
      description: 'Fahrzeugübersicht und -verwaltung',
    },
    drivers: {
      title: 'Fahrer',
      description: 'Fahrerverwaltung',
    },
    'fleet-overview': {
      title: 'Fahrzeugflotte',
      description: 'Fahrzeugübersicht und -verwaltung',
    },
    'live-tracking': {
      title: 'Echtzeitkarte',
      description: 'Fahrzeugverfolgung in Echtzeit',
    },
    'track-playback': {
      title: 'Track-Wiedergabe',
      description: 'Historische Routen anzeigen',
    },
    'map-services': {
      title: 'Kartendienste',
      description: 'Karte, Tracking, Geofence und Heatmap',
    },
    'fuel-management': {
      title: 'Kraftstoffmanagement',
      description: 'Rechnungen, Tankkarten und Kartenverbindungen',
    },
    'fuel-cards': {
      title: 'Tankkarten',
      description: 'Tankkarten- und Fahrzeugverbindungsverzeichnis',
    },
    assignments: {
      title: 'Zuweisungen',
      description: 'Zuordnungen von Daten zu Personen verwalten',
    },
    'vehicle-categories': {
      title: 'Fahrzeugkategorien',
      description: 'Auswählbare Fahrzeugkategorien verwalten',
    },
    'equipment-tags': {
      title: 'Fahrzeugausstattung',
      description: 'Fahrzeugausrüstung pro Stützpunkt verwalten',
    },
    'replacement-chain': {
      title: 'Ersatzkette',
      description: 'Zeigen Sie, welche Fahrzeuge in einer Kette ersetzt wurden',
    },
    'alternative-fuels': {
      title: 'Alternative Kraftstoffe',
      description: 'Auswählbare alternative Kraftstoffe pro Stützpunkt verwalten',
    },
    'usage-statuses': {
      title: 'Fahrzeugstatus',
      description: 'Auswählbare Fahrzeugstatus pro Stützpunkt verwalten',
    },
    tidbok: {
      title: 'Digitale Zeit Buch',
      description: 'Lenk- und Ruhezeiten gemäß EU 561/2006 und TSFS 2013:3',
    },
    'vehicle-economy': {
      title: 'Fahrzeugökonomie',
      description: 'Importierte Kosten pro Organisation, Gruppe und Fahrzeug analysieren',
    },
    'vehicle-procurement': {
      title: 'Anschaffung und Stilllegung',
      description: 'Entscheidung über den Ersatz oder die Stilllegung von Fahrzeugen, mit Belegen und Dokumenten',
    },
    'license-check': {
      title: 'Führerscheinprüfung',
      description: 'Kontrolle der Fahrerberechtigung über BKY',
    },
    charging: {
      title: 'Laden',
      description: 'Abrechnung des Ladens von Elektroautos pro Zeitraum',
    },
    'vehicle-log': {
      title: 'Fahrzeugprotokoll',
      description: 'Ereignisse für Fahrzeuge, wie Umzug, Austausch und Protokollzeitraum',
    },
    'nordea-leasing': {
      title: 'Nordea-Leasing',
      description: 'Import der Leasingdatei von Nordea',
    },
    'personal-trackers': {
      title: 'Persönliche Tracker',
      description: 'Karte der persönlichen Tracker',
    },
    'protector-insurance': {
      title: 'Protektor-Versicherung',
      description: 'Versicherungsdatei aus Protector importieren',
    },
    'unplug-events': {
      title: 'Unscharf-Verlauf',
      description: 'Scharf- und Unscharfschaltung GPSGerät mit Zeit und Position',
    },
    'service-overview': {
      title: 'Service',
      description: 'Serviceübersicht und -verwaltung',
    },
    heatmap: {
      title: 'Heatmap',
      description: 'Heatmap der Fahrzeugpositionen',
    },
    'heatmap-import': {
      title: 'Heatmap-Import',
      description: 'Daten für die Heatmap-Analyse importieren',
    },
    'crash-detection': {
      title: 'Crash-Erkennung',
      description: 'Crash-Ereignisse von Geräten mit Crash Trace (AVL 257)',
    },
    'ai-analysis': {
      title: 'KI-Analyse',
      description: 'Fahrzeuge und Flotte mit KI analysieren',
    },
    eco: {
      title: 'ECO-Fahren',
      description: 'Umwelt und Fahrverhalten',
    },
    fuel: {
      title: 'Kraftstoff',
      description: 'Kraftstoffberichte',
    },
    activity: {
      title: 'Aktivität',
      description: 'Aktivitätsprotokolle',
    },
    statistics: {
      title: 'Statistiken',
      description: 'Statistische Übersicht',
    },
    trends: {
      title: 'Trends',
      description: 'Trendanalyse und Kilometerstand im Vergleich zum Leasingvertrag',
    },
    benchmarks: {
      title: 'Vergleiche',
      description: 'Benchmarking',
    },
    overview: {
      title: 'Übersicht',
      description: 'Systemstatus',
    },
    replay: {
      title: 'GPSWiedergabe',
      description: 'GPSDaten wiedergeben',
    },
    logs: {
      title: 'Protokolle',
      description: 'Systemprotokolle',
    },
    'pickup-locations': {
      title: 'Ausstellungsorte',
      description: 'Unter Buchung: Standorte, an denen Fahrzeuge abgeholt und abgegeben werden',
    },
    suppliers: {
      title: 'Lieferanten',
      description: 'Lieferanten z.B. Autovermietung',
    },
    destinations: {
      title: 'Ziele',
      description: 'Vordefinierte Reiseziele bei der Buchung',
    },
    calendar: {
      title: 'Kalender',
      description: 'Buchungskalender',
    },
    'bookings-search': {
      title: 'Kundendienst',
      description: 'Buchungen verwalten und unterstützen',
    },
    'unbooked-trips': {
      title: 'Fahrten ohne Buchung',
      description: 'Fahrten ohne Buchung einem Fahrer und einem Zweck zuordnen',
    },
    'booking-optimization': {
      title: 'Buchungsoptimierung',
      description: 'KI-Optimierung von Tagesbuchungen pro Pool',
    },
    requests: {
      title: 'Buchungsanfragen',
      description: 'Buchungsanfragen verwalten',
    },
    'vehicle-replacement': {
      title: 'Fahrzeugtausch',
      description: 'Fahrzeuge im Pool ersetzen, außer Betrieb markieren und Buchungen neu zuordnen',
    },
    'own-car-trip': {
      title: 'Reisen mit dem eigenen Auto',
      description: 'Geschäftsreisen mit dem privaten Auto registrieren und verwalten',
    },
    'own-car-trips': {
      title: 'Reisen mit dem eigenen Auto',
      description: 'Geschäftsreisen mit dem privaten Auto registrieren und verwalten',
    },
    'collision-bookings': {
      title: 'Kollisionsbuchungen',
      description: 'Buchungen ohne zugewiesenes Fahrzeug nach Pool oder Fahrzeugwechsel',
    },
    service: {
      title: 'Service',
      description: 'Serviceintervalle und Erinnerungen',
    },
    repairs: {
      title: 'Reparaturen',
      description: 'Reparaturhistorie und -kosten',
    },
    inspections: {
      title: 'Inspektion',
      description: 'Inspektionsstatus und Erinnerungen',
    },
    'key-cabinet': {
      title: 'Schlüsselschränke',
      description: 'Übersicht über Schlüsselschränke und Schlüssel',
    },
    'key-log': {
      title: 'Schlüsselhistorie',
      description: 'Protokoll der Schlüsselentnahmen und -abgaben',
    },
    'homecare-planning': {
      title: 'Routenplanung',
      description: 'Hausservice-Routenoptimierung',
    },
    'homecare-clients': {
      title: 'Benutzer',
      description: 'Hausservice-Benutzer',
    },
    'homecare-staff': {
      title: 'Personal',
      description: 'Heimservice-Mitarbeiter',
    },
    dashboard: {
      title: 'Dashboard',
      description: 'Startansicht',
    },
    realtime: {
      title: 'Echtzeitkarte',
      description: 'Fahrzeugverfolgung in Echtzeit',
    },
    'temperature-monitoring': {
      title: 'Temperaturüberwachung',
      description: 'Temperatur und Kühlkette',
      reports: {
        title: 'Kühlkettenberichte',
        description: 'Temperatur- und Kühlkettenberichte',
      },
    },
    administration: {
      title: 'Administration',
      description: 'Systemverwaltung',
    },
    sysadmin: {
      title: 'Systemverwaltung',
      description: 'Erweiterte Systemeinstellungen',
    },
    reports: {
      title: 'Berichte',
      description: 'Berichte und Statistiken',
    },
    crm: {
      title: 'CRM',
      description: 'Kundenverwaltung',
    },
    deque: {
      title: 'Fahrzeugverwaltung',
      description: 'Fahrzeugflottenverwaltung',
    },
    booking: {
      title: 'Buchung',
      description: 'Fahrzeugbuchungen',
    },
    homecare: {
      title: 'Heimservice',
      description: 'Home-Service-Planung',
    },
    workshop: {
      title: 'Workshop',
      description: 'Werkstatt und Wartung',
    },
    keymanagement: {
      title: 'Schlüssel Verwaltung',
      description: 'Schlüsselschließfachverwaltung',
    },
    workorder: {
      title: 'Arbeitsaufträge',
      description: 'Arbeitsaufträge und Aufgaben',
    },
    analysis: {
      title: 'Analyse',
      description: 'Statistiken und Analysen',
    },
    'cost-centers': {
      title: 'Kostenstellen',
      description: 'Kostenstellen verwalten',
    },
    'old-booking': {
      title: 'Vorherige Buchung',
      description: 'Historische Buchungsdaten (temporär)',
    },
    'cabinet-sync': {
      title: 'Schließfachsynchronisierung',
      description: 'Was KeyWin an die Schließfächer sendet (globaler Administrator)',
    },
    'carinfo-filter': {
      title: 'Fahrzeugfilter',
      description: 'Filterkonfiguration für Fahrzeugdaten',
    },
    'widget-vehicle-count': {
      title: 'Fahrzeugübersicht',
      description: 'Anzahl der Fahrzeuge und Status online oder offline',
    },
    'widget-inspection': {
      title: 'Anstehende Inspektionen',
      description: 'Fahrzeuge, die innerhalb von 40 Tagen überprüft werden müssen',
    },
    'widget-leasing-expiring': {
      title: 'Leasing läuft ab',
      description: 'Fahrzeuge, deren Leasingverträge innerhalb von 3 Monaten ablaufen',
    },
    'widget-unplugged': {
      title: 'Abgeschaltete Einheiten',
      description: 'Fahrzeuge mit abgetrennter GPSEinheit',
    },
    'widget-low-battery': {
      title: 'Niedrige Batteriespannung',
      description: 'Fahrzeuge mit Batteriespannung unter 12 V',
    },
    'widget-vehicle-status': {
      title: 'Fahrzeugstatus',
      description: 'Zusammenfassung der Fahrzeuge nach Status',
    },
    'widget-tax-due': {
      title: 'Anstehende Kfz-Steuer',
      description: 'Fahrzeuge mit fälliger Steuer innerhalb von 45 Tagen',
    },
    'widget-service': {
      title: 'Ablaufender Service',
      description: 'Ablaufende Serviceintervalle',
    },
    'widget-assignments': {
      title: 'Meine Aufgaben',
      description: 'Offene Aufgaben für den angemeldeten Benutzer',
    },
    'widget-bookings': {
      title: 'Meine Buchungen',
      description: 'Anstehende Buchungen für den angemeldeten Benutzer',
    },
    craftsman: {
      title: 'Handwerker',
      description: 'Arbeitsauftrag für Handwerker und Service',
    },
    delivery: {
      title: 'Paketzustellung',
      description: 'Arbeitsauftrag für Pakete und Lieferungen',
    },
    'service-agreements': {
      title: 'Serviceverpflichtung',
      description: 'Wiederkehrende Serviceaufgabe mit Intervall',
    },
    resource_manager: {
      title: 'Der Ressourcenmanager',
      description: 'Wochenübersicht pro Fahrzeug',
    },
    collision_bookings: {
      title: 'Kollisionsbuchungen',
      description: 'Buchungen ohne zugeordnetes Fahrzeug',
    },
    vehicle_replacement: {
      title: 'Fahrzeugtausch',
      description: 'Fahrzeuge ersetzen und Außerbetriebnahme in Buchungspools verwalten',
    },
    'booking-settings': {
      title: 'Buchungseinstellungen',
      description: 'Formulare, Projekte, Ziele, Kostenstellen, Zwecke und Buchungsbedingungen',
    },
    'booking-resources': {
      title: 'Buchungsressourcen',
      description: 'Ressourcentypen und Ressourcen pro Kunde',
    },
    'rental-management': {
      title: 'Autovermieter',
      description: 'Kunden mit Autovermietungen verbinden',
    },
    'booking-basis': {
      title: 'Buchungsunterlagen',
      description: 'Dokumente für zurückgegebene Buchungen, mit Kilometern, Fahrten und Umgebung',
    },
    'quick-booking': {
      title: 'Schnellbuchung',
      description: 'Kostenloses Auto für Gäste buchen, die anrufen, mit PIN per SMS',
    },
    'travel-planner': {
      title: 'Reiseplaner',
      description: 'Routenplanung mit dem Auto, Fahrrad, zu Fuß und öffentlichen Verkehrsmitteln',
    },
    'vehicle-pools': {
      title: 'Fahrzeugpark',
      description: 'Fahrzeugpools mit automatischer Buchung bei Schlüsselentnahmen',
    },
    'pool-watch': {
      title: 'Fehlende Daten',
      description: 'Überwachung von Poolentnahmen bei fehlenden Pflichtfeldern',
    },
    'customer-keys': {
      title: 'Schlüssel Verwaltung',
      description: 'Fahrzeuge mit Schlüsseln in Ihren Schließfächern verbinden',
    },
    'key-management': {
      title: 'Schließfachverwaltung',
      description: 'Schließfächer, Kunden, Verbindung und Synchronisierung',
    },
    'booking-stats': {
      title: 'Buchungsstatistik',
      description: 'Aggregierte Buchungsstatistiken',
    },
    'service-costs': {
      title: 'Servicekosten',
      description: 'Servicekosten pro Kategorie und Zeitraum',
    },
    'fuel-analysis': {
      title: 'Kraftstoffanalyse',
      description: 'Kraftstoffkosten und Verbrauch aus importierten Transaktionen',
    },
    'fleet-tco': {
      title: 'Gesamtkosten der Flotte',
      description: 'Gesamtbetriebskosten pro Fahrzeug: Kraftstoff, Service, Leasing und Versicherung',
    },
    executive: {
      title: 'Managementbericht',
      description: 'Gesamtkennzahlen für die Flotte',
    },
    'report-generator': {
      title: 'Berichtsgenerator',
      description: 'Benutzerdefinierte Berichte aus Datenmodellen',
    },
    sensors: {
      title: 'Sensoren',
      description: 'EYE registrieren und mit FMM003 verbinden',
    },
    config: {
      title: 'BLE/EYE-Konfiguration',
      description: 'Interne Fernkonfiguration von BLE und EYE',
    },
    recipients: {
      title: 'Alarmempfänger',
      description: 'Externe Empfänger für E-Mail und SMS',
    },
    schedules: {
      title: 'Berichtszeitpläne',
      description: 'Wöchentliche und monatliche Berichte',
    },
    'tire-analysis': {
      title: 'Reifenanalyse',
      description: 'Verschleiß, saisonale Planung und Kaufbedarf',
    },
    'module-catalog': {
      title: 'Modulkatalog',
      description: 'Übersicht über Module und Funktionen',
    },
    'fota-migration': {
      title: 'FOTA-Migration',
      description: 'Konfiguration über FOTA Web an Geräte senden',
    },
    'carinfo-org-sync': {
      title: 'Fahrzeugimport von Car.info',
      description: 'Fahrzeuge von Car.info nach Organisationsnummer importieren',
    },
    'dev-projects': {
      title: 'Produktentwicklung',
      description: 'Internes Projektmanagement',
    },
    'flinkey-boxes': {
      title: 'FlinkeyBoxen',
      description: 'Digitale Schlüsselboxen und Zuteilungen',
    },
    'guide-management': {
      title: 'Guide-Management',
      description: 'Einführungsguides und Touren',
    },
    'theme-settings': {
      title: 'Thema und Branding',
      description: 'Farbthema und Partnerprofil',
    },
    'jam-detection': {
      title: 'Störungserkennung',
      description: 'Wo GSM-Störungen erkannt wurden',
    },
    'trip-analysis': {
      title: 'Analysieren Fahrten',
      description: 'Aufgezeichnete Fahrten mit der Fahrzeugbehälterdatei vergleichen',
    },
    'device-baseline': {
      title: 'Standarddateien für Geräte',
      description: 'Standarddatei für Firmware und Konfiguration pro Modell',
    },
    'obd-vehicles': {
      title: 'OBDFahrzeugliste',
      description: 'Suche OBDUnterstützung nach Marke und Modell',
    },
    'obd-knowledge': {
      title: 'OBD-Knowledge',
      description: 'Durchsuchbare Wissensdatenbank für OBD',
    },
    'damage-reports': {
      title: 'Schadensberichte',
      description: 'Eingehende Schadensberichte verwalten',
    },
    'econ-kodverk': {
      title: 'Codework',
      description: 'Region Scania Raindance Codework',
    },
    'eye-inventory': {
      title: 'EYE-Repository',
      description: 'EYE-Sensoren und GPS-Tracker aus der Packliste importieren',
    },
    'cost-invoices': {
      title: 'Kostenrechnungen',
      description: 'Fahrzeugkosten von Leasingunternehmen importieren',
    },
    'device-queues': {
      title: 'Gerätewarteschlangen',
      description: 'Ausstehende ausgehende Aufträge an Geräte',
    },
    moten: {
      title: 'Besprechung',
      description: 'Interne Besprechungsaufzeichnung und Notizen',
    },
    'vehicle-carinfo-sync': {
      title: 'Fahrzeug von Car.info synchronisieren',
      description: 'Marke, Modell, Jahr und Kraftstofftyp synchronisieren',
    },
    'mobile-access': {
      title: 'Mobiler Zugriff',
      description: 'Mobile App-Anmeldung',
    },
    'support-chat': {
      title: 'Support-Chat',
      description: 'Web- und App-Support-Chat',
    },
    flinky: {
      title: 'Meine Buchungen',
      description: 'Mobile App-Buchungen',
    },
    dqbooking: {
      title: 'Ein Auto buchen',
      description: 'Fahrzeug in der mobilen App buchen',
    },
    'driving-log-mobile': {
      title: 'Fahrprotokoll',
      description: 'Digitale Fahraufzeichnung in der mobilen App',
    },
    'damage-report': {
      title: 'Schadensmeldung',
      description: 'Fahrzeugschäden in der mobilen App melden',
    },
    'find-vehicle-mobile': {
      title: 'Fahrzeuge finden',
      description: 'Fahrzeuge in der mobilen App suchen und finden',
    },
    arbetsorder: {
      title: 'Arbeitsaufträge',
      description: 'Zugewiesene Aufgaben, Zeitstempel und Ausfahrt in der App',
    },
    flinkyboxes: {
      title: 'FlinkeyBoxen',
      description: 'Schloss, Batterie und NFC-Karte an der Abgabestelle',
    },
    'delad-bil': {
      title: 'Gemeinsames Auto',
      description: 'Reisen im gemeinsamen Firmenwagen',
    },
  },
  systemPage: {
    loading: 'Laden System...',
    errorTitle: 'Fehler beim Laden des Systems',
    tryAgain: 'Erneut versuchen',
    systemNotFound: 'System nicht gefunden',
    systemNotFoundDescription: 'Das System „{name}“ konnte nicht in der Datenbank gefunden werden.',
    backToStart: 'Zurück zur Startseite',
    noModules: 'Für dieses System wurden keine Module gefunden.',
    comingSoon: 'Bald verfügbar',
    plannedFeatures: 'Geplante Funktionen',
    underDevelopment: 'Dieses Modul befindet sich in der aktiven Entwicklung.',
    notFoundOrNoAccess: 'Das System „{name}“ wurde nicht gefunden oder Sie haben keine Berechtigung.',
    notLoggedIn: 'Sie sind nicht angemeldet oder Ihre Sitzung ist abgelaufen. Sie werden zum Login weitergeleitet.',
    noPermission: 'Sie sind nicht berechtigt, diese Informationen anzuzeigen.',
    serverError: 'Serverfehler. Bitte versuchen Sie es später erneut.',
    unexpectedError: 'Beim Abrufen der Systemdaten ist ein unerwarteter Fehler aufgetreten',
    noSystemName: 'Kein Systemname angegeben',
    apiError: 'API hat einen Fehler zurückgegeben',
    functionCountOne: '{count}-Funktion',
    functionCount: '{count}-Funktionen',
    searchFunctions: 'Funktion in {name} suchen...',
    noSearchHits: 'Keine Funktionen entsprechen der Suche.',
    groups: {
      daily: 'Täglicher Betrieb',
      planning: 'Planung und Optimierung',
      resources: 'Ressourcen & Lieferanten',
      history: 'Hintergrund & Geschichte',
      settings: 'Einstellungen',
      vehicles: 'Fahrzeuge',
      devices: 'Geräte & Position',
      economy: 'Wirtschaftlichkeit',
      compliance: 'Einhaltung',
      driving: 'Ausführung',
      environment: 'Umwelt & Energie',
      fleet: 'Fuhrpark',
      analysis: 'Analyse',
      customers: 'Kunden',
      catalog: 'Katalog',
      people: 'Benutzer & Rollen',
      data: 'Daten & Import',
      monitor: 'Überwachung',
      overview: 'Übersicht',
      map: 'Karte',
      events: 'Ereignisse',
      functions: 'Funktionen',
      other: 'Andere',
    },
    comingSoonBooking: {
      feature1: 'Kalenderansicht für Buchungen',
      feature2: 'Anfragen und Genehmigungen',
      feature3: 'Konfliktmanagement',
      feature4: 'Benachrichtigungen an Fahrer',
      feature5: 'Integration mit Fuhrpark',
    },
    comingSoonWorkshop: {
      feature1: 'Serviceintervalle und Erinnerungen',
      feature2: 'Reparaturhistorie',
      feature3: 'Inspektionsstatus',
      feature4: 'Kostenverfolgung',
      feature5: 'Werkstattbuchung',
    },
    comingSoonKeymanagement: {
      feature1: 'Schlüsselschrankübersicht',
      feature2: 'An-/Abmelden',
      feature3: 'Berechtigungsverwaltung',
      feature4: 'Alarmfunktionen',
      feature5: 'Integration mit Buchungssystem',
    },
    comingSoonWorkorder: {
      feature1: 'Arbeitsaufträge erstellen',
      feature2: 'Zu Fahrer/Fahrzeug zuweisen',
      feature3: 'Statusverfolgung',
      feature4: 'Priorisierung und Frist',
      feature5: 'Dokumentation und Anhänge',
    },
    comingSoonAnalysis: {
      feature1: 'Statistische Übersicht',
      feature2: 'Trendanalyse im Zeitverlauf',
      feature3: 'Vergleiche zwischen Fahrzeugen',
      feature4: 'Berichte exportieren',
      feature5: 'Benutzerdefinierte Dashboards',
    },
  },
  vehicleAttachments: {
    attachments: 'Anhänge',
    uploadButton: 'Hochladen',
    category: 'Kategorie',
    insurance: 'Versicherungen',
    inspection: 'Inspektion',
    damage: 'Schaden',
    invoice: 'Rechnung',
    contract: 'Vereinbarung',
    service: 'Service',
    other: 'Andere',
    addCategory: 'Eigene Kategorie hinzufügen…',
    newCategoryPlaceholder: 'Kategoriename',
    categoryCustomerHint: 'Nur für diesen Kunden sichtbar.',
    categorySaveFailed: 'Kategorie konnte nicht gespeichert werden',
    edit: 'Bearbeiten',
    description: 'Text',
    descriptionPlaceholder: 'Optionaler Text zum Anhang',
    saveFailed: 'Änderung konnte nicht gespeichert werden',
    clickToPreview: 'Zur Vorschau klicken',
    download: 'Herunterladen',
    deleteFile: 'Entfernen',
    preview: 'Vorschau',
    closePreview: 'Schließen',
  },
  ecoSettings: {
    couldNotSave: 'Einstellungen konnten nicht gespeichert werden',
    confirmDelete: 'Sind Sie sicher, dass Sie diese organisationsspezifischen Einstellungen entfernen möchten?',
    couldNotDelete: 'Einstellungen konnten nicht entfernt werden',
    globalDefaults: 'Globale Standardeinstellungen',
    globalDefaultsOption: 'Globale Standardeinstellungen',
    hasOwnSettings: 'Hat benutzerdefinierte Einstellungen',
    usesGlobal: 'Verwendet globale',
    orgsWithOwnSettings: 'Organisationen mit benutzerdefinierten Einstellungen:',
    removeOrgSettings: 'Entfernen Organisationsspezifische Einstellungen',
    hardAccelDescription: 'Grenzwerte zur Erkennung starker Beschleunigung...',
    defaultSpeedOverLimit: 'Standard: 10 % Geschwindigkeitsüberschreitung',
    smoothDrivingDescription: 'Grenzwerte zur Belohnung von wirtschaftlichem und umweltfreundlichem Fahren.',
    defaultSmoothAccel: 'Standard: 1,5 m/s² für sanftes Fahren',
    defaultSmoothBrake: 'Standard: 2,0 m/s² für sanftes Bremsen',
    defaultMinSpeed: 'Standard: 10 km/h (Stand, nicht gezählt)',
    defaultIdleTime: 'Standard: 120 Sekunden (2 Minuten) kontinuierlich',
  },
  geofencesPage: {
    exportToCsv: 'Export nach CSV',
    clearSelection: 'Auswahl löschen',
    noGeofences: 'Keine Geofences erstellt',
    hide: 'Ausblenden',
    show: 'Anzeigen',
    editGeofence: 'Bearbeiten',
    deleteGeofence: 'Entfernen',
    clickMapToAddPoints: 'Auf klicken der Karte, um Punkte hinzuzufügen',
    minPointsRequired: 'Für ein Polygon sind mindestens 3 Punkte erforderlich',
    globalAllOrgs: 'Global (alle Organisationen)',
    specificOrg: 'Spezifische Organisation',
    selectOrg: 'Organisation auswählen',
    hideCoordinatesInArea: 'Koordinaten innerhalb des Bereichs ausblenden',
    tollArea: 'Zollgebiet',
    defaultPricePlaceholder: 'Standardpreis, wenn keine Zeitregel zutrifft',
  },
  widgets: {
    remove: 'Entfernen',
    addWidget: 'Widget hinzufügen',
    selectColumn: 'Spalte auswählen:',
    available: 'Verfügbar',
    lowBattery: 'Niedrige Batteriespannung',
    openVehicleCard: 'Fahrzeugkarten öffnen',
    vehicleStatus: 'Fahrzeugstatus',
    vehicleStatusSubtitle: 'Fahrzeuge nach Status',
    vehicleUnit: 'Fahrzeuge',
    noUsageStatus: 'Kein Status',
    noVehicles: 'Keine Fahrzeuge',
    serviceDue: 'Ablaufender Service',
    overdue: 'Überfällig',
    noServiceDue: 'Kein Service überfällig',
    servicePointsNeedAction: 'Servicepunkte erfordern Aktion',
    overdueLabel: 'Überfällig',
    soonLabel: 'Bald',
    bookedLabel: 'Gebucht',
    allBatteriesOk: 'Alle Batterien in Ordnung',
    move: 'Verschieben',
    alreadyAdded: 'Bereits auf dem Armaturenbrett',
    alreadyAddedHint: 'Schließen Sie dieses Dialogfeld und sehen Sie sich Ihr Dashboard an – das Widget wird bereits angezeigt. Entfernen Sie es unter Bearbeiten, wenn Sie es zu einer anderen Spalte hinzufügen möchten.',
    alreadyAddedOnPage: 'Das Widget ist bereits auf der Seite. Entfernen Sie es unter Bearbeiten, wenn Sie es erneut hinzufügen möchten.',
    sectionAvailable: 'Kann hinzugefügt werden',
    sectionOnDashboard: 'Bereits auf Ihrem Dashboard',
    notInPackage: 'Nicht für Ihre Organisation in den Diensten aktiviert',
    comingSoon: 'Bald verfügbar',
    columns: {
      left: 'Links',
      center: 'Mitte',
      right: 'Rechts',
    },
  },
  usersManagement: {
    title: 'Benutzerverwaltung',
    usersCount: 'Benutzer',
    driversLicense: 'Führerschein:',
    employeeId: 'Beschäftigungs-ID:',
    costCenter: 'Kostenstelle:',
    createUser: 'Erstellen Benutzer',
    editUser: 'Benutzer bearbeiten',
    downloadTemplate: 'Vorlage herunterladen',
    importUsers: 'Benutzer importieren',
    importTitle: 'Benutzer importieren aus Excel',
    importDescription: 'Eine vollständige Excel-Vorlage hochladen, um Benutzer, Fahrer und Fahrzeugzuweisungen in einem Schritt zu erstellen.',
    importSelectOrg: 'Organisation zum Importieren auswählen',
    importUploadLabel: 'Excel-Datei (.xlsx) auswählen',
    importUploadHint: 'Vorlage herunterladen, ausfüllen und hier hochladen.',
    importPreviewTitle: 'Vorschau',
    importPreviewRows: 'Zeilen gefunden',
    importRun: 'Import ausführen',
    importRunning: 'Importieren...',
    importResultTitle: 'Importergebnis',
    importResultSuccess: 'Benutzer erstellt',
    importResultFailed: 'Zeilen fehlgeschlagen',
    importErrorsTitle: 'Zeilen fehlgeschlagen',
    importPasswordsTitle: 'Passwörter generiert',
    importPasswordsHint: 'Kopieren Sie diese Passwörter und geben Sie sie an die jeweiligen Benutzer weiter.',
    importPasswordsCopied: 'Kopiert!',
    importDone: 'Schließen',
    importNoFile: 'Wählen Sie eine Datei aus, bevor Sie fortfahren.',
    importNoOrg: 'Wählen Sie eine Organisation aus, bevor Sie fortfahren.',
    importVehicleNotFound: 'Registrierungsnummer nicht gefunden',
    sendWelcomeEmail: 'Willkommens-E-Mail mit Passwort-Zurücksetzung senden',
    sendWelcomeEmailDesc: 'Der Benutzer erhält eine E-Mail mit einem Link zur Aktivierung seines Kontos und zur Auswahl seines eigenen Passworts. Der Link ist 72 Stunden lang gültig.',
    sendWelcomeEmailSent: 'Willkommens-E-Mail gesendet',
    sendWelcomeEmailSentTo: 'Willkommens-E-Mail gesendet an {{email}}',
    sendWelcomeEmailButton: 'Willkommens-E-Mail senden',
    sendWelcomeEmailSending: 'Senden...',
    sendWelcomeEmailError: 'Willkommens-E-Mail konnte nicht gesendet werden',
    sendWelcomeEmailBulk: 'Willkommens-E-Mail an Liste senden',
    sendWelcomeEmailBulkHint: 'Sendet eine Willkommens-E-Mail mit einem Aktivierungslink an alle Benutzer in der Liste. Benutzer ohne E-Mail, SSO-Anmeldung oder inaktiv/gesperrt werden übersprungen.',
    sendWelcomeEmailBulkConfirm: 'Willkommens-E-Mail mit Aktivierungslink an {{count}}-Benutzer in der Liste senden?',
    sendWelcomeEmailBulkDone: 'Willkommens-E-Mail an {{sent}}-Benutzer',
    sendWelcomeEmailBulkPartial: '{{skipped}} übersprungen, {{failed}} fehlgeschlagen',
    sendWelcomeEmailBulkNone: 'Es gibt keine Benutzer in der Liste, an die gesendet werden kann',
    welcomeSkipNoEmail: 'E-Mail fehlt',
    welcomeSkipSso: 'SSOAnmeldung',
    welcomeSkipInactive: 'inaktiv/gesperrt',
    welcomeSkipNotFound: 'nicht gefunden',
    welcomeSkipEmailOff: 'E-Mail für Kunden deaktiviert',
    notVerified: 'Nicht bestätigt',
    neverLoggedIn: 'Nie angemeldet',
    noPassword: 'Kein Passwort',
    lastLoginAt: 'Letzte Anmeldung: {{date}}',
    searchPlaceholder: 'Nach Namen, E-Mail-Adresse oder Registrierungsnummer suchen...',
    department: 'Abteilung',
    editUserTitle: 'Bearbeiten',
    deleteUserTitle: 'Entfernen',
    hardDeleteButton: 'Vollständig löschen',
    hardDeleteTitle: 'Benutzer vollständig löschen (SSO Test)',
    hardDeleteConfirm: 'Dadurch wird {{name}} ({{email}}) vollständig aus dem System entfernt, sodass SSO neu erstellt werden kann das Konto. Kann nicht rückgängig gemacht werden.',
    emailRequiredForWelcome: 'E-Mail-Adresse ist erforderlich, um Willkommens-E-Mail zu senden.',
    downloadTemplateError: 'Vorlage konnte nicht heruntergeladen werden',
    driverInformation: 'Fahrerinformationen',
    connectedVehicle: 'Vernetztes Fahrzeug: {{reg}}',
  },
  userFormFields: {
    password: 'Passwort',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    selectOrg: 'Auswählen Organisation...',
    selectOrgForRoles: 'Zuerst Organisation auswählen',
    noRolesForOrg: 'Keine Rollen für Diese Organisation',
    rolesFromOrganization: 'Zeigt Rollen vom obersten Knoten der Organisation an.',
    keepCurrentPassword: 'Leer lassen, um auf dem neuesten Stand zu bleiben',
    mobileLoginOptional: 'Optional – für die Anmeldung in der mobilen App',
    driverInfo: 'Fahrerinformationen',
    tabSchedule: 'Zeitplan',
    tabVehicle: 'Fahrzeuge',
    tabHistory: 'Verlauf',
    driverDraftHint: 'Der Zeitplan und das Fahrzeug werden gespeichert, wenn Sie auf „Benutzer erstellen“ klicken. Sie müssen den Benutzer nicht zuerst speichern.',
    vehicleDraftSaved: 'Zuweisung im Entwurf gespeichert – zusammen mit dem Benutzer erstellt.',
    isAlsoDriver: 'Auch Fahrer',
    ongoing: ' – fortlaufend',
    globalAdminRolesHint: 'Einige interne Rollen (z. B. Deviaq Management) können nur vom globalen Administrator zugewiesen werden.',
    roleViewer: 'Betrachter',
    roleDriver: 'Treiber',
    roleAdmin: 'Admin',
  },
  rolePermissions: {
    selectFunctions: 'Wählen Sie aus, welche Funktionen verfügbar sein sollen',
    moduleNotEnabled: 'Das Modul ist nicht aktiviert',
    selectModuleLeft: 'Wählen Sie links ein Modul aus, um die Funktionen anzuzeigen',
  },
  dataTable: {
    searchPlaceholder: 'Suchen...',
    filterPlaceholder: 'Filter…',
    filterColumn: 'Filter {{column}}',
    selectAll: 'Alle auswählen',
    selectRow: 'Zeile auswählen',
  },
  customerDetail: {
    privateCompany: 'Privates Unternehmen',
    companyName: 'Firmenname: ',
    employees: 'Mitarbeiter: ',
    yearsInBusiness: 'Betriebsjahr: ',
    perBrand: 'Nach Marke',
    perFuelType: 'pro Kraftstofftyp',
    usersLabel: 'Benutzer',
    keyCabinet: 'Schlüsselschränke',
    devices: 'Geräte (GPS)',
    flinkeyBoxes: 'FlinkeyBoxen',
    registeredCables: 'Kabel (registriert)',
    devicesPerType: 'Einheiten pro Typ',
    firstName: 'Vorname',
    primaryContact: 'Primärkontakt',
  },
  customerWizard: {
    namePlaceholder: 'z.B. LinköpingGemeinde',
    privateCompany: 'Privates Unternehmen',
    cityPlaceholder: 'Linköping',
    fixedMonthly: 'Feste monatliche Gebühr',
    perUser: 'Pro Benutzer',
    otherInfoPlaceholder: 'Weitere Informationen...',
  },
  customerPackages: {
    allPackagesSelected: 'Alle verfügbaren Pakete sind ausgewählt',
  },
  customerApiConfig: {
    lastUsed: 'Zuletzt verwendet:',
    noEndpoints: 'Keine Endpunkte verfügbar',
  },
  customerFederationConfig: {
    autoGenerate: 'Leer lassen für automatische Generierung basierend auf der Organisations-ID.',
    redirectUri: 'Umleitungs-URI (für IdP-Konfiguration)',
    clientAuthMethod: 'Client Authentifizierung',
    certificate: 'Zertifikat (private_key_jwt)',
    certHelp: 'Wir (der Kunde) besitzen den privaten Schlüssel. Das öffentliche Zertifikat wird in Entra hochgeladen (Zertifikate & Geheimnisse → Zertifikate). Die Felder akzeptieren Inline-PEM oder einen Dateipfad auf dem Server (empfohlen: Datei mit 0600).',
    certificatePem: 'Öffentliches Zertifikat (PEM oder Dateipfad)',
    privateKeyPem: 'Privater Schlüssel (PEM oder Dateipfad)',
    privateKeyHint: 'Wird von uns geheim gespeichert und niemals von der API zurückgegeben. Verwenden Sie vorzugsweise einen Dateipfad auf dem Server.',
    defaultRole: 'Standardrolle für neue SSO-Benutzer',
    defaultRoleFallback: 'Standard (Benutzer / VIEWER)',
    defaultRoleHelp: 'Rolle wird automatisch zugewiesen, wenn sich ein neuer Benutzer über SSO anmeldet. Vorhandene Konten behalten ihre Rolle.',
    claimMapping: 'Anspruchszuordnung',
    claimMappingHelp: 'Geben Sie die Anspruchsnamen ein, die der IdP sendet. Lassen Sie das Feld leer, um Standardnamen zu verwenden (E-Mail, Vorname, Nachname, RSID, Telefonnummer).',
    claimRsid: 'RSID',
    claimEmail: 'E-Mail',
    claimFirstName: 'Vorname',
    claimLastName: 'Nachname',
    claimPhone: 'Telefon',
    mustActivate: 'Der Kunde muss aktiviert sein, um den Verbund zu konfigurieren.',
    mustActivateSso: 'Ermöglichen Sie dem Kunden, eine Organisation zu erstellen und dann SSO zu konfigurieren.',
    configured: 'Konfiguriert, aber inaktiv',
    notConfigured: 'Nicht konfiguriert',
    enabled: 'Aktiviert',
    activateSaml: 'SAML aktivieren 2.0',
    activateOidc: 'OpenID Connect aktivieren',
    activateAdSync: 'AD-Benutzersynchronisierung aktivieren',
    updateSaml: 'SAML aktualisieren',
    saveSaml: 'SAML speichern',
    updateOidc: 'OIDC aktualisieren',
    saveOidc: 'OIDC speichern',
    update: 'Aktualisieren',
    save: 'Speichern',
    delete: 'Entfernen',
    adSyncTab: 'AD-Benutzersynchronisierung',
    adSyncTitle: 'Was der Kunde bereitstellen muss (Enter ID)',
    adSyncStep1: 'Schritt 1 – App-Registrierung in Entra ID',
    adSyncStep2: 'Schritt 2 – API-Berechtigungen (erfordert Global Admin)',
    adSyncStep3: 'Schritt 3 – Client Secret',
    adSyncSyncMode: 'Synchronisierungsmodus',
    adSyncModeManual: 'Manuell (über Schaltfläche)',
    adSyncModeNightly: 'Automatisch jede Nacht',
    adSyncLastSync: 'Letzte Synchronisierung',
    adSyncNone: 'Noch keine Synchronisierung durchgeführt',
    adSyncSyncChanges: 'Änderungen synchronisieren',
    adSyncSyncAll: 'Alle synchronisieren',
    adSyncFullSync: 'Vollständige Synchronisierung',
    adSyncTestConnection: 'Verbindung testen (Vorschau)',
    adSyncLogTitle: 'Letzte Synchronisierungen',
    adSyncPreviewOk: 'Verbindung OK – ~{{count}} Benutzer in AD ({{disabled}} deaktiviert)',
    adSyncPreviewMore: 'Zeigt 10 der heruntergeladenen {{count}} (Vorschau)',
    adSyncIncremental: '(inkrementell)',
    adSyncFull: '(vollständig)',
    adSyncFetched: 'heruntergeladen',
    adSyncCreated: 'neu',
    adSyncUpdated: 'aktualisiert',
    adSyncDeactivated: 'deaktiviert',
    copyUrl: 'URL kopieren',
    copyUrlShort: 'Kopieren',
    giveUrlToIt: 'Geben Sie diese URL an die IT-Abteilung des Kunden weiter, um dessen IdP zu konfigurieren.',
    tableColName: 'Name',
    tableColEmail: 'E-Mail',
    tableColDepartment: 'Abteilung',
    tableColStatus: 'Status',
    userActive: 'Aktiv',
    userInactive: 'Inaktiv',
  },
  customerSmsConfig: {
    enableSmsService: 'SMS-Dienst aktivieren',
    useCases: 'Einsatzbereiche:',
    title: 'SMS-Konfiguration',
    subtitle: 'SMS-Versand für Benachrichtigungen und Alarme konfigurieren',
    statusActive: 'Aktiv',
    statusInactive: 'Inaktiv',
    provider: 'SMS-Anbieter',
    senderId: 'Absender-ID (max. 11 Zeichen)',
    apiKey: 'API-Schlüssel',
    apiKeyUnchanged: '(unverändert)',
    apiKeyPlaceholder: 'API-Schlüssel eingeben',
    apiKeyConfigured: 'Ein API-Schlüssel ist bereits konfiguriert. Lassen Sie das Feld leer, um es beizubehalten.',
    apiUrl: 'API-URL (optional)',
    apiUrlPlaceholder: 'Standard-URL leer lassen',
    saveSettings: 'Speichern Einstellungen',
    saving: 'Speichern...',
    saveSuccess: 'SMS-Einstellungen gespeichert',
    saveError: 'SMS-Einstellungen konnten nicht gespeichert werden',
    testSection: 'SMS-Konfiguration testen',
    testPhonePlaceholder: '07XXXXXXXX oder +46...',
    testSend: 'Test senden',
    testSending: 'Senden...',
    testSuccess: 'Test-SMS gesendet!',
    testFailed: 'Test fehlgeschlagen',
    testError: 'Test-SMS konnte nicht gesendet werden',
    noOrgId: 'Organisation fehlt Organisations-ID',
    noPhoneNumber: 'Geben Sie eine Telefonnummer zum Testen ein',
    noOrgActivated: 'Dieser Kunde hat keine verknüpfte Organisation. Aktivieren Sie zuerst die Organisation.',
    useCaseGeofence: 'Geofence-Benachrichtigungen für Fahrer',
    useCaseVehicleEvents: 'Benachrichtigungen bei Fahrzeugereignissen',
    useCaseService: 'Wartungs- und Inspektionserinnerungen',
    providerNone: 'Keine (deaktiviert)',
    monthlyTitle: 'SMS pro Monat',
    monthlyEmpty: 'Noch keine SMS gesendet.',
    monthlyMonth: 'Monat',
    monthlyCount: 'Anzahl der SMS',
    monthlyAmount: 'Gesamt',
  },
  systemPackagesManager: {
    featuresPlaceholder: 'Telefonsupport\nSLA 99,9 %\nAPI-Zugriff',
  },
  importsManagement: {
    namePlaceholder: 'Z.B. Fahrzeugimport von Excel',
    selectTable: 'Tabelle auswählen...',
    firstRowIsHeader: 'Erste Zeile ist Kopfzeile',
    dragFileHere: 'Datei hierher ziehen oder zum Auswählen klicken',
    skipKeepExisting: 'Überspringen (vorhanden bleiben)',
    replaceRow: 'REPLACE (Zeile ersetzen)',
    runImport: 'Import ausführen',
    filesFromSource: 'Dateien aus der Quelle',
    runImportFromFtp: 'Import von FTP ausführen',
  },
  tripValidation: {
    needsReview: 'Überprüfung erforderlich',
    manage: 'Verwalten',
    resolve: 'Auflösen',
    deleteReasonPlaceholder: 'Beschreiben Sie, warum diese Reise entfernt wird (mindestens 5 Zeichen)...',
    minCharsRequired: 'Mindestens 5 Zeichen sind erforderlich',
  },
  systemMonitor: {
    title: 'Systemüberwachung',
    queue: 'Warteschlange',
    queueLength: 'Warteschlangenlänge',
    serverNumbers: 'Zahlen vom Server:',
    running: 'Laufen',
    runNow: 'Wird jetzt ausgeführt',
    latestRuns: 'Letzte Ausführungen',
    speedLimitBackfill: 'Geschwindigkeitsbegrenzungs-Backfill',
    speedLimitQueue: 'Warteschlange (trip_speed_limit_backfill)',
    speedLimitConsumers: 'Verbraucher',
    speedLimitDlq: 'DLQ-Meldungen',
    speedLimitRate: 'Fahrten/Minute (durchschnittlich 5 Minuten)',
    speedLimitProcessedTotal: 'Gesamt verarbeitet',
    speedLimitWorkers: 'Mitarbeiter online',
    speedLimitAlerts: 'Warnungen',
    noAlerts: 'Keine Warnungen',
    importSources: {
      title: 'Importquellen (Empfang)',
      total: 'Quellen',
      active: 'Aktiv',
      failed: 'Fehler',
      pendingFiles: 'Dateien in Verzeichnissen',
      none: 'Keine Importquellen konfiguriert',
      name: 'Name',
      type: 'Typ',
      lastFetch: 'Letzter Download',
      filesInDir: 'Dateien im Verzeichnis',
      newestFile: 'Letzte Datei',
      inactive: 'Inaktiv',
      never: 'Nie',
      dirMissing: 'Verzeichnis fehlt/nicht lesbar',
    },
  },
  dataReplay: {
    clearAllDescription: 'Alle Tripp/GPS/eco/stats-Daten und Warteschlangen löschen. Fahrzeuge und Geräte bleiben erhalten.',
    searchPlaceholder: 'Suche IMEI oder Kennzeichen...',
    verifyDataStatus: 'Datenstatus überprüfen',
    fullReset: 'Vollständiger Reset',
    replayAllFiles: 'Alle Dateien erneut abspielen (Entwickler)',
    fullResetInProgress: 'Vollständiger Reset läuft... Dies kann einige Minuten dauern. Warten.',
    allDbEmpty: 'Alle Datenbanken leer (vollständiges Zurücksetzen bestätigt)',
    someTablesHaveData: 'Einige Tabellen/Sammlungen enthalten noch Daten',
    startReplay: 'Wiedergabe starten',
    startReplaySection: 'Wiedergabe starten',
    fromDate: 'Von-Datum',
    toDate: 'Bis-Datum',
    organization: 'Organisation',
    vehicleImei: 'Fahrzeuge (IMEI)',
    selectOrgFirst: 'Zuerst Organisation auswählen',
    allVehiclesInOrg: 'Alle Fahrzeuge in der Organisation',
    allVehiclesInOrgHint: 'Leer IMEI – alle Einheiten in der Organisation (je nach Datenbankumfang)',
    noVehiclesFound: 'Für diesen Datumsbereich sind keine Fahrzeuge aufgeführt (oder keine, die mit dem übereinstimmen). Suche)',
    replayNote: 'HINWEIS: Bei der Wiedergabe werden zunächst die vorhandenen Daten für die ausgewählte Organisation und den ausgewählten Datumsbereich gelöscht. Bei ausgewähltem Fahrzeug (IMEI) wird die Batch-Wiedergabe verwendet, die Fahrten sofort erstellt und speichert (empfohlen). Wenn IMEI nicht ausgewählt ist, werden Pakete über Worker für alle Einheiten im Organisationsbereich in die Warteschlange gestellt.',
    availableDates: 'Verfügbare Daten',
    noBinFiles: 'Keine Bin-Dateien gefunden',
    clickDateHint: 'Klicken Sie auf ein Datum, um es ein-/auszuschalten. Sie können auch ein beliebiges Datum in die Felder oben schreiben (die Liste zeigt maximal 90 Tage).',
    files: 'Dateien',
    showingDates: 'Zeigt 90 von {{total}} Daten an. Verwenden Sie die Von/Bis-Felder für ältere Daten.',
    replayJobs: 'Jobs wiederholen',
    noActiveJobs: 'Keine aktiven Jobs',
    orgLabel: 'Organisation {{id}}',
    allDevicesInOrg: 'alle Einheiten in der Organisation',
    allVehiclesGlobal: 'Alle Fahrzeuge (global)',
    filesProgress: '{{processed}}/{{total}} Dateien',
    tripsDeleted: '{{count}}Fahrten gelöscht',
    queued: '{{count}} in der Warteschlange',
    stopReplay: 'Wiedergabe stoppen',
    stepLog: 'Schrittprotokoll:',
    selectOrgPlaceholder: 'Organisation auswählen…',
  },
  speedComplianceReport: {
    selectOrgAndDateRange: 'Organisation und Datumsbereich auswählen',
    violationPercent: 'Verstoß (%)',
    violations: 'Verstöße',
    timeOverLimit: 'Zeitüberschreitung',
    segmentsHint: 'Zeigt Messpunkte pro Geschwindigkeitsbegrenzung (NVDB, sonst OSM-Zeichen). Der Höchstwert des Verstoßes ist die höchste GPS-Geschwindigkeit, bei der das Fahrzeug mehr als 10 % über dem Grenzwert unterwegs war. Einzelne Sekunden, in denen die Position auf eine Nebenstraße trifft, werden nicht gezählt. Nur GPSSpitzen über 250 km/h werden herausgefiltert.',
  },
  vehicleWearReport: {
    wearScore: 'Verschleißpunkte',
    wear: 'Verschleißpunkte',
    noVehicleData: 'Keine Fahrzeugdaten',
  },
  co2Report: {
    noVehicleData: 'Keine Fahrzeugdaten',
  },
  odometerReport: {
    searchPlaceholder: 'Regnr, Marke suchen...',
  },
  drivingLog: {
    searchVehiclePlaceholder: 'Fahrzeug suchen oder auswählen...',
  },
  rentalReport: {
    recipientNamePlaceholder: 'Empfängername',
  },
  geofenceEvents: {
    searchVehiclePlaceholder: 'Fahrzeuge suchen...',
  },
  signup: {
    title: 'DQFleetKonto erstellen',
    subtitle: 'Nach der Registrierung müssen Sie Ihre E-Mail-Adresse bestätigen, bevor Sie sich anmelden können.',
    firstNameLabel: 'Vorname',
    lastNameLabel: 'Nachname',
    emailLabel: 'E-Mail',
    passwordLabel: 'Passwort',
    confirmPasswordLabel: 'Passwort bestätigen',
    firstNamePlaceholder: 'Vorname',
    lastNamePlaceholder: 'Nachname',
    emailPlaceholder: 'din@foretag.se',
    passwordPlaceholder: 'Mindestens 8 Zeichen',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    passwordRulesHint: 'Mindestens 8 Zeichen, Großbuchstabe, Kleinbuchstabe, Zahl und Sonderzeichen (gleiche Anforderungen wie für manuell erstellte Konten).',
    infoBoxTitle: 'Organisation und Zugriff',
    infoBoxBody: 'Verwenden Sie vorzugsweise Ihre geschäftliche E-Mail-Adresse. Wenn Ihre Organisation Ihre E-Mail-Domäne registriert hat, werden Sie nach der Überprüfung automatisch mit der Rolle „Betrachter“ mit ihr verbunden.',
    infoBoxManual: 'Wenn die Domäne nicht registriert ist, erhalten Sie ein Konto, das ein Administrator anschließend mit der richtigen Organisation verbinden kann.',
    tosPrefix: 'Ich akzeptiere',
    tosTerms: 'die Nutzungsbedingungen',
    tosAnd: 'und',
    tosPrivacy: 'die Datenschutzrichtlinie',
    submit: 'Konto erstellen',
    creating: 'Erstellerkonto...',
    hasAccount: 'Haben Sie bereits ein Konto?',
    loginLink: 'Anmelden',
    toastSuccessOrgLinked: 'Konto erstellt. Ihre Domain ist mit einer Organisation verknüpft. Bestätigen Sie Ihre E-Mail-Adresse, um das Konto zu aktivieren.',
    toastSuccessManual: 'Konto erstellt. Bestätigen Sie Ihre E-Mail. Wenn Ihre Organisation Ihre Domäne nicht erkennt, muss möglicherweise ein Administrator Ihr Konto verknüpfen.',
    createError: 'Konto konnte nicht erstellt werden. Versuchen Sie es erneut.',
  },
  packagesManagement: {
    unlimitedPlaceholder: 'Unbegrenzt',
    phoneSupportPlaceholder: 'Telefonsupport...',
  },
  serviceOverview: {
    statusOverdue: 'Läuft ab',
    statusDueSoon: 'Läuft bald ab',
    statusCompleted: 'Fertig',
    allStatuses: 'Alle Status',
    overdueFilter: 'Überfällig',
    dueSoonFilter: 'Läuft bald ab',
    bookedFilter: 'Gebucht',
    nextKm: 'Nächster km',
  },
  deviceAssignModal: {
    title: 'IMEI der Organisation zuweisen',
    pasteImeiAndSelectOrg: 'XLSX hochladen oder IMEI einfügen und Organisation auswählen',
    assignmentComplete: 'Vollständig zuweisen',
    devicesAssigned: 'Geräte zugewiesen',
    assigned: 'Zugewiesen',
    skippedMounted: 'Überspringen (montiert)',
    notFound: 'Nicht gefunden',
    invalidFormat: 'Ungültiges Format',
    notFoundImeis: 'Nicht gefunden IMEI:',
    errors: 'Fehler:',
    selectOrg: 'Auswählen Organisation...',
    imeiLabel: 'IMEI Zahlen (einfügen, eine pro Zeile, durch Komma oder Semikolon getrennt)',
    pasteImeiHere: 'Hier IMEI einfügen...',
    validateImei: 'Validieren IMEI',
    validImeiFound: '{count}gültige IMEI-Nummern gefunden',
    clear: 'Löschen',
    assignDevices: '{count}-Einheiten zuweisen',
    xlsxSection: 'Excel-Import (.xlsx)',
    xlsxHint: 'Klicken Sie, um die Datei auszuwählen – Spalte A = IMEI, Zelle B2 = Anzahl der Kabel',
    xlsxOnly: 'Nur .xlsx-Dateien werden unterstützt.',
    xlsxNoImei: 'Kein gültiges IMEI in Spalte A gefunden.',
    xlsxReadError: 'Die Datei konnte nicht gelesen werden.',
    xlsxImeiNote: 'Tipp: Formatieren Sie IMEI als Text in Excel, damit die Zahlen angezeigt werden werden nicht gerundet.',
    orPaste: 'oder',
    cablesFromFile: 'Kabel aus Datei (B2): {n} (wird bei Zuweisung beim CRM-Kunden gespeichert)',
  },
  commonUi: {
    closeModal: 'Schließen',
    previousMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    noLanguages: 'Keine Sprachen verfügbar',
    noRouteData: 'Keine Routendaten verfügbar',
    highPriority: 'Hoch',
  },
  customerDevicesTab: {
    inVehicle: 'Im Fahrzeug',
    customerStock: 'Kundenbestand',
    centralStock: 'Zentrale Lagerung',
    allOrganizations: 'Alle Organisationen',
    deviceCount: 'Einheiten',
  },
  vehicleListWidget: {
    totalVehicles: 'Gesamtfahrzeuge',
    fleetNow: 'Flotte gerade jetzt',
    withDevice: 'mit Gerät',
    online: 'online',
    offline: 'offline',
  },
  inspectionWidget: {
    title: 'Inspektionen',
    titleWithDays: 'Inspektion innerhalb von 40 Tagen',
    noVehicles: 'Keine Fahrzeuge',
    overdue: 'Überfällig',
    daysAgo: '{days}vor',
    today: 'Heute',
  },
  leasingWidget: {
    title: 'Leasing',
    titleWithMonths: 'Vermietung innerhalb von {months} Monaten',
    noVehicles: 'Keine Leasingverträge laufen bald aus',
    overdue: 'Überfällig',
    daysAgo: '{days}vor',
    today: 'Heute',
    openCase: 'Offener Fall',
    toModule: 'Zum Kauf',
  },
  procurement: {
    title: 'Anschaffung und Stilllegung',
    cardDescription: 'Entscheidung, das Fahrzeug zu ersetzen oder zu verschrotten, wenn sich das Leasing dem Ende nähert',
    tabCases: 'Fall',
    tabSettings: 'Einstellungen',
    newCase: 'Neuer Fall',
    newCaseHelp: 'Zuerst Fahrzeug auswählen. Der Fall wird nur gespeichert, wenn Sie auf „Speichern“ klicken.',
    selectVehicle: 'Fahrzeug im oberen Knoten auswählen',
    selectVehiclePlaceholder: 'Registrierungsnummer, Marke oder Modell suchen',
    noVehiclesFound: 'Keine Fahrzeuge entsprechen der Suche',
    vehicleSearchError: 'Fahrzeug konnte nicht gesucht werden',
    vehicleLoadError: 'Fahrzeugdetails konnten nicht abgerufen werden',
    business: 'Vorgang',
    unknownBusiness: 'Keine Aktivität angegeben',
    organization: 'Organisation',
    makeModel: 'Marke, Modell und Modelljahr',
    currentStatus: 'Aktueller Status',
    vehicleType: 'Fahrzeugtyp',
    poolCar: 'Poolwagen',
    alreadyOpenCase: 'Es gibt bereits einen offenen Fall für dieses Fahrzeug.',
    openExisting: 'Vorhandenen Fall öffnen',
    existingCaseOpened: 'Vorhandenen Fall öffnen',
    caseCreated: 'Der Fall wurde gespeichert',
    firstDecisionHint: 'Die folgende Verwendung ist die Grundlage für die erste Entscheidung: Fahrzeug ersetzen oder verschrotten.',
    utilizationWindow: 'Analyse der letzten {months} Monate, berechnet anhand der verfügbaren Fahrdaten.',
    insufficientHistory: 'Wir haben Fahrdaten von weniger als 12 Monaten ({months} Monate). Die Berechnung erfolgt auf Basis der verfügbaren Daten.',
    poolUtilization: 'Auslastung Poolwagen',
    poolOccupancy: '{pct} % Auslastung ({booked} gebuchte Stunden von {capacity} möglich).',
    poolUtilizationMissing: 'Keine Buchungsdaten zur Berechnung der Belegung.',
    noCases: 'Keine Fälle',
    noVehicle: 'Ohne Fahrzeug',
    loadError: 'Fälle konnten nicht geladen werden',
    createError: 'Fall konnte nicht erstellt werden',
    saveError: 'Speichern nicht möglich',
    refreshError: 'Datenbank konnte nicht aktualisiert werden',
    uploadError: 'Datei konnte nicht hochgeladen werden',
    settingsLoadError: 'Einstellungen konnten nicht geladen werden',
    settingsSaveError: 'Einstellungen konnten nicht gespeichert werden',
    settingsSaved: 'Einstellungen gespeichert',
    colTitle: 'Fall',
    colVehicle: 'Fahrzeuge',
    colOrg: 'Organisation',
    colStatus: 'Status',
    colOutcome: 'Ergebnis',
    colStep: 'Schritt',
    colRentEnd: 'Leasingende',
    statusOpen: 'Offen',
    statusDraft: 'Entwurf',
    statusInProgress: 'In Bearbeitung',
    statusCompleted: 'Beendet',
    statusCancelled: 'Abgebrochen',
    status_draft: 'Entwurf',
    status_in_progress: 'In Bearbeitung',
    status_completed: 'Fertig',
    status_cancelled: 'Storniert',
    outcome_undecided: 'Unentschlossen',
    outcome_replace: 'Ersetzen',
    outcome_decommission: 'Stilllegung',
    decisionModel: 'Entscheidungsmodell',
    decisionAuthority: 'Wer entscheidet',
    authorityFleet: 'Flottenmanager',
    authorityOperations: 'Das Unternehmen',
    utilizationMonths: 'Nutzungszeitraum (Monate)',
    utilizationMonthsHelp: 'Standard 36. Kann pro Kunde geändert werden (1–60).',
    steps: 'Schritt',
    processTitle: 'Kundenprozess',
    processHelp: 'Die Schritte gelten oben Knoten und wird in jeden neuen Fall kopiert. Vorhandene Fälle behalten den Prozess bei, mit dem sie erstellt wurden. Aktivieren Sie „Verwenden“, damit die Schritte bei der Fallerstellung einbezogen werden sollen.',
    stepOrder: 'Auftrag',
    stepName: 'Schrittname',
    stepNamePlaceholder: 'Beispiel: Angebot vom Lieferanten',
    stepApplies: 'Anwenden',
    stepUse: 'Übernehmen',
    stepRequired: 'Erforderlich',
    stepAttachment: 'Anhang',
    addStep: 'Schritte hinzufügen',
    moveUp: 'Nach oben verschieben',
    moveDown: 'Nach unten verschieben',
    noProcessSteps: 'Noch keine Schritte. Fügen Sie die Schritte hinzu, die für diesen Kunden gelten.',
    stepNameRequired: 'Alle Schritte müssen einen Namen haben',
    processNeedsStep: 'Mindestens ein Schritt muss als „Verwenden“ aktiviert sein',
    grounds: 'Entscheidungsbasis',
    applies_always: 'Immer',
    applies_replace: 'Ersetzen',
    applies_decommission: 'Stilllegung',
    applies_both: 'Beide',
    utilization: 'Nutzungsbasis',
    refreshUtilization: 'Basis aktualisieren',
    kpiDistance: 'Kilometerstand',
    kpiTrips: 'Reise',
    kpiDaysDriven: 'Getriebene Tage',
    kpiScore: 'Auslastungsbewertung',
    recommend: 'Fleetmanager-Empfehlung',
    fleetStatement: 'Stellungnahme von Fleetmanager',
    saveRecommend: 'Empfehlung speichern',
    recommendSaved: 'Empfehlung gespeichert',
    decide: 'Formelle Entscheidung',
    operationsStatement: 'Stellungnahme des Unternehmens',
    justification: 'Begründung',
    saveDecision: 'Geben Sie ab Entscheidung',
    decisionSaved: 'Entscheidung gespeichert',
    markDone: 'Fertig',
    attach: 'Anhängen',
    proposals: 'Vergütungsvorschlag',
    proposalTitle: 'Vorschlagstitel',
    addProposal: 'Vorschlag hinzufügen',
    documents: 'Dokument',
    complete: 'Fall beenden',
    cancel: 'Fall stornieren',
    step_pending: 'Warten',
    step_done: 'Fertig',
    step_skipped: 'Gesprungen',
  },
  taxWidget: {
    title: 'Kfz-Steuer',
    titleWithDays: 'Steuer innerhalb von 45 Tagen',
    noVehicles: 'Keine Fahrzeuge mit Steuer innerhalb von 45 Tagen',
    overdue: 'Überfällig',
    daysAgo: '{days}vor',
    today: 'Heute',
  },
  productionCost: {
    title: 'Produktion und Kosten',
    kmTitle: 'Gefahrene Kilometer pro Monat',
    fuelTitle: 'Kraftstoffkosten pro Monat',
    inMonth: 'im {month}',
    vsPrevious: '{percent} gegenüber {month}',
    totalKm: 'Gesamt',
    periodCost: 'Kosten im Zeitraum',
    perKm: 'Schnitt kr/km',
    perVehicle: 'Schnitt pro Fahrzeug und Monat',
    link: 'Gesamtkosten der Flotte →',
    noData: 'Keine Strecke oder Kosten für den Zeitraum',
    span: { months: '12 Mon.', year: '1 Jahr', quarter: 'Pro Quartal' },
  },

  actionRequired: {
    title: 'Handlungsbedarf',
    sortedByOverdue: 'Nach Überfälligen sortiert',
    service: 'Service',
    serviceHint: 'innerhalb von 300 km oder 60 Tagen',
    inspection: 'Inspektion',
    inspectionHint: 'innerhalb von {days} Tagen',
    leasing: 'Leasing',
    leasingHint: 'läuft innerhalb von {months} Monaten ab',
    tax: 'Kfz-Steuer',
    taxHint: 'innerhalb von {days} Tagen',
    overdue: '{count} überfällig',
    soon: '{count} bald',
    assigned: '{count} zugewiesen',
    openDetail: '{name} öffnen',
  },
  unpluggedWidget: {
    title: 'Verbindung getrennt',
    subtitle: 'Verbindung getrennt',
    warning: 'Warnung',
    allConnected: 'Alle Geräte verbunden',
  },
  gpsLagWidget: {
    title: 'GPS Verzögerungen',
    subtitle: 'Empfangene Bins im Vergleich zu im Gerät erstellten Daten (>1 Stunde)',
    noVehicles: 'Keine Fahrzeuge mit verzögerten GPS-Daten',
    dumpQueue: 'in der Dump-Warteschlange',
    dumpLagLabel: 'Diff-Empfänger',
    showDumpOnly: 'Nur Dump-Warteschlange anzeigen',
    showAllStale: 'Alle veralteten anzeigen',
    kind: {
      dumping_lag: 'Dump-Warteschlange',
      silent: 'Still',
      parked_or_old: 'Geparkt',
      lost_while_driving: 'Fahrt – gelöscht',
    },
  },
  unplugEvents: {
    title: 'Unscharf-Verlauf',
    subtitle: 'Scharfschalten und Deaktivierung des GPSGeräts mit Zeit und nächstgelegener Position.',
    backToDashboard: 'Zurück zum Dashboard',
    openHistory: 'Scharf- und Deaktivierungsverlauf anzeigen',
    eventType: 'Ereignis',
    allTypes: 'Alle',
    unplugged: 'Getrennt',
    plugged: 'Verbunden',
    occurredAt: 'Zeit',
    address: 'Position',
    email: 'E-Mail',
    emailSent: 'Gesendet',
    emailNotSent: 'Nicht gesendet',
    searchPlaceholder: 'Registrierungsnummer suchen',
    registrationNumber: 'Registernummer',
    empty: 'Keine Ereignisse im ausgewählten Zeitraum.',
    showing: 'Anzeige von {{from}}–{{to}} von {{total}}',
    pageOf: 'Seite {{page}} von {{pages}}',
    loadError: 'Verbindungsverlauf konnte nicht abgerufen werden.',
    mapSource: 'Nächster GPS-Punkt',
  },
  appRoutes: {
    salesPipeline: 'Sales-Pipeline',
    salesPipelineDesc: 'Sales-Funnel und Leads',
    economicOverview: 'Finanzübersicht',
    economicOverviewDesc: 'Rolling 12, Trends und Umsatz',
  },
  deviceImportModal: {
    pasteImeiAndSelectOrg: 'Fügen Sie die IMEI-Nummer ein und wählen Sie die Organisation aus',
  },
  tireManagement: {
    partnerPlaceholder: 'Reifenpartner Sundsvall',
  },
  companySearch: {
    title: 'Firma suchen',
    lookupButton: 'Firma suchen',
    whoLabel: 'Firmenname/Telefon',
    whoPlaceholder: 'Z.B. Volvo oder 08-123',
    whereLabel: 'Stadt (optional)',
    wherePlaceholder: 'Z.B. Stockholm',
    search: 'Suchen',
    searching: 'Suche...',
    minChars: 'Geben Sie mindestens 2 Zeichen ein',
    searchError: 'Konnte nicht nach Unternehmen suchen',
    noResults: 'Es wurden keine Unternehmen gefunden. Versuchen Sie es mit einem anderen Schlüsselwort.',
    startSearching: 'Suchen Sie nach Firmenname, Telefonnummer oder Adresse.',
    resultsCount: '{{count}} Treffer',
    showingOfTotal: 'Zeigt {{showing}} von {{total}} Treffern',
    refineSearch: 'Suche für weitere Ergebnisse verfeinern',
    wildcardHint: 'Platzhalter (*) wird automatisch hinzugefügt. Verwenden ? für einzelnes Zeichen.',
    page: 'Seite',
  },
  poolcarDemo: {
    myBookings: 'Meine Buchungen',
    bookingDetails: 'Buchung Details',
    digitalKey: 'Digitaler Schlüssel',
    returnVehicle: 'Fahrzeug zurückgeben',
    receipt: 'Beleg',
    noBookings: 'Keine Buchungen',
    noBookingsHint: 'Sie haben im Moment keine bevorstehenden Buchungen.',
    upcoming: 'Anstehende Buchungen',
    active: 'Aktiv',
    vehicle: 'Fahrzeuge',
    pool: 'Pool',
    period: 'Zeitraum',
    destination: 'Ziel',
    licenseConfirm: 'Ich bestätige, dass ich einen gültigen Führerschein habe und zum Führen des Fahrzeugs geeignet bin.',
    startsIn: 'Die Buchung beginnt erneut',
    checkoutVehicle: 'Fahrzeug abholen',
    vehicleUnlocked: 'Das Auto steht entriegelt',
    vehicleLocked: 'Das Auto ist verschlossen',
    communicating: 'Kommunikation...',
    bookingEnded: 'Die Buchung ist abgeschlossen',
    cannotUnlock: 'Das Auto kann nach Abschluss der Buchung nicht geöffnet werden.',
    tapToToggle: 'Zum Sperren/Entsperren drücken',
    bookingTime: 'Buchungszeit',
    returnTitle: 'Rückgabe',
    checkParked: 'Das Auto ist am richtigen Ort geparkt',
    checkLocked: 'Das Auto ist verschlossen',
    reportDamage: 'Schäden oder Unstimmigkeiten melden',
    damageDescription: 'Schaden beschreiben...',
    confirmReturn: 'Rückgabe bestätigen',
    thankYou: 'Vielen Dank!',
    vehicleReturned: 'Das Fahrzeug wurde zurückgegeben und registriert.',
    backToBookings: 'Zurück zu Buchungen',
    demoTitle: 'Schlüssellose Fahrgemeinschaft – Demo',
    demoDescription: 'Die Demo zeigt den gesamten Benutzerablauf für einen Mitarbeiter, der einen Poolwagen nutzen möchte, inklusive Buchung, Abholung, digitaler Schlüssellösung und Rückgabe.',
    step1: 'Buchung auswählen',
    step2: 'Fahrzeug abholen',
    step3: 'Entsperren/Sperren (Digitaler Schlüssel)',
    step4: 'Rückgabe',
    step5: 'Beleg',
  },
  tidbok: {
    title: 'Digitales Arbeitszeitbuch',
    subtitle: 'Lenk- und Ruhezeiten gemäß EU 561/2006 und TSFS 2013:3',
    registerActivity: 'Aktivität registrieren',
    selectDriver: 'Fahrer',
    selectDriverPlaceholder: 'Fahrer auswählen...',
    searchDriverPlaceholder: 'Fahrer suchen (Name oder Fahrerkartennummer)...',
    selectDriverToStart: 'Fahrer auswählen, um das Arbeitszeitbuch anzuzeigen',
    driverCard: 'Fahrerkarte',
    previousWeek: 'Vorherige',
    nextWeek: 'Weiter',
    weekLabel: 'Woche {{week}}, {{year}}',
    noActivities: 'Diese Woche wurden keine Aktivitäten registriert',
    registerFirstActivity: 'Erste Aktivität registrieren',
    activitySaved: 'Aktivität gespeichert',
    errorLoadingDrivers: 'Fahrer konnte nicht abgerufen werden',
    errorLoadingVehicles: 'Fahrzeug konnte nicht heruntergeladen werden',
    errorLoadingEntries: 'Fahrplaneinträge konnten nicht heruntergeladen werden',
    errorSaving: 'Aktivität konnte nicht gespeichert werden',
    weekDriving: 'Fahrzeitwoche',
    weekWork: 'Arbeitszeitwoche',
    weekRest: 'Ruhewoche',
    driving: 'Fahrzeit',
    continuous: 'Kontinuierlich',
    activityType: 'Aktivitätstyp',
    vehicle: 'Fahrzeuge',
    selectVehiclePlaceholder: 'Fahrzeug auswählen...',
    date: 'Datum',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    noteOptional: 'Hinweis (optional)',
    notePlaceholder: 'z. B. Stockholm → Göteborg',
    saving: 'Speichern...',
    saveActivity: 'Aktivität speichern',
    rulesTitle: 'Vorschriften – gültige Grenzwerte',
    activity: {
      driving: 'Fahrzeit',
      otherWork: 'Andere Arbeiten',
      available: 'Verfügbar',
      rest: 'Ruhe',
    },
    rule: {
      maxDailyDriving: 'Maximale Lenkzeit pro Tag',
      maxContinuousDriving: 'Maximale ununterbrochene Lenkzeit',
      mandatoryBreak: 'Obligatorische Ruhezeit',
      minDailyRest: 'Meine tägliche Ruhezeit',
      maxWeeklyDriving: 'Maximale Lenkzeit pro Woche',
      maxBiweeklyDriving: 'Maximale Lenkzeit pro 2 Wochen',
    },
    validation: {
      selectVehicle: 'Fahrzeug auswählen',
      enterDate: 'Datum eingeben',
      enterStartTime: 'Startzeit eingeben',
      enterEndTime: 'Endzeit eingeben',
      endAfterStart: 'Endzeit muss nach Startzeit liegen',
    },
  },
  customerKeyHandling: {
    title: 'Schlüssel Verwaltung',
    summary: {
      cabinets: 'Anzahl der Schließfächer',
      places: 'Anzahl der Sitzplätze',
      linked: 'Verbundene Fahrzeuge',
    },
    columns: {
      name: 'Schrankname',
      lists: 'Listen',
      places: 'Standorte',
    },
    empty: 'Keine Schließfächer sind mit dem Kunden verknüpft.',
    noLayout: 'Die Schließfachlisten konnten nicht gelesen werden.',
    pickCustomer: 'Kunde auswählen',
    loadError: 'Konnte die Schließfächer nicht bekommen.',
    backToList: 'Zurück zu den Schließfächern',
    switchCabinet: 'Schließfach wechseln',
    historyTitle: 'KeyId {{keyId}}',
    historyEmpty: 'Keine gespeicherte Verbindung für diesen Schlüssel.',
    vehicleHistory: 'Fahrzeugschlüssel',
    historyOpen: 'In Bearbeitung',
    nameLabel: 'Schrankname',
    saveName: 'Name speichern',
    nameSaved: 'Der Schließfachname wurde gespeichert.',
    nameError: 'Der Schließfachname konnte nicht gespeichert werden.',
    selectSlot: 'Wählen Sie einen freien grünen Schlüssel aus und suchen Sie dann nach dem Fahrzeug. Die Verbindung wird sofort gespeichert.',
    searchVehicle: 'Fahrzeug suchen',
    searchPlaceholder: 'Registrierungsnummer, Marke oder Modell',
    searching: 'Suche…',
    noVehicles: 'Keine verfügbaren Fahrzeuge entsprechen der Suche.',
    linking: 'Verbindung wird hergestellt…',
    linked: 'Das Fahrzeug wurde verknüpft und auf {{location}} abgelegt.',
    linkError: 'Das Fahrzeug konnte nicht verbunden werden.',
    readOnly: 'Sie können die Schließfächer sehen. Zum Verknüpfen eines Schlüssels ist die Berechtigung „Schlüssel verknüpfen“ erforderlich.',
    fleetCount: '{{count}} Fahrzeuge ohne Steckplatz und Flinkey-Box',
    fleetEmpty: 'Kein Fahrzeug fehlt sowohl Steckplatz als auch Flinkey-Box.',
    kindVehicle: 'Fahrzeug',
    kindResource: 'Ressource',
    linkedResource: 'Die Buchungsressource wurde verknüpft.',
    unlink: 'Trennen',
    unlinkConfirm: '{{registration}} trennen? Der Schlüssel wird im Schrank frei.',
    unlinking: 'Trennen…',
    unlinked: 'Der Schlüssel wurde getrennt.',
    unlinkError: 'Trennen fehlgeschlagen.',
  },
  keyManagement: {
    title: 'Schließfachverwaltung',
    tabs: {
      cabinets: 'Cabinet',
      keys: 'Schlüssel',
      onpremConnect: 'Verbindung',
      cabinetSync: 'Schließfachsynchronisierung',
    },
    onpremConnect: {
      title: 'OpenVPN für OnPrem Cabinet',
      subtitle: 'Client-Zertifikat erstellen und .ovpn herunterladen. CA bleibt auf Kreon. Das Profil ist TCP zu 192.121.133.61:1194. Ein vorhandenes Profil kann erneut heruntergeladen werden.',
      cn: 'Allgemeiner Name',
      location: 'Standort',
      organization: 'Organisation',
      proto: 'Protokoll',
      validTo: 'Gültig bis',
      cnHint: 'Verwenden Sie Kleinbuchstaben, Zahlen und Bindestriche. Empfohlen: Cabinet-Location-Location.',
      create: '.ovpn erstellen und herunterladen',
      creating: 'Zertifikat wird generiert…',
      download: '.ovpn herunterladen',
      downloading: 'Wird geholt…',
      downloadError: 'OpenVPN-Profil konnte nicht geholt werden',
      loadError: 'OpenVPN-Clients konnten nicht aufgelistet werden',
      createError: 'OpenVPN-Zertifikat konnte nicht erstellt werden',
      empty: 'Noch keine Schrankzertifikate.',
    },
    cabinetSync: {
      title: 'Schranksynchronisierung (Creone Rabbit)',
      subtitle: 'Was KeyWin an jeden Schrank sendet. Nur globaler Administrator. PIN und persönliche Daten werden maskiert.',
      spyConnected: 'Beobachter verbunden',
      spyDisconnected: 'Beobachter getrennt',
      traceOn: 'Feuerschlauch an',
      traceOff: 'Feuerschlauch aus',
      eventsLastMinute: 'Ereignisse / Minute',
      eventsLastHour: 'Ereignisse / Stunde',
      bytesLastHour: 'Bytes / Stunde',
      storedEvents: 'Gespeicherte Ereignisse',
      queues: 'Warteschlangen',
      events: 'Ereignisse',
      queue: 'Warteschlange',
      kind: 'Typ',
      backlog: 'Rückstand',
      consumers: 'Verbraucher',
      publishRate: 'Veröffentlichen/s',
      deliverRate: 'Liefern/s',
      online: 'Kabinett hoch',
      offline: 'Kabinett runter',
      time: 'Zeit',
      type: 'Typ',
      size: 'Größe',
      summary: 'Inhalt',
      payload: 'Nutzlast',
      noEvents: 'Noch keine Nachrichten abgefangen. Machen Sie eine Reservierung oder warten Sie auf die nächste Synchronisierung.',
      loadError: 'Konnte keine Schranksynchronisierung erhalten',
      filterQueue: 'Warteschlange filtern',
      allQueues: 'Alle Warteschlangen',
      cabinet: 'Cabinet',
      keywin: 'KeyWin-Cloud',
      other: 'Andere',
      source: 'Quelle',
      sourceAll: 'Alla kallor',
      sourceRabbit: 'Rabbit',
      sourceLocker: 'Unsere API',
      sourceCabinetHttp: 'Schrank-HTTP',
    },
    summary: {
      totalCabinets: 'Schränke gesamt',
      keysIn: 'Nycklar inne',
      keysOut: 'Nycklar ute',
      unusedSlots: 'Outnyttjade tappar',
    },
    cabinet: {
      name: 'Name',
      location: 'Standort',
      status: 'Status',
      capacity: 'Kapacitet',
      occupiedSlots: 'Upptagna-Sitzplätze',
      availableSlots: 'Verfügbare Sitzplätze',
      assignedGroup: 'Ausgabeort',
      noGroup: 'Nicht zugewiesen',
      assignGroup: 'Übergabesitzplatz zuweisen',
      changeGroup: 'Lieferort ändern',
      removeGroup: 'Zuordnung entfernen',
      keysInCabinet: 'Schlüssel im Schließfach',
      showKeys: 'Schlüssel anzeigen',
      hideKeys: 'Schlüssel ausblenden',
      lists: 'Listen',
      listsShort: 'Streifen',
      keysShort: 'Schlüssel',
      keysIn: 'Nycklar inne',
      keysOut: 'Nycklar ute',
      inShort: 'innen',
      emptyShort: 'leer',
      unusedSlots: 'Outnyttjade tappar',
      slotsPerList: 'Zapfen/Streifen',
      empty: 'frei',
      emptySlot: 'Frei',
      backToOverview: 'Zurück zur Schrankübersicht',
      changeShort: 'Änderung',
      assignShort: 'Zuweisen',
      linkedToCustomer: 'Mit Kunden verknüpft',
      notLinkedToCustomer: 'Nicht mit Kunden verknüpft',
      linkCustomer: 'Mit Kunden verknüpft',
      unlinkCustomer: 'Kundenverknüpfung entfernen',
      linkCustomerConfirm: 'Das Schließfach mit einem Kunden verknüpfen? SuperAdmin und LocalAdmin werden als KeyWin-Benutzer mit den Schrankabgriffen angelegt (kein Web-Login).',
      unlinkCustomerConfirm: 'Kundenverbindung entfernen? Ausstellungsort und LocalAdmin werden entfernt.',
      linkCustomerFirst: 'Zuerst mit dem Kunden verknüpfen',
      localAdminPin: 'LocalAdmin-PIN',
      syncTags: 'Taps synchronisieren',
      syncTagsHelp: 'Verbindet nur Zapfstellen in diesem Schrank mit SuperAdmin und LocalAdmin. Keine Gruppe erstellt – KeyWin-Tastatur geht über Benutzer + Drops.',
    },
    key: {
      name: 'Name',
      keyId: 'KeyId',
      cabinet: 'Cabinet',
      slot: 'Standort',
      status: 'Status',
      available: 'Verfügbar',
      vehicle: 'Fahrzeuge',
      noVehicle: 'Nicht verbunden',
      assignVehicle: 'Fahrzeug verbinden',
      removeVehicle: 'entkoppeln',
      history: 'Verbindungsverlauf',
      historyOpen: 'In Bearbeitung',
      externalId: 'Externe ID',
      keyInfo: 'Schlüsselinformationen',
      linkedVehicle: 'Verbundenes Fahrzeug',
    },
    status: {
      online: 'Online',
      offline: 'Offline',
      error: 'Fehler',
      maintenance: 'Wartung',
      in_cabinet: 'Im Schrank',
      taken: 'Entfernt',
      lost: 'Verloren',
    },
    assignment: {
      assignedAt: 'Zugewiesen',
      assignedBy: 'Zugewiesen von',
      unassignedAt: 'Entfernt',
      note: 'Hinweis',
      notePlaceholder: 'Optionaler Hinweis...',
      noAssignments: 'Keine aktiven Verbindungen',
    },
    logs: {
      activityLog: 'Aktivitätsprotokoll',
      keyHistory: 'Aus-/Eingänge-Verlauf',
      noEvents: 'Keine Ereignisse',
      taken: 'Entfernt',
      returned: 'Zurückgegeben',
      alarm: 'Alarme',
      alarmsExist: 'Unbestätigte Alarme',
      linked: 'Verbunden mit',
      unlinked: 'Von',
      cabinetEvents: 'Kabinettsveranstaltungen',
      last24h: 'Letzte 24 Stunden',
      unacknowledgedAlarms: 'unquittierte Alarme',
      acknowledgeAll: 'Alle bestätigen',
      filterAll: 'Alle',
      filterAlarms: 'Alarme',
      filterKeys: 'Schlüssel',
      filterSystem: 'System',
      noEventsToShow: 'Keine anzuzeigenden Ereignisse',
    },
    messages: {
      assignSuccess: 'Verbindung erstellt',
      unassignSuccess: 'Kopplung entfernt',
      assignError: 'Kopplung konnte nicht erstellt werden',
      unassignError: 'Kopplung konnte nicht entfernt werden',
      customerAssignSuccess: 'Schrank mit Kunden verbunden',
      customerUnassignSuccess: 'Kundenverbindung war entfernt',
      customerAssignError: 'Schließfach konnte dem Kunden nicht zugeordnet werden',
      customerUnassignError: 'Kundenzuordnung konnte nicht entfernt werden',
      syncTagsSuccess: '{{count}} Taps, die mit SuperAdmin und LocalAdmin verknüpft sind',
      syncTagsEmpty: 'Noch keine Taps im Schrank. Mit integriertem SuperAdmin öffnen, Pins einstecken und erneut synchronisieren.',
      syncTagsError: 'Pins konnten nicht synchronisiert werden',
      missingKeyId: 'Schlüssel fehlt KeyId (OnPrem-Pin). Es kann nicht an einem Fahrzeug befestigt werden.',
      renameWarning: 'Das Fahrzeug wurde gekoppelt, aber der Name im Schließfach konnte nicht in das Kennzeichen geändert werden.',
      unassignRenameWarning: 'Die Kopplung wurde entfernt, aber das alte Kennzeichen konnte nicht aus dem PIN-Namen im Schließfach gelöscht werden.',
      loadError: 'Daten konnten nicht geladen werden',
      confirmRemove: 'Sind Sie sicher, dass Sie diese Kopplung entfernen möchten?',
      alarmAcknowledged: 'Alarm bestätigt',
      allAlarmsAcknowledged: 'Alle Alarme bestätigt',
      alarmError: 'Konnte nicht bestätigt werden Alarm',
    },
    filters: {
      allCabinets: 'Alle Schränke',
      allStatuses: 'Alle Status',
      searchPlaceholder: 'Suche nach Schlüsselname...',
    },
    modal: {
      selectGroup: 'Abholort auswählen',
      selectVehicle: 'Fahrzeug auswählen',
      registrationNumber: 'Registrierungsnummer',
      searchVehicle: 'Registrierungsnummer oder Modell suchen...',
      searchRegistration: 'Typregistrierungsnummer, z.B. ABC123',
      typeRegistrationHint: 'Geben Sie mindestens zwei Zeichen ein. Es werden nur Fahrzeuge ohne Schlüssel oder FlinkeyBox angezeigt.',
      orgVehiclesWithoutKey: 'Fahrzeuge unter der Schrankorganisation, die keinen Schlüsselstift haben. Zum Filtern suchen.',
      noOrgVehiclesWithoutKey: 'Keine Fahrzeuge ohne Schlüsselanhänger in der Organisation.',
      clickToSelect: 'Klicken Sie auf das Fahrzeug in der Liste, um es auszuwählen',
      noVehicleMatch: 'Kein verfügbares Fahrzeug stimmte mit der Suche überein',
      currentAssignment: 'Aktuelle Verbindung',
      noGroupSelected: 'Kein Lieferort ausgewählt',
      selectCustomer: 'Wählen Sie den obersten Knoten aus',
      searchCustomer: 'Oberen Knoten durchsuchen',
      noCustomerSelected: 'Kein oberster Knoten ausgewählt',
      noEligibleCustomers: 'Keine oberen Knoten gefunden.',
      linkCustomerHelp: 'Wählen Sie aus, an welchem obersten Knoten der Schrank befestigt werden soll. Als globaler Administrator sind alle Top-Knoten sichtbar. SuperAdmin und LocalAdmin werden zu KeyWin-Benutzern mit Schrankbetätigung, ohne Web-Login.',
    },
  },
  assignments: {
    title: 'Zuweisungen',
    description: 'Zuordnungen von Daten zu Personen verwalten',
    myAssignments: 'Meine Aufgaben',
    myAssignmentsHint: 'Ihnen zugewiesene Aufgaben',
    assigneeFilterMine: 'Mir zugewiesene',
    assigneeFilterAll: 'Alle Aufgaben',
    create: 'Aufgabe erstellen',
    category: 'Kategorie',
    whatToDo: 'Was zu tun ist',
    titlePlaceholder: 'Beschreiben Sie kurz die Aufgabe...',
    descriptionLabel: 'Beschreibung',
    assignedTo: 'Zugewiesen an',
    assignedBy: 'Zugewiesen von',
    assignedAt: 'Zugewiesen',
    selectUser: 'Benutzer auswählen...',
    priorityLabel: 'Priorität',
    priorityLow: 'Niedrig',
    priorityNormal: 'Normal',
    priorityHigh: 'Hoch',
    priorityUrgent: 'Dringend',
    vehicle: 'Fahrzeuge',
    vehicleIdPlaceholder: 'Fahrzeug-ID (optional)',
    dueDate: 'Frist',
    startWork: 'Beginn',
    complete: 'Als abgeschlossen markieren',
    cancel: 'Abbrechen',
    completionNotes: 'Hinweis',
    completionNotesPlaceholder: 'Beschreiben Sie, was getan wurde...',
    startedAt: 'Begonnen',
    completedAt: 'Bereit markiert',
    allStatuses: 'Alle Status',
    allCategories: 'Alle Kategorien',
    noCategories: 'Keine Kategorien verfügbar (Seed ausführen oder API prüfen)',
    statusPending: 'Warten',
    statusInProgress: 'In Bearbeitung',
    statusCompleted: 'Fertig',
    statusCancelled: 'Abgebrochen',
    noAssignments: 'Keine Zuweisungen gefunden',
    noOpenAssignments: 'Keine offenen Aufgaben',
    open: 'offen',
    viewAll: 'Alle Aufgaben anzeigen',
    fillRequired: 'Alle erforderlichen Felder ausfüllen',
    created: 'Aufgabe erstellt',
    started: 'Aufgabe gestartet',
    completed: 'Aufgabe gelöscht',
    cancelled: 'Aufgabe abgebrochen',
    confirmCancel: 'Sind Sie sicher, dass Sie diese Aufgabe abbrechen möchten?',
    assigned: 'zugewiesen',
    assign: 'Zuweisen',
    selectAll: 'Alle auswählen',
    assignSelected: 'Markierte zuweisen',
    vehiclesSelected: 'Markierte Fahrzeuge',
    assignmentsCreated: 'Zuweisungen erstellt',
  },
  mine: {
    title: 'Mein',
    bookings: 'Buchungen',
    assignments: 'Zuweisungen',
    nothingToday: 'Heute nichts gebucht. Brauchen Sie ein Auto?',
    bookedToday: '{count} Buchung heute',
    bookedTodayMany: '{count} Buchungen heute',
  },
  bookingWidget: {
    title: 'Meine Buchungen',
    noBookings: 'Keine bevorstehenden Buchungen',
    upcoming: 'Kommt',
    booked: 'Gebucht',
    checkedOut: 'Ausgecheckt',
    awaiting: 'Warten',
    awaitingHandling: 'Wartet auf Bearbeitung',
    noVehicleAssigned: 'Kein Auto zugewiesen',
    previousVehicle: 'Vorherige',
    openCalendar: 'Buchungskalender öffnen',
  },
  resourceTypesAdmin: {
    title: 'Ressourcentypen (System)',
    description: 'Systemressourcentypen verwalten, die Organisationen zugewiesen werden können',
    code: 'Code',
    nameSv: 'Name (en)',
    nameEn: 'Name (en)',
    displayOrder: 'Sortierreihenfolge',
    addNew: 'Neue Ressource hinzufügen Typ',
    codePlaceholder: 'zB. ROLLER',
    nameSvPlaceholder: 'zB. Elektroroller',
    nameEnPlaceholder: 'z. B. E-Scooter',
    created: 'Ressourcentyp erstellt',
    updated: 'Ressourcentyp aktualisiert',
    codeRequired: 'Code und Name erforderlich',
  },
  equipment: {
    title: 'Fahrzeugausstattung',
    description: 'Fahrzeugausrüstung zuordenbar verwalten',
    tagName: 'Name',
    organization: 'Organisation',
    createUnderOrganization: 'Organisation',
    icon: 'Symbol',
    newTagPlaceholder: 'Neue Fahrzeugausrüstung…',
    iconPlaceholder: 'Symbol (optional)',
    noTags: 'Keine Fahrzeugausrüstung. Fügen Sie zunächst einen Eintrag hinzu.',
    vehicleEquipment: 'Fahrzeugausstattung',
    noEquipment: 'Diesem Fahrzeug ist keine Ausrüstung zugewiesen.',
    selectTag: 'Ausrüstung auswählen…',
    notesPlaceholder: 'Hinweis (optional)',
    removed: 'Ausrüstung entfernt',
  },
  flinkeyBoxes: {
    title: 'FlinkeyBoxen',
    dashboardDescription: 'Digitale Schlüsselboxen und individuelle Zuweisungen Flinkey verwalten',
    addBox: 'Box hinzufügen',
    search: 'Produkt-ID, Seriennummer suchen...',
    productId: 'Produkt-ID',
    serialNumber: 'Seriennummer',
    boxType: 'Typ',
    carName: 'Fahrzeuge',
    licensePlate: 'Registernummer',
    contractStart: 'Vertragsbeginn',
    contractState: 'Vertragsstatus',
    notes: 'Notizen',
    organization: 'Organisation',
    individuals: 'Personen',
    noBoxes: 'Keine Boxen gefunden',
    scopeAll: 'Alle Boxen',
    scopeResponsible: 'Ich bin verantwortlich',
    noOrg: 'Keine Organisation',
    editBox: 'Feld bearbeiten',
    linkVehicleTitle: 'Fahrzeug verbinden',
    searchVehicle: 'Fahrzeuge suchen...',
    individualsDescription: 'Personen mit Zugriff auf dieses Feld',
    searchUser: 'Nach Benutzern suchen...',
    addUser: 'Hinzufügen',
    noUsers: 'Keine Personen hinzugefügt',
    vehicleLinked: 'Fahrzeug verbunden',
    vehicleLinkError: 'Fehler beim Verbinden des Fahrzeugs',
    linkVehicle: 'Fahrzeug verbinden',
    unlinkVehicle: 'Fahrzeug trennen',
    vehicleUnlinked: 'Fahrzeug getrennt',
    linkedVehicle: 'Verbundenes Fahrzeug',
    confirmDelete: 'Sind Sie sicher, dass Sie das Feld entfernen möchten {{id}}?',
    userAddError: 'Fehler beim Hinzufügen einer Person',
    removeUser: 'Person entfernen',
    confirmRemoveUser: 'Sind Sie sicher, dass Sie möchten {{name}} entfernen?',
    firmwareVersion: 'Firmware',
    importDeviaq: 'Deviaq importieren (Excel)',
    importDeviaqSuccess: 'Import abgeschlossen: {{inserted}} neu, {{updated}} aktualisiert',
    importDeviaqError: 'Import fehlgeschlagen',
    deviaqDetailsTitle: 'Deviaq-Zeile',
    deviaqNoDetails: 'Keine Deviaq-Daten für diese Box gespeichert.',
    selectedBoxes: 'Box(en) ausgewählt',
    assignOrg: 'Organisation zuweisen',
    assignOrgTitle: 'Organisation zuweisen',
    assignOrgTopNode: 'Organisation (Oberknoten)',
    searchOrg: 'Organisation suchen...',
    noOrgMatches: 'Keine Treffer',
    battery: 'Batterie',
    batteryUnknown: 'Unbekannt',
    batteryCharging: 'Laden',
    chargerDisconnected: 'Ladegerät nicht angeschlossen',
    nfcTestMode: 'Testmodus (kein Schlüssel/Karte bei Rückgabe erforderlich)',
    nfcTestModeHint: 'Wenn der Testmodus ausgeschaltet ist, muss der Schlüssel immer in der Box sein. Gekreuzt: Keine Überprüfung des Schlüssels oder der Karte.',
    nfcCardCheck: 'Karte bei Rückgabe prüfen',
    nfcCardCheckHint: 'Optional. Aktivieren Sie diese Option, wenn der Kunde auch die registrierte Karte zurückgeben soll. Erfordert die Registrierung der Karte auf der Box.',
    nfcDetectMode: 'Karten in der Box erkennen',
    nfcDetectModeHint: 'Bei Rückgabe/Öffnen: Wenn eine unbekannte NFC-Karte gefunden wird, kann autorisiertes Personal diese auf der Box registrieren.',
    permanentPower: 'Permanentes Ladekabel',
    permanentPowerHint: 'Warnung, wenn das Ladegerät als nicht angeschlossen gemeldet wird.',
    nfcTagsTitle: 'Registrierte NFC-Tags (Schlüssel/Tankkarte)',
    nfcTagsHint: 'Die Registrierung erfolgt in der mobilen App (in der Nähe der Box). Tags können hier angezeigt und entfernt werden.',
    noNfcTags: 'Keine NFC-Tags registriert.',
    nfcRequired: 'Erforderlich',
    nfcLabelKey: 'Taste',
    nfcLabelCard: 'Tankkarten',
    nfcTagDeleted: 'NFC-Tag entfernt',
    nfcTagDeleteError: 'NFC-Tag konnte nicht entfernt werden',
  },
  guide: {
    admin: {
      title: 'Guide-Verwaltung',
      description: 'Onboarding-Guides und Touren verwalten',
      newTour: 'Neue Tour',
      noTours: 'Keine Touren erstellt',
      inactive: 'Inaktiv',
      steps: 'Schritt',
      preview: 'Vorschau',
      deactivate: 'Deaktivieren',
      activate: 'Aktivieren',
      noSteps: 'Keine Schritte',
      noTitle: '(Kein Titel)',
      addStep: 'Schritte hinzufügen',
      stepTitle: 'Schritttitel',
      stepTitlePlaceholder: 'Z.B. Willkommen bei der Flottenübersicht',
      stepOrder: 'Auftrag',
      content: 'Inhalt',
      contentPlaceholder: 'Beschreiben Sie, was der Benutzer in diesem Schritt tun soll...',
      targetSelector: 'CSS-Selektor (Ziel)',
      targetSelectorHint: 'Z.B. #fleet-map oder .vehicle-list. Für zentrierten Dialog leer lassen.',
      placement: 'Standort',
      tourKey: 'Turn Key',
      tourName: 'Turn Name',
      tourNamePlaceholder: 'Z.B. Einführung in die Flottenübersicht',
      tourDescription: 'Beschreibung',
      sortOrder: 'Sortierreihenfolge',
      confirmDeleteTour: 'Sind Sie sicher, dass Sie diesen Schritt löschen möchten?',
      confirmDeleteStep: 'Sind Sie sicher, dass Sie diesen Schritt löschen möchten?',
    },
    showGuide: 'Anleitung anzeigen',
  },
  carinfoOrgSync: {
    title: 'Carinfo-Fahrzeugimport',
    dashboardDescription: 'Fahrzeuge von Car.info nach Organisationsnummer importieren',
    orgNumber: 'Org.nr',
    customer: 'Kunde',
    lastSync: 'Aktualisiert',
    syncCount: 'Synchronisierung',
    vehicleCount: 'Anzahl',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    source: 'Quelle',
    actions: 'Funktion',
    sync: 'Aktualisieren',
    log: 'Protokoll',
    syncResult: 'Ergebnisse synchronisieren',
    resultFor: 'Ergebnisse für',
    added: 'Hinzugefügt',
    updated: 'Aktualisiert',
    unchanged: 'Unverändert',
    inactivated: 'Deaktiviert',
    failed: 'Fehlgeschlagen',
    total: 'Gesamt',
    vehicles: 'Fahrzeuge',
    filialNumbersTitle: 'Erkannte Filialnummern',
    addFilialsAndSync: 'Ausgewählte Fahrzeuge hinzufügen und abrufen',
    syncLog: 'Synchronisieren Verlauf',
    noLogEntries: 'Kein Synchronisierungsverlauf verfügbar',
    noOrgNumbers: 'Keine Organisationsnummern konfiguriert. Fügen Sie org.nr über den CRM-Kunden-Tab „Org.nr Fahrzeuge“ hinzu.',
    date: 'Datum',
  },
  themeSettings: {
    title: 'Theme & Branding',
    description: 'Passen Sie die Farben für den Hell- und Dunkelmodus an. Die Vorschau wird sofort aktualisiert – nichts wird gespeichert, bis Sie auf Speichern klicken.',
    tabGlobal: 'Globaler Standard',
    tabPartner: 'Partnerthema',
    selectPartner: 'Partner auswählen',
    editMode: 'Bearbeitungsmodus',
    editModeHint: 'Zwischen Hell und Dunkel umschalten – beide werden beim Speichern gespeichert',
    lightTitle: 'Hellmodus',
    darkTitle: 'Dunkelmodus',
    primary: 'Primärfarbe',
    secondary: 'Sekundärfarbe',
    sectionPrimary: 'Primär Farben',
    sectionBackground: 'Hintergründe',
    sectionText: 'Textfarben',
    bgPage: 'Seitenhintergrund',
    bgContainer: 'Behälter / Seitenwand',
    bgElevated: 'Karte / Oberfläche',
    textDefault: 'Text Haupt',
    textPrimary: 'Textakzent',
    textSecondary: 'Text stumm geschaltet',
    textTertiary: 'Text schwach (tertiär)',
    textDisabled: 'Text inaktiv',
    textDanger: 'Text Gefahr/rot',
    textLight: 'Heller Text (auf Schaltflächen)',
    previewTitle: 'Vorschau',
    previewLight: 'Hell',
    previewDark: 'Dunkel',
    previewNavActive: 'Aktives Menü',
    previewNavItem: 'Menü',
    previewHeader: 'Kopfzeile',
    previewCardTitle: 'Kartenkopfzeile',
    previewBody: 'Text, den Benutzer in der Benutzeroberfläche lesen.',
    previewLink: 'Akzentlink',
    previewMuted: 'Gedeckter Hilfetext',
    previewPrimaryBtn: 'Primär',
    previewSecondaryBtn: 'Sekundär',
    previewFormTitle: 'Formulare',
    previewTabsTitle: 'Tabs',
    previewTabOne: 'Übersicht',
    previewTabTwo: 'Details',
    previewTabThree: 'Verlauf',
    previewTabContent: 'Inhalt im aktiven Tab – so sieht der Textkörper während der Tab-Navigation aus.',
    previewBadgesTitle: 'Badges',
    previewBadgePrimary: 'Primär',
    previewBadgeNeutral: 'Neutral',
    previewBadgeOutline: 'Gliederung',
    previewBadgeSecondary: 'Sekundär',
    previewModalTitle: 'Modal',
    previewModalHeading: 'Aktion bestätigen',
    previewModalBody: 'Sind Sie sicher, dass Sie fortfahren möchten? Dies ist eine Vorschau des Dialogfelds.',
    previewModalCancel: 'Abbrechen',
    previewModalConfirm: 'Bestätigen',
    previewComboboxLabel: 'Kombinationsfeld',
    previewComboboxValue: 'Option auswählen…',
    previewInputLabel: 'Textfeld',
    previewInputPlaceholder: 'Wert eingeben…',
    previewGridTitle: 'Datenraster',
    previewColName: 'Name',
    previewColStatus: 'Status',
    previewColDate: 'Datum',
    previewRowA: 'Fahrzeug ABC123',
    previewRowB: 'Fahrzeug XYZ789',
    previewRowC: 'Fahrzeug DEF456',
    previewStatusActive: 'Aktiv',
    previewStatusPending: 'Warten',
    previewStatusDone: 'Fertig',
    contrastWarning: 'Warnung: Ein geringer Kontrast zwischen Text und Hintergrund kann die Lesbarkeit des Inhalts erschweren.',
    reset: 'Zurücksetzen',
    saveSuccess: 'Thema gespeichert',
    saveSuccessActivated: 'Theme in der gesamten Web-App gespeichert und aktiviert',
    activate: 'Theme aktivieren',
    reapply: 'Erneut bewerben',
    saveError: 'Das Thema konnte nicht gespeichert werden',
    loadError: 'Das Thema konnte nicht geladen werden',
    unsavedConfirm: 'Sie haben nicht gespeicherte Änderungen. Möchten Sie ohne Speichern fortfahren?',
    disabledBannerTitle: 'Das dynamische Design ist noch nicht aktiv',
    disabledBannerBody: 'Sie können es hier bearbeiten und in der Vorschau anzeigen. Klicken Sie auf „Aktivieren“, um das globale Theme für alle Benutzer zu aktivieren (Partner mit einem eigenen aktivierten Theme sind nicht betroffen).',
    disabledBannerBodyPartner: 'Sie können es hier bearbeiten und in der Vorschau anzeigen. Klicken Sie auf „Aktivieren“, um das Design nur für die Benutzer dieses Partners zu aktivieren – andere und das globale Design sind nicht betroffen.',
  },
  fotaMigration: {
    title: 'FOTA-Konfiguration',
    description: 'Laden Sie eine .cfg-Datei hoch und senden Sie sie über Teltonika FOTA Web an Geräte. Geräte rufen die Konfiguration ab, wenn sie sich das nächste Mal bei FOTA Web anmelden – unabhängig davon, auf welchen Server sie verweisen.',
    wakeupInfo: 'Hinweis: Ohne die SMS „web_connect“ ruft das Gerät die Konfiguration beim nächsten geplanten FOTA-Check-in ab (normalerweise innerhalb von 1–24 Stunden). Klicken Sie auf Status aktualisieren, um zu sehen, wann es fertig ist.',
    tabSend: 'Konfiguration senden',
    tabStatus: 'Status',
    uploadFile: 'Konfigurationsdatei hochladen (.cfg)',
    dropCfgHere: 'Ziehen Sie die .cfg-Datei hierher und legen Sie sie dort ab, oder klicken Sie, um sie auszuwählen',
    onlyCfgAllowed: 'Es sind nur .cfg-Dateien zulässig',
    uploading: 'Laden...',
    uploadSuccess: 'Die Datei „{name}“ wurde auf FOTA Web hochgeladen',
    uploadError: 'Datei konnte nicht hochgeladen werden',
    errorLoadingFiles: 'Konfigurationsdateien konnten nicht von FOTA Web heruntergeladen werden',
    selectConfigFile: 'Wählen Sie die zu sendende Konfigurationsdatei aus',
    configFilePlaceholder: 'Wählen Sie eine Konfigurationsdatei...',
    deliveryType: 'Was möchten Sie senden?',
    selectFirmwareFile: 'Firmware-Datei zum Senden auswählen',
    firmwareFilePlaceholder: 'Firmware-Datei auswählen...',
    firmwareWarning: 'Firmware-Update ändert die Gerätesoftware. Senden Sie nur Firmware, von der Sie überprüft haben, dass sie für das Gerätemodell korrekt ist.',
    noFilesFound: 'Keine Dateien in FOTA Web gefunden',
    selectFilFirst: 'Wählen Sie zuerst eine Konfigurationsdatei aus',
    filterAll: 'Alle',
    kindConfig: 'Konfiguration',
    kindFirmware: 'Firmware',
    kindLog: 'Protokoll',
    kindOther: 'Andere',
    selectOrganization: 'Organisation auswählen',
    organizationPlaceholder: 'Organisation suchen und auswählen...',
    selectOrgFirst: 'Zuerst Organisation auswählen',
    previewBtn: 'Vorschau der Geräte',
    previewing: 'Geräte werden heruntergeladen...',
    vehiclesFound: 'Fahrzeuge mit IMEI',
    vehiclesSelected: 'Fahrzeuge ausgewählt',
    sendToAll: 'Alle',
    sendToSelected: 'Ausgewählt',
    selectAll: 'Alle auswählen',
    noVehiclesSelected: 'Keine Fahrzeuge ausgewählt',
    noVehicles: 'Keine Fahrzeuge mit IMEI in der ausgewählten Organisation gefunden',
    errorLoading: 'Einheiten konnten nicht abgerufen werden',
    sendBtn: 'Über FOTA senden',
    sending: 'Senden...',
    errorSending: 'Konfiguration konnte nicht gesendet werden',
    successMessage: '{succeeded} von {total}-Aufgaben in der Warteschlange in FOTA Web',
    confirmTitle: 'FOTA-Versand bestätigen',
    confirmMessage: 'Sie sind im Begriff zu senden „{file}“ an {count}Geräte über FOTA Web.',
    confirmWakeupNote: 'Das Gerät ruft die Konfiguration beim nächsten FOTA-Check-in ab. Wenn SMS „web_connect“ verwendet wird, wird es sofort ausgelöst.',
    resultTitle: 'Ergebnis',
    succeeded: 'In der Warteschlange',
    failed: 'Fehlgeschlagen',
    total: 'Gesamt',
    taskQueued: 'In der Warteschlange',
    taskDownloading: 'Herunterladen',
    taskApplied: 'Installiert',
    taskFailed: 'Fehler',
    taskStatusTitle: 'FOTA-Aufgabenstatus pro Gerät',
    refreshStatus: 'Status aktualisieren',
    lastUpdated: 'Letzte Aktualisierung',
    selectOrgForStatus: 'Wählen Sie auf der Registerkarte „Konfiguration senden“ eine Organisation aus, um den Status anzuzeigen',
    clickRefreshToLoad: 'Klicken Sie auf „Status aktualisieren“, um Aufgaben abzurufen',
    noTasksFound: 'Keine Aufgaben für die ausgewählte Organisation gefunden',
    errorLoadingStatus: 'Aufgabenstatus konnte nicht abgerufen werden',
    registrationNumber: 'Reg.Nr',
    vehicleName: 'Fahrzeugname',
    imei: 'IMEI',
    status: 'Status',
    taskId: 'Aufgaben-ID',
    errorMsg: 'Fehlermeldung',
    configFile: 'Konfigurationsdatei',
    columnSuccess: 'In der Warteschlange',
    columnFailed: 'Fehler',
    tabFiles: 'Dateien',
    fileListTitle: 'Konfigurationsdateien in FOTA Web hochgeladen',
    deleteFile: 'Datei löschen',
    confirmDelete: 'Sind Sie sicher?',
    fileDeleted: 'Datei „{name}“ wurde gelöscht',
    fileDeleteError: 'Datei konnte nicht gelöscht werden',
    downloadFile: 'Datei herunterladen',
    fileDownloadError: 'Fehlgeschlagen Datei herunterladen',
    noImei: 'IMEI fehlt',
    apiKeyMissing: 'FOTA-Web-API-Schlüssel fehlt auf dem Server',
    offlineInfo: 'Geräte offline (nicht mit DQFleet verbunden) können ohne nicht erreicht werden SMS',
    responseLabel: 'Gerätereaktion',
  },
  damageReports: {
    title: 'Schadensberichte',
    subtitle: 'Eingehende Schadensmeldungen von der mobilen App',
    filterStatus: 'Status',
    filterSeverity: 'Schweregrad',
    filterFromDate: 'Von-Datum',
    filterToDate: 'Bis-Datum',
    filterRegistration: 'Registernummer',
    filterRegistrationPlaceholder: 'z.B. EEM51Z',
    clearFilter: 'Filter löschen',
    noReports: 'Keine Schadensberichte gefunden',
    loading: 'Laden...',
    vehicle: 'Fahrzeuge',
    reporter: 'Reporter',
    severity: 'Schweregrad',
    status: 'Status',
    date: 'Datum',
    images: 'Bilder',
    description: 'Beschreibung',
    adminNotes: 'Notizen (intern)',
    adminNotesPlaceholder: 'Interne Notizen hinzufügen...',
    save: 'Änderungen speichern',
    saving: 'Speichern...',
    saved: 'Bericht aktualisiert',
    saveError: 'Speichern nicht möglich',
    loadDetailError: 'Bericht konnte nicht geladen werden',
    location: 'Standort',
    resolvedAt: 'Gelöst',
    handling: 'Management',
    statusPending: 'Warten',
    statusInProgress: 'In Bearbeitung',
    statusResolved: 'Gelöst',
    statusClosed: 'Geschlossen',
    severityLow: 'Niedrig',
    severityMedium: 'Durchschnitt',
    severityHigh: 'Hoch',
    severityCritical: 'Kritisch',
    statTotal: 'Gesamt',
    statPending: 'Warten',
    statInProgress: 'In Bearbeitung',
    statResolved: 'Gelöst',
    statCritical: 'Kritisch',
    allStatuses: 'Alle Status',
    allSeverities: 'Alle',
    totalCount: '{{total}}Gesamtberichte',
    prev: 'Vorherige',
    next: 'Weiter',
    fetchError: 'Schadensberichte konnten nicht abgerufen werden',
    damageImage: 'Schadensbild',
    reportTitle: 'Bericht Nr.{{id}}',
    releaseBlock: 'Entsperren',
    releaseBlockUntil: 'Das Fahrzeug ist für {{end}}',
    releaseBlockConfirm: 'Die Sperre aufheben, damit das Fahrzeug erneut gebucht werden kann?',
    releaseBlockSuccess: 'Die Sperre freigegeben',
    releaseBlockError: 'Block konnte nicht freigegeben werden',
    myList: 'Meine Listen',
    listBecomesAssignment: 'Die Person sieht den Fall unter „Meine Aufgaben“.',
    noMyList: 'Keine Fälle auf Ihrer Liste',
    listColumn: 'Liste',
    onMyList: 'Ihrer Liste',
    addToMyList: 'Zu meinen hinzufügen Liste',
    addToList: 'Person zuweisen',
    assignPerson: 'Zuweisen',
    listSearchPlaceholder: 'Nach Person suchen (Name oder E-Mail)',
    listSearchHint: 'Geben Sie mindestens zwei Zeichen ein',
    listEmpty: 'Niemand hat den Fall auf seiner Liste',
    listAdded: 'Zur Liste hinzugefügt',
    listRemoved: 'Aus der Liste entfernt',
    listRemove: 'Entfernen',
    listAlready: 'Bereits auf der Liste',
    listAddError: 'Konnte nicht zur Liste hinzugefügt werden',
    listRemoveError: 'Konnte nicht aus der Liste entfernt werden',
    logTitle: 'Protokoll',
    logEmpty: 'Noch kein Ereignis',
    logPlaceholder: 'Schreiben Sie, was Sie getan haben…',
    logSubmit: 'In das Protokoll schreiben',
    logSaved: 'Gespeichert in Das Protokoll',
    logError: 'Konnte nicht im Protokoll gespeichert werden',
    logUnknown: 'Unbekannt',
    logCreated: 'Der Fall wurde erstellt',
    logStatus: 'Status von {{from}} in {{to}}',
    logSeverity: 'Schweregrad geändert von {{from}} zu {{to}}',
    logAdminNote: 'Interne Notizen aktualisiert',
    logNote: 'Hinweis',
    logListAdd: 'Zugewiesen {{name}}. Gesehen in „Meine Aufgaben“',
    logListRemove: 'Entfernt {{name}}aus der Liste',
    logBlockRelease: 'Freigegebene Fahrzeugsperre',
  },
  tireAnalysis: {
    title: 'Reifenanalyse',
    update: 'Aktualisieren',
    analysisDate: 'Analyse abgeschlossen {{date}} · Nächste Saison: {{season}}',
    loading: 'Reifendaten werden analysiert...',
    loadError: 'Reifenanalyse konnte nicht geladen werden',
    vehiclesWithData: 'Fahrzeuge mit Reifendaten',
    ofTotal: 'von {{total}} insgesamt',
    criticalNow: 'Jetzt kritisch',
    belowMin: 'Unter dem empfohlenen Minimum',
    needsReplacement: 'Muss ersetzt werden',
    nextSeasonLabel: 'Weiter: {{label}}',
    tiresToBuy: 'Zu kaufende Reifen',
    totalPurchaseNeed: 'Gesamtkaufbedarf',
    critical: 'Kritisch',
    warning: 'Warnung',
    noCritical: 'Keine Reifen unter dem empfohlenen Mindestwert',
    noForecast: 'Keine Reifen, die in der nächsten Saison voraussichtlich ausgetauscht werden müssen',
    noProcurement: 'Kein Kaufbedarf festgestellt',
    stored: '📦 Gespeichert',
    installed: '🔩Montiert',
    currentTread: 'Aktuelle Mustertiefe',
    predictedTread: 'Berechnet am Ende der Saison',
    season: 'Saison',
    wearRate: 'Verschleißpunkte',
    threshold: 'Limit',
    type: 'Typ',
    size: 'Größe',
    count: 'Anzahl',
    level: 'Ebene',
    urgent: 'Dringend',
    planned: 'Geplant',
    affectedVehicles: 'Betroffene Fahrzeuge:',
    orderList: '📋 Bestellliste (zum Vergrößern klicken)',
    copyToOrder: 'Kopie zur Bestellung:',
    totalTires: 'GESAMT: {{count}} Reifen',
    procurementSummary: 'Es müssen insgesamt {{count}} Reifen gekauft werden ({{groups}} einzigartige Größen)',
    tabCritical: 'Jetzt kritisch',
    tabForecast: 'Nächste Saison Prognose',
    tabProcurement: 'Kaufplanung',
    criticalTitle: 'Kritische Reifen – Jetzt müssen Maßnahmen ergriffen werden',
    criticalDesc: 'Es wurden Reifen montiert, die unter dem empfohlenen Mindestwert für ihren Typ liegen. Winterreifen ≥ 4 mm, Winterreifen ≥ 3 mm, Sommerreifen ≥ 3 mm. Gesetzlicher Mindestwert für alle: 1,6 mm.',
    forecastTitle: 'Vorhersage – nächste Saison: {{season}}',
    forecastDesc: 'Reifen, deren berechnete Profiltiefe am Ende der Saison möglicherweise unter die empfohlene Mindestprofiltiefe fällt. Berechnet auf der Grundlage des historischen Verschleißes pro Fahrzeug.',
    procurementTitle: 'Kaufplanung – gruppiert nach Größe',
    procurementDesc: 'Zusammenfassung aller Reifen, die gekauft werden müssen – sowohl dringend (jetzt kritisch) als auch geplant (Prognose). Klicken Sie auf eine Zeile, um zu sehen, welche Fahrzeuge betroffen sind.',
    methodology: 'ℹ️ Wie werden die Prognosen berechnet?',
    methodWear: 'Verschleißrate: Berechnet aus historischen Reifenwechseln im Änderungsprotokoll. Wenn die Historie fehlt, wird ein Standardwert von 1 mm pro 18.000 km verwendet.',
    methodSeason: 'Saisonlänge: Durchschnitt der gefahrenen km pro Saison aus dem Austauschprotokoll. Rückfall: 15.000 km pro Saison.',
    methodForecast: 'Prognose: Aktuelle Profiltiefe minus (Verschleißrate × geschätzte Saisonlänge).',
    methodThresholds: 'Grenzwerte: Winterreifen 4 mm (empfohlen), Spikereifen 4 mm, Winterreifen 3 mm, Sommerreifen 3 mm. Gesetzliches Minimum: 1,6 mm.',
    treadMin: 'Mustertiefe (min.)',
    thresholdLabel: 'Grenzwert: {{mm}} mm',
    seasonKm: '🛣️ Saison: ~{{km}} km',
    wearRateLabel: '📉 Verschleiß: {{rate}}',
    thresholdMm: '🎯 Limit: {{mm}} mm',
    wearRatePer10k: '{{rate}} mm/10.000 km',
  },
  bookingResources: {
    title: 'Buchungsressourcen',
    description: 'Erstellen Sie Ihre eigenen Ressourcentypen (z. B. Fahrrad, Anhänger) und registrieren Sie buchbare Ressourcen mit eindeutiger Asset-ID.',
    organization: 'Organisation (Kunde)',
    tabTypes: 'Ressourcentypen',
    tabResources: 'Ressourcen',
    addType: 'Ressourcentyp hinzufügen',
    editType: 'Ressourcentyp bearbeiten',
    addResource: 'Ressource hinzufügen',
    editResource: 'Ressource bearbeiten',
    noTypes: 'Noch keine Ressourcentypen. Erstellen Sie mindestens einen Typ, bevor Sie Ressourcen registrieren.',
    noResources: 'Keine Ressourcen registriert. Erstellen Sie zuerst Ressourcentypen und fügen Sie dann Ressourcen hinzu.',
    createTypeFirst: 'Erstellen Sie mindestens einen aktiven Ressourcentyp, bevor Sie Ressourcen hinzufügen.',
    colCode: 'Code',
    colName: 'Name',
    colResourceCount: 'Anzahl der Ressourcen',
    colIdentity: 'Identität (Asset-ID)',
    colType: 'Ressourcentyp',
    colPool: 'Ausgabeort',
    nameEn: 'Name (Englisch, optional)',
    confirmDeactivateType: 'Diesen Ressourcentyp deaktivieren? Funktioniert nicht, wenn Ressourcen oder Buchungen verknüpft sind.',
    confirmDeactivateResource: 'Diese Ressource deaktivieren? Nicht möglich, wenn eine aktive Buchung vorliegt oder sich in einem Pool befindet.',
    connectKey: 'Schlüssel verknüpfen',
    connectKeyTitle: 'Schlüssel mit {{name}} verknüpfen',
    connectKeyPick: 'Freien grünen Steckplatz wählen',
    connectKeyPickCabinet: 'Schrank wählen',
    connectKeySelected: 'Ausgewählter Steckplatz {{name}}',
    connectKeySaved: 'Der Schlüssel wurde mit {{name}} verknüpft.',
    connectKeyError: 'Der Schlüssel konnte nicht verknüpft werden.',
    connectKeyNoCabinets: 'Der Kunde hat keinen Schlüsselschrank.',
  },
  travelPlanner: {
    title: 'Reiseplaner',
    modeCar: 'Auto',
    modeBicycle: 'Fahrrad',
    modeFoot: 'Zu Fuß',
    modeTransit: 'Öffentliche Verkehrsmittel',
    from: 'Von',
    to: 'Bis',
    fromPlaceholder: 'Startadresse suchen...',
    toPlaceholder: 'Ziel suchen...',
    clickOnMap: 'Auf die Karte klicken',
    swap: 'Richtung ändern',
    timeNow: 'Jetzt losfahren',
    timeDeparture: 'Abfahrt um ',
    timeArrival: 'Ankunftszeit',
    showAlternatives: 'Alternative Routen anzeigen',
    search: 'Reise suchen',
    sendEmail: 'Wegbeschreibung per E-Mail senden',
    emailPlaceholder: 'Ihre E-Mail-Adresse',
    send: 'Senden',
    routeAlternatives: 'Routen',
    route: 'Route',
    transitAlternatives: 'Abfahrt',
    transfers: 'Änderungen',
    tripDetails: 'Reisedetails',
    selectBothPoints: 'Start- und Zielort auswählen',
    noRouteFound: 'Keine Route gefunden',
    noTripsFound: 'Keine Abfahrten gefunden',
    transitNotConfigured: 'Öffentliche Verkehrsmittel nicht konfiguriert (ResRobot-API-Schlüssel fehlt auf dem Server)',
    searchError: 'Suche fehlgeschlagen',
    emailSent: 'Wegbeschreibung gesendet!',
    emailError: 'E-Mail konnte nicht gesendet werden',
  },
  pipeline: {
    newCase: 'Neuer Fall',
    caseType: 'Falltyp',
    caseTitle: 'Titel',
    typeInquiry: 'Kontakt/Interessent',
    typeProcurement: 'Beschaffung',
    filterAll: 'Alle',
    estimatedValue: 'Geschätzter Wert',
    calculatedValue: 'Geschätzter Wert',
    contractMonths: 'Vertragslaufzeit (Monate)',
    referenceNumber: 'Referenznummer',
    submissionDeadline: 'Ausschreibungsfrist',
    procurementUrl: 'Beschaffungslink',
    noCustomer: 'Kein Kunde verbunden',
    tabOverview: 'Übersicht',
    tabDocuments: 'Dokument',
    tabRequirements: 'Anforderungsanalyse',
    tabValue: 'Geschäftswert',
    contact: 'Kontakt',
    analysisStatus: 'Analysestatus',
    uploadDocument: 'Dokument hochladen',
    uploadSuccess: 'Dokument hochgeladen',
    uploadSuccessCount: '{{count}}Dokument hochgeladen',
    uploadPartial: '{{ok}} hochgeladen, {{failed}} fehlgeschlagen',
    uploadFailed: 'Hochladen fehlgeschlagen',
    uploadMultipleHint: 'Sie können mehrere Dateien gleichzeitig auswählen',
    noDocuments: 'Noch keine Dokumente',
    runAnalysis: 'Führen Sie eine KI-Analyse durch',
    runAnalysisAll: 'Anforderungsspezifikation analysieren',
    runAnalysisAllHint: 'Analysiert die Hauptdatei der Anforderungsspezifikation. Wählen Sie weitere Dokumente aus und verwenden Sie „Ausgewählte analysieren“ für andere Anhänge.',
    runAnalysisSelected: 'Ausgewählte Dokumente analysieren',
    analyzeDocument: 'Analysieren',
    analyzing: 'Analysieren...',
    analyzeStarting: 'Analyse wird gestartet...',
    analyzeStartedBackground: 'Analyse wird im Hintergrund gestartet. Sie können die Seite verlassen – wir aktualisieren den Status automatisch, wenn Sie zurückkehren.',
    analyzeAlreadyRunning: 'Für diesen Fall läuft bereits eine Analyse.',
    analyzeAlreadyRunningInfo: 'Die Analyse läuft bereits im Hintergrund. Warten Sie, bis der Vorgang abgeschlossen ist, oder klicken Sie auf Analyse neu starten.',
    analyzeStuckHint: 'Die Analyse scheint hängenzubleiben (z. B. nach einem Neustart). Sie können es neu starten.',
    forceRestartAnalysis: 'Analyse neu starten',
    analysisRunningHint: 'Die KI-Analyse läuft im Hintergrund. Sie können wegnavigieren – das Ergebnis wird hier angezeigt, wenn die Analyse abgeschlossen ist.',
    analysisStatusNone: 'Nicht analysiert',
    analyzeSlow: 'KI-Analyse läuft – kann bei großen Beschaffungsdokumenten einige Minuten dauern.',
    analyzeTimeout: 'Die Analyse hat zu lange gedauert. Versuchen Sie es erneut oder analysieren Sie weniger Anhänge gleichzeitig.',
    analyzeSuccess: 'Analyse abgeschlossen',
    analyzeFailed: 'Analyse fehlgeschlagen',
    requirementType: 'Typ',
    requirement: 'Anforderung',
    requirementText: 'Vollständiger Anforderungstext',
    matchStatus: 'Übereinstimmung',
    fulfilled: 'erfüllt',
    skaCount: '{{count}} SOLL-Anforderungen',
    borCount: '{{count}} SOLL-Anforderungen',
    systemHandles: 'Was das System verarbeitet',
    whatIsMissing: 'Was fehlt',
    noCatalogMatch: 'Keine übereinstimmende Fähigkeit',
    noCoverageNotes: 'Keine Bewertung verfügbar – führen Sie die Analyse erneut aus, um eine KI-Erklärung zu erhalten',
    matchedCapability: 'Fähigkeit stimmt überein',
    noGapNotes: 'Keine Bewertung verfügbar',
    nothingMissing: 'Nichts fehlt – Anforderung erfüllt',
    confidence: 'Sicherheit',
    noRequirements: 'Noch keine Anforderungen analysiert',
    createDevTask: 'Entwicklungsaufgabe erstellen',
    devTaskCreated: 'Entwicklungsaufgabe erstellt',
    handlingStatus: 'Bearbeitung',
    handlingNotSet: 'Nicht festgelegt',
    manualHandling: 'Manuelle Bearbeitung',
    assessment: 'Bewertung',
    reuseInOtherCases: 'Antwort in anderen Beschaffungen verwenden',
    reuseInOtherCasesHint: 'Speichert die Bewertung, sodass ähnliche Anforderungen (z. B. Fahrzeugdaten abrufen) automatisch auf den gleichen Status gesetzt werden.',
    comment: 'Kommentar',
    commentPlaceholder: 'Kommentar schreiben, z.B. dass Fahrzeugdaten über Car.info abgerufen werden...',
    handlingSaved: 'Vorgang gespeichert',
    handlingSavedReuse: 'Bewertung gespeichert und in anderen Beschaffungen wiederverwendet',
    handling: {
      hanterat: 'Verwaltet',
      utveckling: 'Entwicklung',
      juridik: 'Recht',
    },
    product: 'Produkt',
    selectProduct: 'Produkt auswählen',
    quantity: 'Anzahl',
    unitPrice: 'À-Preis',
    lineTotal: 'Zeilensumme',
    addLine: 'Hinzufügen Zeile',
    monthlyTotal: 'Monatswert',
    caseNotFound: 'Fall nicht gefunden',
    status: {
      fulfilled: 'Zufrieden',
      partial: 'Teilweise',
      missing: 'Fehlend',
      unknown: 'Unbekannt',
      review: 'Überprüfung',
    },
    analysisStatusValues: {
      none: 'Nicht analysiert',
      pending: 'Warten',
      analyzing: 'Analysieren',
      completed: 'Analyse abgeschlossen',
      failed: 'Analyse fehlgeschlagen',
    },
  },
  moten: {
    title: 'Besprechung',
    intro: 'Interner Ausdruck und Zusammenfassung. Der Support steht an erster Stelle in der Warteschlange.',
    titlePlaceholder: 'Besprechungstitel',
    upload: 'Audio oder Teams-Datei hochladen',
    uploading: 'Hochladen…',
    fileRequired: 'Bitte wählen Sie zuerst eine Datei aus.',
    uploadError: 'Datei konnte nicht hochgeladen werden.',
    loadError: 'Besprechungen konnten nicht heruntergeladen werden.',
    empty: 'Noch keine Besprechungen.',
    delete: 'Entfernen',
    deleteConfirm: 'Besprechung löschen und Datei?',
    deleteError: 'Besprechung konnte nicht gelöscht werden.',
    summary: 'Zusammenfassung',
    decisions: 'Entscheidungspunkte',
    ideas: 'Neue Ideen',
    followUps: 'Verwaltung',
    transcript: 'Drucken',
    waiting: 'Warten auf Drucken.',
    statusQueued: 'Eingegangen Warteschlange',
    statusUploading: 'Hochladen',
    statusProcessing: 'Verarbeitung',
    statusReady: 'Fertig',
    statusFailed: 'Fehlgeschlagen',
    colTitle: 'Titel',
    colDate: 'Datum',
    colTime: 'Zeit',
    colRecordedBy: 'Aufgezeichnet von',
    colStatus: 'Status',
    meetingTitle: 'Titel',
    backToList: 'Zurück zur Liste',
    formatBold: 'Fett',
    formatHeading: 'Überschrift',
    formatList: 'Liste',
    reformat: 'Neuformatieren',
    reformatError: 'Der Text konnte nicht neu formatiert werden.',
    save: 'Speichern',
    saveError: 'Notiz konnte nicht gespeichert werden.',
    download: 'Datei speichern',
    send: 'Senden',
    sendHint: 'An eine oder mehrere Personen senden',
    sendError: 'E-Mail konnte nicht gesendet werden.',
    recipientPlaceholder: 'name@foretag.se',
    addRecipient: 'Hinzufügen',
    recipientsRequired: 'Geben Sie mindestens eine E-Mail-Adresse ein.',
  },
  econKodverk: {
    title: 'Codework',
    description: 'Region Skåne Raindance Code funktioniert.',
    snapshot: 'Auszug {date}',
    searchPlaceholder: 'Suchcode oder Text',
    company: 'Firma',
    department: 'Verwaltung',
    code: 'Code',
    text: 'Text',
    passive: 'Passiv',
    validTo: 'Gültig bis',
    empty: 'Keine Zeilen entsprechen der Suche.',
    loadError: 'Die Codebasis konnte nicht heruntergeladen werden',
    prev: 'Vorherige',
    next: 'Weiter',
    page: 'Seite {page} von {pages} ({total} Zeilen)',
    kind: {
      ansvar: 'Verantwortung',
      konto: 'Konto',
      motpart: 'Gegenpartei',
    },
  },
  eyeInventory: {
    title: 'EYE-Repository',
    description: 'Nehmen Sie die Packliste von Teltonika entgegen. EYE-Sensoren werden in diesem Lager untergebracht und können an einen Kunden verteilt werden. GPS-Tracker wie der ATC700 werden als Ebenen zur Geräteregistrierung hinzugefügt. Ein bereits zugeordnetes Gerät behält seinen Kunden.',
    import: 'Packliste importieren',
    assign: 'Kunde zuordnen',
    assignTitle: 'Kunde auswählen',
    assignHint: '{count}Geräte werden dem obersten Knoten des Kunden hinzugefügt und sind im Temperaturmonitor sichtbar.',
    search: 'MAC, Seriennummer, Name oder Kunde suchen',
    searchCustomer: 'Kunden finden',
    all: 'Alle',
    stock: 'Auf Lager',
    assignedFilter: 'Zugewiesen',
    inStock: 'Auf Lager',
    name: 'Name',
    serial: 'Seriennummer',
    box: 'Kiste',
    firmware: 'Firmware',
    customer: 'Kunde',
    tracker: 'Tracker',
    unassign: 'Zurückziehen',
    selectAll: 'Alle auf Seite markieren',
    empty: 'Keine Geräte entsprechen dem Filter. Importieren Sie eine Packliste, um den Lagerbestand aufzufüllen.',
    loadError: 'Fehler beim Abrufen des EYE-Bestands',
    importError: 'Datei konnte nicht importiert werden',
    importDone: '{created} neues EYE, {updated} aktualisiert',
    importTrackers: '{created} neue persönliche Tracker ({model}), {updated} aktualisiert',
    assigned: '{count} Einheiten zugewiesen',
    unassigned: '{count} Einheiten wieder auf Lager',
    assignError: 'Zuweisung konnte nicht geändert werden',
    prev: 'Vorherige',
    next: 'Weiter',
    page: 'Seite {page} von {pages} ({total} Zeilen)',
    rowIssue: 'Zeile {row}: {message}',
    errors: {
      INVALID_FILE: 'Die Datei ist keine TeltonikaPackliste',
      NO_ROWS: 'Die Datei enthält keine Geräte',
      FILE_REQUIRED: 'Wählen Sie eine XLSX-Datei aus',
      INVALID_INPUT: 'Wählen Sie Geräte und einen Kunden aus',
      ORG_NOT_FOUND: 'Der Kunde wurde nicht gefunden',
      INVALID_MAC: 'Ungültige MAC-Adresse',
      MISSING_MAC: 'MAC-Adresse fehlt',
      MISSING_IMEI: 'IMEI fehlt',
      DEVICE_BLOCKED: 'Das Gerät ist abgemeldet und wurde nicht aktualisiert',
      SERIAL_CONFLICT: 'Die Seriennummer befindet sich bereits auf einem anderen Gerät',
      ROW_FAILED: 'Die Zeile konnte nicht gespeichert werden',
      NOT_FOUND: 'Das Gerät ist nicht im Inventar',
      ALREADY_LINKED: 'Das Gerät befindet sich auf einem Tracker und kann nicht verschoben werden',
      AMBIGUOUS_MAC: 'Die MAC-Adresse befindet sich auf mehreren Sensoren',
      PRODUCT_UNKNOWN: 'Produkttypen in Katalogen',
    },
  },
  documentTitle: {
    testRunner: 'Testlauf',
    emailVerification: 'E-Postverifizierung',
    poolCar: 'Poolwagen',
  },
  copy: {
    reports: {
      aGrade: 'A-Betyg',
      achievements: 'Prestationer',
      active: 'Aktiv',
      allVehicles: 'Alle Fahrzeuge',
      anticipation: 'Voraussicht',
      avgCoasting: 'Snitt uttrullning',
      avgScore: 'Durchschnittspunkte',
      avgSpeed: 'Medelhastighet',
      batteryCapacity: 'Batteriekapazität:',
      binDescription: 'Beschreibung',
      binValue: 'Wert',
      brand: 'Marke',
      cancel: 'Abbrechen',
      chargeAtEnd: 'Laden am Ende:',
      chooseDate: 'Datum auswählen',
      chooseFilters: 'Filter auswählen',
      chooseFiltersAndFetch: 'Filter auswählen und auf „Bericht herunterladen“ klicken',
      chooseOrgVehiclePeriod: 'Organisation, Fahrzeug und Zeitraum auswählen',
      chooseOrganization: 'Organisation auswählen',
      chooseVehicle: 'Fahrzeug auswählen',
      clickFetchSpeed: 'Auf „Daten herunterladen“ klicken, um Geschwindigkeitsverstöße anzuzeigen.',
      close: 'Schließen',
      co2Emissions: 'CO₂-Emissionen',
      coasting: 'Segeln',
      coasting20: '20 % Rollout.',
      coastingChartHint: 'Grün = Rollout. Gelbe Linie: positiv = zieht Energie, negativ = regeneriert',
      coastingDistance: 'Wicklungsdistanz',
      coastingPercent: 'Wicklung %',
      coastingSegments: 'Wickelsegment ({{count}} st)',
      coastingShare: 'Wicklungsprozentsatz',
      coastingTime: 'Einführungszeit',
      comparedToWltp: 'Im Vergleich zu WLTP:',
      consumptionPer100: 'Verbrauch (l/100 km)',
      date: 'Datum',
      dateRequired: 'Datum *',
      details: 'Details',
      distance: 'Entfernung',
      distanceDrivenKm: 'Gefahrene Strecke (km)',
      distanceKm: 'Entfernung (km)',
      distributionByType: 'Verteilung nach Typ',
      downloadPdf: 'PDF herunterladen',
      downloadPdfFailed: 'PDF konnte nicht heruntergeladen werden',
      driver: 'Fahrer',
      drivingLogFilePrefix: 'Fahrtenbuch',
      drivingSplit: 'Fahrverteilung',
      dtcCount: 'Nummernfehler Codes:',
      durationTotal: '{{duration}} insgesamt',
      electricVehicle: '⚡ Elektrofahrzeug',
      emailPlaceholder: 'mägkester@exempel.se',
      emailRequired: 'E-Mail-Adresse *',
      emailSentTo: 'E-Mail gesendet an {{email}}',
      endDateRequired: 'Enddatum *',
      endTime: 'Endzeit',
      enter: 'In',
      environment: 'Umgebung',
      evBattery: 'EV-Batterie',
      eventCount: '{{count}} Ereignisse',
      eventTrend: 'Ereignistrend',
      events: 'Ereignisse',
      eventsPerDay: 'Ereignisse pro Tag',
      excessiveIdling: 'Langer Leerlauf',
      exit: 'Aus',
      exportCsv: 'Export CSV',
      fetchData: 'Daten abrufen',
      fetchReport: 'Bericht herunterladen',
      fetchReportFailed: 'Bericht konnte nicht abgerufen werden',
      fetching: 'Bekommen...',
      firstB: 'Das erste B',
      fiveDays: '5 Tage',
      fromAddress: 'Von (Adresse)',
      fuelDiesel: 'Diesel',
      fuelElectric: 'Elektro',
      fuelHybrid: 'Hybrid',
      fuelLiters: 'Kraftstoff (L)',
      fuelPetrol: 'Benzin',
      fuelUnknown: 'unbekannt',
      genericError: 'Ein Fehler ist aufgetreten',
      geofenceCosts: 'Geofence-Kosten',
      geofences: 'Geofences',
      gradeBasedOnCoasting: 'Bewertung basierend auf Rollout-Leistung',
      gradePassed: '👌 Bestanden',
      gradeWithValue: 'Bewertung {{grade}}',
      greatDriving: '👍 Gute Fahrt!',
      harshAccShort: 'Hartes Zubehör',
      harshAcceleration: 'Starke Beschleunigung',
      harshBrakeShort: 'Harte Bremse.',
      harshBraking: 'Hartes Bremsen',
      harshCornering: 'Harte Kurvenfahrt',
      highestDuringViolation: 'Höchste bei Verstößen',
      history: 'Verlauf',
      hoursAndMinutes: '{{hours}} Std. {{minutes}} Min.',
      idleMinutes: '{{count}} Min. Leerlauf',
      improvementTips: 'Tipps zur Verbesserung',
      improver: 'Verbesserer',
      keepPracticing: '💪 Trainieren Sie weiter',
      kmWithMil: 'Kilometer mit MIL an:',
      latestTrip: 'Neueste Fahrt',
      loading: 'Laden...',
      loadingCoasting: 'Rollout-Statistiken werden geladen...',
      maxKmh: 'Max. km/h',
      maxOverLimit: 'Max. Grenzwert überschritten',
      maxSpeed: 'Max. Geschwindigkeit',
      maxSpeedShort: 'Max. Geschwindigkeit.',
      measurementPoints: 'Messpunkte',
      messageOptional: 'Meldung (optional)',
      milActiveTrips: '⚠ MIL-Alarm aktiv während {{count}} Fahrt(en)',
      milAlarms: 'MIL-Alarm (Fehlercodes)',
      minutesOnly: '{{minutes}} min',
      missingLiters: '⚠ Fehlt etwa {{liters}} Liter',
      missingOdometer: 'Fehlende Zählereinstellung',
      model: 'Modell',
      monthApril: 'April',
      monthAugust: 'August',
      monthDecember: 'Dezember',
      monthFebruary: 'Februar',
      monthJanuary: 'Januar',
      monthJuly: 'Juli',
      monthJune: 'Juni',
      monthMarch: 'März',
      monthMay: 'Mai',
      monthNovember: 'November',
      monthOctober: 'Oktober',
      monthSeptember: 'September',
      mostViolations: 'Die meisten Verstöße (Fahrzeuge)',
      noChartData: 'Keine Daten für Grafik verfügbar',
      noCoastingData: 'Kein Rollout Daten für den ausgewählten Zeitraum verfügbar',
      noComparisonData: 'Keine Vergleichsdaten',
      noDataForRange: 'Keine Daten für den ausgewählten Datumsbereich',
      noDataToExport: 'Keine Daten zum Exportieren',
      noEventsInPeriod: 'Keine Ereignisse im ausgewählten Zeitraum',
      noGeofencePassages: 'Keine Geofence-Passagen aufgezeichnet',
      noMilAlarms: ' ✓ Keine MIL-Alarme während des Zeitraums',
      noTankData: 'Keine Daten zum Tankfüllstand',
      noTripsInPeriod: 'Keine Fahrten aufgezeichnet während des Zeitraums',
      noVehicleData: 'Keine Fahrzeugdaten',
      noVehiclesFound: 'Keine Fahrzeuge gefunden',
      noWarningsGoodDriving: 'Keine Warnungen! Gute Fahrt während des Zeitraums.',
      odometer: 'Anzeigenstand',
      odometerEnd: 'Ende: {{value}}',
      odometerEndKm: 'Spurweitenende (km)',
      odometerFilePrefix: 'Zubringerbericht',
      odometerKm: 'Zählerstand (km)',
      odometerReportHint: 'Der Bericht zeigt den Spurweitenwert für Fahrzeuge am ausgewählten Datum.',
      odometerReportTitle: 'Spurweitenbericht – {{date}}',
      odometerStart: 'Start: {{value}}',
      odometerStartKm: 'Startzeit (km)',
      ofVehicles: 'des {{count}}Fahrzeugs',
      orgOrVehicle: 'Organisation/Fahrzeug',
      organization: 'Organisation',
      organizationRequired: 'Organisation *',
      overspeed: 'Beschleunigung',
      overspeedByOrg: 'Geschwindigkeitsbegrenzung pro Organisation überschritten',
      overspeedTooltip: '{{count}}Verstöße ({{rate}}%)',
      overview: 'Übersicht',
      passageCount: '{{count}}Passagiere',
      perKmColon: 'Pro km:',
      perOrganization: 'Pro Organisation',
      perSpeedLimit: 'Pro Geschwindigkeit limit',
      perVehicle: 'Pro Fahrzeug',
      personalMessagePlaceholder: 'Persönliche Nachricht...',
      pieceCount: '{{count}} st',
      points: 'Punkte',
      recipientNameOptional: 'Name des Empfängers (optional)',
      registrationNumber: 'Registrierungsnummer',
      rentalPdfFileName: 'Mietbericht.pdf',
      reportExported: 'Bericht exportiert',
      reportSent: 'Bericht gesendet!',
      roomToImprove: '📈 Verbesserungsmöglichkeit',
      route: 'Entfernung',
      scoreImpact: 'Punktauswirkung',
      scoreWeek: 'Punkte (Woche)',
      searchRegistration: 'Registrierungsnummer suchen...',
      segmentCount: 'Anzahl der Segmente',
      segmentLength: 'Segmentlänge',
      send: 'Senden',
      sendByEmail: 'Per E-Mail senden',
      sendEmailFailed: 'E-Mail konnte nicht gesendet werden',
      sendReportByEmail: 'Bericht per E-Mail senden',
      severity: 'Schweregrad',
      severityCritical: 'Kritisch',
      severityHigh: 'Hoch',
      severityLow: 'Niedrig',
      severityMedium: 'Mittel',
      severityOutOf: 'Schweregrad: {{severity}}/10',
      sharePercent: 'Prozentsatz (%)',
      showMoreWithSearch: 'Mit der Suche {{count}} mehr anzeigen...',
      smoothness: 'Gleichmäßigkeit',
      source: 'Quelle',
      sourceCalculated: 'Berechnet',
      sourceInitial: 'Anfänglich',
      sourceMissing: 'Fehlend',
      speed: 'Geschwindigkeit',
      speedAndEnergy: 'Geschwindigkeit und Energiefluss',
      speedFilePrefix: 'Geschwindigkeitsverstöße',
      speedKmh: 'Geschwindigkeit (km/h)',
      speedLimit: 'Geschwindigkeitsbegrenzung',
      speedViolations: 'Geschwindigkeitsverstöße',
      startDateRequired: 'Startdatum *',
      startTime: 'Startzeit',
      status: 'Status',
      subScores: 'Teilpunkte',
      tankCapacity: 'Tankkapazität:',
      tankFull: ' ✓ Tank ist voll (≥98 %)',
      tankLevelEnd: 'Tank Füllstand am Ende:',
      tankLevelStart: 'Tankfüllstand am Anfang:',
      tankStatus: 'Tankstatus',
      time: 'Zeit',
      timestamp: 'Zeit',
      toAddress: 'An (Adresse)',
      tonnes: '{{value}}Tonne',
      total: 'Gesamt',
      totalColon: 'Gesamt:',
      totalCost: 'Gesamtkosten: {{amount}}',
      totalDistance: 'Gesamtkilometerleistung',
      totalMeasurementPoints: 'Gesamtmesspunkte',
      totalVehicles: 'Gesamtfahrzeug',
      totalVehiclesLine: 'Gesamtfahrzeug: {{count}}',
      totalViolations: 'Gesamtverstöße',
      travelTimeMin: 'Fahrzeit (min)',
      trend: 'Trend',
      tripCount: 'Anzahl der Fahrten',
      trips: 'Reise',
      type: 'Typ',
      unknown: 'Unbekannt',
      vehicle: 'Fahrzeuge',
      vehicleFileToken: 'Fahrzeuge',
      vehicleKpiFilePrefix: 'Schlüsselnummer_Fahrzeug',
      vehicleRequired: 'Fahrzeug *',
      violationCount: 'Anzahl der Verstöße',
      violationPercent: 'Verstoß (%)',
      violationShare: 'Anteil der Verstöße',
      violations: 'Verstöße',
      violationsByLimit: 'Verstöße pro Tempolimit',
      violationsCount: 'Verstöße (Anzahl)',
      violationsLower: 'Verstöße',
      violationsOverTime: 'Verstöße im Zeitverlauf',
      violationsPercent: 'Verstöße %',
      warnings: 'Warnungen',
      weeklyDevelopment: 'Entwicklung letzte Woche',
      withOdometer: 'Mit Zählerstand',
      withOdometerLine: 'Mit Zählerstand: {{count}}',
      withOem: 'Mit OEM-Zähler',
      withOemLine: 'Mit OEM-Zähler: {{count}}',
      wltpValue: 'WLTP-Wert:',
    },
    sysadmin: {
      missingInMariadb: 'Fehlt in MariaDB',
      missingInMongodb: 'Fehlt in MongoDB',
      tooFewGpsPoints: 'Zu wenige GPS Punkte',
      invalidDistance: 'Ungültige Distanz',
      invalidDuration: 'Ungültige Dauer',
      syncMismatch: 'Synchronisierungskonflikt',
      loadPendingError: 'Ausstehende Validierungen konnten nicht geladen werden',
      selectDate: 'Datum auswählen',
      validationDone: 'Validierung abgeschlossen für {{date}}',
      validationAlreadyRunning: 'Validierung für dieses Datum bereits im Gange',
      validationRunFailedHint: 'Validierung konnte nicht ausgeführt werden. Siehe Konsolen- oder Serverprotokoll.',
      validationRunFailed: 'Validierung konnte nicht ausgeführt werden',
      validationGone: 'Der Validierungsdatensatz ist nicht mehr vorhanden (z. B. entfernt oder aufgelöst). Liste schließen und aktualisieren.',
      invalidReplayDate: 'Ungültiges Wiedergabedatum',
      replayQueuedWaiting: 'Wiedergabe (über Warteschlange) gestartet für {{imei}} ({{date}}). Warten auf den Abschluss der Wiedergabe…',
      replayDone: 'Wiedergabe für {{imei}} ({{date}}) abgeschlossen.',
      replayFailedFor: 'Wiedergabe für {{imei}} ({{date}}) fehlgeschlagen.',
      replayStillRunning: 'Wiedergabe für {{imei}} noch in Bearbeitung. Überprüfen Sie den Status manuell, falls es zu Verzögerungen kommt.',
      replayStartedFor: 'Wiedergabe für {{imei}} ({{date}}) gestartet.',
      replayStartFailed: 'Wiedergabe konnte nicht gestartet werden',
      noValidDates: 'Keine gültigen Daten in der Liste',
      replayStartedForDate: 'Wiedergabe für {{date}} gestartet (über Warteschlange).',
      replayStartFailedForDate: 'Wiedergabe für {{date}}',
      unknownError: 'Unbekannter Fehler',
      replayDateError: 'Wiedergabe {{date}}: {{message}}',
      replayStartedForDates: 'Wiedergabe für {{count}} Datum gestartet. Wenn Aufträge erledigt sind, können Sie das Protokoll löschen.',
      noReplayStarted: 'Keine Wiedergabe gestartet ({{count}} fehlgeschlagen).',
      markedResolved: 'Als gelöst markiert',
      markResolvedFailed: 'Konnte nicht als gelöst markiert werden',
      deleteReasonMin: 'Geben Sie einen Grund mit mindestens 5 Zeichen ein.',
      manualValidation: 'Manuelle Validierung',
      runValidation: 'Validierung durchführen',
      validationHint: 'Fahrten für ausgewähltes Datum validieren und MongoDB mit MariaDB vergleichen',
      emptyPending: 'Keine ausstehenden Validierungen',
      regNr: 'Regnr',
      details: 'Details',
      action: 'Aktion',
      manual: 'Manuell',
      created: 'Erstellt',
      tripCount: '{{count}}Fahrten',
      binFile: 'Bin-Datei:',
      segmentCount: '{{count}}Segment',
      totalGpsInBin: 'Gesamtzahl {{count}} GPS Punkte in Bin-Datei',
      binSegmentsTitle: 'Reisesegmente in Bin-Datei:',
      segmentNumber: 'Segment {{n}}',
      noAvl250: 'Keine AVL250',
      pointsAndKm: '{{points}} Punkte • {{km}} km',
      noBinSegments: 'Keine Reisesegmente in der Bin-Datei gefunden',
      mongoTripsTitle: 'MongoDB-Reisen:',
      tripNumber: 'Reise {{n}}',
      missingInMariadbMark: '✗ Fehlt in MariaDB',
      mariaTripsTitle: 'MariaDB-Reisen:',
      mariaOnly: 'Nur MariaDB (fehlt in MongoDB)',
      segmentsFound: '{{count}}-Segmente wurden in der Bin-Datei gefunden.',
      mongoTripDiff: 'MongoDB hat {{count}} Fahrten – Unterschiede können auf Fahrterkennungsregeln zurückzuführen sein.',
      replayBinHint: 'Replay verarbeitet die Bin-Datei erneut und kann fehlende Fahrten in MongoDB erstellen. Die Validierung vergleicht nun den gleichen UTC-Tag in beiden Datenbanken.',
      avl250Window: 'AVL250 in der Bin-Datei für dieses Zeitfenster ({{from}} – {{to}})',
      avl250Legend: '{{count}} Punkte. 1 = Fahrt aktiv, 0 = Stopp, – = fehlt im Paket.',
      time: 'Zeit',
      speed: 'Geschwindigkeit',
      avlTrip: '1 (Fahrt)',
      avlStop: '0 (Stop)',
      statusLoadError: 'Status konnte nicht abgerufen werden',
      syncFailed: 'Synchronisiert fehlgeschlagen',
      fromToDate: '{{from}} zu {{to}}',
      tripsCreated: '{{count}} Fahrten erstellt',
      jobCompleted: '{{name}} abgeschlossen',
      jobFailed: '{{name}} fehlgeschlagen',
      runCompleted: 'Lauf abgeschlossen',
      runFailed: 'Lauf fehlgeschlagen',
      dataStatusError: 'Datenstatus konnte nicht abgerufen werden',
      selectFromToDate: 'Von- und Bis-Datum auswählen',
      selectOrganization: 'Organisation auswählen',
      stopReplayFailed: 'Wiedergabe konnte nicht gestoppt werden',
      fullResetConfirm: 'Beim vollständigen Zurücksetzen werden ALLE in Echtzeit abgeleiteten Daten entfernt:\n• Fahrten, GPS-Blöcke, Öko-Ereignisse\n• Vehicle_daily_stats, trip_state, dedup-cache\n• Löscht Wiedergabe- und GPS-Warteschlangen\n\nFahrzeuge und Geräte bleiben erhalten. Weiter?',
      fullResetDone: 'Vollständiger Reset abgeschlossen. Alle abgeleiteten Echtzeitdaten wurden gelöscht.',
      fullResetFailed: 'Vollständiger Reset fehlgeschlagen',
      replayAllConfirm: 'Dies wird:\n1. Stoppen Sie das TCP-Gateway\n2. ALLE Daten löschen\n3. Alle Bin-Dateien erneut lesen\n4. TCP erneut starten\n\nSind Sie sicher?',
      allVehiclesInSelectedOrg: 'Alle Fahrzeuge in der ausgewählten Organisation',
      syncComplete: 'Synchronisierung abgeschlossen',
      syncFailedGeneric: 'Synchronisierung fehlgeschlagen',
      carInfoSyncTitle: 'Fahrzeug von Car.info synchronisieren',
      carInfoSyncDescription: 'Marke, Modell, Jahr, Kraftstofftyp, Tankgröße, CO₂ usw. werden von der Car.info-API abgerufen',
      missingData: 'Fehlende Daten',
      vehiclesInSystemBefore: 'Gesamt',
      vehiclesInSystemAfter: 'Fahrzeuge in der System',
      missingVin: 'Fehlendes VIN',
      missingBrand: 'Fehlendes Fabrikat',
      missingModel: 'Fehlendes Modell',
      missingYear: 'Fehlendes Modelljahr',
      missingFuelType: 'Fehlender Kraftstofftyp',
      missingTank: 'Fehlender Tankinhalt',
      missingConsumption: 'Fehlender Kraftstoffverbrauch',
      missingCo2: 'Fehlender CO₂/km',
      syncFromCache: 'Synchronisierung aus dem Cache',
      syncFromCacheHint: 'Aktualisiert Fahrzeuge, für die Daten fehlen, mit bereits zwischengespeicherten Car.info-Daten. Schnell – keine API-Aufrufe.',
      syncing: 'Synchronisierung...',
      startCacheSync: 'Synchronisierung aus dem Cache starten',
      syncViaApi: 'Synchronisierung über die Car.info-API',
      syncViaApiHint: 'Erhält neue Daten direkt von der Car.info-API für Fahrzeuge mit fehlenden Informationen. Langsamer, liefert aber aktuelle Daten.',
      fetchFromCarInfo: 'Von der Car.info-API abrufen',
      forceResync: 'Neusynchronisierung erzwingen',
      forceResyncBefore: 'Erhält neue Daten für ',
      forceResyncAll: 'alle',
      forceResyncAfter: ' Fahrzeuge, unabhängig von vorhandenen Daten. Löscht alte falsche Werte (z. B. falscher Kraftstofftyp).',
      forceResyncAllVehicles: 'Neusynchronisierung erzwingen (alle Fahrzeuge)',
      result: 'Ergebnis',
      total: 'Gesamt',
      updated: 'Aktualisiert',
      skipped: 'Überspringen',
      updatedFields: 'Aktualisierte Felder:',
      vehiclesSyncFailed: '{{count}} Fahrzeug konnte nicht synchronisiert werden. Überprüfen Sie das Fehlerprotokoll auf Details.',
      clearSlowLogConfirm: 'Sind Sie sicher, dass Sie das langsame Abfrageprotokoll löschen möchten?',
      slowLogCleared: 'Langsames Protokoll gelöscht',
      settingsUpdated: 'Einstellungen aktualisiert',
      settingsUpdateFailed: 'Einstellungen konnten nicht aktualisiert werden',
      slowQueryPermissionError: 'Berechtigungsfehler: Dem Datenbankbenutzer fehlt die Berechtigung. Führen Sie Folgendes aus: {{command}}',
      minutesShort: 'min',
      lastHour: 'Letzte Stunde',
      last6Hours: 'Letzte 6 Stunden',
      last24Hours: 'Letzte 24 Stunden',
      last48Hours: 'Letzte 48 Stunden',
      lastWeek: 'Letzte Woche',
      settingsGear: '⚙️ Einstellungen',
      clearLog: 'Protokoll löschen',
      threshold: 'Schwellenwert:',
      countLabel: 'Anzahl:',
      average: 'Durchschnitt:',
      max: 'Max:',
      slowQuerySettings: 'Einstellungen für langsame Abfragen',
      on: 'EIN',
      off: 'AUS',
      thresholdSeconds: 'Schwellenwert (Sekunden)',
      recommendedOneSecond: 'Empfohlen: mindestens 1 Sekunde',
      logOutputTable: 'TABLE (für UI)',
      logOutputFile: 'FILE (für Datei)',
      logOutputBoth: 'TABLE,FILE (beide)',
      tableRequiredHint: 'TABLE ist erforderlich, um hier Abfragen anzuzeigen',
      saveSettings: 'Speichern Einstellungen',
      thresholdWarning: '⚠️ Warnung: Ein Schwellenwert unter 1 Sekunde kann viele Daten generieren. Empfohlen: mindestens 1 Sekunde.',
      noSlowQueries: 'Keine langsamen Abfragen in diesem Zeitraum',
      slowQueryLoggedHint: 'Anfragen, die länger als {{seconds}}s dauern, werden hier protokolliert',
      queryTime: 'Abfragezeit:',
      lockTime: 'Sperrzeit:',
      rowsSent: 'Gesendete Zeilen:',
      rowsExamined: 'Untersuchte Zeilen:',
      user: 'Benutzer:',
      copySql: 'SQL wird kopiert',
      importSyncResult: 'Synchronisierung durchgeführt: {{imported}} neu, {{skipped}} übersprungen{{totalPart}}',
      loadingSystemData: 'Systemdaten werden geladen...',
      lastUpdated: 'Letzte Aktualisierung: {{time}}',
      viewingHost: 'Sie sehen:',
      backendResponding: '→ Backend antwortet:',
      overviewIntro: 'Sammelansicht aller vier DQFleet-Server. Remote-Daten werden alle 60 Sekunden aktualisiert – aktuell: {{time}}',
      diskPath: 'Disk ({{path}})',
      cores: '{{count}} Kerne',
      unreachableError: 'Nicht erreichbar: {{error}}',
      noData: 'Keine Daten',
      fetchingData: 'Daten werden abgerufen...',
      noDataRunAgent: 'Keine Daten – Überwachungsagent auf dem Server ausführen.',
      serverUnreachable: '{{name}} ist nicht erreichbar',
      checkAgentRuns: 'Überprüfen Sie, ob der Überwachungsagent ausgeführt wird:',
      onTheServer: 'auf dem Server.',
      portLabel: 'Port:',
      startCommand: 'Startbefehl:',
      latestData: 'Neueste Daten',
      freeMemory: 'Frei: {{value}}',
      allDisks: 'Alle Datenträger',
      geoServices: 'Geodienste',
      dockerContainers: 'Docker-Container',
      name: 'Name',
      running: 'Wird ausgeführt',
      notRunning: 'Wird nicht ausgeführt',
      loadedModels: 'Geladene Modelle ({{count}})',
      allSystemsOk: 'Alle Systeme funktionieren normal',
      statusWarning: 'Warnung: Einige Systeme erfordern Aufmerksamkeit',
      statusCritical: 'Kritisch: Sofortige Maßnahmen erforderlich',
      functionalChecks: 'Funktionsprüfungen (Produkt)',
      dataVolumeRw: 'Datenvolumen RW',
      checkFailed: '✗ Fehler',
      criticalPm2: 'Kritische PM2-Prozesse',
      pm2Online: ' ✓ {{count}} online',
      pm2Offline: '✗ offline',
      criticalDocker: 'Kritische Docker-Container',
      memoryPercent: 'Speicher {{percent}}%',
      diskPercent: 'Festplatte {{percent}}%',
      diskMax: 'Festplatte max. {{percent}}%',
      platform: 'Plattform',
      cpuCores: 'CPU ({{count}} Kerne)',
      pm2Processes: 'Prozesse (PM2)',
      stoppedOrError: 'Gestoppt/Fehler',
      notConnectedError: 'Nicht verbunden: {{error}}',
      totalMessages: 'Gesamtnachrichten',
      messages: 'Nachrichten',
      totalShort: '({{count}} tot)',
      devicesOnline: 'Geräte online',
      packetsPerMinute: 'Pakete/Minute',
      latestPacket: 'Neueste Pakete',
      databases: 'Datenbanken',
      connected: 'Verbunden',
      notConnected: 'Nicht verbunden',
      dataSize: 'Datengröße',
      indexSize: 'Indexgröße',
      peakMemory: 'Spitzenspeicher',
      fragmentation: 'Fragmentierung',
      keysTotal: 'Gesamt Schlüssel',
      keysByPrefix: 'Schlüssel pro Präfix:',
      dockerAllZero: 'Alle Ziffern sind 0.',
      dockerDataFrom: 'Daten werden von {{host}} abgerufen.',
      thisServer: 'dieser Server',
      dockerZeroBeforeGroup: 'Wenn Docker tatsächlich auf diesem Server läuft, aber 0 angezeigt wird: Fügen Sie den Benutzer, der das Backend (z. B. Ubuntu) ausführt, zur Gruppe hinzu',
      dockerZeroRestart: 'und starten Sie den Server neu:',
      dockerZeroThen: 'dann',
      runningEllipsis: 'Ausführen...',
      lastPrefix: 'Neueste',
      scheduleTimezoneHint: 'Der Zeitplan wird in Serverzeit (UTC) angegeben. Der nächste und letzte Lauf wird in Ihrer Ortszeit angezeigt.',
      manualRunHint: 'Wenn ein Lauf abgeschlossen ist, wird eine Benachrichtigung angezeigt. Manuelles „Ausführen“ führt jeweils einen Job aus (keine Warteschlange).',
      showLatest: 'Neueste anzeigen',
      dayCount: '{{count}} Tage',
    },
    admin: {
      comingSoonBookingDescription: 'Fahrzeuge für verschiedene Missionen und Benutzer buchen und planen.',
      comingSoonWorkshopTitle: 'Workshop',
      comingSoonWorkshopDescription: 'Serviceintervalle, Reparaturen und Wartung verwalten.',
      comingSoonWorkorderTitle: 'Arbeitsaufträge',
      comingSoonWorkorderDescription: 'Arbeitsaufträge für Fahrzeuge und Personal erstellen und verwalten.',
      comingSoonAnalysisTitle: 'Analyse',
      comingSoonAnalysisDescription: 'Analysieren Sie Trends und Statistiken für Ihre Fahrzeugflotte.',
      comingSoonDefaultDescription: 'Dieses System befindet sich in der Entwicklung.',
      comingSoonModuleInDevelopment: 'Dieses Modul befindet sich in der aktiven Entwicklung und wird bald verfügbar sein.',
      emailRequired: 'E-Mail-Adresse erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      firstNameMin: 'Vorname muss mindestens 2 Zeichen lang sein',
      lastNameMin: 'Nachname muss mindestens 2 Zeichen lang sein',
      passwordMin: 'Passwort muss mindestens 8 Zeichen lang sein',
      passwordUpper: 'Passwort muss mindestens einen Großbuchstaben enthalten',
      passwordLower: 'Passwort muss mindestens einen Kleinbuchstaben enthalten',
      passwordDigit: 'Passwort muss mindestens eine Zahl enthalten',
      passwordSpecial: 'Passwort muss mindestens ein Sonderzeichen enthalten',
      acceptTerms: 'Sie müssen die Bedingungen akzeptieren',
      passwordsMismatch: 'Passwörter stimmen nicht überein',
      mustVerifyEmail: 'Sie müssen Ihre E-Mail-Adresse bestätigen, bevor Sie sich anmelden können.',
      hidePassword: 'Passwort ausblenden',
      showPassword: 'Passwort anzeigen',
      resetEmailSentToast: 'Wenn ein Benutzer mit dieser E-Mail-Adresse vorhanden ist, wird eine E-Mail zum Zurücksetzen gesendet.',
      resetTokenMissing: 'Wiederherstellungstoken fehlt',
      resetSuccess: 'Das Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
      resetFailed: 'Passwort konnte nicht zurückgesetzt werden',
      couldNotReadFile: 'Die Datei konnte nicht gelesen werden',
      fuelImportName: '{{supplier}} Kraftstoffimport',
      fuelImportFromCompany: 'Import von Kraftstofftransaktionen aus {{company}}',
      fuelImportSt1PresetDescription: 'Import von Kraftstofftransaktionen aus ST1 (fillings_customerview.xlsx usw.)',
      fuelImportOkq8Description: 'OKQ8: ein Import pro Dateityp (K02 / K05 / Schwedisch), Dateinamenfilter *K02*, *K05* oder ^\\d. Kartennummer = Kundennummer/Kontonummer + Kartenseriennummer/Kartenseriennummer (4 Zeichen, mit Nullen aufgefüllt).',
      importProgressCounts: '{{imported}} imp · {{updated}} upd · {{skipped}} exh · {{failed}} error',
      importRunRowCounts: '{{total}} total · {{imported}} imp · {{updated}} upd · {{skipped}} other · {{failed}} error',
      skipRowsBeforeHeader: 'Zeilen überspringen (vor dem Titel)',
      skipRowsHint: 'Zeilen überspringen, z. B. eine Rechnungskopfzeile vor der Kopfzeile (Qstar: 6).',
      invalidCellAddress: 'Ungültige Zellenadresse: {{cell}}',
      headerSplitMismatch: 'Kopfzeile {{cell}} ("{{raw}}") stimmte nicht mit dem Aufteilungsmuster überein',
      headerCellReadError: 'Kopfzelle konnte nicht gelesen werden {{cell}}',
      packageCount: '{{count}} Paket',
      packagesNoneYet: 'Noch keine Pakete erstellt',
      packagesCreateFirst: 'Erstellen Sie zuerst die Paket',
      packagesNoSystems: 'Keine Systeme mit Paketen gefunden',
      pricePerMonthSek: 'Preis pro Monat (SEK)',
      pricePerYearSek: 'Preis pro Jahr (SEK)',
      yearlyPriceAutoHint: 'Belassen Sie 0 für die automatische Berechnung (10-facher Monatspreis)',
      orgChartSelectOrganization: 'Auswählen Organisation...',
      orgChartAutoLayoutTitle: 'Knoten automatisch anordnen',
      orgChartAutoLayout: 'Auto-Layout',
      orgChartImportCsv: 'Importieren CSV',
      orgChartAddUnder: 'Unter „{{name}}“ hinzufügen',
      orgChartInstructions: 'Anleitung:',
      orgChartMoveNode: 'Knoten verschieben:',
      orgChartDragNode: 'Knoten ziehen',
      orgChartNewLink: 'Neue Verbindung:',
      orgChartNewLinkHint: 'Von ● unten nach ● oben auf einen anderen Knoten ziehen',
      orgChartSelectNode: 'Knoten auswählen:',
      orgChartClickNode: 'Klicken Sie darauf',
      orgChartAddUnderSelected: 'Unter „Ausgewählt“ hinzufügen:',
      orgChartAddUnderSelectedHint: 'Knoten auswählen, auf „Hinzufügen“ klicken',
      orgChartAutoLayoutHint: 'Ordnet alle Knoten ordentlich an',
      orgChartPickToShow: 'Wählen Sie eine Organisation aus, um den Zeitplan anzuzeigen',
      orgChartUseDropdown: 'Verwenden Sie das Dropdown-Menü oben',
      orgChartAddOrganization: 'Organisation hinzufügen',
      orgChartParent: 'Elternteil',
      orgChartNamePlaceholder: 'Name der Organisation',
      orgChartDescriptionPlaceholder: 'Optionale Beschreibung',
      geofenceDrawModeActive: 'Zeichenmodus aktiv',
      geofenceFinishPolygon: 'Vollständiges Polygon',
      geofenceCrossingsOnly: 'Nur Grenzübergänge',
      geofenceSkipInitialEntry: '(Bei der ersten Einreise keinen Alarm auslösen)',
      geofenceTimeRules: 'Zeitbasierte Zollregeln ({{count}}-Regeln)',
      weekdayShortSun: 'Sonn',
      weekdayShortMon: 'Mo',
      weekdayShortTue: 'Di',
      weekdayShortWed: 'Mi',
      weekdayShortThu: 'Do',
      weekdayShortFri: 'Fr',
      weekdayShortSat: 'Sa',
      monthShortJan: 'Jan',
      monthShortFeb: 'Februar',
      monthShortMar: 'März',
      monthShortApr: 'Apr',
      monthShortMay: 'Mai',
      monthShortJun: 'Jun',
      monthShortJul: 'Jul',
      monthShortAug: 'August',
      monthShortSep: 'Sep',
      monthShortOct: 'Okt.',
      monthShortNov: 'November',
      monthShortDec: 'Dez',
      geofenceAllDays: 'Alle Tage',
      geofenceAllMonths: 'Alle Monate',
      geofenceAllDay: 'Ganztägig',
      geofenceRule: 'Regel {{index}}',
      geofenceTimeRulesReadonly: 'Zeitregeln können hier nicht bearbeitet werden. Sie werden per Backend-Skript erstellt.',
      weekdayMonday: 'Montag',
      weekdayTuesday: 'Dienstag',
      weekdayWednesday: 'Mittwoch',
      weekdayThursday: 'Donnerstag',
      weekdayFriday: 'Freitag',
      weekdaySaturday: 'Samstag',
      weekdaySunday: 'Sonntag',
      monthJanuary: 'Januar',
      monthFebruary: 'Februar',
      monthMarch: 'März',
      monthApril: 'April',
      monthMay: 'Mai',
      monthJune: 'Juni',
      monthJuly: 'Juli',
      monthAugust: 'August',
      monthSeptember: 'September',
      monthOctober: 'Oktober',
      monthNovember: 'November',
      monthDecember: 'Dezember',
      minutesAgo: '{{count}}mein seit',
      hoursAgo: '{{count}}vor Std.',
      yesterday: 'Gestern',
      deviceCsvOrganization: 'Organisation',
      deviceCsvRegistration: 'Reg.Nr',
      deviceCsvMake: 'Marke',
      deviceCsvModel: 'Modell',
      deviceCsvLastVin: 'Neuer VIN',
      deviceCsvSimStatus: 'SIM-Status',
      deviceCsvCreated: 'Erstellt',
      deviceCsvUpdated: 'Aktualisiert',
      jamVehicleLabel: 'Fahrzeug {{id}}',
      jamTripLabel: 'Fahrtnummer{{id}}',
      jamPoints: 'Problempunkte',
      pageLabel: 'Seite',
      totalLower: 'Gesamt',
      adminUsersDescription: 'Benutzer, Fahrer und SSOBenutzer verwalten',
      aiRequestTitle: 'KI-Anfrage #{{id}}',
      avlCapabilitiesLoadError: 'AVL-Fähigkeiten konnten nicht abgerufen werden',
      guideElementMissing: '(Element fehlt auf dieser Seite: „{{selector}}“)',
      broadcastReadCount: '{{count}} gelesen',
      translationsExported: 'In Dateien exportieren! Kopieren Sie den Inhalt in die richtigen Dateien.',
      ssoLoginInfoError: 'Anmeldeinformationen konnten nicht abgerufen werden',
      or: 'oder',
      auditCannotDeleteAcknowledged: 'Bestätigte Befehle können nicht gelöscht werden',
      auditDeleteCommandConfirm: 'Sind Sie sicher, dass Sie diesen Befehl löschen möchten?',
      emailVerifyTokenMissing: 'In der URL wurde kein Bestätigungstoken gefunden.',
      emailVerifiedToast: 'E-Mail-Adresse erfolgreich bestätigt!',
      emailVerifyFailed: 'Verifizierung fehlgeschlagen',
      emailVerifyError: 'E-Mail-Adresse konnte nicht bestätigt werden',
      emailVerifyingTitle: 'E-Mail-Adresse wird überprüft...',
      emailVerifyingBody: 'Bitte warten Sie, während wir Ihre E-Mail-Adresse überprüfen.',
      emailVerifiedTitle: 'E-Mail-Adresse bestätigt!',
      emailVerifiedBody: 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt. Sie können sich jetzt anmelden.',
      emailVerifyRedirect: 'Automatische Weiterleitung in 3 Sekunden...',
      emailVerifyExpiredHint: 'Wenn der Bestätigungslink abgelaufen ist, können Sie auf der Anmeldeseite einen neuen anfordern.',
      testRunnerPatternRequired: 'Testmuster oder Testdatei eingeben oder „Alle Tests ausführen“ auswählen',
      testRunnerStartFailed: 'Tests konnten nicht gestartet werden: {{message}}',
      testRunnerDeleteOneConfirm: 'Sind Sie sicher, dass Sie dieses Testergebnis löschen möchten?',
      testRunnerDeleteAllConfirm: 'Sind Sie sicher, dass Sie es löschen möchten Alle Testergebnisse?',
      testRunnerResultHeading: 'Testergebnis – {{name}}',
      testRunnerAllTests: 'Alle Tests',
      testRunnerStatus: 'Status',
      testRunnerTimestamp: 'Zeit',
      testRunnerSummary: 'Zusammenfassung',
      testRunnerTotal: 'Gesamt',
      testRunnerTests: 'Tests',
      testRunnerPassed: 'Bestanden',
      testRunnerFailed: 'Fehlgeschlagen',
      testRunnerDuration: 'Dauer',
      testRunnerTestDetails: 'Testdetails',
      testRunnerError: 'Fehler',
      testRunnerCopyFallback: 'Konnte nicht automatisch kopiert werden. Hier ist der Text:\n\n{{text}}...',
      testRunnerClipboardFailed: 'Konnte nicht in die Zwischenablage kopieren.',
      testRunnerNoFailedToCopy: 'Keine fehlgeschlagenen Tests zum Kopieren.',
      testRunnerFailedTests: 'Fehlgeschlagene Tests ({{count}})',
      testRunnerSuiteError: 'Testsuite-Fehler',
      testRunnerDeleteAll: 'Alle entfernen',
      testRunnerRunTests: 'Tests ausführen',
      testRunnerRunAll: 'Alle Tests ausführen',
      testRunnerStarting: 'Wird gestartet...',
      testRunnerResults: 'Testergebnisse',
      testRunnerNoResults: 'Noch keine Testergebnisse. Führen Sie Tests aus, um Ergebnisse zu sehen.',
      testRunnerPassedFraction: '{{passed}}/{{total}} bestanden',
      testRunnerFailedCount: '{{count}} fehlgeschlagen',
      testRunnerDetails: 'Details',
      testRunnerCopyErrorsTitle: 'Nur fehlgeschlagene Tests und Fehlerinformationen kopieren',
      testRunnerCopied: ' ✓ Kopiert!',
      testRunnerCopyErrors: 'Fehler kopieren',
      testRunnerCopyAllTitle: 'Vollständiges Testergebnis kopieren',
      testRunnerCopyAll: 'Alles kopieren',
    },
    ui: {
      activeLoansBlockDelete: 'Aktive Kreditsperre löschen',
      addPackage: 'Paket hinzufügen',
      aiConnectError: 'Verbindung zum KI-Dienst konnte nicht hergestellt werden',
      aiPromptBestVehicles: 'Welche Fahrzeuge schneiden am besten ab?',
      aiPromptFleetOverview: 'Geben Sie einen Überblick über die Flotte.',
      aiPromptReduceFuel: 'Wie können wir den Kraftstoffverbrauch senken?',
      aiPromptSaveFuel: 'Wie können wir Kraftstoff sparen?',
      aiPromptWarnings: 'Gibt es Warnsignale?',
      aiRequestFailed: 'KI-Anfrage fehlgeschlagen',
      aiVehicleContext: 'Benutzer sieht sich Fahrzeuge an: {{reg}} ({{make}} {{model}})',
      apiAccess: 'API-Zugriff',
      apiCreateFirstKey: 'Ersten Schlüssel erstellen',
      apiEndpointsHelp1: 'Wählen Sie aus, auf welche API-Endpunkte dieser Kunde Zugriff haben soll. Aktivierte Endpunkte',
      apiEndpointsHelp2: 'können mit den API-Schlüsseln des Kunden verwendet werden.',
      apiError: 'API-Fehler',
      apiExpired: 'Abgelaufen',
      apiExpiryOptional: 'Ablaufdatum (optional)',
      apiKeyOnce: 'Der Schlüssel wird nur einmal angezeigt und kann nicht zurückgesetzt werden.',
      apiNoKeys: 'Keine API-Schlüssel erstellt',
      apiScopesRequired: 'Berechtigungen (Bereiche) *',
      appPassword: 'App-Passwort (für mobile App)',
      areaPlace: 'Bereich/Standort',
      autoYearlyPriceHint: 'Belassen Sie 0 für die automatische Berechnung (10-facher Monatspreis)',
      calculated: 'berechnet',
      change: 'Änderung',
      changed: 'geändert',
      chargingPriority: 'Priorität der Ladeinfrastruktur',
      circleSizeHint: '(Kreisgröße = Haltezeit, Anzahl = Anzahl der Fahrzeuge)',
      companyEconomic: 'Wirtschaftsverband',
      companyFoundation: 'Stiftung',
      companyNonprofit: 'Gemeinnütziger Verein',
      companySoleProp: 'Einzelunternehmen',
      days: 'Tage',
      daysTotalStop: 'Tage Gesamtausfallzeit',
      demoMode: 'Demo-Modus',
      demoModeReadOnly: 'Sie befinden sich im Demo-Modus. Es sind nur Lesevorgänge verfügbar.',
      demoModeUpgrade: 'Kontaktieren Sie uns, um ein Upgrade auf die Vollversion durchzuführen.',
      deviceImportAction: 'Importieren',
      deviceImportDeactivateSim: 'SIM-Karte bei Jasper deaktivieren',
      deviceImportDisconnect: 'Vom Fahrzeug trennen',
      deviceImportError: 'Import fehlgeschlagen',
      deviceImportFailed: 'Fehlgeschlagen',
      deviceImportManual: 'Handbuch erforderlich',
      deviceImportNeedsAttention: 'Aktion erforderlich:',
      deviceImportNoImei: 'Keine gültigen IMEI-Nummern',
      deviceImportSetStock: 'Status auf LAGER setzen',
      deviceImportSettings: 'Einstellungen:',
      deviceImportSubtitle: 'IMEI-Nummern aus Excel einfügen (eine pro Zeile)',
      deviceImportSuccess: 'Erfolgreich',
      deviceImportTitle: 'Retoureneinheiten importieren',
      deviceImportValidCount: 'gültige IMEI-Nummern gefunden',
      distanceCrow: 'Vogelpfad',
      distanceOem: 'OEM-Messgerät',
      distanceOsrm: 'OSRM-Schätzung',
      enterClientSecret: 'Client-Geheimnis eingeben',
      featureNotInPackage: 'Diese Funktion ist nicht in Ihrem aktuellen Paket enthalten.',
      featureUnavailable: 'Funktion nicht verfügbar',
      featureUpgradeContact: 'Kontaktieren Sie uns, um ein Upgrade durchzuführen und auf weitere Funktionen zuzugreifen.',
      federationIntro: 'Konfigurieren Sie SAML 2.0 oder OpenID Connect, um den Benutzern des Kunden die Anmeldung mit ihrem eigenen Identitätssystem (z. B. Microsoft Entra ID, Google Workspace, Okta) zu ermöglichen.',
      federationMinLoa: 'Mindestvertrauensstufe (LoA)',
      federationMinLoaHelp: 'Erfordert ein bestimmtes Maß an Vertrauen bei der SITHS/Inera-Anmeldung. LoA3 wird für das Gesundheitswesen empfohlen.',
      fetchDataError: 'Daten konnten nicht abgerufen werden',
      graphAddPermission: 'Hinzufügen:',
      graphAppName: 'Name:',
      graphChooseLifetime: 'Laufzeit auswählen (empfohlen: 24 Monate)',
      graphCopyValue: 'Wert kopieren (wird nur einmal angezeigt)',
      graphGrantConsent: 'Klicken Sie auf „Administratoreinwilligung erteilen“ – sonst funktioniert es nicht',
      graphNoteIds: 'Anwendungs-ID (Client) und Verzeichnis (Mandant) notieren. ID',
      graphOptionalDirectory: 'Optional: für gelöschte Konten',
      graphSecretHint: 'Zertifikate & Geheimnisse → Kundengeheimnisse → Wert (bei Erstellung kopiert)',
      graphStep1: 'Schritt 1 – App-Registrierung in Entra ID',
      graphStep2: 'Schritt 2 – API-Berechtigungen (erfordert Global Admin)',
      graphStep3: 'Schritt 3 – Client Secret',
      highPriority: 'Hohe Priorität',
      hoursPerStop: 'Stunde/Stopp',
      inspectionAllSweden: 'Ganz Schweden',
      inspectionHeavy: 'Schwere Fahrzeuge/Industrie',
      inspectionMachines: 'Maschinen/Spezialfahrzeuge',
      levelNumber: 'Stufe {{level}}',
      licenseCategoriesExample: 'Führerscheinkategorien (z. B. B, C, CE)',
      linkedFromDriverForm: 'Verlinkt aus Benutzerformular / Fahrerzuordnung',
      linkedFromVehicleList: 'Verlinkt über die Fahrzeugliste von {{email}}',
      linkedOnDriverCreate: 'Verlinkt bei Neuanmeldung aus Fahrerformular',
      logoAltCrop: 'Logo zum Zuschneiden',
      logoBgDark: 'Dunkel',
      logoBgWhite: 'Weiß',
      logoChooseOther: 'Wählen Sie ein anderes Bild',
      logoClickToChoose: 'oder klicken Sie, um eine Datei auszuwählen',
      logoCropImage: 'Bild zuschneiden',
      logoDarkPreview: 'Dunkel',
      logoDropImage: 'Ein Bild hierher ziehen und ablegen',
      logoExportBackground: 'Hintergrund im exportierten Bild',
      logoExportHint: 'Exportiert als max. {{max}}px PNG mit Beibehaltung Proportionen',
      logoLightPreview: 'Hell',
      logoPreview: 'Vorschau',
      manualAuditLog: 'Audit-Protokoll',
      manualAuditLogDesc: 'Überprüfen Sie alle Änderungen im System',
      manualBookingStatsDesc: 'Volumen, Belegung, Anfragefluss und Trend der Buchungen',
      manualCertMonitor: 'Zertifikat Überwachung',
      manualCertMonitorDesc: 'Ablaufende Zertifikate (OIDC/SSO) und deren Erneuerung überwachen',
      manualCo2: 'CO2-Emissionen',
      manualCo2Desc: 'CO2-Emissionen berechnen und melden',
      manualCrmDesc: 'Kundenverwaltung und CRM-Funktionen',
      manualCustomersDesc: 'Kundenliste mit Ansprechpartnern, Statistiken und Kundenkarten',
      manualDataMigration: 'Datenmigration',
      manualDataMigrationDesc: 'Daten zwischen Datenbanken und Formaten migrieren',
      manualDataReplay: 'Datenwiedergabe',
      manualDataReplayDesc: 'GPS-Daten wiedergeben, um Fahrten neu zu generieren',
      manualDeviceAdminDesc: 'Erweiterte Geräteverwaltung und -konfiguration',
      manualDeviceCommands: 'Gerätebefehle',
      manualDeviceCommandsDesc: 'SMS-Befehle an GPS-Geräte senden',
      manualDeviceQueuesDesc: 'Ausstehende Befehle, OBD P&P und Nicht-OBD an Geräte anzeigen und verwalten',
      manualDevicesDesc: 'GPS-Geräte und ihre Verbindung zu Fahrzeugen verwalten',
      manualDrivingLogDesc: 'Fahrtagebuch gemäß den Anforderungen der schwedischen Steuerbehörde mit Zählereinstellung, CSV-Export',
      manualEcoDriving: 'Eco-Fahren',
      manualEcoDrivingDesc: 'Analysieren Sie den Fahrstil: Beschleunigung, Bremsen, Leerlauf, Ausrollen',
      manualEcoSettingsDesc: 'Konfigurieren Sie Schwellenwerte für die Analyse des umweltfreundlichen Fahrens',
      manualEnergyDesc: 'Kraftstoff- und Stromverbrauch pro Fahrzeug und Zeitraum',
      manualErrorLogs: 'Fehlerprotokolle',
      manualErrorLogsDesc: 'Systemfehler anzeigen und analysieren',
      manualExecutiveDesc: 'Gesamt-KPIs für die gesamte Flotte: Kosten, Auslastung, CO₂ und Top-5-Abweichungen',
      manualFuelDesc: 'Kraftstoffkosten, Verbrauch und SEK/Meile aus importierten Transaktionen analysieren',
      manualGeneralAudit: 'Allgemeines Prüfprotokoll',
      manualGeneralAuditDesc: 'Alle Systemereignisse und Benutzeraktivitäten anzeigen',
      manualGeofenceEventsDesc: 'Protokoll aller Geofence-Alarme anzeigen',
      manualGeofenceReportDesc: 'Bericht über Geofence-Ereignisse und Zeit in Zonen',
      manualGeofenceZones: 'Geofence-Zonen',
      manualGeofenceZonesDesc: 'Geografische Zonen für Ein-/Ausfahrtalarme erstellen',
      manualHeatmapDesc: 'Visualisierung, wo Fahrzeuge am häufigsten fahren, mit einer Wärmekarte',
      manualImportDesc: 'Fahrzeuge und Daten aus Excel/CSV',
      manualLiveTrackingDesc: 'Alle Fahrzeuge in Echtzeit auf der Karte mit Baumansicht anzeigen für Organisationen',
      manualNewCustomer: 'Neuer Kunde (Assistent)',
      manualNewCustomerDesc: '5-Schritte-Assistent zum Erstellen neuer Kunden (Interessent oder Aktiv)',
      manualOrgHierarchyDesc: 'Organisationshierarchie und Kundenstrukturen verwalten',
      manualPackagesDesc: 'Servicepakete und Preispläne verwalten',
      manualPipelineDesc: 'Verkaufsfall, Anforderungsanalyse, Geschäftswert und Verbindung zur Produktentwicklung',
      manualPricelistDesc: 'Kategorien, Produkte und Preise',
      manualRolesDesc: 'Rollen mit spezifischen Berechtigungen erstellen und verwalten',
      manualSectionCrm: 'CRM – Kundenverwaltung',
      manualSectionTools: 'Tools und Analysen',
      manualSecurityDesc: 'Fail2ban-Verbote, Schutzprotokolle, Freigabe-IP und sichere Liste',
      manualSimCards: 'SIM-Karten',
      manualSimCardsDesc: 'SIM-Karten und Mobilfunkabonnements verwalten (Tele2/Jasper)',
      manualSlowQueries: 'Langsame Abfragen',
      manualSlowQueriesDesc: 'Langsame Datenbank identifizieren und optimieren Abfragen',
      manualSpeedViolations: 'Geschwindigkeitsverstöße',
      manualSpeedViolationsDesc: 'Anzeigen, wo und wann Geschwindigkeitsbegrenzungen überschritten wurden',
      manualSupportDesc: 'Supportfälle und Kundenkommunikation',
      manualSystemMonitor: 'Systemmonitor',
      manualSystemMonitorDesc: 'Systemzustand, Datenbanken und Prozesse überwachen',
      manualTcoDesc: 'Gesamtbetriebskosten pro Fahrzeug: Kraftstoff, Service, Leasing, Versicherung und Steuern (Kr/km)',
      manualTranslationsDesc: 'Verwalten Sie Übersetzungen für Schwedisch und Englisch',
      manualTripCompareDesc: 'Vergleichen Sie aufgezeichnete Fahrten mit der Behälterdatei des Fahrzeugs, um Anomalien zu identifizieren',
      manualTripsDesc: 'Listen Sie alle Fahrten mit Start/Ende, Entfernung und Zeit auf',
      manualUnderutilizedDesc: 'Identifizieren Sie Fahrzeuge mit geringem Nutzungsgrad (Mehrwert 100.000 SEK)',
      manualUsersDesc: 'Verwalten Sie Benutzer, Berechtigungen und Passwörter',
      manualWearDesc: 'Analysieren Sie das Fahrverhalten, das sich auf den Fahrzeugverschleiß auswirkt (Mehrwert 120.000 SEK)',
      max50Hits: 'Zeigt maximal 50 Treffer an. Verfeinern Sie Ihre Suche, um weitere Ergebnisse zu erhalten.',
      maxValue: '{{label}} darf höchstens {{max}} sein',
      minInteger: '{{label}} muss mindestens eine Ganzzahl sein {{min}}',
      mobileAppAccess: 'Zugriff auf die mobile App',
      mobileAppAccessHint: 'Ermöglicht dem Fahrer Zugriff auf die Anmeldung bei der DQFleet-App.',
      modulesAvailable: '{{count}} verfügbar',
      monthsCount: '{{count}} Mo',
      motenCustomerWishes: 'Kundenwunsch',
      moveOrgToParent: 'Verschieben Sie „{{name}}“ in eine neue Mutterorganisation.',
      noCustomersMatch: 'Keine Kunden entsprechen dem Filter',
      noCustomersYet: 'Noch keine Kunden',
      noGroupStructure: 'Keine Gruppenstruktur gespeichert. Klicken Sie auf „Herunterladen & Speichern“, um von Checkbiz/SCB herunterzuladen.',
      noVehiclesAvailable: 'Keine Fahrzeuge verfügbar',
      noVehiclesMatch: 'Keine Fahrzeuge stimmen mit „{{term}}“ überein',
      notNegative: '{{label}} darf nicht negativ sein',
      oidcCertPlaceholder: '-----BEGIN CERTIFICATE-----\n...\n-----END CERTIFICATE-----\n oder /opt/dqfleet/secrets/oidc-1555-cert.pem',
      oidcKeyPlaceholder: '-----BEGIN PRIVATE KEY-----\n...\n oder /opt/dqfleet/secrets/oidc-1555-private.pem',
      ownershipShare: 'Eigentümer: {{share}}',
      perMonthShort: '/Monat',
      placesByStopTime: 'Standorte nach Stoppzeit sortiert',
      priority: 'Priorität',
      priorityCritical: 'Kritisch',
      priorityHigh: 'Hoch',
      priorityLow: 'Niedrig',
      priorityMedium: 'Durchschnitt',
      reconstructedDistance: 'Rekonstruierte Fahrt (GPS fehlte) – Etappe: {{source}}',
      registeredSince: '{{value}}, dann {{date}}',
      replaceTenantId: 'Ersetzen Sie {tenant-id} durch die Azure AD-Mandanten-ID des Kunden.',
      resizeColumn: 'Ändern Sie die Breite von {{label}}',
      roleDecisionMaker: 'Entscheidungsträger',
      roleFinance: 'Wirtschaftlichkeit',
      roleFleetManager: 'Fahrzeugmanager',
      roleOther: 'Sonstiges',
      searchHits: '{{count}} Treffer',
      searchOrSelectVehicle: 'Fahrzeug suchen oder auswählen...',
      searchRegNumber: 'Suchen Sie die Zugnummer...',
      searching: 'Suche...',
      searchingVehicles: 'Fahrzeug wird gesucht...',
      secretUnchanged: '(unverändert, wenn leer)',
      selectVehicleDash: '-- Fahrzeug auswählen --',
      simActivated: 'Aktiviert',
      simActivationReady: 'Bereit zur Aktivierung',
      simCardJasper: 'SIM-Karte (Jasper)',
      simCommPlan: 'Kommunikationsplan',
      simDataLimit: 'Datenlimit erreicht!',
      simDeactivated: 'Disabled',
      simFetching: 'SIM-Status wird abgerufen...',
      simInventory: 'Lagerbestand',
      simNoIccid: 'Keine ICCID konfiguriert',
      simPurged: 'Gelöscht',
      simRatePlan: 'Tarifplan',
      simRetired: 'Fertig',
      simSessions: 'Sitzungen',
      simStatusChangeError: 'Status konnte nicht geändert werden',
      simStatusFetchError: 'SIM-Status konnte nicht abgerufen werden',
      simTestReady: 'Testmodus',
      simUsagePeriod: 'Nutzung in diesem Zeitraum',
      sithsAuthTitle: 'SITHSAuthentifizierung (Inera)',
      sithsClaims: 'Ansprüche: Sozialversicherungsnummer, HSA-ID, Name über SITHSZertifikat',
      sithsEnv: 'QA: https://idp.ineraqa.org/oidc | Produkt: https://idp.inera.se/oidc',
      sithsRegistration: 'Die Kundenregistrierung erfolgt manuell über die Vorstudienvorlage von Inera',
      sortByHoursPerStop: 'Sortieren: Stunden/Stopps',
      sortByStopCount: 'Sortieren: Anzahl der Stopps',
      sortByStopTime: 'Sortieren: Stoppzeit',
      sortByVehicleCount: 'Sortieren: Anzahl der Fahrzeuge',
      ssoAppPasswordHint: 'SSO Benutzer können ein Passwort für die Protokollierung festlegen in der mobilen App',
      stop: 'Stopp',
      stopCount: 'Anzahl der Stopps',
      stopTime: 'Stoppzeit',
      stopTimeDays: 'Ausfallzeit (Tage)',
      storageLocationExample: 'BVS Linköping',
      supportMessagePlaceholder: 'Beschreiben Sie Ihr Problem im Detail...',
      supportReplyPlaceholder: 'Schreiben Sie eine Antwort...',
      supportSubjectPlaceholder: 'Beschreiben Sie kurz Ihr Problem',
      supportWaitingOnYou: 'Warten auf Sie',
      syncMode: 'Synchronisierungsmodus',
      ticketResolved: 'Dieser Fall ist gelöst',
      tireHistoryAuto: 'Verlauf wird beim nächsten Reifenwechsel automatisch erstellt',
      topStopAreas: 'Die Bereiche mit der höchsten Stoppzeit (klicken Sie für Details)',
      treadPerWheel: 'Mustertiefe pro Rolle',
      trialDaysLeft: '{{count}}Nur noch Tage zum Testen',
      trialEndingSoon: 'Ihre Testversion endet bald. Kontaktieren Sie uns für ein Upgrade.',
      trialExpiredBody: 'Ihr Testzeitraum ist abgelaufen. Kontaktieren Sie uns, um den Service weiterhin zu nutzen.',
      trialExpiredTitle: 'Testzeitraum ist abgelaufen',
      trialOneDayLeft: 'Noch 1 Tag im Testzeitraum',
      typeTwoCharsToSearch: 'Geben Sie mindestens 2 Zeichen für die Suche ein...',
      unknownError: 'Unbekannter Fehler',
      userCount: '{{count}} Benutzer',
      weekdayFr: 'fr',
      weekdayMo: 'Mo',
      weekdaySa: 'Sa',
      weekdaySu: 'Sonn',
      weekdayTh: 'bis',
      weekdayTu: 'Di',
      weekdayWe: 'on',
      xlsxReadError: 'Datei konnte nicht gelesen werden – prüfen Sie, ob es sich um eine gültige XLSX-Datei handelt',
      yearsCount: '{{count}} Jahr',
    },
    hooks: {
      userLoadError: 'Fehler beim Laden des Benutzers: {{message}}',
      emailAndRoleRequired: 'E-Mail-Adresse und Rolle sind erforderlich',
      organizationRequired: 'Organisation ist erforderlich',
      userCreatedDriverMissing: 'Benutzer erstellt, aber Fahrerdatensatz fehlt. Benutzer öffnen und Zeitplan und Fahrzeug festlegen.',
      userCreatedDriverSetupFailed: 'Benutzer erstellt, aber Fahrereinstellungen fehlgeschlagen: {{message}}',
      userCreatedWelcomeSent: 'Benutzer erstellt – Willkommens-E-Mail gesendet',
      userCreated: 'Benutzer erstellt',
      welcomeEmailFailed: 'Willkommens-E-Mail konnte nicht gesendet werden',
      welcomeEmailDisabled: 'Willkommens-E-Mail ist für den Kunden deaktiviert',
      userCreateError: 'Fehler beim Erstellen des Benutzers: {{message}}',
      userUpdated: 'Benutzer aktualisiert',
      userUpdateError: 'Fehler beim Aktualisieren des Benutzers: {{message}}',
      driverCreated: 'Treiber erstellt',
      driverCreateError: 'Fehler beim Erstellen des Treibers: {{message}}',
      userDeleted: 'Benutzer gelöscht',
      userDeleteError: 'Fehler beim Löschen des Benutzers: {{message}}',
      userHardDeleted: 'Benutzer wurde vollständig gelöscht und kann über SSO',
      userHardDeleteError: 'Fehler beim Löschen des Benutzers: {{message}}',
      vehicleFetchFailed: 'Fahrzeugdaten konnten nicht heruntergeladen werden',
      genericError: 'Ein Fehler ist aufgetreten',
      odometerSaveFailed: 'Zählerstand konnte nicht gespeichert werden',
      saveFailed: 'Fehler beim Speichern',
      flinkeyLinkFailed: 'Flinkey konnte nicht verbunden werden',
      flinkeyUnlinkFailed: 'Flinkey konnte nicht entfernt werden',
      boxLinkFailed: 'Box konnte nicht verbunden werden',
      boxUnlinkFailed: 'Box konnte nicht getrennt werden',
      assignFailed: 'Konnte nicht zugewiesen werden',
      transferError: 'Bei der Übertragung ist ein Fehler aufgetreten',
      vehicleMissing: 'Fahrzeug fehlt',
      vehicleTransferFailed: 'Fahrzeug konnte nicht übertragen werden',
      changeSaveFailed: 'Änderung konnte nicht gespeichert werden',
      invalidOrganization: 'Ungültige Organisation',
      vehicleChangesSaveFailed: 'Fahrzeugänderungen konnten nicht gespeichert werden',
      topNodeResolveFailed: 'Der oberste Knoten der ausgewählten konnte nicht ermittelt werden Organisation',
      saveGenericFailed: 'Beim Speichern ist ein Fehler aufgetreten',
      drawPolygonHint: 'Klicken Sie auf die Karte, um ein Polygon zu zeichnen. Klicken Sie auf „Fertig stellen“, wenn Sie fertig sind.',
      polygonDrawnFillForm: 'Polygon gezeichnet! Füllen Sie das Formular aus und speichern Sie es.',
      drawPolygonFirst: 'Zeichnen Sie zuerst ein Polygon auf der Karte (mindestens 3 Punkte)',
      csvCostPerPassage: 'Kosten pro Durchfahrt',
      csvCostPerMinute: 'Kosten pro Minute',
      csvHideCoordinates: 'Koordinaten ausblenden',
      csvBorderOnly: 'Nur Grenzübergänge',
      scopeGlobalShort: 'Global',
      csvDownloaded: 'CSVDatei heruntergeladen',
      selectAtLeastOneVehicle: 'Mindestens ein Fahrzeug auswählen',
      enterStartAndEndTime: 'Start- und Endzeit eingeben',
      gpsPointsFetched: 'Heruntergeladen {{count}} GPS Punkte',
      fetchDataFailed: 'Daten konnten nicht abgerufen werden',
      fetchGpsFailed: 'Fehler beim Abrufen von GPS-Daten',
      tenantAndClientRequired: 'Mandanten-ID und Client-ID erforderlich',
      clientSecretRequired: 'Client-Geheimnis für neue Konfiguration erforderlich',
      graphConfigUpdated: 'Diagrammkonfiguration aktualisiert',
      graphConfigCreated: 'Graph-Konfiguration erstellt',
      couldNotSave: 'Speichern nicht möglich',
      graphSaveFailed: 'Graph-Konfiguration konnte nicht gespeichert werden',
      confirmDeleteGraph: 'Graph-API-Konfiguration entfernen? Synchronisierungsprotokoll bleibt erhalten.',
      graphConfigRemoved: 'Grafikkonfiguration entfernt',
      couldNotDelete: 'Konnte nicht entfernt werden',
      graphDeleteFailed: 'Grafikkonfiguration konnte nicht entfernt werden',
      syncDone: 'Synchronisierung abgeschlossen',
      syncFailed: 'Synchronisiert fehlgeschlagen',
      previewFailed: 'Vorschau konnte nicht heruntergeladen werden',
      samlUpdated: 'SAML-Konfiguration aktualisiert',
      samlCreated: 'SAML Konfiguration erstellt',
      confirmDeleteSaml: 'SAML-Konfiguration entfernen?',
      oidcUpdated: 'OIDC-Konfiguration aktualisiert',
      oidcCreated: 'OIDC-Konfiguration erstellt',
      confirmDeleteOidc: 'OIDC-Konfiguration entfernen?',
      confirmDeactivate: 'Möchten Sie das Fahrzeug deaktivieren {{reg}}?\n\nDas Fahrzeug ist ausgeblendet aus der Liste, aber nicht dauerhaft entfernt.',
      vehicleDeactivated: '{{reg}} wurde deaktiviert',
      vehicleDeactivateFailed: '{{reg}}',
      vehicleAlreadyActive: '{{reg}} ist bereits aktiv',
      vehicleReactivateFailed: '{{reg}}',
      connectKey: 'Schlüssel mit {{reg}} verbinden...',
      subscribeVehicle: 'Abonnieren bei {{reg}}...',
      unknownOrg: 'Unbekannt',
      ticketUpdated: 'Fall aktualisiert',
      fillTitleAndMessage: 'Titel und Nachricht eingeben',
      selectOrganization: 'Organisation auswählen',
      broadcastSent: 'Übertragung gesendet!',
      categoryNameRequired: 'Geben Sie einen Kategorienamen ein',
      categoryCreated: 'Kategorie erstellt',
      categoryCreateFailed: 'Kategorie konnte nicht erstellt werden',
      broadcastDeleted: 'Broadcast entfernt',
      faqAdded: 'FAQ hinzugefügt',
      faqUpdated: 'FAQ aktualisiert',
      faqDeleted: 'FAQ entfernt',
      faqAddedFromTicket: 'FAQ aus Fall hinzugefügt',
      pricingHourly: 'Pro Stunde',
      pricingMonthly: 'Pro Monat',
      pricingPerVehicle: 'Pro Fahrzeug',
      pricingPerUser: 'Pro Benutzer',
      pricingOneTime: 'Einmaliger Kauf',
      pricingCustom: 'Benutzerdefiniert',
      dailyDrivingExceeded: 'Lenkzeit {{hours}}h überschreitet die Höchstgrenze {{limit}}h',
      continuousDrivingExceeded: 'Kontinuierliche Lenkzeit {{hours}}h ohne ausreichende Ruhezeiten',
      minimumBreakTooShort: 'Mindestruhe {{minutes}}min – mindestens 45 Minuten erforderlich',
      weeklyDrivingExceeded: 'Wöchentliche Lenkzeit {{hours}}h überschreitet 56-Stunden-Grenze',
      layoutUpdated: 'Layout aktualisiert',
      linkCreated: 'Verbindung erstellt',
      showingHierarchy: 'Hierarchie von „{{name}}“ anzeigen',
      organizationNameRequired: 'Geben Sie einen Namen für die Organisation ein',
      orgAddedUnder: 'Hinzugefügt „{{name}}“ unter „{{parent}}“',
      topNode: 'Oberer Knoten',
      cannotDeleteTopNode: 'Oberster Knoten konnte nicht entfernt werden',
      nodeDeleted: 'Knoten entfernt',
      structureSaved: 'Organisationsstruktur gespeichert!',
      orgSaveFailed: 'Konnte nicht gespeichert werden: {{message}}',
      orgSaveUnresolvedParent: 'Die Gruppe konnte nicht gespeichert werden, weil die Verbindung zur übergeordneten Gruppe fehlt',
      importedOrganizations: 'Importierte {{count}} Organisationen. Ziehen Sie Konnektoren, um die Hierarchie anzuordnen.',
      noOrganizationsInFile: 'Keine Organisationen in der Datei gefunden',
      otherCategory: 'Andere',
      mobileModule: 'Mobil: {{name}}',
      wizardBasicInfo: 'Grundlegende Informationen',
      wizardAddress: 'Adresse',
      wizardContact: 'Ansprechpartner',
      wizardPricing: 'Preise',
      wizardSummary: 'Zusammenfassung',
      pricePerMonth: '{{price}} SEK/Monat',
      pricePerVehicle: '{{price}} SEK/Fahrzeug',
      pricePerUser: '{{price}} SEK/Benutzer',
      packageAddedSyncFailed: 'Paket hinzugefügt, aber Modulsynchronisierung ist fehlgeschlagen.',
      confirmRemovePackage: 'Möchten Sie? Soll das Paket „{{name}}“ vom Kunden entfernt werden?',
      packageRemoved: 'Paket entfernt',
      packageRemoveFailed: 'Paket konnte nicht entfernt werden',
      mapViewSaved: 'Kartenansicht gespeichert!',
      simUsageFetchFailed: 'Nutzungsdaten konnten nicht abgerufen werden',
      simCardsFetchFailed: 'SIM-Karte konnte nicht abgerufen werden',
      reportCreated: 'Bericht erstellt',
      reportCreateFailed: 'Bericht konnte nicht erstellt werden',
      deviceStatusStock: 'Lagerbestand',
      deviceStatusCustomer: 'Beim Kunden',
      deviceStatusVehicle: 'Im Fahrzeug',
      deviceStatusLost: 'Verloren',
      deviceStatusDecommissioned: 'Entsorgt',
      deviceChangeStatus: 'Status geändert',
      deviceChangeMounted: 'Im Fahrzeug montiert',
      deviceChangeUnmounted: 'Demontiert',
      deviceChangeTransferred: 'In ein anderes Fahrzeug verschoben',
      deviceChangeVin: 'VIN erkannt',
      deviceChangeVehicleCreated: 'Fahrzeug erstellt',
      deviceChangeSimActivated: 'SIM aktiviert',
      deviceChangeSimSuspended: 'SIM deaktiviert',
      deviceChangeCreated: 'Gerät erstellt',
      deviceChangeImported: 'Einheit importiert',
      loaNone: 'Keine (optional)',
      loa2: 'LoA2 – Einiges Vertrauen',
      loa3: 'LoA3 – Hohes Vertrauen',
      loa4: 'LoA4 – Sehr hoch Vertrauen',
      nameIdEmail: 'E-Mail',
      nameIdPersistent: 'Persistent',
      nameIdTransient: 'Vorübergehend',
      nameIdUnspecified: 'Nicht spezifiziert',
      somethingWentWrong: 'Etwas ist schief gelaufen',
      entityCreated: '{{entity}} erstellt',
      entityCreateFailed: 'Erstellung fehlgeschlagen {{entity}}',
      entityUpdated: '{{entity}} aktualisiert',
      entityUpdateFailed: 'Aktualisierung fehlgeschlagen {{entity}}',
      entityDeleted: '{{entity}} gelöscht',
      entityDeleteFailed: 'Löschen fehlgeschlagen {{entity}}',
      benchmarksFetchFailed: 'Vergleiche konnten nicht abgerufen werden',
      ticketCreateFailed: 'Fall konnte nicht erstellt werden',
      apiKeyCreated: 'API-Schlüssel erstellt',
      confirmDeactivateApiKey: 'Sind Sie sicher, dass Sie diesen API-Schlüssel deaktivieren möchten?',
      apiKeyDeactivated: 'API-Schlüssel deaktiviert',
      endpointDeactivated: 'Endpunkt deaktiviert',
      endpointActivated: 'Endpunkt aktiviert',
      customerCreateFailed: 'Kunde konnte nicht erstellt werden',
      networkError: 'Netzwerkfehler',
      statusChangeFailed: 'Fehler beim Ändern des Status',
      unmountFailed: 'Fehler beim Aufheben der Bereitstellung',
      orgAssignFailed: 'Fehler beim Zuweisen der Organisation',
      fileReadFailed: 'Die Datei konnte nicht gelesen werden',
      uploadFailed: 'Upload-Fehler',
      importComplete: 'Import abgeschlossen: {{imported}} importiert, {{updated}} aktualisiert, {{failed}} fehlgeschlagen',
      importFailed: 'Import fehlgeschlagen',
      importLoadFailed: 'Import konnte nicht geladen werden',
      leasingMileageFetchFailed: 'Mietkilometer konnten nicht abgerufen werden',
      remoteServersFetchFailed: 'Daten konnten nicht von Remote-Servern abgerufen werden',
      tripsFetchFailed: 'Fahrten konnten nicht abgerufen werden',
      analysisFailed: 'Analyse fehlgeschlagen',
      trendsFetchFailed: 'Trends konnten nicht abgerufen werden',
      registeredTripsFetchFailed: 'Aufgezeichnete Fahrten konnten nicht abgerufen werden',
      invalidCase: 'Ungültiger Fall',
      binDataFetchFailed: 'Behälterdaten konnten nicht heruntergeladen werden',
      roleDashboard: 'Dashboard',
      roleLiveMap: 'Echtzeitkarte',
      roleWorkOrders: 'Arbeitsaufträge',
      roleBooking: 'Buchung',
      roleWorkshop: 'Workshop',
      roleKeys: 'Schlüssel Verwaltung',
      roleTemperature: 'Temperaturüberwachung',
      roleReports: 'Berichte',
      roleAnalysis: 'Analyse',
      roleAdmin: 'Administration',
      roleMobile: 'Mobile App',
      unknownVehicle: 'Unbekanntes Fahrzeug',
      supportStatusOpen: 'Offen',
      supportStatusInProgress: 'In Bearbeitung',
      supportStatusWaitingCustomer: 'Warten auf Kunden',
      supportStatusResolved: 'Gelöst',
      supportStatusClosed: 'Bereit markiert',
      supportPriorityLow: 'Niedrig',
      supportPriorityMedium: 'Mittel',
      supportPriorityHigh: 'Hoch',
      supportPriorityCritical: 'Kritisch',
      supportCategoryTechnical: 'Technisch',
      supportCategoryBilling: 'Rechnung',
      supportCategoryFeatureRequest: 'Anfrage',
      supportCategoryBugReport: 'Fehlerbericht',
      supportCategoryQuestion: 'Frage',
      supportCategoryTraining: 'Bildung',
      supportCategoryIntegration: 'Integration',
      unassigned: 'Nicht zugewiesen',
      binAnalysisFailed: 'Analyse fehlgeschlagen bin-Datei',
    },
  },
};
